import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
};

/** Academic Career */
export type AcademicCareer = {
  __typename?: 'AcademicCareer';
  /** Code of the career */
  code: Scalars['String'];
  /** Description of the career */
  description: Scalars['String'];
  /** Unique identifier for the career */
  id: Scalars['ID'];
  /** Short description of the career */
  shortDescription?: Maybe<Scalars['String']>;
};

/** Settings for the Academic Planner, aka student-app */
export type AcademicPlanningSettings = {
  __typename?: 'AcademicPlanningSettings';
  /** Label text for the Admin Analytics link in the navigation bar */
  adminAnalyticsLabel: Scalars['String'];
  /** Optional URL to take users to the Admin Analytics app */
  adminAnalyticsUrl: Scalars['String'];
  /** Label text for the Advising link in the navigation bar */
  advisingLabel: Scalars['String'];
  /** Optional URL to take users to Inspire's Advising App */
  advisingUrl: Scalars['String'];
  /** flag indicating whether a dual-role user may view/edit their own plan while advising */
  advisorViewOwnPlan: Scalars['Boolean'];
  /** flag indicating whether students can edit placeholder items on read-only plans. */
  allowPlaceholderEditInReadOnly: Scalars['Boolean'];
  /** Flag to always show the required/used/needed course and credit counts for audit requirements */
  alwaysShowRequirementCourseAndCreditCounts: Scalars['Boolean'];
  /** Interval (in days) since the last audit run to prompt the student to update the audit. */
  auditRefreshNudgeInterval: Scalars['Int'];
  /** Macro to format the display course data */
  courseDisplayFormat: Scalars['String'];
  /** Specific options for course history progress summary */
  courseHistoryProgressSummaryOptions: Array<CourseHistoryProgressSummaryOption>;
  /** Optional message to display in course taken requirements list */
  courseTakenRequirementMessage: Scalars['String'];
  /** flag indicating whether plan items should be locked by default. */
  defaultPlanLockedState: Scalars['Boolean'];
  /** Degree Requirements Panel Configuration */
  degreeRequirementsPanelConfiguration: DegreeRequirementsPanelConfiguration;
  /** Flag indicating if Elev.io integation is disabled overall */
  disableElevio: Scalars['Boolean'];
  /** Flag indicating if Elev.io integation is disabled for students only */
  disableElevioForStudents: Scalars['Boolean'];
  /** Flag indicating if Academic Planning student access is disabled */
  disableStudentLogin: Scalars['Boolean'];
  /** Flag indicating if removing a primary plan is disallowed */
  disallowPrimaryPlanRemoval: Scalars['Boolean'];
  /** Flag indicating if switching plans is disallowed */
  disallowSwitchingPlans: Scalars['Boolean'];
  /** Optional message to display in course taken requirements list */
  duplicateCourseMessage: Scalars['String'];
  /** Flag indicating if the Academic Planner (student-app) is enabled */
  enableAcademicPlanning: Scalars['Boolean'];
  /** Flag indicating whether the Admin Analytics link is shown on the main navbar. */
  enableAdminAnalyticsLink: Scalars['Boolean'];
  /** Flag indicating whether the Advising link is shown on the main navbar. */
  enableAdvisingLink: Scalars['Boolean'];
  /** Flag to enable the cross listing courses to be marked as used according to the audit in the Plan Board */
  enableCrossListingUsedCourses: Scalars['Boolean'];
  /** Flag indicating whether to display LMS data in the course history table. */
  enableLmsCoursesView: Scalars['Boolean'];
  /** flag indicating whether all plan items can be locked. */
  enableLockAllPlanItems: Scalars['Boolean'];
  /** flag indicating whether the new comments can be marked as read. */
  enableMarkAllCommentsAsRead: Scalars['Boolean'];
  /** Flag indicating whether the requirements tab is enabled on the plan board */
  enableRequirementsTab: Scalars['Boolean'];
  /** Flag to enable the substitution courses to be marked as used according to the audit in the Plan Board */
  enableSubstitutionUsedCourses: Scalars['Boolean'];
  /** Optional URL to take users to an external student audit system */
  externalDegreeAuditUrl: Scalars['String'];
  /** A list of failed grades to generate not meet requirements alerts. */
  failedGrades: Array<Scalars['String']>;
  /** flag indicating whether to hide or show the requirements, or requirements groups on the audit/requirements. */
  hideNotUsedRequirementInAudit: Scalars['Boolean'];
  /** Flag indicating if requirement percent complete is hidden on Degree Requirements */
  hideRequirementPercentComplete: Scalars['Boolean'];
  /** flag indicating whether to hide or show the requisites on plan item details. */
  hideRequisitesOnPlanItemDetails: Scalars['Boolean'];
  /** Flag indicating if terms Offered section should be hidden in course info */
  hideTermsOffered: Scalars['Boolean'];
  /** Flag indicating whether the students can only add courses on the plan board that match their home campus */
  lockPlanBoardToHomeCampus: Scalars['Boolean'];
  /** Optional list of term filters used on the New Plan page. When creating a plan a student will have the option to include particular term types such as Intersession or Summer, depending on this configuration. */
  newPlanTermFilters: Array<NewPlanTermFilter>;
  /** A list of requirement group IDs that represent courses not used to meet any requirement. */
  notUsedRequirementGroups: Array<Scalars['String']>;
  /** A list of requirement IDs that represent courses not used to meet any requirement. */
  notUsedRequirements: Array<Scalars['String']>;
  /** For plans and templates when we show past terms, how many years in the past to get terms. */
  pastTermYears: Scalars['Int'];
  /** Optional message to display as an alert banner at the top of every plan. */
  planDisclaimer: Scalars['String'];
  /** Academic Planning Help Link Text Setting */
  planningHelpLinkText: Scalars['String'];
  /** Academic Planning Help Link URL Setting */
  planningHelpLinkUrl: Scalars['String'];
  /** Academic Planning Help Videos Text Setting */
  planningHelpVideosText: Scalars['String'];
  /** Academic Planning Help Videos URL Setting */
  planningHelpVideosUrl: Scalars['String'];
  /** flag indicating whether all plan items can be readonly. */
  readOnlyPlansForStudents: Scalars['Boolean'];
  /** Flag indicating whether plan items created from templates should be required */
  requireTemplatePlanItems: Scalars['Boolean'];
  /** Flag indicating whether to show exceptions on the audit */
  showExceptionsOnAudit: Scalars['Boolean'];
  /** Flag indicating whether to show exceptions on plan board */
  showExceptionsOnPlanAlerts: Scalars['Boolean'];
  /** Flag indicating whether to show grades on the planItemCard on the plan board */
  showGradesOnPlanItems: Scalars['Boolean'];
  /** Flag indicating whether to show withdrawn statuses on the planItemCard on the plan board */
  showWithdrawnStatusOnPlanItems: Scalars['Boolean'];
  /** Student Help Link Text Setting */
  studentHelpLinkText: Scalars['String'];
  /** Student Help Link URL Setting */
  studentHelpLinkUrl: Scalars['String'];
  /** List of overrides for template details */
  templateDetailOptions: Array<TemplateDetailOption>;
  /** Naming override options for terms */
  termOptions: Array<TermOption>;
  /** Defines how we assign term types to terms in term ingest. When mode is DESCRIPTION, we parse the description and map description to termType using termTypeIdentifiers. When mode is TERM_CODE, we parse the termCode to map termCode to termType using termTypeIdentifiers */
  termTypeIdentifierMode: TermTypeIdentifierMode;
  /** Mapping of term types to identifiers. Identifier can be a description, or the last digit of a termCode, depending on termTypeIdentifierMode. */
  termTypeIdentifiers: Array<TermTypeIdentifier>;
};

/** Academic Program for the student */
export type AcademicProgram = {
  __typename?: 'AcademicProgram';
  /** The academic program code */
  code?: Maybe<Scalars['String']>;
  /** The academic program description */
  description?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** Flag to denote if the program is the primary one */
  primary?: Maybe<Scalars['Boolean']>;
};

/** List of program ids to use for filtering majors and minors */
export type AcademicProgramFilter = {
  /** Ids of the academic programs to filter on */
  programIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Academic Year */
export type AcademicYear = {
  __typename?: 'AcademicYear';
  /** Academic year */
  academicYear: Scalars['String'];
  /** Description of the academic year as a range, ie: 2020-2021 */
  academicYearDescription: Scalars['String'];
  /** Date marking the end of the academic year (latest term end date for the academic year) */
  endDate: Scalars['DateTime'];
  /** Date marking the beginning of the academic year (earliest term start date for the academic year) */
  startDate: Scalars['DateTime'];
};

/** The additional report types to run when making the audit request for peoplesoft. */
export type AdditionalAuditReportType = {
  __typename?: 'AdditionalAuditReportType';
  /** Audit Report Type to use for this career code */
  auditReportType: Scalars['String'];
  /** Career */
  career: Scalars['String'];
  /** Career Code */
  careerCode: Scalars['String'];
};

/** Additional Identifier for the student */
export type AdditionalIdentifier = {
  __typename?: 'AdditionalIdentifier';
  /** The unique id */
  id: Scalars['ID'];
  /** The identifier type */
  identifierType?: Maybe<IdentifierType>;
  /** The institution id */
  institutionId?: Maybe<Scalars['String']>;
  /** The identifier value */
  value?: Maybe<Scalars['String']>;
};

/** Settings to control admin features */
export type AdminSettings = {
  __typename?: 'AdminSettings';
  /** Enabled features */
  features: Array<Scalars['String']>;
};

export type AdminUser = User & {
  __typename?: 'AdminUser';
  /** App User Id for user */
  appUserId: Scalars['Int'];
  /** Display Name */
  displayName?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['EmailAddress']>;
  /** SAAS Environment */
  environment: Scalars['String'];
  /** Unique identifier for the user from external system. */
  externalId?: Maybe<Scalars['String']>;
  /** External Roles for the user the from external system. */
  externalRoles?: Maybe<Scalars['String']>;
  /** First Name */
  firstName?: Maybe<Scalars['String']>;
  /** Generated User ID Unique Per Role */
  id: Scalars['Long'];
  /** Is user deleted. */
  isDeleted: Scalars['Boolean'];
  /** Is user a super user. */
  isSuperUser: Scalars['Boolean'];
  /** Last Name */
  lastName?: Maybe<Scalars['String']>;
  /** Timestamp of when the user profile was last updated from identity provider */
  lastSyncTimestamp?: Maybe<Scalars['DateTime']>;
  permissions: Array<AdminUserPermission>;
  /** User Picture */
  picture?: Maybe<Scalars['String']>;
  /** JWT Subject Identifier */
  sub?: Maybe<Scalars['String']>;
};

export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: AdminUser;
};

/** The input object used when creating an admin user */
export type AdminUserInput = {
  adminUserRole?: InputMaybe<AdminUserRole>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type AdminUserPagedResult = {
  __typename?: 'AdminUserPagedResult';
  /** Which page is currently displayed */
  page: Scalars['Int'];
  /** What is the current page size */
  pageSize: Scalars['Int'];
  /** How many total results where found */
  resultCount: Scalars['Int'];
  /** Resulting paged admin users */
  results: Array<AdminUser>;
  /** What is the current sort key */
  sortKey: Scalars['String'];
  /** What is the current sort order */
  sortOrder: SortOrder;
};

export type AdminUserPagedResultInput = {
  /** Include disabled / deleted users */
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Include super users */
  includeSuperUsers?: InputMaybe<Scalars['Boolean']>;
  /** End date of logs to look for */
  nameEmailFilter?: InputMaybe<Scalars['String']>;
  /** Which page worth of results to view */
  page?: InputMaybe<Scalars['Int']>;
  /** How many results to return per page */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Which field to sort by */
  sortKey?: InputMaybe<Scalars['String']>;
  /** Should results  be sorted ASC or DESC */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Admin user specific permissions controlled through user management. */
export enum AdminUserPermission {
  AccessStudents = 'ACCESS_STUDENTS',
  CartSectionsReports = 'CART_SECTIONS_REPORTS',
  CourseDemandRawData = 'COURSE_DEMAND_RAW_DATA',
  Diagnostics = 'DIAGNOSTICS',
  EnrollmentOptimization = 'ENROLLMENT_OPTIMIZATION',
  EnrollmentOptimizationAdmin = 'ENROLLMENT_OPTIMIZATION_ADMIN',
  ManageEnrollmentBlocks = 'MANAGE_ENROLLMENT_BLOCKS',
  ManageTemplates = 'MANAGE_TEMPLATES',
  ManageUsers = 'MANAGE_USERS',
  PlanningAiAssistant = 'PLANNING_AI_ASSISTANT',
  PlanningCourseDemandData = 'PLANNING_COURSE_DEMAND_DATA',
  PlanCreationData = 'PLAN_CREATION_DATA',
  PreloadStudentCourses = 'PRELOAD_STUDENT_COURSES',
  ReadonlyPlans = 'READONLY_PLANS',
  RegistrationWorksheet = 'REGISTRATION_WORKSHEET',
  SampleStudentLogin = 'SAMPLE_STUDENT_LOGIN',
  StudentSendToCart = 'STUDENT_SEND_TO_CART',
  StudentSendToCartAndRegister = 'STUDENT_SEND_TO_CART_AND_REGISTER',
  StudentUsageRawData = 'STUDENT_USAGE_RAW_DATA',
  StudentUsageReports = 'STUDENT_USAGE_REPORTS',
  ViewAllStudents = 'VIEW_ALL_STUDENTS'
}

/** The list of "profile" roles used for admin users. */
export enum AdminUserRole {
  Advisor = 'ADVISOR',
  AdvisorPlus = 'ADVISOR_PLUS',
  Director = 'DIRECTOR',
  Staff = 'STAFF'
}

/** Alert levels for plan alerts. */
export enum AlertLevel {
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Alert types for plan alerts. */
export enum AlertType {
  DuplicateCourse = 'DUPLICATE_COURSE',
  EnrolledCourse = 'ENROLLED_COURSE',
  InactiveCourse = 'INACTIVE_COURSE',
  InProgressCourse = 'IN_PROGRESS_COURSE',
  ItemDoesNotMeetRequirement = 'ITEM_DOES_NOT_MEET_REQUIREMENT',
  ItemMeetsRequirement = 'ITEM_MEETS_REQUIREMENT',
  Requisite = 'REQUISITE',
  TemplateApplied = 'TEMPLATE_APPLIED',
  TemplateMessage = 'TEMPLATE_MESSAGE',
  Unavailable = 'UNAVAILABLE',
  WithdrawnCourse = 'WITHDRAWN_COURSE'
}

/** User object containing the student or admin (non-student) user record */
export type AppUser = {
  __typename?: 'AppUser';
  /** Admin user record */
  adminUser?: Maybe<AdminUser>;
  /** App User Id */
  id: Scalars['Int'];
  /** Admin User Permissions. (eventually to be expanded to be permissions for any type of user) */
  permissions?: Maybe<Array<Maybe<AdminUserPermission>>>;
  /** The users roles */
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Student user record */
  studentUser?: Maybe<StudentUser>;
};

/** The template ID, along with a list of student IDs, and the first term code of their plan */
export type ApplyTemplateInput = {
  /** The unique identifier of the template */
  id: Scalars['ID'];
  /** The first term of the students' plans */
  startTerm: Scalars['String'];
  /** The IDs of the students to which the template should be applied */
  studentIds: Array<Scalars['String']>;
  /** Optional message to add to the created plan when the template is a applied */
  templateMessage?: InputMaybe<Scalars['String']>;
  /** If true, an error will be thrown if there will be inactive courses on the resulting plans */
  throwErrorIfInactiveCourses: Scalars['Boolean'];
};

/** Apply Template response */
export type ApplyTemplateResponse = {
  __typename?: 'ApplyTemplateResponse';
  /** The id that correlates this response with the request */
  correlationId: Scalars['String'];
  /** Why the background job failed. Null unless status is FAILED. */
  failureReason?: Maybe<Scalars['String']>;
  /** The plans that were created by applying the template */
  plansCreated?: Maybe<Array<Plan>>;
  /** The apply template status: RUNNING, COMPLETE, or FAILED */
  status: ApplyTemplateStatus;
  /** The amount of students that this template should be applied to */
  studentCount: Scalars['Int'];
  /** The title of the template that was applied */
  templateTitle: Scalars['String'];
};

/** Possible status for the process of applying a template */
export enum ApplyTemplateStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

/** A skill the Civitas Learning AI assistant can run via slash menu selection */
export type AssistantSkill = {
  __typename?: 'AssistantSkill';
  /** Short human-readable description of what the skill does */
  description: Scalars['String'];
  /** Kebab-case identifier of the skill (e.g. "create-plan") */
  name: Scalars['String'];
};

/** A single event in the assistant response stream */
export type AssistantStreamEvent = {
  __typename?: 'AssistantStreamEvent';
  /** Event payload: text fragment for TOKEN, human-readable label for TOOL_STATUS, error message for ERROR, JSON-encoded ToolUseBlock[] for DOM_TOOL_CALL, JSON-encoded { assistant: ContentBlock[], user: ToolResultBlockParam[] } for TOOL_TURN, null for DONE */
  content?: Maybe<Scalars['String']>;
  /** The event type */
  type: AssistantStreamEventType;
};

/** The type of event emitted by the assistant message stream */
export enum AssistantStreamEventType {
  /** JSON-encoded ToolUseBlock[] for client-side DOM execution; stream ends after this event */
  DomToolCall = 'DOM_TOOL_CALL',
  /** Stream completed — no further events will follow */
  Done = 'DONE',
  /** A human-friendly error message; stream has ended */
  Error = 'ERROR',
  /** A text fragment generated by Claude */
  Token = 'TOKEN',
  /** Human-readable label shown while a tool executes */
  ToolStatus = 'TOOL_STATUS',
  /** JSON-encoded { assistant: ContentBlockParam[], user: ToolResultBlockParam[] } for one server-side tool round; client accumulates these to maintain tool history across DOM interruptions */
  ToolTurn = 'TOOL_TURN'
}

/** A course returned as part of the audit report */
export type AuditCourse = {
  __typename?: 'AuditCourse';
  /** The courseNumber of the course */
  courseNumber: Scalars['String'];
  /** Is the course usedToMeetRequirement in another Requirement */
  courseTakenInReq?: Maybe<Scalars['Boolean']>;
  /** The amount of credits this class is worth */
  credits: Scalars['String'];
  /** Whether the audit course is enrolled/registered */
  enrolled?: Maybe<Scalars['Boolean']>;
  /** The id of the equivalent course group */
  equivalentCourseGroupId?: Maybe<Scalars['String']>;
  /** The exceptions of this course */
  exceptions?: Maybe<Array<Exception>>;
  /** The sis specific id of the course */
  externalCourseId: Scalars['String'];
  /** (DegreeWorks only) whether the course is included in fallThrough */
  fallThrough?: Maybe<Scalars['Boolean']>;
  /** (DegreeWorks only) Code denoting the fallThrough status of this course (ECA-OK vs. ECA-OVERFLOW) */
  fallThroughCode?: Maybe<Scalars['String']>;
  /** The grade the student received from taking this course */
  gradeReceived: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Is this course currently in progress */
  inProgress: Scalars['Boolean'];
  /** (DegreeWorks only) whether the course is included in the insufficient block.  Which includes withdrawn courses */
  insufficient?: Maybe<Scalars['Boolean']>;
  /** (DegreeWorks only) whether the course is included in overTheLimit */
  overTheLimit?: Maybe<Scalars['Boolean']>;
  /** Is the student planning to take this course */
  planned?: Maybe<Scalars['Boolean']>;
  /** The requirement external ID associated with this course */
  requirementExternalId: Scalars['String'];
  /** The requirement group external ID associated with this course */
  requirementGroupExternalId: Scalars['String'];
  /** The requirement group title associated with this course */
  requirementGroupTitle: Scalars['String'];
  /** The title of the requirement line associated with the AuditCourse */
  requirementLineTitle?: Maybe<Scalars['String']>;
  /** The title of the requirement associated with the AuditCourse */
  requirementTitle: Scalars['String'];
  /** The subject id of the course */
  subjectId: Scalars['String'];
  /** The course number of the substitution course */
  substitutionCourseNumber?: Maybe<Scalars['String']>;
  /** The external course id of the substitution course */
  substitutionExternalCourseId?: Maybe<Scalars['String']>;
  /** The subject id of the substitution course */
  substitutionSubjectId?: Maybe<Scalars['String']>;
  /** The term code when this course was taken */
  termCode?: Maybe<Scalars['String']>;
  /** The term description when this course was taken */
  termDescription?: Maybe<Scalars['String']>;
  /** The title of the course */
  title: Scalars['String'];
  /** The topic description */
  topicDescription?: Maybe<Scalars['String']>;
  /** The topic id */
  topicId?: Maybe<Scalars['String']>;
  /** Is course a transfer course */
  transferCourse?: Maybe<Scalars['Boolean']>;
  /** Was this course used to meet the requirement, and therefore the course was completed */
  usedToMeetRequirement: Scalars['Boolean'];
  /** Whether the course was withdrawn by the student */
  withdrawn?: Maybe<Scalars['Boolean']>;
};

/** Error object */
export type AuditError = {
  __typename?: 'AuditError';
  /** The error message */
  message: Scalars['String'];
  /** The type of error (ie: system_unavailable, unknown) */
  type: AuditErrorType;
};

/** The possible types of error encountered while requesting an audit */
export enum AuditErrorType {
  SystemUnavailable = 'SYSTEM_UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

/** The audit report for a student */
export type AuditReport = {
  __typename?: 'AuditReport';
  /** The careers for this student */
  careers: Array<Career>;
  /** The id that correlates the audit response and request */
  correlationId?: Maybe<Scalars['String']>;
  /** The number of courses the student has taken */
  coursesCompleted?: Maybe<Scalars['Int']>;
  /** The number of courses that are in progress */
  coursesInProgress?: Maybe<Scalars['Int']>;
  /** The total number of courses required */
  coursesRequired?: Maybe<Scalars['Int']>;
  /** The number of credits the student has earned */
  creditsEarned?: Maybe<Scalars['Int']>;
  /** The total number of credits required */
  creditsRequired?: Maybe<Scalars['Int']>;
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** The institution this audit is for/from */
  institution: Scalars['String'];
  /** Flag to denote if this audit was a what-if audit report */
  isWhatIf: Scalars['Boolean'];
  /** The appUserId of the user that requested the audit be generated */
  requestedByAppUserId?: Maybe<Scalars['String']>;
  /** The name of the user that requested the audit be generated */
  requesterUserName?: Maybe<Scalars['String']>;
  /** The date and time at which the audit report was ran */
  runDate: Scalars['DateTime'];
  /** The unique identifier of the student */
  studentId?: Maybe<Scalars['String']>;
  /** The career criteria used to run if this was a what-if report */
  whatIfCareer?: Maybe<Scalars['String']>;
  /** The catalogYear criteria used to run if this was a what-if report */
  whatIfCatalogYear?: Maybe<Scalars['String']>;
  /** The degree criteria used to run if this was a what-if report */
  whatIfDegree?: Maybe<Scalars['String']>;
  /** The program stack criteria used to run if this was a what-if report */
  whatIfProgramStacks: Array<WhatIfProgramStack>;
};

/** The input object used for requesting an audit run */
export type AuditRequestInput = {
  /** The environment of the application (for example: demo) */
  environment: Scalars['String'];
  /** The type of report this audit should be run for */
  reportType?: InputMaybe<Scalars['String']>;
  /** The student app user id for whom this audit should be run for */
  studentAppUserId: Scalars['Int'];
};

/** The audit response from the bridge */
export type AuditResponse = {
  __typename?: 'AuditResponse';
  /** The audit report information from the sis */
  auditReport?: Maybe<AuditReport>;
  /** The id that correlates this response with the request */
  correlationId: Scalars['String'];
  /** Any errors from making the audit request */
  errors?: Maybe<Array<AuditError>>;
};

/** Audit System to fetch the audit from */
export enum AuditSystem {
  Degreeworks = 'DEGREEWORKS',
  None = 'NONE',
  Peoplesoft = 'PEOPLESOFT'
}

/** Settings to control the authentication process */
export type AuthSettings = {
  __typename?: 'AuthSettings';
  /** Whether or not to allow federated logout */
  enableStudentAppFederatedLogout: Scalars['Boolean'];
  /** Student App Login Options to control which auth0 connections to use per option */
  studentAppAuth0LoginOptions: Array<StudentAppAuth0LoginOption>;
  /** Defines the type of provider */
  studentAppProvider: StudentAppAuthProviderType;
};

/** The input object used for creating admin users in batch */
export type BatchCreateAdminUsersInput = {
  users: Array<AdminUserInput>;
};

/** The response object for creating admin users in batch */
export type BatchCreateAdminUsersResponse = {
  __typename?: 'BatchCreateAdminUsersResponse';
  createdUsers: Array<AdminUser>;
  failedUsers: Array<BatchFailedAdminUser>;
  updatedUsers: Array<AdminUser>;
};

/** User profile that failed to be created. */
export type BatchFailedAdminUser = {
  __typename?: 'BatchFailedAdminUser';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

/** Response when starting a bulk lock operation */
export type BulkLockJobResponse = {
  __typename?: 'BulkLockJobResponse';
  /** Unique identifier for the job */
  jobId: Scalars['String'];
  /** Informational message about the job */
  message: Scalars['String'];
};

/** Status information for a bulk lock job */
export type BulkLockJobStatus = {
  __typename?: 'BulkLockJobStatus';
  /** When the job completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** List of errors encountered during processing */
  errors: Array<Scalars['String']>;
  /** Unique identifier for the job */
  jobId: Scalars['String'];
  /** Number of plans locked */
  lockedPlans: Scalars['Int'];
  /** Number of students processed so far */
  processedStudents: Scalars['Int'];
  /** When the job started */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the job */
  status: BulkLockJobStatusEnum;
  /** Total number of students to process */
  totalStudents: Scalars['Int'];
};

/** The status of a bulk lock job */
export enum BulkLockJobStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Response when starting a bulk read-only reset operation */
export type BulkReadOnlyJobResponse = {
  __typename?: 'BulkReadOnlyJobResponse';
  /** Unique identifier for the job */
  jobId: Scalars['ID'];
  /** Informational message about the job */
  message: Scalars['String'];
};

/** Status information for a bulk read-only reset job */
export type BulkReadOnlyJobStatus = {
  __typename?: 'BulkReadOnlyJobStatus';
  /** When the job completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Environment being processed */
  env: Scalars['String'];
  /** List of errors encountered during processing */
  errors: Array<Scalars['String']>;
  /** Number of plans that failed processing */
  failedPlans: Scalars['Int'];
  /** Unique identifier for the job */
  jobId: Scalars['ID'];
  /** Number of plans processed so far */
  processedPlans: Scalars['Int'];
  /** When the job started */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the job */
  status: BulkReadOnlyJobStatusEnum;
  /** Total number of plans to process */
  totalPlans: Scalars['Int'];
};

/** The status of a bulk read-only reset job */
export enum BulkReadOnlyJobStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Campus */
export type Campus = {
  __typename?: 'Campus';
  /** Code of the campus */
  code: Scalars['String'];
  /** Description of the campus */
  description: Scalars['String'];
  /** Unique identifier for the campus */
  id: Scalars['ID'];
};

/** The students career (undergrad, grad, etc) */
export type Career = {
  __typename?: 'Career';
  /** The description of the career */
  description: Scalars['String'];
  /** Fall Through Courses (DegreeWorks only) */
  fallThroughCourses?: Maybe<Array<Maybe<AuditCourse>>>;
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Insufficient Courses (DegreeWorks only) */
  insufficientCourses?: Maybe<Array<Maybe<AuditCourse>>>;
  /** Over The Limit Courses (DegreeWorks only) */
  overTheLimitCourses?: Maybe<Array<Maybe<AuditCourse>>>;
  /** Programs related to this career */
  programs?: Maybe<Array<Maybe<DegreeProgram>>>;
  /** The requirements needed to complete this career */
  requirementGroups?: Maybe<Array<RequirementGroup>>;
  /** The title of the career */
  title: Scalars['String'];
};

/** Career Term Enroll Date */
export type CareerTermEnrollDate = {
  __typename?: 'CareerTermEnrollDate';
  /** The code of the career */
  careerCode?: Maybe<Scalars['String']>;
  /** The description of the career */
  careerDescription?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The enrollment begin date */
  termEnrollBegin?: Maybe<Scalars['String']>;
  /** The enrollment end date */
  termEnrollEnd?: Maybe<Scalars['String']>;
};

/** Cart Customization Center Settings */
export type CartSettings = {
  __typename?: 'CartSettings';
  /** Shopping cart label. */
  cartLabel: Scalars['String'];
};

/** A course from the catalog */
export type CatalogCourse = {
  __typename?: 'CatalogCourse';
  /** Campus code for the course */
  campus?: Maybe<Scalars['String']>;
  /** Campus description for the course */
  campusDescription?: Maybe<Scalars['String']>;
  /** The career for this course */
  career?: Maybe<Scalars['String']>;
  /** Whether the course is printed on the catalog. PeopleSoft only. */
  catalogPrint: Scalars['Boolean'];
  /** Course number, i.e. 101 or 204A */
  courseNumber: Scalars['String'];
  /** Maximum number of credits awarded by the course */
  creditsMax: Scalars['Float'];
  /** Minimum number of credits awarded by the course */
  creditsMin: Scalars['Float'];
  /** Description of the course */
  description: Scalars['String'];
  /** Environment associated with this course */
  environment: Scalars['String'];
  /** The course's ID in the SIS */
  externalCourseId: Scalars['String'];
  /** Unique identifier of the course */
  id: Scalars['ID'];
  /** Whether this course is in progress */
  inProgress?: Maybe<Scalars['Boolean']>;
  /** Institution associated with the offering. PeopleSoft only. */
  institution: Scalars['String'];
  /** The titles of the requirements met by this course */
  requirementTitles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The description of prereq/coreq for this course */
  requisiteDescription?: Maybe<Scalars['String']>;
  /** The long description of the prereq/coreq for this course */
  requisiteDescriptionLong?: Maybe<Scalars['String']>;
  /** Description of the subject associated with the offering */
  subjectDescription: Scalars['String'];
  /** ID of the subject associated with the course */
  subjectId: Scalars['String'];
  /** Title of the course */
  title: Scalars['String'];
  /** When the course is typically offered */
  typicallyOffered?: Maybe<Scalars['String']>;
  /** Whether this course is used to meet a requirement */
  usedToMeetRequirement?: Maybe<Scalars['Boolean']>;
};

/** The change log object mapped from the result of the rest api */
export type ChangeLog = {
  __typename?: 'ChangeLog';
  /** The appUserId of the user that made the change */
  changedByAppUserId: Scalars['Int'];
  /** The timestamp of when this change was made */
  changedTimestamp: Scalars['DateTime'];
  /** User friendly description of the change */
  description: Scalars['String'];
  /** The affected group id */
  groupId?: Maybe<Scalars['String']>;
  /** The unique identifier of the change log entry */
  id: Scalars['ID'];
  /** The affect item id */
  itemId?: Maybe<Scalars['String']>;
  /** The id of the plan where this change occurred */
  planId: Scalars['String'];
};

export type ChangeLogConnection = {
  __typename?: 'ChangeLogConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ChangeLogEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
};

export type ChangeLogEdge = {
  __typename?: 'ChangeLogEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: ChangeLog;
};

/** College */
export type College = {
  __typename?: 'College';
  /** Code of the college */
  code: Scalars['String'];
  /** Description of the college */
  description: Scalars['String'];
  /** Unique identifier for the college */
  id: Scalars['ID'];
  /** Short description of the college */
  shortDescription?: Maybe<Scalars['String']>;
};

/** The comment object mapped from the result of the rest api */
export type Comment = {
  __typename?: 'Comment';
  /** The comment text itself */
  comment: Scalars['String'];
  /** The timestamp of when this comment was added */
  createdAt: Scalars['DateTime'];
  /** The appUserId of the writer/creator of the comment */
  createdByAppUserId: Scalars['Int'];
  /** The name of the writer/creator of this comment. This will only be populated if the name exists for the user */
  creatorName?: Maybe<Scalars['String']>;
  /** The identifier of the PlanGroup (aka term) that this comment is associated with */
  groupId: Scalars['String'];
  /** The unique identifier of the comment */
  id: Scalars['ID'];
  /** The identifier of the Plan that the group belongs to */
  planId: Scalars['String'];
  /** Flag to denote whether or not the logged in user has read this comment */
  read: Scalars['Boolean'];
  /** The timestamp of when the logged in user read this comment */
  readTimestamp?: Maybe<Scalars['DateTime']>;
};

/** Completed Course Preference for moving completed courses to scheduler */
export type CompletedCoursePreference = {
  /** The course number of the course */
  courseNumber: Scalars['String'];
  /** The id of the plan that this course belongs to */
  planId: Scalars['String'];
  /** A flag for whether or not this course should be included in scheduler */
  schedulerInclude?: InputMaybe<Scalars['Boolean']>;
  /** The subject id of the course */
  subject: Scalars['String'];
  /** The termCode for the term that this course was taken in */
  termCode: Scalars['String'];
};

/** Completed Course Preference for moving completed courses to scheduler */
export type CompletedCoursePreferenceInput = {
  /** The appUserId of the student whose courses are moving into scheduler */
  appUserId: Scalars['Float'];
  /** The completed courses for the student moving into scheduler */
  completedCoursePreferences: Array<CompletedCoursePreference>;
};

/** Concentration */
export type Concentration = {
  __typename?: 'Concentration';
  /** Career that the concentration belongs to */
  career?: Maybe<Scalars['String']>;
  /** Code of the concentration */
  code: Scalars['String'];
  /** The degree associated with the concentration */
  degree?: Maybe<Scalars['String']>;
  /** Description of the concentration */
  description: Scalars['String'];
  /** Unique identifier for the concentration */
  id: Scalars['ID'];
  /** The major associated with the concentration */
  major: Scalars['String'];
  /** The minor associated with the concentration */
  minor: Scalars['String'];
  /** Program that the concentration is in */
  program?: Maybe<Scalars['String']>;
  /** Short description of the concentration */
  shortDescription?: Maybe<Scalars['String']>;
};

/** Response for copying all published templates */
export type CopyAllPublishedTemplatesResponse = {
  __typename?: 'CopyAllPublishedTemplatesResponse';
  /** The number of templates that were successfully copied */
  copiedCount: Scalars['Int'];
  /** Message describing the result of the operation */
  message: Scalars['String'];
  /** The templates that were successfully copied */
  plans?: Maybe<Array<Maybe<Plan>>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean'];
};

/** Response object with a correlationId; typically returned via pubsub from microservice (ie: sis-bridge-service, or plan-service) */
export type CorrelatableResponse = {
  __typename?: 'CorrelatableResponse';
  /** A unique id to correlate the bridge request with the response */
  correlationId: Scalars['String'];
};

/** Course */
export type Course = {
  __typename?: 'Course';
  /** Course Number */
  courseNumber: Scalars['String'];
  /** Course Description */
  description: Scalars['String'];
  /** Environment */
  environment: Scalars['String'];
  /** External unique ID */
  externalCourseId: Scalars['String'];
  /** Internal unique ID */
  id: Scalars['ID'];
  /** Subject ID */
  subjectId: Scalars['String'];
  /** Title */
  title: Scalars['String'];
  /** When the course is typically offered */
  typicallyOffered: Scalars['String'];
};

/** The course availability status of a plan item. */
export enum CourseAvailability {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

/** specific options for course history progress summary */
export enum CourseHistoryProgressSummaryOption {
  CourseWithdrawals = 'COURSE_WITHDRAWALS',
  InProgressUnits = 'IN_PROGRESS_UNITS',
  TotalEarnedUnits = 'TOTAL_EARNED_UNITS',
  TransferUnits = 'TRANSFER_UNITS'
}

/** Course Instructor */
export type CourseInstructor = {
  __typename?: 'CourseInstructor';
  /** External Id of the course from the sis */
  courseExternalId: Scalars['String'];
  /** The externalId of the instructor */
  facultyExternalId?: Maybe<Scalars['String']>;
  /** The first name of the instructor */
  instructorFirstName?: Maybe<Scalars['String']>;
  /** The last name of the instructor */
  instructorLastName?: Maybe<Scalars['String']>;
  /** The timestamp of when this data was inserted */
  lastSyncTimestamp: Scalars['DateTime'];
  /** The term season when the course was taken, for example: Fall, Spring, Summer */
  season?: Maybe<Scalars['String']>;
  /** ExternalId of the section */
  sectionExternalId?: Maybe<Scalars['String']>;
  /** The year when the course was taken */
  year?: Maybe<Scalars['Int']>;
};

/** Course Search Customization Center Settings */
export type CourseSearchSettings = {
  __typename?: 'CourseSearchSettings';
  /** Which fields to display on the course search result list */
  courseFields: Array<Scalars['String']>;
  /** Which filters and facets to display */
  courseSearchFilters: Array<Scalars['String']>;
  /** List of footer entries that may contain html links */
  footerEntries: Array<Scalars['String']>;
  /** Custom links included in the header */
  headerLinks: Array<LinkSettings>;
  /** Label for scheduler link */
  plannerLinkText: Scalars['String'];
  /** Text in the course search field when nothing has been entered */
  searchPlaceholder: Scalars['String'];
  /** Which fields to display when viewing a course sections */
  sectionFields: Array<Scalars['String']>;
  /** list of entries displayed when you expand section details */
  sectionFooterEntries: Array<Scalars['String']>;
};

/** Course Customization Center Settings */
export type CourseSettings = {
  __typename?: 'CourseSettings';
  /** Does the sis support topics. Topics include an additional selection in addition to subject and course. */
  topicsEnabled: Scalars['Boolean'];
};

/** Input object used to create a comment */
export type CreateCommentInput = {
  /** The comment text itself */
  comment: Scalars['String'];
  /** The identifier of the PlanGroup (aka term) that this comment is associated with */
  groupId: Scalars['String'];
};

/** The input object used for creating item major linking rows */
export type CreateItemMajorInput = {
  /** The id of the item */
  itemId: Scalars['String'];
  /** The major code to link to the item */
  majorCode: Scalars['String'];
};

/** The input object used for creating item minor linking rows */
export type CreateItemMinorInput = {
  /** The id of the item */
  itemId: Scalars['String'];
  /** The minor code to link to the item */
  minorCode: Scalars['String'];
};

/** The input object used for creating groups for a plan */
export type CreatePlanGroupInput = {
  /** The sequence / position within the plan */
  displaySequence?: InputMaybe<Scalars['Int']>;
  /** The id to link the codified term with the group */
  externalTermId?: InputMaybe<Scalars['String']>;
  /** The id of the plan that this group is assigned to */
  planId: Scalars['String'];
  /** The term type associated with this group, i.e. "Fall" or "Spring" */
  termType?: InputMaybe<Scalars['String']>;
  /** The title of the group */
  title?: InputMaybe<Scalars['String']>;
};

/** The input object used for creating plans */
export type CreatePlanInput = {
  /** The campus identifier associated with the template */
  campusCode?: InputMaybe<Scalars['String']>;
  /** The catalog year associated with this template */
  catalogYear?: InputMaybe<Scalars['String']>;
  /** The catalog year description, such as 2020-2021 */
  catalogYearDescription?: InputMaybe<Scalars['String']>;
  /** The college identifier associated with this template */
  collegeCode?: InputMaybe<Scalars['String']>;
  /** The concentration associated with this template */
  concentrationCode?: InputMaybe<Scalars['String']>;
  /** The degree identifier associated with this template */
  degreeCode?: InputMaybe<Scalars['String']>;
  /** A description of the template */
  description?: InputMaybe<Scalars['String']>;
  /** Groups to initialize with newly created plan. */
  groups?: InputMaybe<Array<NewPlanGroupInput>>;
  /** A flag to denote is this is the owner's primary plan. Only one plan can be marked as primary */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  /** A flag to denote whether this plan is public */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan is a template. Default to true when creating a template */
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  /** The appUserId of the  owner of the plan or template. Defaults to the logged in user if not populated */
  ownerAppUserId?: InputMaybe<Scalars['Int']>;
  /** The plan id that this plan was copied / created from */
  sourcePlanId?: InputMaybe<Scalars['String']>;
  /** Whether the template is a draft, published, or archived */
  status?: InputMaybe<TemplateStatus>;
  /** The title of the plan */
  title?: InputMaybe<Scalars['String']>;
};

/** The input object used for creating items */
export type CreatePlanItemInput = {
  /** The internal id of the course */
  courseId?: InputMaybe<Scalars['String']>;
  /** The courseNumber associated with this item */
  courseNumber?: InputMaybe<Scalars['String']>;
  /** Maximum amount of credits for this course */
  creditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum amount of credits for this course */
  creditsMin?: InputMaybe<Scalars['Float']>;
  /** The description of an item */
  description?: InputMaybe<Scalars['String']>;
  /** The externalCourseId of the course; should be the same as the externalCourseId in catalogCourse from the sis-data-service */
  externalCourseId?: InputMaybe<Scalars['String']>;
  /** The groupId that this item is assigned to; null if the item is not assigned to a group */
  groupId?: InputMaybe<Scalars['String']>;
  /** Maximum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMin?: InputMaybe<Scalars['Float']>;
  /** The title of an item, if this item is either a placeholder or non-codified course */
  nonCourseTitle?: InputMaybe<Scalars['String']>;
  /** The planId that this item is assigned to */
  planId: Scalars['String'];
  /** The subjectId associated with this item */
  subjectId?: InputMaybe<Scalars['String']>;
  /** The title of the item */
  title?: InputMaybe<Scalars['String']>;
};

/** The input object used for creating plan major linking rows */
export type CreatePlanMajorInput = {
  /** The major code to link to the plan */
  majorCode: Scalars['String'];
  /** The id of the plan */
  planId: Scalars['String'];
};

/** The input object used for creating plan minor linking rows */
export type CreatePlanMinorInput = {
  /** The minor code to link to the plan */
  minorCode: Scalars['String'];
  /** The id of the plan */
  planId: Scalars['String'];
};

export type CreateSchedulerLoginInput = {
  studentAppUserId?: InputMaybe<Scalars['String']>;
};

export type CreateSchedulerLoginResponse = {
  __typename?: 'CreateSchedulerLoginResponse';
  key: Scalars['String'];
};

export type CreateUsersInput = {
  /** Unique identifier for the advisor from external system */
  advisorId?: InputMaybe<Scalars['String']>;
  /** Display Name */
  displayName?: InputMaybe<Scalars['String']>;
  /** Email */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** Unique identifier for the user from external system */
  externalId?: InputMaybe<Scalars['String']>;
  /** Roles for the user from external system */
  externalRoles?: InputMaybe<Scalars['String']>;
  /** First Name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']>;
  /** User Picture */
  picture?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the student from external system */
  studentId?: InputMaybe<Scalars['String']>;
  /** JWT Subject Identifier */
  sub?: InputMaybe<Scalars['String']>;
};

/** The response from the createUsers call */
export type CreateUsersResponse = {
  __typename?: 'CreateUsersResponse';
  /** Unique identifier for the user */
  appUserId?: Maybe<Scalars['Int']>;
  /** Permissions list for the user */
  effectivePermissions?: Maybe<Array<AdminUserPermission>>;
  /** User's first name */
  firstName?: Maybe<Scalars['String']>;
  /** User's last name */
  lastName?: Maybe<Scalars['String']>;
};

/** Detailed information on a list of students and their credit counts for a given term. */
export type CreditCountDetail = {
  __typename?: 'CreditCountDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** Students last name */
  lastName: Scalars['String'];
  /** Maximum number of credits possible for the term. */
  maxCredits?: Maybe<Scalars['Float']>;
  /** Minimum number of credits possible for the term. */
  minCredits?: Maybe<Scalars['Float']>;
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
};

export type CreditCountDetailEdge = {
  __typename?: 'CreditCountDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: CreditCountDetail;
};

/** Detailed count information for the selected term credits. */
export type CreditCounts = {
  __typename?: 'CreditCounts';
  /** The count of students who have four to six credits. */
  fourToSixCredits: Scalars['Int'];
  /** The count of students who have no credits. */
  noCredits: Scalars['Int'];
  /** The count of students who have seven to nine credits. */
  sevenToNineCredits: Scalars['Int'];
  /** The count of students who have 16 or more credits. */
  sixteenPlusCredits: Scalars['Int'];
  /** The count of students who have 10 to 12 credits. */
  tenToTwelveCredits: Scalars['Int'];
  /** The count of students who have 13 to 15 credits. */
  thirteenToFifteenCredits: Scalars['Int'];
  /** The count of students who have zero to three credits. */
  zeroToThreeCredits: Scalars['Int'];
};

/** Degree */
export type Degree = {
  __typename?: 'Degree';
  /** Code of the degree */
  code: Scalars['String'];
  /** Description of the degree */
  description: Scalars['String'];
  /** Unique identifier for the degree */
  id: Scalars['ID'];
  /** Short description of the degree */
  shortDescription?: Maybe<Scalars['String']>;
};

/** The students plan (or major) */
export type DegreePlan = {
  __typename?: 'DegreePlan';
  /** The plan code */
  code: Scalars['String'];
  /** The description or title of the plan */
  description: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether all the requirements in this plan have been met */
  met: Scalars['Boolean'];
  /** Sub plans related to this plan */
  subPlans?: Maybe<Array<Maybe<DegreeSubPlan>>>;
  /** The type of this plan (ie: Major, Minor) */
  type?: Maybe<DegreePlanType>;
};

/** Degree plan course */
export type DegreePlanCourse = {
  __typename?: 'DegreePlanCourse';
  /** Additional data specific to the SIS.  In json format, but is a Map<string, string> on the backend */
  additionalData?: Maybe<Scalars['JSON']>;
  /** The description of the course */
  description?: Maybe<Scalars['String']>;
  /** The unique id */
  id?: Maybe<Scalars['ID']>;
  /** The institution code */
  institutionCode?: Maybe<Scalars['String']>;
  /** The name of the course */
  name?: Maybe<Scalars['String']>;
  /** The course number */
  number?: Maybe<Scalars['String']>;
  /** The requirement id */
  requirementId?: Maybe<Scalars['String']>;
  /** The course subject */
  subject?: Maybe<Scalars['String']>;
  /** The term for the course */
  term?: Maybe<Scalars['String']>;
  /** The term code for the course */
  termCode?: Maybe<Scalars['String']>;
  /** The topic */
  topic?: Maybe<Scalars['String']>;
  /** The topic id */
  topicId?: Maybe<Scalars['String']>;
};

/** Degree plan placeholder */
export type DegreePlanPlaceHolder = {
  __typename?: 'DegreePlanPlaceHolder';
  /** The description of the placeholder */
  description?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The name of the placeholder */
  name?: Maybe<Scalars['String']>;
  /** The requirement id */
  requirementId?: Maybe<Scalars['String']>;
  /** The term for the placeholder */
  term?: Maybe<Scalars['String']>;
  /** The term code for the placeholder */
  termCode?: Maybe<Scalars['String']>;
};

/** The type of plan this is */
export enum DegreePlanType {
  Major = 'MAJOR',
  Minor = 'MINOR'
}

/** The students program */
export type DegreeProgram = {
  __typename?: 'DegreeProgram';
  /** The program code */
  code: Scalars['String'];
  /** The description or title of the program */
  description: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether all the requirements in this program have been met */
  met: Scalars['Boolean'];
  /** Plans related to this program */
  plans?: Maybe<Array<Maybe<DegreePlan>>>;
};

export enum DegreeRequirementsPanelConfiguration {
  Disabled = 'DISABLED',
  EnabledWithExternalLink = 'ENABLED_WITH_EXTERNAL_LINK',
  EnabledWithIntegration = 'ENABLED_WITH_INTEGRATION'
}

/** The students sub plan (ie: concentration) */
export type DegreeSubPlan = {
  __typename?: 'DegreeSubPlan';
  /** The sub plan code */
  code: Scalars['String'];
  /** The description or title of the sub plan */
  description: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether all the requirements in this sub plan have been met */
  met: Scalars['Boolean'];
};

/** ETL logs for schedule and open seat updates and ties to the actual process. If there is a start date but no end date then either the process is running or it timed out. */
export type DiagnosticLog = {
  __typename?: 'DiagnosticLog';
  /** When the event ended. If the process failed this may be empty. */
  endDate: Scalars['Timestamp'];
  /** Uniquely generated id */
  id: Scalars['Int'];
  /** Message about the log. When the schedule updated or there was an error */
  message: Scalars['String'];
  /** When the event started */
  startDate: Scalars['Timestamp'];
};

export type DiagnosticLogEdge = {
  __typename?: 'DiagnosticLogEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: DiagnosticLog;
};

export type DiagnosticLogPagedResult = {
  __typename?: 'DiagnosticLogPagedResult';
  /** Which page is currently displayed */
  page: Scalars['Int'];
  /** What is the current page size */
  pageSize: Scalars['Int'];
  /** How many total results where found */
  resultCount: Scalars['Int'];
  /** Resulting paged diagnostic logs */
  results: Array<DiagnosticLog>;
  /** What is the current sort key */
  sortKey: Scalars['String'];
};

export type DiagnosticLogPagedResultInput = {
  /** Filter logs results by start date */
  endDate?: InputMaybe<Scalars['Timestamp']>;
  /** Which page worth of results to view */
  page?: InputMaybe<Scalars['Int']>;
  /** How many results to return per page */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Which field to sort by */
  sortKey?: InputMaybe<Scalars['String']>;
  /** Should results  be sorted ASC or DESC */
  sortOrder?: InputMaybe<SortOrder>;
  /** Filter logs results by start date */
  startDate?: InputMaybe<Scalars['Timestamp']>;
  /** Which events should be included in the results */
  types?: InputMaybe<Array<DiagnosticLogType>>;
};

/** Log types define different log events. */
export enum DiagnosticLogType {
  Catalog = 'CATALOG',
  EmptyOpenSeat = 'EMPTY_OPEN_SEAT',
  OpenSeat = 'OPEN_SEAT',
  Other = 'OTHER',
  Schedule = 'SCHEDULE'
}

/** The input object used for dismissing an alert */
export type DismissAlertInput = {
  /** The unique key of the alert. A concatenation of type and all associated Item IDs. */
  alertKey: Scalars['String'];
  /** The alert type. */
  alertType: AlertType;
  /** Optional item ID associated with the alert */
  itemId?: InputMaybe<Scalars['String']>;
  /** The plan ID */
  planId: Scalars['String'];
};

export type DismissedPlanAlert = {
  __typename?: 'DismissedPlanAlert';
  /** The unique key for the dismissed alert. A concatenation of type and all associated Item IDs. */
  alertKey: Scalars['String'];
  /** The alert type. */
  alertType: AlertType;
  /** When the alert was dismissed. */
  dismissedAt: Scalars['DateTime'];
  /** The plan ID of the dismissed alert */
  planId: Scalars['String'];
};

/** An object describing the enrollment status of a course, including the associated term code and description */
export type EnrollmentStatus = {
  __typename?: 'EnrollmentStatus';
  /** Whether the student is enrolled in the course */
  enrolled?: Maybe<Scalars['Boolean']>;
  /** The term code of the term in which the course is enrolled */
  termCode?: Maybe<Scalars['String']>;
  /** The description of the term in which the course is enrolled */
  termDescription?: Maybe<Scalars['String']>;
};

/** The student exception */
export type Exception = {
  __typename?: 'Exception';
  /** The exception additional information */
  additionalInformation: Scalars['String'];
  /** The exception apply status */
  applyStatus: Scalars['String'];
  /** The courseNumber of the exception course */
  courseNumberBegin: Scalars['String'];
  /** The datetime when the exception was created */
  createdDate: Scalars['DateTime'];
  /** The email who created the exception */
  createdEmail: Scalars['String'];
  /** The name who created the exception */
  createdName: Scalars['String'];
  /** The code of the degree; degree works specific */
  degree: Scalars['String'];
  /** The details of the exception */
  details: Scalars['String'];
  /** Is the details of the exception hidden */
  detailsHidden: Scalars['Boolean'];
  /** The enforced of the exception */
  enforced: Scalars['String'];
  /** The type of the exception (ie: AA, AH, FC, NN, RR) */
  exceptionType: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** The label tag of the exception */
  labelTag: Scalars['String'];
  /** The reason of the exception */
  reason: Scalars['String'];
  /** The remark of the exception */
  remark: Scalars['String'];
  /** The school of the exception */
  school: Scalars['String'];
  /** The status of the exception */
  status: Scalars['String'];
  /** The subject id of the exception course */
  subjectId: Scalars['String'];
  /** The title of the exception */
  title: Scalars['String'];
  /** The user last of the exception */
  userLast: Scalars['String'];
};

/** Faculty */
export type Faculty = {
  __typename?: 'Faculty';
  /** The email of the faculty member */
  email?: Maybe<Scalars['String']>;
  /** The externalId of the faculty member from the sis */
  externalId: Scalars['String'];
  /** The firstName of the faculty member */
  firstName: Scalars['String'];
  /** The lastName of the faculty member */
  lastName: Scalars['String'];
};

/** Filter for the student */
export type Filter = {
  __typename?: 'Filter';
  /** The filter code */
  code?: Maybe<Scalars['String']>;
  /** The filter type */
  filterType?: Maybe<FilterType>;
  /** The unique id */
  id: Scalars['ID'];
};

export enum FilterType {
  Campus = 'CAMPUS'
}

/** Help Link Settings */
export type HelpLink = {
  __typename?: 'HelpLink';
  /** Description of the help link */
  description: Scalars['String'];
  /** Unique help link key */
  key: Scalars['String'];
  /** Title of the help link */
  title: Scalars['String'];
  /** Url of the help link */
  url: Scalars['String'];
};

/** Help settings and custom links */
export type HelpSettings = {
  __typename?: 'HelpSettings';
  /** List of custom links to show on the help page */
  links: Array<HelpLink>;
  /** List of videos with description and urls to display */
  videos: Array<HelpVideo>;
};

/** Help Video Settings */
export type HelpVideo = {
  __typename?: 'HelpVideo';
  /** Description of the help video */
  description: Scalars['String'];
  /** Unique video key */
  key: Scalars['String'];
  /** Label for how difficult the video content is */
  skillLevel: Scalars['String'];
  /** Sub text of description */
  subText: Scalars['String'];
  /** Url of the help video */
  url: Scalars['String'];
};

/** Hold that the student has */
export type Hold = {
  __typename?: 'Hold';
  /** The hold code */
  code?: Maybe<Scalars['String']>;
  /** The hold description */
  description?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** Instructions for the hold */
  instructions?: Maybe<Scalars['String']>;
  /** The hold type */
  type?: Maybe<Scalars['String']>;
};

/** Home settings */
export type HomeSettings = {
  __typename?: 'HomeSettings';
  /** Custom Header Link Text Setting */
  customLinkText: Scalars['String'];
  /** Custom Header Link URL Setting */
  customLinkUrl: Scalars['String'];
  /** Help Text Setting */
  helpText: Scalars['String'];
  /** Help URL Settings */
  helpUrl: Scalars['String'];
  /** Text to display on the sign out button */
  signoutText: Scalars['String'];
};

export enum IdentifierType {
  Pidm = 'PIDM'
}

/** Detailed information on a list of incoming students who have not created plans. */
export type IncomingNoPlanDetail = {
  __typename?: 'IncomingNoPlanDetail';
  /** The programs belonging to the student. */
  academicPrograms?: Maybe<Array<Maybe<StudentAcademicProgram>>>;
  /** Student's first name */
  firstName: Scalars['String'];
  /** Student's last name */
  lastName: Scalars['String'];
  /** Student's appUserId */
  studentAppUserId: Scalars['Int'];
  /** Student's external id from the sis */
  studentId: Scalars['String'];
};

export type IncomingNoPlanDetailEdge = {
  __typename?: 'IncomingNoPlanDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: IncomingNoPlanDetail;
};

/** Settings for interaction with the sis. These are optionally controlled by the client. */
export type IntegrationField = {
  __typename?: 'IntegrationField';
  /** The label / description of the field being displayed. For example Gateway Url */
  description: Scalars['String'];
  /** Which integration setting does this apply to. For example gatewayUrl */
  key: Scalars['String'];
};

/** Settings for interaction with the sis. These are optionally controlled by the client. */
export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the academic structure data (sometimes called templateData) */
  academicStructureRequestPath: Scalars['String'];
  /** The additional report types to run when making the audit request for peoplesoft */
  additionalAuditReportTypes: Array<AdditionalAuditReportType>;
  /** Type of audit report to be run; value configurable in peoplesoft */
  auditReportType: Scalars['String'];
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the audit */
  auditRequestPath: Scalars['String'];
  /** The system used to retrieve the audit; PeopleSoft, Degree Works, or None. */
  auditSystem: AuditSystem;
  /** Controls if ETL process will run. If disabled requests to the ETL process will be ignored. */
  automaticUpdates: Scalars['Boolean'];
  /** Basic Auth password set? Used in multi-tenant bridge for calls via RestUrl (anything other than SendToCart) */
  basicAuthPasswordSet: Scalars['Boolean'];
  /** Basic Auth username used in multi-tenant bridge for calls via RestUrl (anything other than SendToCart) */
  basicAuthUsername: Scalars['String'];
  /** The soap action included in the header of the soap request to fetch courses from the sis. */
  courseListingSoapAction: Scalars['String'];
  /** Optionally if send to cart should point to a different url then the gateway / registration url */
  customSendToCartUrl: Scalars['String'];
  /** Data service db name used with colleague */
  dataServiceDbName: Scalars['String'];
  /** Is data service password set for use with colleague */
  dataServicePasswordSet: Scalars['Boolean'];
  /** Data service user name used with colleague */
  dataServiceUserName: Scalars['String'];
  /** The location of the sis to retrieve data. This may be called registrationUrl for some sis's */
  gatewayUrl: Scalars['String'];
  /** Peoplesoft institution; needed for retrieving the students audit report */
  institution: Scalars['String'];
  /** All the integration settings listed out as a description and a type. Used in diagnostics to decide what to display and what labels to use. */
  integrationFields: Array<IntegrationField>;
  /** Typically used in conjunction with Rest URL */
  nodeName: Scalars['String'];
  /** Used for workday to point to the correct open seat url path */
  openSeatsReportPath: Scalars['String'];
  /** The integration gateway path used for pulling planning catalog data from the SIS. */
  planningCatalogRequestPath: Scalars['String'];
  /** The integration gateway path used for pulling term data from the SIS. */
  planningTermRequestPath: Scalars['String'];
  /** Typically used for peoplesoft to set rest end point for multi-tenant bridge student data pull only for cas and SAML and sample login */
  registrationUrl: Scalars['String'];
  /** Url used for peoplesoft rest gateway */
  restGatewayUrl: Scalars['String'];
  /** The soap action used for sending to cart included in the header of the soap request to fetch courses from the sis. */
  sendToCartSoapAction: Scalars['String'];
  /** The report type for the what-if audit; value configurable in peoplesoft */
  whatIfAuditReportType: Scalars['String'];
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the what-if audit */
  whatIfAuditRequestPath: Scalars['String'];
};

/** Settings for interaction with the sis. These are optionally controlled by the client. */
export type IntegrationSettingsInput = {
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the academic structure data (sometimes called templateData) */
  academicStructureRequestPath?: InputMaybe<Scalars['String']>;
  /** Type of audit report to be run; value configurable in peoplesoft */
  auditReportType?: InputMaybe<Scalars['String']>;
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the audit */
  auditRequestPath?: InputMaybe<Scalars['String']>;
  /** The system used to retrieve the audit; PeopleSoft, Degree Works, or None. */
  auditSystem?: InputMaybe<AuditSystem>;
  /** Controls if ETL process will run. If disabled requests to the ETL process will be ignored. */
  automaticUpdates?: InputMaybe<Scalars['Boolean']>;
  /** Basic Auth password used in multi-tenant bridge for calls via RestUrl (anything other than SendToCart) */
  basicAuthPassword?: InputMaybe<Scalars['String']>;
  /** Basic Auth password set? Used in multi-tenant bridge for calls via RestUrl (anything other than SendToCart) */
  basicAuthPasswordSet?: InputMaybe<Scalars['Boolean']>;
  /** Basic Auth username used in multi-tenant bridge for calls via RestUrl (anything other than SendToCart) */
  basicAuthUsername?: InputMaybe<Scalars['String']>;
  /** The soap action included in the header of the soap request to fetch courses from the sis. */
  courseListingSoapAction?: InputMaybe<Scalars['String']>;
  /** Optionally if send to cart should point to a different url then the gateway / registration url */
  customSendToCartUrl?: InputMaybe<Scalars['String']>;
  /** Data service db name used with colleague */
  dataServiceDbName?: InputMaybe<Scalars['String']>;
  /** Data service password used with colleague */
  dataServicePassword?: InputMaybe<Scalars['String']>;
  /** Is data service password set for use with colleague */
  dataServicePasswordSet?: InputMaybe<Scalars['Boolean']>;
  /** Data service user name used with colleague */
  dataServiceUserName?: InputMaybe<Scalars['String']>;
  /** The location of the sis to retrieve data. This may be called registrationUrl for some sis's */
  gatewayUrl?: InputMaybe<Scalars['String']>;
  /** Peoplesoft institution; needed for retrieving the students audit report */
  institution?: InputMaybe<Scalars['String']>;
  /** Typically used in conjunction with Rest URL */
  nodeName?: InputMaybe<Scalars['String']>;
  /** Used for workday to point to the correct open seat url path */
  openSeatsReportPath?: InputMaybe<Scalars['String']>;
  /** The integration gateway path used for pulling planning catalog data from the SIS. */
  planningCatalogRequestPath?: InputMaybe<Scalars['String']>;
  /** The integration gateway path used for pulling planning term data from the SIS. */
  planningTermRequestPath?: InputMaybe<Scalars['String']>;
  /** Typically used for peoplesoft to set rest end point for multi-tenant bridge student data pull only for cas and SAML and sample login */
  registrationUrl?: InputMaybe<Scalars['String']>;
  /** Url used for peoplesoft rest gateway */
  restGatewayUrl?: InputMaybe<Scalars['String']>;
  /** The soap action used for sending to cart included in the header of the soap request to fetch courses from the sis. */
  sendToCartSoapAction?: InputMaybe<Scalars['String']>;
  /** The report type for the what-if audit; value configurable in peoplesoft */
  whatIfAuditReportType?: InputMaybe<Scalars['String']>;
  /** Used in conjunction with rest gateway and node name for constructing the url used to retrieve the what-if audit */
  whatIfAuditRequestPath?: InputMaybe<Scalars['String']>;
};

/** The input object used for creating an item from a placeholder template */
export type ItemFromPlaceholderTemplateInput = {
  /** The new groupId for the item */
  groupId: Scalars['String'];
  /** The unique id of the placeholder template to copy */
  placeholderTemplateId: Scalars['ID'];
  /** The new planId for the item */
  planId: Scalars['String'];
};

/** Major object associated with the item */
export type ItemMajor = {
  __typename?: 'ItemMajor';
  /** ID of the item/major linking row */
  id: Scalars['ID'];
  /** The id of the item the major is linked to */
  itemId: Scalars['String'];
  /** The identifier for the major associated with the item */
  majorCode: Scalars['String'];
  /** The description for the major associated with the item */
  majorDescription?: Maybe<Scalars['String']>;
};

/** Minor object associated with the item */
export type ItemMinor = {
  __typename?: 'ItemMinor';
  /** ID of the item/minor linking row */
  id: Scalars['ID'];
  /** The id of the item the minor is linked to */
  itemId: Scalars['String'];
  /** The identifier for the minor associated with the item */
  minorCode: Scalars['String'];
  /** The description for the minor associated with the item */
  minorDescription?: Maybe<Scalars['String']>;
};

/** Pairs of urls with a title. */
export type LinkSettings = {
  __typename?: 'LinkSettings';
  /** The text to display along with the url */
  title: Scalars['String'];
  /** The url to link to */
  url: Scalars['String'];
};

/** Major */
export type Major = {
  __typename?: 'Major';
  /** Career that the major belongs to */
  career?: Maybe<Scalars['String']>;
  /** Code of the major */
  code: Scalars['String'];
  /** The degree associated with the major */
  degree?: Maybe<Scalars['String']>;
  /** Description of the major */
  description: Scalars['String'];
  /** Unique identifier for the major */
  id: Scalars['ID'];
  /** Program that the major is in */
  program?: Maybe<Scalars['String']>;
  /** Short description of the major */
  shortDescription?: Maybe<Scalars['String']>;
};

/** Message for the student */
export type Message = {
  __typename?: 'Message';
  /** Flag to denote if the message is dismissible */
  dismissible?: Maybe<Scalars['Boolean']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The message location */
  location?: Maybe<MessageLocation>;
  /** The message text */
  messageText?: Maybe<Scalars['String']>;
  /** The message type */
  type?: Maybe<MessageType>;
};

/** A single message in the conversation history */
export type MessageInput = {
  /** The text content of the message */
  content: Scalars['String'];
  /** The sender of the message: user or assistant */
  sender: MessageSender;
  /** Anthropic ContentBlockParam[] for tool_use/tool_result turns */
  toolContent?: InputMaybe<Scalars['JSON']>;
};

/** The location of where the message should show */
export enum MessageLocation {
  Home = 'HOME',
  Schedule = 'SCHEDULE'
}

/** The sender of a message in a conversation: user or assistant */
export enum MessageSender {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

/** The type or severity of the message */
export enum MessageType {
  Danger = 'DANGER',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Minor */
export type Minor = {
  __typename?: 'Minor';
  /** Career that the minor belongs to */
  career?: Maybe<Scalars['String']>;
  /** Code of the minor */
  code: Scalars['String'];
  /** The degree associated with the minor */
  degree?: Maybe<Scalars['String']>;
  /** Description of the minor */
  description: Scalars['String'];
  /** Unique identifier for the minor */
  id: Scalars['ID'];
  /** The major associated with the minor */
  major: Scalars['String'];
  /** Program that the minor is in */
  program?: Maybe<Scalars['String']>;
  /** Short description of the minor */
  shortDescription?: Maybe<Scalars['String']>;
};

/** The input object used for moving a group within a plan */
export type MovePlanGroupInput = {
  /** The new display sequence / position of the group within the plan */
  displaySequence: Scalars['Int'];
  /** The unique id of the group */
  id: Scalars['ID'];
};

/** The input object used for moving an item */
export type MovePlanItemInput = {
  /** The sequence / position within the group. If blank, the end of the list will be assumed */
  displaySequence?: InputMaybe<Scalars['Int']>;
  /** The new groupId for the item */
  groupId?: InputMaybe<Scalars['String']>;
  /** The unique id of the item */
  id: Scalars['ID'];
  /** The new planId for the item.  Only used if moving items between plans */
  planId?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a comment */
  addComment: Comment;
  /** Add a new link row for item and major */
  addItemMajor: ItemMajor;
  /** Add a new link row for item and minor */
  addItemMinor: ItemMinor;
  /** Add a new link row for plan and major */
  addMajor: PlanMajor;
  /** Add a new link row for plan and minor */
  addMinor: PlanMinor;
  /** Add a new placeholder course to the item */
  addPlaceholderCourse: PlaceholderCourse;
  /** Add a new placeholder template item */
  addPlaceholderTemplate: PlanItem;
  /** Add a new plan */
  addPlan: Plan;
  /** Add a new group */
  addPlanGroup: PlanGroup;
  /** Add a new item */
  addPlanItem: PlanItem;
  /** Add a student to a non-student's watchlist, returns new pair Id */
  addStudentToWatchlist: WatchlistStudent;
  /** Add a new template */
  addTemplate: Plan;
  /** Add a new group */
  addTemplateGroup: PlanGroup;
  /** Applies the template as a primary plan to the list of students, starting with startTerm */
  applyTemplate: ApplyTemplateResponse;
  /** Sets the placeholder template status to ARCHIVED */
  archivePlaceholderTemplate: PlanItem;
  /** Sets the template status to ARCHIVED */
  archiveTemplate: Plan;
  /** Catch a list of admin users in batch. */
  batchCreateAdminUsers: BatchCreateAdminUsersResponse;
  /** Start a bulk operation to lock or unlock all plan items for all students. This operation is asynchronous. */
  bulkLockAllStudentPlans: BulkLockJobResponse;
  /** Clear the groups and items from the plan */
  clearPlan: Plan;
  /** Creates a copy of all published templates */
  copyAllPublishedTemplates: CopyAllPublishedTemplatesResponse;
  /** Creates a copy of the specified plan for the embedded plan owner */
  copyEmbeddedPlan: Plan;
  /** Create a plan item from a placeholder template */
  copyPlaceholderTemplate: PlanItem;
  /** Creates a copy of the specified plan */
  copyPlan: Plan;
  /** Create users for each role. Each role has their own distinct user type. A role of admin or advisor will create an AdminUser record (admin_user table), and a role of student will create a StudentUser record. */
  createUsers: CreateUsersResponse;
  /** Delete a comment */
  deleteComment: ResponseStatus;
  /** Delete item major */
  deleteItemMajor: ResponseStatus;
  /** Delete item minor */
  deleteItemMinor: ResponseStatus;
  /** Delete plan major */
  deleteMajor: ResponseStatus;
  /** Delete plan minor */
  deleteMinor: ResponseStatus;
  /** Delete placeholder course from item */
  deletePlaceholderCourse: ResponseStatus;
  /** Delete the placeholder template */
  deletePlaceholderTemplate: ResponseStatus;
  /** Mark a plan as deleted */
  deletePlan: ResponseStatus;
  /** Delete the group and any associated items */
  deletePlanGroup: ResponseStatus;
  /** Delete the item */
  deletePlanItem: ResponseStatus;
  /** Mark a template as deleted */
  deleteTemplate: ResponseStatus;
  /** Delete the group and any associated items */
  deleteTemplateGroup: ResponseStatus;
  /** Dismiss the alert */
  dismissPlanAlert: ResponseStatus;
  /** Kicks off the processing necessary to generate an audit report for a particular student and returns a correlationId */
  generateAuditReport: CorrelatableResponse;
  /** Kicks off the processing necessary to generate a what-if audit report for a particular student and returns a correlationId */
  generateWhatIfAuditReport: CorrelatableResponse;
  /** Create a plan item from a placeholder template */
  itemFromPlaceholderTemplate: PlanItem;
  /** Mark a plan as the primary one for the owner */
  makePlanPrimary: ResponseStatus;
  /** Mark all comments for a PlanGroup (aka Term) as read */
  markAllCommentsAsRead: Array<Comment>;
  /** Mark all student comments as read */
  markAllStudentCommentsAsRead: ResponseStatus;
  /** Mark a single comment as read */
  markCommentAsRead: Comment;
  /** Move the group to a different position within the plan */
  movePlanGroup: PlanGroup;
  /** Move the item to a different group/plan and or sequence */
  movePlanItem: PlanItem;
  /** Move the group to a different position within the template */
  moveTemplateGroup: PlanGroup;
  /** Sets the placeholder template status to PUBLISHED */
  publishPlaceholderTemplate: PlanItem;
  /** Sets the template status to PUBLISHED */
  publishTemplate: Plan;
  /** Remove a student from a non-student's watchlist. If no student id is provided, entire non-student's watchlist will be cleared */
  removeStudentFromWatchlist: ResponseStatus;
  /** Start a bulk operation to set read_only_for_students for all plans in an environment. This operation is asynchronous. */
  resetAllPlansReadOnly: BulkReadOnlyJobResponse;
  /** Log into Scheduler using Auth0 */
  schedulerLogin?: Maybe<CreateSchedulerLoginResponse>;
  /** Send an email */
  sendEmail: ResponseStatus;
  /** Kicks off request for student data; returns a correlationId */
  studentData: CorrelatableResponse;
  /** Create or update student user using profile data (aka data from civetl) */
  studentUserProfile: StudentUser;
  /** Updates the changelogViewedAt field for current time and current user */
  touchChangelogViewed: Plan;
  /** Update integration settings for use in communication with external systems. */
  updateIntegrationSettings: ResponseStatus;
  /** Update the locked value of all Plan Items */
  updateLockForAllItems: ResponseStatus;
  /** Update the placeholder template */
  updatePlaceholderTemplate: PlanItem;
  /** Update the plan */
  updatePlan: Plan;
  /** Update the external term id associated with the group. Omitting externalTermId will unassign the term. */
  updatePlanGroupTerm: PlanGroup;
  /** Update the title of the group */
  updatePlanGroupTitle: PlanGroup;
  /** Update the item */
  updatePlanItem: PlanItem;
  /** Update the title of the item */
  updatePlanItemTitle: PlanItem;
  /** Toggle the read_only_for_students flag for a specific plan. Only admins or Civitas employees can perform this action. */
  updatePlanReadOnlyForStudents: PlanReadOnlyForStudentsResult;
  /** Update the title of the plan */
  updatePlanTitle: Plan;
  /** Update the current user's Student App Last Login field to the current date/time. */
  updateStudentAppLastLogin: ResponseStatus;
  /** Update template */
  updateTemplate: Plan;
  /** Update the title of the group */
  updateTemplateGroupTitle: PlanGroup;
  /** Create or update an admin user. */
  upsertAdminUser: UpsertAdminUserResponse;
  /** Update completed course preferences for a user.  The backend will delete/insert */
  upsertCompletedCoursePreference: ResponseStatus;
};


export type MutationAddCommentArgs = {
  input: CreateCommentInput;
};


export type MutationAddItemMajorArgs = {
  input: CreateItemMajorInput;
};


export type MutationAddItemMinorArgs = {
  input: CreateItemMinorInput;
};


export type MutationAddMajorArgs = {
  input: CreatePlanMajorInput;
};


export type MutationAddMinorArgs = {
  input: CreatePlanMinorInput;
};


export type MutationAddPlaceholderCourseArgs = {
  input: PlaceholderCourseInput;
};


export type MutationAddPlanArgs = {
  input: CreatePlanInput;
};


export type MutationAddPlanGroupArgs = {
  input: CreatePlanGroupInput;
};


export type MutationAddPlanItemArgs = {
  input: CreatePlanItemInput;
};


export type MutationAddStudentToWatchlistArgs = {
  studentAppUserId: Scalars['Int'];
};


export type MutationAddTemplateArgs = {
  input: CreatePlanInput;
};


export type MutationAddTemplateGroupArgs = {
  input: CreatePlanGroupInput;
};


export type MutationApplyTemplateArgs = {
  input: ApplyTemplateInput;
};


export type MutationArchivePlaceholderTemplateArgs = {
  input: Scalars['String'];
};


export type MutationArchiveTemplateArgs = {
  input: Scalars['String'];
};


export type MutationBatchCreateAdminUsersArgs = {
  input: BatchCreateAdminUsersInput;
};


export type MutationBulkLockAllStudentPlansArgs = {
  locked: Scalars['Boolean'];
};


export type MutationClearPlanArgs = {
  input: Scalars['String'];
};


export type MutationCopyAllPublishedTemplatesArgs = {
  environment?: InputMaybe<Scalars['String']>;
};


export type MutationCopyEmbeddedPlanArgs = {
  input: Scalars['String'];
};


export type MutationCopyPlaceholderTemplateArgs = {
  input: Scalars['String'];
};


export type MutationCopyPlanArgs = {
  input: Scalars['String'];
};


export type MutationCreateUsersArgs = {
  input: CreateUsersInput;
};


export type MutationDeleteCommentArgs = {
  input: Scalars['String'];
};


export type MutationDeleteItemMajorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteItemMinorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMajorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMinorArgs = {
  id: Scalars['String'];
};


export type MutationDeletePlaceholderCourseArgs = {
  id: Scalars['String'];
};


export type MutationDeletePlaceholderTemplateArgs = {
  input: Scalars['String'];
};


export type MutationDeletePlanArgs = {
  input: Scalars['String'];
};


export type MutationDeletePlanGroupArgs = {
  input: Scalars['String'];
};


export type MutationDeletePlanItemArgs = {
  input: Scalars['String'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTemplateGroupArgs = {
  input: Scalars['String'];
};


export type MutationDismissPlanAlertArgs = {
  input: DismissAlertInput;
};


export type MutationGenerateAuditReportArgs = {
  input: AuditRequestInput;
};


export type MutationGenerateWhatIfAuditReportArgs = {
  input: WhatIfAuditRequestInput;
};


export type MutationItemFromPlaceholderTemplateArgs = {
  input: ItemFromPlaceholderTemplateInput;
};


export type MutationMakePlanPrimaryArgs = {
  input: Scalars['String'];
};


export type MutationMarkAllCommentsAsReadArgs = {
  input: Scalars['String'];
};


export type MutationMarkAllStudentCommentsAsReadArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationMarkCommentAsReadArgs = {
  input: Scalars['String'];
};


export type MutationMovePlanGroupArgs = {
  input: MovePlanGroupInput;
};


export type MutationMovePlanItemArgs = {
  input: MovePlanItemInput;
};


export type MutationMoveTemplateGroupArgs = {
  input: MovePlanGroupInput;
};


export type MutationPublishPlaceholderTemplateArgs = {
  input: Scalars['String'];
};


export type MutationPublishTemplateArgs = {
  input: Scalars['String'];
};


export type MutationRemoveStudentFromWatchlistArgs = {
  studentAppUserId?: InputMaybe<Scalars['Int']>;
};


export type MutationResetAllPlansReadOnlyArgs = {
  readOnlyForStudents: Scalars['Boolean'];
};


export type MutationSchedulerLoginArgs = {
  input: CreateSchedulerLoginInput;
};


export type MutationSendEmailArgs = {
  input: SendEmailInput;
};


export type MutationStudentDataArgs = {
  input: StudentDataRequestInput;
};


export type MutationStudentUserProfileArgs = {
  input: UpsertStudentUserProfileInput;
};


export type MutationTouchChangelogViewedArgs = {
  input: Scalars['String'];
};


export type MutationUpdateIntegrationSettingsArgs = {
  input: UpdateIntegrationSettingsInput;
};


export type MutationUpdateLockForAllItemsArgs = {
  input: UpdateLockForAllItemsInput;
};


export type MutationUpdatePlaceholderTemplateArgs = {
  input: UpdatePlanItemInput;
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdatePlanGroupTermArgs = {
  input: UpdatePlanGroupTermInput;
};


export type MutationUpdatePlanGroupTitleArgs = {
  input: UpdatePlanGroupTitleInput;
};


export type MutationUpdatePlanItemArgs = {
  input: UpdatePlanItemInput;
};


export type MutationUpdatePlanItemTitleArgs = {
  input: UpdatePlanItemTitleInput;
};


export type MutationUpdatePlanReadOnlyForStudentsArgs = {
  planId: Scalars['String'];
  readOnlyForStudents: Scalars['Boolean'];
};


export type MutationUpdatePlanTitleArgs = {
  input: UpdatePlanTitleInput;
};


export type MutationUpdateTemplateArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdateTemplateGroupTitleArgs = {
  input: UpdateTemplateGroupTitleInput;
};


export type MutationUpsertAdminUserArgs = {
  input: UpsertAdminUserInput;
};


export type MutationUpsertCompletedCoursePreferenceArgs = {
  input: CompletedCoursePreferenceInput;
};

/** Fields needed for a plan group with creating a plan. */
export type NewPlanGroupInput = {
  /** The external ID (such as termCode) associated with the plan group. */
  externalTermId?: InputMaybe<Scalars['String']>;
  /** Items to seed within this group when creating the plan. */
  items?: InputMaybe<Array<NewPlanItemInput>>;
  /** The initial title of the plan group */
  title?: InputMaybe<Scalars['String']>;
};

/** Fields needed to seed a plan item when creating a plan. Provide externalCourseId for a course-backed item, or the nonCourse* placeholder fields for a requirement placeholder. */
export type NewPlanItemInput = {
  /** Course number, e.g., 101. */
  courseNumber?: InputMaybe<Scalars['String']>;
  /** Maximum credit hours. */
  creditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum credit hours. */
  creditsMin?: InputMaybe<Scalars['Float']>;
  /** The SIS course ID for a course-backed item. Omit for a placeholder item. */
  externalCourseId?: InputMaybe<Scalars['String']>;
  /** Marks the item as a placeholder the student must later fill with a course. */
  isCoursePlaceholder?: InputMaybe<Scalars['Boolean']>;
  /** Maximum credit hours for a placeholder item. */
  nonCourseCreditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum credit hours for a placeholder item. */
  nonCourseCreditsMin?: InputMaybe<Scalars['Float']>;
  /** Optional description for a placeholder item. */
  nonCourseDescription?: InputMaybe<Scalars['String']>;
  /** Label for a placeholder item, e.g., "General Education: Natural Science". */
  nonCourseTitle?: InputMaybe<Scalars['String']>;
  /** Eligible courses that can fulfill this placeholder item. */
  placeholderCourses?: InputMaybe<Array<PlaceholderCourseInput>>;
  /** Subject prefix, e.g., MATH. */
  subjectId?: InputMaybe<Scalars['String']>;
  /** Course title for display. */
  title?: InputMaybe<Scalars['String']>;
};

/** Filter used on the New Plan page so users can optionally choose particular term types to include. */
export type NewPlanTermFilter = {
  __typename?: 'NewPlanTermFilter';
  /** The value to display on the checkbox control */
  label: Scalars['String'];
  /** The value to compare against the termType column */
  termType: Scalars['String'];
};

export type NotRegisteredCountDetail = {
  __typename?: 'NotRegisteredCountDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** Students last name */
  lastName: Scalars['String'];
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
};

export type NotRegisteredCountDetailEdge = {
  __typename?: 'NotRegisteredCountDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: NotRegisteredCountDetail;
};

/** PageInfo cursor, as defined in https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']>;
};

/** A course that can be used to fulfill a placeholder item */
export type PlaceholderCourse = {
  __typename?: 'PlaceholderCourse';
  /** The campus code of the course. Populated from sis-data-service */
  campus?: Maybe<Scalars['String']>;
  /** The campus description of the course. Populated from sis-data-service */
  campusDescription?: Maybe<Scalars['String']>;
  /** The courseNumber associated with this placeholder course */
  courseNumber: Scalars['String'];
  /** The datetime that the placeholder course was created in UTC */
  createdAt: Scalars['DateTime'];
  /** The appUserId of the user that created this placeholder course */
  createdByAppUserId: Scalars['Int'];
  /** Maximum amount of credits for this course */
  creditsMax?: Maybe<Scalars['Float']>;
  /** Minimum amount of credits for this course */
  creditsMin?: Maybe<Scalars['Float']>;
  /** The description of the placeholder course */
  description?: Maybe<Scalars['String']>;
  /** The externalCourseId of the course; should be the same as the externalCourseId in catalogCourse from the sis-data-service */
  externalCourseId?: Maybe<Scalars['String']>;
  /** The unique id of the placeholder course */
  id: Scalars['ID'];
  /** The subject description associated with this item */
  subjectDescription?: Maybe<Scalars['String']>;
  /** The subjectId associated with this placeholder course */
  subjectId: Scalars['String'];
  /** The title of the placeholder course */
  title: Scalars['String'];
};

/** A course that can be used to fulfill a placeholder item */
export type PlaceholderCourseDetail = {
  __typename?: 'PlaceholderCourseDetail';
  /** Alerts associated with the course */
  alerts: Array<PlanAlert>;
  /** The catalog course with details populated from sis-data-service */
  course: CatalogCourse;
};

/** A course that can be used to fulfill a placeholder item */
export type PlaceholderCourseInput = {
  /** The courseNumber associated with this placeholder course */
  courseNumber: Scalars['String'];
  /** Maximum amount of credits for this course */
  creditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum amount of credits for this course */
  creditsMin?: InputMaybe<Scalars['Float']>;
  /** The description of the placeholder course */
  description?: InputMaybe<Scalars['String']>;
  /** The externalCourseId of the course; should be the same as the externalCourseId in catalogCourse from the sis-data-service */
  externalCourseId?: InputMaybe<Scalars['String']>;
  /** Id of the associated item */
  itemId?: InputMaybe<Scalars['String']>;
  /** The subjectId associated with this placeholder course */
  subjectId: Scalars['String'];
  /** The title of the placeholder course */
  title?: InputMaybe<Scalars['String']>;
};

/** The plan object mapped from the result of the rest api */
export type Plan = {
  __typename?: 'Plan';
  /** The campus identifier associated with the template */
  campusCode: Scalars['String'];
  /** The description of the campus associated with the template */
  campusDescription?: Maybe<Scalars['String']>;
  /** The catalog year associated with the template */
  catalogYear: Scalars['String'];
  /** The catalog year description, such as 2020-2021 */
  catalogYearDescription?: Maybe<Scalars['String']>;
  /** The timestamp of when the ChangeLog was last viewed */
  changelogViewedAt?: Maybe<Scalars['DateTime']>;
  /** The college identifier associated with the template */
  collegeCode: Scalars['String'];
  /** The description of the college associated with the template */
  collegeDescription?: Maybe<Scalars['String']>;
  /** The concentration identifier associated with the template */
  concentrationCode: Scalars['String'];
  /** The description of the concentration associated with the template */
  concentrationDescription?: Maybe<Scalars['String']>;
  /** The timestamp of when this plan was created in UTC */
  createdAt: Scalars['DateTime'];
  /** The appUserId for the user that created this plan */
  createdByAppUserId: Scalars['Int'];
  /** The name of the writer/creator of this plan. This will only be populated if the name exists for the user */
  creatorName?: Maybe<Scalars['String']>;
  /** The degree identifier associated with the template */
  degreeCode: Scalars['String'];
  /** The description of the degree associated with the template */
  degreeDescription?: Maybe<Scalars['String']>;
  /** A description of the template */
  description: Scalars['String'];
  /** The groups associated with this plan */
  groups: Array<PlanGroup>;
  /** The unique identifier of the plan */
  id: Scalars['ID'];
  /** A flag to denote whether the plan has been marked as deleted or not */
  isDeleted: Scalars['Boolean'];
  /** Whether the plan was created from a template */
  isFromTemplate?: Maybe<Scalars['Boolean']>;
  /** A flag to denote is this is the owner's primary plan. Only one plan can be marked as primary */
  isPrimary: Scalars['Boolean'];
  /** A flag to denote whether this plan is public */
  isPublic: Scalars['Boolean'];
  /** A flag to denote that this plan was shared with the user */
  isShared: Scalars['Boolean'];
  /** Whether the plan is a template */
  isTemplate: Scalars['Boolean'];
  /** The items associated with this plan, that are not yet assigned to a group */
  items: Array<PlanItem>;
  /** The majors associated with the template */
  majors: Array<PlanMajor>;
  /** The minors associated with the template */
  minors: Array<PlanMinor>;
  /** The appUserId for the owner of the plan or template */
  ownerAppUserId: Scalars['Int'];
  /** The timestamp of when the plan was last viewed */
  planViewedAt?: Maybe<Scalars['DateTime']>;
  /** The timestamp of when this plan was published in UTC */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the plan is read-only for students */
  readOnlyForStudents: Scalars['Boolean'];
  /** The plan id that this plan was copied / created from */
  sourcePlanId?: Maybe<Scalars['String']>;
  /** Whether the template is a draft, published, or archived */
  status?: Maybe<TemplateStatus>;
  /** Optional message added to a plan when created from a template */
  templateMessage?: Maybe<Scalars['String']>;
  /** The title of the plan */
  title: Scalars['String'];
  /** The timestamp of when this plan was created or updated in UTC */
  updatedAt: Scalars['DateTime'];
  /** The appUserId for the user that updated this plan */
  updatedByAppUserId: Scalars['Int'];
};

export type PlanAlert = {
  __typename?: 'PlanAlert';
  /** The unique key for the alert. A concatenation of type and all associated Item IDs. */
  alertKey: Scalars['String'];
  /** The alert type. */
  alertType: AlertType;
  /** The group ID of the alert */
  groupId?: Maybe<Scalars['String']>;
  /** The item ID of the alert */
  itemId?: Maybe<Scalars['String']>;
  /** The level of the alert */
  level: AlertLevel;
  /** The plan ID of the alert */
  planId: Scalars['String'];
};

/** Data for when the plan was changed by someone */
export type PlanChangedBy = {
  __typename?: 'PlanChangedBy';
  /** The appUserId of who changed the plan */
  changedByAppUserId: Scalars['Int'];
  /** The id of the plan the plan that was changed */
  planId: Scalars['String'];
};

/** Detailed count information for students have or have not created a plan. */
export type PlanCreationDetail = {
  __typename?: 'PlanCreationDetail';
  /** The count of students who have plans. */
  studentsWithPlansCount: Scalars['Int'];
  /** The count of students who have logged in but do not have any plans. */
  studentsWithoutPlansCount: Scalars['Int'];
};

/** The planGroup object mapped from the result of the rest api */
export type PlanGroup = {
  __typename?: 'PlanGroup';
  /** The comments for this group */
  comments: Array<Comment>;
  /** The timestamp of when this group was created in UTC */
  createdAt: Scalars['DateTime'];
  /** The appUserId of the user that created this group */
  createdByAppUserId: Scalars['Int'];
  /** The sequence / position within the plan */
  displaySequence: Scalars['Int'];
  /** The id to link the codified term with the group */
  externalTermId?: Maybe<Scalars['String']>;
  /** The unique identifier of the group */
  id: Scalars['ID'];
  /** A flag to denote whether the group has been marked as deleted or not */
  isDeleted: Scalars['Boolean'];
  /** The items assigned to this group */
  items: Array<PlanItem>;
  /** The id of the plan that this group is assigned to */
  planId: Scalars['String'];
  /** The sequence / position of a specific term type within a template */
  termSequence?: Maybe<Scalars['Int']>;
  /** The term type associated with this group, i.e. "Fall" or "Spring". When a PlanGroup is in a template, we can use termType to assign the correct externalTermId when the template is applied. */
  termType?: Maybe<Scalars['String']>;
  /** The title of the group */
  title: Scalars['String'];
  /** The timestamp of when this group was created or updated in UTC */
  updatedAt: Scalars['DateTime'];
  /** The appUserId of the user that last updated this group */
  updatedByAppUserId: Scalars['Int'];
};

/** The planItem object mapped from the result of the rest api */
export type PlanItem = {
  __typename?: 'PlanItem';
  /** The availability status of the course. */
  availability?: Maybe<CourseAvailability>;
  /** The campus of the course. Populated from sis-data-service */
  campusCode?: Maybe<Scalars['String']>;
  /** The campus description of the course. Populated from sis-data-service */
  campusDescription?: Maybe<Scalars['String']>;
  /** The career of the course. Populated from sis-data-service */
  career?: Maybe<Scalars['String']>;
  /** The catalog year associated with the placeholder template */
  catalogYear: Scalars['String'];
  /** The catalog year description, such as 2020-2021 */
  catalogYearDescription?: Maybe<Scalars['String']>;
  /** The college identifier associated with the placeholder template */
  collegeCode: Scalars['String'];
  /** The description of the college associated with the placeholder template */
  collegeDescription?: Maybe<Scalars['String']>;
  /** The concentration identifier associated with the placeholder template */
  concentrationCode: Scalars['String'];
  /** The description of the concentration associated with the placeholder template */
  concentrationDescription?: Maybe<Scalars['String']>;
  /** The external course id of the course in the sis; null for banner */
  courseId?: Maybe<Scalars['String']>;
  /** The courseNumber associated with this item */
  courseNumber?: Maybe<Scalars['String']>;
  /** Whether the course has been used in other requirement. */
  courseTakenInReq?: Maybe<Scalars['Boolean']>;
  /** The datetime that the item was created in UTC */
  createdAt: Scalars['DateTime'];
  /** The appUserId of the user that created this item */
  createdByAppUserId: Scalars['Int'];
  /** The name of the writer/creator of this plan item. This will only be populated if the name exists for the user */
  creatorName?: Maybe<Scalars['String']>;
  /** Maximum amount of credits for this course */
  creditsMax?: Maybe<Scalars['Float']>;
  /** Minimum amount of credits for this course */
  creditsMin?: Maybe<Scalars['Float']>;
  /** The degree identifier associated with the placeholder template */
  degreeCode: Scalars['String'];
  /** The description of the degree associated with the placeholder template */
  degreeDescription?: Maybe<Scalars['String']>;
  /** The freeform description of an item */
  description?: Maybe<Scalars['String']>;
  /** The sequence / position within the group */
  displaySequence: Scalars['Int'];
  /** An object representing the enrollment status of the PlanItem, according to the audit */
  enrollmentStatus?: Maybe<EnrollmentStatus>;
  /** Environment that the course belongs to. Necessary when not tied to group or plan */
  environment: Scalars['String'];
  /** The id of the equivalent course group */
  equivalentCourseGroupId?: Maybe<Scalars['String']>;
  /** The externalCourseId of the course; should be the same as the externalCourseId in catalogCourse from the sis-data-service */
  externalCourseId?: Maybe<Scalars['String']>;
  /** From the audit, grade received for the course. */
  gradeReceived?: Maybe<Scalars['String']>;
  /** The groupId that this item is assigned to; null if the item is not assigned to a group */
  groupId?: Maybe<Scalars['String']>;
  /** The unique id of the item */
  id: Scalars['ID'];
  /** Whether the course is in progress, according to the audit. */
  inProgress?: Maybe<Scalars['Boolean']>;
  /** Whether the course is active based on the effective date and term that it is in */
  isActive: Scalars['Boolean'];
  /** Whether the plan item is a course placeholder that the student must choose a course for. */
  isCoursePlaceholder: Scalars['Boolean'];
  /** Indicates whether an item is a placeholder template */
  isTemplate: Scalars['Boolean'];
  /** Whether the plan item has been locked by an admin. */
  locked: Scalars['Boolean'];
  /** The majors associated with the placeholder template */
  majors: Array<ItemMajor>;
  /** The minors associated with the placeholder template */
  minors: Array<ItemMinor>;
  /** Maximum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMax?: Maybe<Scalars['Float']>;
  /** Minimum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMin?: Maybe<Scalars['Float']>;
  /** The freeform description of an item, if this item is either a placeholder or non-codified course */
  nonCourseDescription?: Maybe<Scalars['String']>;
  /** The title of an item, if this item is either a placeholder or non-codified course */
  nonCourseTitle?: Maybe<Scalars['String']>;
  /** The placeholder courses for this item, if this item is a placeholder */
  placeholderCourses?: Maybe<Array<Maybe<PlaceholderCourse>>>;
  /** The planId that this item is assigned to */
  planId: Scalars['String'];
  /** The datetime that the item was published in UTC */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the plan item has been required by an admin. */
  required: Scalars['Boolean'];
  /** The titles of the requirements that are fulfilled by this plan item */
  requirementTitles: Array<Scalars['String']>;
  /** The prereq/coreq description of the course. Populated from sis-data-service */
  requisiteDescription?: Maybe<Scalars['String']>;
  /** The long prereq/coreq description of the course. Populated from sis-data-service */
  requisiteDescriptionLong?: Maybe<Scalars['String']>;
  /** Whether to show the requisite alert (if the item has a requisite) */
  showRequisiteAlert?: Maybe<Scalars['Boolean']>;
  /** The planItemId that this item was created from */
  sourcePlanItemId?: Maybe<Scalars['String']>;
  /** Whether the item is draft/published/archived. Applicable to placeholder templates */
  status?: Maybe<TemplateStatus>;
  /** The subject description associated with this item */
  subjectDescription?: Maybe<Scalars['String']>;
  /** The subjectId associated with this item */
  subjectId?: Maybe<Scalars['String']>;
  /** From the audit, the term in which the associated course has a grade */
  termGradeReceived?: Maybe<Scalars['String']>;
  /** The title of the item */
  title: Scalars['String'];
  /** When the course is typically offered */
  typicallyOffered?: Maybe<Scalars['String']>;
  /** The datetime that the item was created or updated in UTC */
  updatedAt: Scalars['DateTime'];
  /** The appUserId of the user that last updated this item */
  updatedByAppUserId: Scalars['Int'];
  /** Whether the course satisfies a requirement, according to the audit. */
  usedToMeetRequirement?: Maybe<Scalars['Boolean']>;
};

/** Major object associated with the plan */
export type PlanMajor = {
  __typename?: 'PlanMajor';
  /** ID of the plan/major linking row */
  id: Scalars['ID'];
  /** The identifier for the major associated with the plan */
  majorCode: Scalars['String'];
  /** The description for the major associated with the plan */
  majorDescription?: Maybe<Scalars['String']>;
  /** The id of the plan the major is linked to */
  planId: Scalars['String'];
};

/** Minor object associated with the plan */
export type PlanMinor = {
  __typename?: 'PlanMinor';
  /** ID of the plan/minor linking row */
  id: Scalars['ID'];
  /** The identifier for the minor associated with the plan */
  minorCode: Scalars['String'];
  /** The description for the minor associated with the plan */
  minorDescription?: Maybe<Scalars['String']>;
  /** The id of the plan the minor is linked to */
  planId: Scalars['String'];
};

/** Result of updating the read-only for students flag on a plan */
export type PlanReadOnlyForStudentsResult = {
  __typename?: 'PlanReadOnlyForStudentsResult';
  /** The plan ID */
  id: Scalars['ID'];
  /** The current read-only for students state */
  readOnlyForStudents: Scalars['Boolean'];
};

/** Detailed information about the planned courses in planning by terms */
export type PlanningCourseDemand = {
  __typename?: 'PlanningCourseDemand';
  /** The course number */
  courseNumber: Scalars['String'];
  /** The count of students who planned courses during the term. */
  studentsCount: Scalars['Int'];
  /** The subject of the course */
  subjectId: Scalars['String'];
  /** The term selected for the report */
  termId: Scalars['String'];
};

/** Detailed information about the planned courses in planning by terms */
export type PlanningCourseDemandRaw = {
  __typename?: 'PlanningCourseDemandRaw';
  /** The course number */
  courseNumber: Scalars['String'];
  /** The app id of the student who planned the course for the term. */
  ownerAppUserId: Scalars['Int'];
  /** The id of the student who planned the course for the term. */
  studentId: Scalars['String'];
  /** The subject of the course */
  subjectId: Scalars['String'];
  /** The term description */
  termDescription?: Maybe<Scalars['String']>;
  /** The term selected for the report */
  termId: Scalars['String'];
};

/** Term */
export type PlanningTerm = {
  __typename?: 'PlanningTerm';
  /** Academic year associated with this term. */
  academicYear: Scalars['Int'];
  /** Description of the term, often used as the title i.e. Spring 2021 */
  description: Scalars['String'];
  /** Date marking the end of the term */
  endDate: Scalars['DateTime'];
  /** Unique identifier for the term */
  id: Scalars['ID'];
  /** If the term has been used already and cannot be selected again */
  isDisabled: Scalars['Boolean'];
  /** Date marking the beginning of the term */
  startDate: Scalars['DateTime'];
  /** The term code associated with the term in the SIS */
  termCode: Scalars['String'];
  /** The type of term, i.e. "R" for Regular, or "S" for Summer */
  termType?: Maybe<Scalars['String']>;
};

/** Academic Program */
export type Program = {
  __typename?: 'Program';
  /** Group associated with the program; psoft specific */
  academicGroupCode?: Maybe<Scalars['String']>;
  /** Description of the campus associated with the program; banner specific */
  campus?: Maybe<Scalars['String']>;
  /** Code of the campus associated with the program */
  campusCode?: Maybe<Scalars['String']>;
  /** Code of the career associated with the program; psoft specific */
  careerCode?: Maybe<Scalars['String']>;
  /** Description of the college associated with the program; banner specific */
  college?: Maybe<Scalars['String']>;
  /** Code of the college associated with the program; banner specific */
  collegeCode?: Maybe<Scalars['String']>;
  /** Description of the degree associated with the program; banner specific */
  degree?: Maybe<Scalars['String']>;
  /** Code of the degree associated with the program; banner specific */
  degreeCode?: Maybe<Scalars['String']>;
  /** Unique identifier for the program */
  id: Scalars['ID'];
  /** Description of the level associated with the program; banner specific */
  level?: Maybe<Scalars['String']>;
  /** Code of the level associated with the program; banner specific */
  levelCode?: Maybe<Scalars['String']>;
  /** Code of the organization associated with the program; psoft specific */
  organizationCode?: Maybe<Scalars['String']>;
  /** Code of the plan associated with the program; psoft specific */
  planCode?: Maybe<Scalars['String']>;
  /** Description of the program */
  program: Scalars['String'];
  /** Code of the program */
  programCode: Scalars['String'];
  /** Short description of the program; psoft specific */
  shortDescription?: Maybe<Scalars['String']>;
};

/** Settings to control the authentication process */
export type PublicAuthSettings = {
  __typename?: 'PublicAuthSettings';
  /** Whether or not to allow federated logout */
  enableStudentAppFederatedLogout: Scalars['Boolean'];
  /** Student App Login Options to control which auth0 connections to use per option */
  studentAppAuth0LoginOptions: Array<StudentAppAuth0LoginOption>;
  /** OpenID Connect Token Audience value */
  studentAppOidcAudience?: Maybe<Scalars['String']>;
  /** OpenID Connect Provider URL value */
  studentAppOidcAuthority?: Maybe<Scalars['String']>;
  /** OpenID Connect Relying Party ID value */
  studentAppOidcClientId?: Maybe<Scalars['String']>;
  /** OpenID Connect Default Idp Alias value */
  studentAppOidcDefaultIdpAlias?: Maybe<Scalars['String']>;
  /** Defines the type of provider */
  studentAppProvider: StudentAppAuthProviderType;
};

/** Public Customization Center Settings for use when not authenticated */
export type PublicSiteSettings = {
  __typename?: 'PublicSiteSettings';
  /** Settings to control the authentication process that are public */
  authSettings: PublicAuthSettings;
  /** Course Search Settings */
  courseSearchSettings: CourseSearchSettings;
  /** Custom Header Link Text Setting */
  customLinkText: Scalars['String'];
  /** Custom Header Link URL Setting */
  customLinkUrl: Scalars['String'];
  helpSettings: HelpSettings;
  /** Help Text Setting */
  helpText: Scalars['String'];
  /** Help URL Settings */
  helpUrl: Scalars['String'];
  /** Section Field Text Settings */
  sectionFieldText: SectionFieldText;
  /** Style Settings */
  styleSettings: StyleSettings;
  /** Text Settings */
  text: Text;
};

export type Query = {
  __typename?: 'Query';
  /** Settings for the Academic Planner, aka student-app */
  academicPlanningSettings: AcademicPlanningSettings;
  /** Get a list of active terms mapping SchedulerTerm props (code/title)to PlanningTerm props (termCode/description) */
  activeTerms: Array<SchedulerActiveTerm>;
  adminUser: AdminUser;
  adminUsers: QueryAdminUsers_Connection;
  /** Find admin users using standard paging options */
  adminUsersPaged: AdminUserPagedResult;
  /** Get studentProfile data by StudentUser appUserId */
  appUserStudentProfile?: Maybe<StudentProfile>;
  applyTemplateResponse: ApplyTemplateResponse;
  /** List of skills the assistant can run; used by the slash menu in the chat input */
  assistantSkills: Array<AssistantSkill>;
  /** Get all courses from a given student's audit, optionally filtered by subjectId, courseNumber */
  auditCourses: Array<AuditCourse>;
  /** Get the students audit report */
  auditReport: AuditReport;
  /** Get available audit report types that have data for the student. This query triggers bridge requests to check each configured report type and determines which ones have actual data in the external SIS. */
  availableAuditReportTypes: Array<AdditionalAuditReportType>;
  /** Get the status of a bulk lock job */
  bulkLockJobStatus: BulkLockJobStatus;
  /** Get a list of campuses */
  campuses: Array<Campus>;
  /** Get a list of careers */
  careers: Array<AcademicCareer>;
  /** Get course by ID */
  catalogCourse: CatalogCourse;
  changes: ChangeLogConnection;
  /** Retrieve a specific comment */
  comment: Comment;
  /** Retrieve all comments for a specific PlanGroup */
  comments: Array<Comment>;
  /** Get course by ID */
  course: Course;
  /** Get course by external ID */
  courseByExternalId: Course;
  /** Get the timestamp for when the course history data was last updated */
  courseDataLastUpdate?: Maybe<Scalars['DateTime']>;
  creditCountDetails: QueryCreditCountDetails_Connection;
  /** Get the credit counts for the provided term. */
  creditCounts: CreditCounts;
  diagnosticLogs: QueryDiagnosticLogs_Connection;
  /** Find ETL logs paged. */
  diagnosticLogsPaged: DiagnosticLogPagedResult;
  /** Query for all dismissed alerts for a specific plan */
  dismissedPlanAlerts: Array<DismissedPlanAlert>;
  /** Get the json of student credit count detail to download */
  downloadCreditCountDetails: Array<CreditCountDetail>;
  /** Get the json of incoming students without a plan */
  downloadIncomingNoPlanDetails: Array<IncomingNoPlanDetail>;
  /** Get the json of students with a cart but not currently registered, to download. */
  downloadNotRegisteredCountDetail: Array<NotRegisteredCountDetail>;
  /** Get the json of unread comments detail to download */
  downloadPlanCreationDetails: Array<StudentPlanDetail>;
  /** Get the json of unavailable courses detail to download */
  downloadUnavailableCourseDetail: Array<UnavailableCourseDetail>;
  /** Get the json of unread comments detail to download */
  downloadUnreadCommentCountDetail: Array<UnreadCommentCountDetail>;
  /** Get the json of students with carts that have not registered detail to download */
  downloadUnregisteredCountDetail: Array<UnregisteredCountDetail>;
  /** Get the faculty member by external id */
  faculty: Faculty;
  /** Find catalog courses */
  findCatalogCourses: Array<CatalogCourse>;
  /** Get a distinct list of academic years from terms */
  getAcademicYears: Array<AcademicYear>;
  /** Get a list of colleges */
  getColleges: Array<College>;
  /** Get a list of concentrations */
  getConcentrations: Array<Concentration>;
  /** Get a list of degrees */
  getDegrees: Array<Degree>;
  /** Get a list of majors */
  getMajors: Array<Major>;
  /** Get a list of minors */
  getMinors: Array<Minor>;
  /** Get a list of terms with distinct termCodes */
  getTerms: Array<PlanningTerm>;
  /** Get user data by appUserId */
  getUserByAppUserId: AppUser;
  /** Return true if admin has any number of assigned students */
  hasCaseload: Scalars['Boolean'];
  /** Get the counts of incoming students for the selected term who have not created a plan. */
  incomingNoPlanCount: Scalars['Int'];
  incomingNoPlanDetails: QueryIncomingNoPlanDetails_Connection;
  /** Returns true is student belongs to non-students watchlist */
  isStudentInWatchlist: Scalars['Boolean'];
  /** Get the latest change log record.  The group or item id can be passed along if the plan id is unknown */
  latestChange: ChangeLog;
  /** Count of students who have a cart for the term but are not currently registered (no current registered schedule). Advisors see their caseload; users with the view-all-students permission (directors) can pass includeAllStudents to see all students. Reflects platform registrations only. */
  notRegisteredCount: Scalars['Int'];
  notRegisteredCountDetails: QueryNotRegisteredCountDetails_Connection;
  /** Get the details for a course and its alerts */
  placeholderCourseDetail: PlaceholderCourseDetail;
  /** Query for a single placeholder template based on id */
  placeholderTemplate: PlanItem;
  /** Get minimal information about templates that use this placeholder */
  placeholderTemplateInUseLocations: Array<Plan>;
  /** Get all placeholder templates by environment */
  placeholderTemplates: Array<PlanItem>;
  /** Query for a full plan based on id */
  plan: Plan;
  /** Query for all alerts for a specific plan or group or item id */
  planAlerts: Array<PlanAlert>;
  /** Get the counts of students who have or have not created a plan. */
  planCreationCounts: PlanCreationDetail;
  planCreationDetails: QueryPlanCreationDetails_Connection;
  /** Query for full group by id */
  planGroup: PlanGroup;
  /** Get all groups for plan */
  planGroups: Array<PlanGroup>;
  /** Query for an item based on id */
  planItem: PlanItem;
  /** Get all items for group */
  planItemsByGroup: Array<PlanItem>;
  /** Get all items for plan */
  planItemsByPlan: Array<PlanItem>;
  /** Query for a full plan based on id */
  planUnread: Scalars['Boolean'];
  /** Get the courses demand for a term. */
  planningCourseDemand: Array<PlanningCourseDemand>;
  /** Get the courses demand raw data for a list of terms. */
  planningCourseDemandRaw: Array<PlanningCourseDemandRaw>;
  /** Get the terms with planning data for the report */
  planningReportTerms: Array<PlanningTerm>;
  /** Get all plans for owner */
  plans: Array<Plan>;
  /** Query to get the primary plan */
  primaryPlan?: Maybe<Plan>;
  /** Get a list of programs */
  programs: Array<Program>;
  publicSettings: PublicSiteSettings;
  /** Get the status of a bulk read-only reset job */
  readOnlyBulkActionStatus: BulkReadOnlyJobStatus;
  /** Fetch all terms (quarters, trimesters or semesters) */
  reportTerms: Array<ReportTerm>;
  /** Search through courses */
  searchCourses: Array<SearchCourse>;
  /** Searches published placeholder templates by title */
  searchPlaceholderTemplates: Array<PlanItem>;
  /** Search through students */
  searchStudents: Array<StudentProfile>;
  self: AppUser;
  /** Query entire settings object. */
  siteSettings: SiteSettings;
  /** Get student courses by student appUserId */
  studentCourses: Array<StudentCourse>;
  /** Get student data from database, then make call to SIS if the time since the last sync is greater than the configured value */
  studentData: StudentUserResponse;
  /** Get the student plan creation data. */
  studentPlanCreationData: Array<StudentPlanCreation>;
  /** Get a student by external ID */
  studentProfile: StudentProfile;
  /** Get students gpa for each term */
  studentTermGpa: Array<StudentTermGpa>;
  /** Lookup student usage statistics */
  studentUsage: StudentUsage;
  studentUser: StudentUser;
  /** Course suggest autocomplete search */
  suggestCourses: Array<SuggestCourse>;
  template: Plan;
  /** Get extracted data from one or more templates for reporting purposes */
  templateExtractData: Array<TemplateExtractData>;
  /** Get all plans that have been marked as templates */
  templates: Array<Plan>;
  /** The count of students who have planned for courses that are not available for the specific term */
  unavailableCourseCount: Scalars['Int'];
  unavailableCourseDetail: QueryUnavailableCourseDetail_Connection;
  /** Get the count of new comments */
  unreadCommentCount: Scalars['Int'];
  unreadCommentCountDetails: QueryUnreadCommentCountDetails_Connection;
  /** Get the count of students who have abandoned courses in their shopping carts. */
  unregisteredCount: Scalars['Int'];
  unregisteredCountDetails: QueryUnregisteredCountDetails_Connection;
  viewer: Viewer;
  /** List of students assigned to owner's watchlist */
  watchlist: Array<WatchlistStudent>;
  /** Get the what-if audit report by id */
  whatIfAuditReport: AuditReport;
  /** Get the students previously run what-if audit reports */
  whatIfAuditReports: Array<AuditReport>;
};


export type QueryAdminUserArgs = {
  id: Scalars['Int'];
};


export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  includeSuperUsers?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  nameEmailFilter?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryAdminUsersPagedArgs = {
  input: AdminUserPagedResultInput;
};


export type QueryAppUserStudentProfileArgs = {
  appUserId: Scalars['Int'];
};


export type QueryApplyTemplateResponseArgs = {
  correlationId: Scalars['String'];
};


export type QueryAuditCoursesArgs = {
  courseNumber?: InputMaybe<Scalars['String']>;
  studentAppUserId?: InputMaybe<Scalars['Int']>;
  subjectId?: InputMaybe<Scalars['String']>;
};


export type QueryAuditReportArgs = {
  correlationId?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
  studentAppUserId?: InputMaybe<Scalars['Int']>;
};


export type QueryAvailableAuditReportTypesArgs = {
  studentAppUserId: Scalars['Int'];
};


export type QueryBulkLockJobStatusArgs = {
  jobId: Scalars['String'];
};


export type QueryCampusesArgs = {
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryCareersArgs = {
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryCatalogCourseArgs = {
  id: Scalars['ID'];
};


export type QueryChangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  planId: Scalars['String'];
};


export type QueryCommentArgs = {
  id: Scalars['String'];
};


export type QueryCommentsArgs = {
  groupId: Scalars['String'];
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCourseByExternalIdArgs = {
  environment?: InputMaybe<Scalars['String']>;
  externalCourseId: Scalars['String'];
};


export type QueryCreditCountDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  maxCredits?: InputMaybe<Scalars['Int']>;
  minCredits?: InputMaybe<Scalars['Int']>;
  noCredits?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryCreditCountsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
};


export type QueryDiagnosticLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Timestamp']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  types?: InputMaybe<Array<DiagnosticLogType>>;
};


export type QueryDiagnosticLogsPagedArgs = {
  input: DiagnosticLogPagedResultInput;
};


export type QueryDismissedPlanAlertsArgs = {
  planId: Scalars['String'];
};


export type QueryDownloadCreditCountDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  maxCredits?: InputMaybe<Scalars['Int']>;
  minCredits?: InputMaybe<Scalars['Int']>;
  noCredits?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryDownloadIncomingNoPlanDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  majorFilter?: InputMaybe<AcademicProgramFilter>;
  minorFilter?: InputMaybe<AcademicProgramFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryDownloadNotRegisteredCountDetailArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryDownloadPlanCreationDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<StudentPlanFilter>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  loginFilter?: InputMaybe<StudentLoginFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryDownloadUnavailableCourseDetailArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryDownloadUnreadCommentCountDetailArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryDownloadUnregisteredCountDetailArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']>>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryFacultyArgs = {
  externalId: Scalars['String'];
};


export type QueryFindCatalogCoursesArgs = {
  courseNumber?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  externalCourseId?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAcademicYearsArgs = {
  environment?: InputMaybe<Scalars['String']>;
  startYear?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCollegesArgs = {
  code?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryGetConcentrationsArgs = {
  career?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  degree?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
  program?: InputMaybe<Scalars['String']>;
};


export type QueryGetDegreesArgs = {
  code?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryGetMajorsArgs = {
  career?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  degree?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  program?: InputMaybe<Scalars['String']>;
};


export type QueryGetMinorsArgs = {
  career?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  degree?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  major?: InputMaybe<Scalars['String']>;
  program?: InputMaybe<Scalars['String']>;
};


export type QueryGetTermsArgs = {
  currentAndFutureTerms?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  startYear?: InputMaybe<Scalars['Int']>;
};


export type QueryGetUserByAppUserIdArgs = {
  appUserId: Scalars['Int'];
};


export type QueryHasCaseloadArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
};


export type QueryIncomingNoPlanCountArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
};


export type QueryIncomingNoPlanDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  majorFilter?: InputMaybe<AcademicProgramFilter>;
  minorFilter?: InputMaybe<AcademicProgramFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryIsStudentInWatchlistArgs = {
  studentAppUserId: Scalars['Int'];
};


export type QueryLatestChangeArgs = {
  groupId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['String']>;
};


export type QueryNotRegisteredCountArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
};


export type QueryNotRegisteredCountDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryPlaceholderCourseDetailArgs = {
  courseNumber?: InputMaybe<Scalars['String']>;
  externalCourseId?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  subjectId?: InputMaybe<Scalars['String']>;
};


export type QueryPlaceholderTemplateArgs = {
  id: Scalars['String'];
};


export type QueryPlaceholderTemplateInUseLocationsArgs = {
  environment?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type QueryPlaceholderTemplatesArgs = {
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryPlanArgs = {
  id: Scalars['String'];
};


export type QueryPlanAlertsArgs = {
  groupId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
};


export type QueryPlanCreationCountsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPlanCreationDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<StudentPlanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  loginFilter?: InputMaybe<StudentLoginFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPlanGroupArgs = {
  id: Scalars['String'];
};


export type QueryPlanGroupsArgs = {
  planId: Scalars['String'];
};


export type QueryPlanItemArgs = {
  id: Scalars['String'];
};


export type QueryPlanItemsByGroupArgs = {
  groupId: Scalars['String'];
};


export type QueryPlanItemsByPlanArgs = {
  planId: Scalars['String'];
};


export type QueryPlanUnreadArgs = {
  id: Scalars['String'];
};


export type QueryPlanningCourseDemandArgs = {
  termIds: Array<Scalars['String']>;
};


export type QueryPlanningCourseDemandRawArgs = {
  termIds: Array<Scalars['String']>;
};


export type QueryPlansArgs = {
  includeChildren?: InputMaybe<Scalars['Boolean']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  ownerAppUserId?: InputMaybe<Scalars['Int']>;
};


export type QueryPrimaryPlanArgs = {
  ownerAppUserId?: InputMaybe<Scalars['Int']>;
};


export type QueryProgramsArgs = {
  campus?: InputMaybe<Scalars['String']>;
  career?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryPublicSettingsArgs = {
  environment: Scalars['String'];
};


export type QueryReadOnlyBulkActionStatusArgs = {
  jobId: Scalars['String'];
};


export type QuerySearchCoursesArgs = {
  campus?: InputMaybe<Scalars['String']>;
  environment: Scalars['String'];
  termCode?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type QuerySearchPlaceholderTemplatesArgs = {
  campusCode?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  searchText: Scalars['String'];
};


export type QuerySearchStudentsArgs = {
  text: Scalars['String'];
};


export type QueryStudentCoursesArgs = {
  studentAppUserId: Scalars['Int'];
};


export type QueryStudentDataArgs = {
  environment: Scalars['String'];
  studentId: Scalars['String'];
};


export type QueryStudentPlanCreationDataArgs = {
  reportOption?: InputMaybe<StudentPlanCreationReportOption>;
};


export type QueryStudentProfileArgs = {
  externalId: Scalars['String'];
};


export type QueryStudentTermGpaArgs = {
  includeNoClasses?: InputMaybe<Scalars['Boolean']>;
  studentAppUserId: Scalars['Int'];
};


export type QueryStudentUsageArgs = {
  year?: InputMaybe<Scalars['String']>;
};


export type QuerySuggestCoursesArgs = {
  environment?: InputMaybe<Scalars['String']>;
  prefix: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryTemplateArgs = {
  id: Scalars['String'];
};


export type QueryTemplateExtractDataArgs = {
  templateIds: Array<Scalars['String']>;
};


export type QueryTemplatesArgs = {
  environment?: InputMaybe<Scalars['String']>;
};


export type QueryUnavailableCourseCountArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
};


export type QueryUnavailableCourseDetailArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryUnreadCommentCountArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUnreadCommentCountDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryUnregisteredCountArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
};


export type QueryUnregisteredCountDetailsArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
};


export type QueryWatchlistArgs = {
  advisorExternalId?: InputMaybe<Scalars['String']>;
};


export type QueryWhatIfAuditReportArgs = {
  auditReportId: Scalars['Int'];
};


export type QueryWhatIfAuditReportsArgs = {
  studentAppUserId: Scalars['Int'];
};

export type QueryAdminUsers_Connection = {
  __typename?: 'QueryAdminUsers_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<AdminUserEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryCreditCountDetails_Connection = {
  __typename?: 'QueryCreditCountDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<CreditCountDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryDiagnosticLogs_Connection = {
  __typename?: 'QueryDiagnosticLogs_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<DiagnosticLogEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryIncomingNoPlanDetails_Connection = {
  __typename?: 'QueryIncomingNoPlanDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<IncomingNoPlanDetailEdge>;
  /** List of majors to use for filtering */
  majors: Array<StudentAcademicProgram>;
  /** List of minors to use for filtering */
  minors: Array<StudentAcademicProgram>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryNotRegisteredCountDetails_Connection = {
  __typename?: 'QueryNotRegisteredCountDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<NotRegisteredCountDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryPlanCreationDetails_Connection = {
  __typename?: 'QueryPlanCreationDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<StudentPlanDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryUnavailableCourseDetail_Connection = {
  __typename?: 'QueryUnavailableCourseDetail_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<UnavailableCourseDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryUnreadCommentCountDetails_Connection = {
  __typename?: 'QueryUnreadCommentCountDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<UnreadCommentCountDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type QueryUnregisteredCountDetails_Connection = {
  __typename?: 'QueryUnregisteredCountDetails_Connection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<UnregisteredCountDetailEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Registration Time Ticket */
export type RegistrationTimeTicket = {
  __typename?: 'RegistrationTimeTicket';
  /** The unique id */
  id: Scalars['ID'];
  /** Flag to denote if the time ticket uses the legacy format */
  legacyFormat?: Maybe<Scalars['Boolean']>;
  /** Time ticket begin date */
  timeTicketBegin?: Maybe<Scalars['DateTime']>;
  /** Time ticket end date */
  timeTicketEnd?: Maybe<Scalars['DateTime']>;
};

/** An academic period (like quarter, trimester or semester). */
export type ReportTerm = {
  __typename?: 'ReportTerm';
  /** Indicates that the term is active */
  active: Scalars['Boolean'];
  /** The unique identifier of the term from the SIS */
  externalId: Scalars['String'];
  /** The unique identifier of the term */
  id: Scalars['ID'];
  /** Name of the term */
  name: Scalars['String'];
};

/** A requirement that the student needs to meet */
export type Requirement = {
  __typename?: 'Requirement';
  /** The courses that can be or have been used to meet this requirement */
  courses?: Maybe<Array<AuditCourse>>;
  /** The number of courses still needed to satisfy this requirement */
  coursesNeeded: Scalars['String'];
  /** The total number of courses needed to satisfy this requirement */
  coursesRequired: Scalars['String'];
  /** The total number of courses used to satisfy this requirement */
  coursesUsed: Scalars['String'];
  /** The number of credits still needed to satisfy this requirement */
  creditsNeeded: Scalars['String'];
  /** The total number of credits needed to satisfy this requirement */
  creditsRequired: Scalars['String'];
  /** The total number of credits used to satisfy this requirement */
  creditsUsed: Scalars['String'];
  /** Long description of the requirement */
  description: Scalars['String'];
  /** The exceptions of this requirement */
  exceptions?: Maybe<Array<Exception>>;
  /** The identifier from the SIS */
  externalId?: Maybe<Scalars['String']>;
  /** The students actual gpa */
  gpaActual: Scalars['String'];
  /** The gpa required to meet this requirement */
  gpaRequired: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether this requirement is in Progress */
  inProgress: Scalars['Boolean'];
  /** Flag to denote whether this requirement has been met */
  met: Scalars['Boolean'];
  /** The requirement lines or sub-requirements of this requirement */
  requirementLines?: Maybe<Array<RequirementLine>>;
  /** Flag for whether or not to show the gpa in the UI */
  showGpa: Scalars['Boolean'];
  /** Status description such as Satisfied or Not Satisfied */
  statusDescription?: Maybe<Scalars['String']>;
  /** Title of the requirement */
  title: Scalars['String'];
};

/** A group of requirements; For example: general ed requirements, or major requirements */
export type RequirementGroup = {
  __typename?: 'RequirementGroup';
  /** The catalog year, for example: 2022 (degreeworks specific) */
  catalogYear?: Maybe<Scalars['String']>;
  /** The catalog year description, for example 2021-2022 (degreeworks specific) */
  catalogYearDescription?: Maybe<Scalars['String']>;
  /** The number of courses still needed to satisfy this requirement */
  coursesNeeded: Scalars['String'];
  /** The total number of courses needed to satisfy this requirement */
  coursesRequired: Scalars['String'];
  /** The total number of courses used to satisfy this requirement */
  coursesUsed: Scalars['String'];
  /** The number of credits still needed to satisfy this requirement */
  creditsNeeded: Scalars['String'];
  /** The total number of credits needed to satisfy this requirement */
  creditsRequired: Scalars['String'];
  /** The total number of credits used to satisfy this requirement */
  creditsUsed: Scalars['String'];
  /** A description of the requirement grouping */
  description: Scalars['String'];
  /** The identifier from the SIS */
  externalId?: Maybe<Scalars['String']>;
  /** The students actual gpa */
  gpaActual: Scalars['String'];
  /** The gpa required to meet this requirement */
  gpaRequired: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether this requirement is in progress */
  inProgress: Scalars['Boolean'];
  /** Flag to denote whether this requirement has been met */
  met: Scalars['Boolean'];
  /** Code of the students degree plan */
  planCode?: Maybe<Scalars['String']>;
  /** Code of the program this requirement group belongs to */
  programCode?: Maybe<Scalars['String']>;
  /** The requirements belonging to this group */
  requirements: Array<Requirement>;
  /** Flag for whether or not to show the gpa in the UI */
  showGpa: Scalars['Boolean'];
  /** Status description such as Satisfied or Not Satisfied */
  statusDescription?: Maybe<Scalars['String']>;
  /** The code of the subplan (aka degree focus) */
  subPlanCode?: Maybe<Scalars['String']>;
  /** Title of the requirement group */
  title: Scalars['String'];
};

/** A specific requirement line or sub-requirement that the student needs to meet */
export type RequirementLine = {
  __typename?: 'RequirementLine';
  /** The courses that can be or have been used to meet this requirement */
  courses?: Maybe<Array<AuditCourse>>;
  /** The number of courses still needed to satisfy this requirement */
  coursesNeeded: Scalars['String'];
  /** The total number of courses needed to satisfy this requirement */
  coursesRequired: Scalars['String'];
  /** The total number of courses used to satisfy this requirement */
  coursesUsed: Scalars['String'];
  /** The number of credits still needed to satisfy this requirement */
  creditsNeeded: Scalars['String'];
  /** The total number of credits needed to satisfy this requirement */
  creditsRequired: Scalars['String'];
  /** The total number of credits used to satisfy this requirement */
  creditsUsed: Scalars['String'];
  /** Long description of the requirement */
  description: Scalars['String'];
  /** The exceptions of this requirement */
  exceptions?: Maybe<Array<Exception>>;
  /** The identifier from the SIS */
  externalId?: Maybe<Scalars['String']>;
  /** The students actual gpa */
  gpaActual: Scalars['String'];
  /** The gpa required to meet this requirement */
  gpaRequired: Scalars['String'];
  /** Id of this record, if it has been stored in the audit-service database */
  id?: Maybe<Scalars['ID']>;
  /** Flag to denote whether this requirement is in Progress */
  inProgress: Scalars['Boolean'];
  /** Flag to denote whether this requirement has been met */
  met: Scalars['Boolean'];
  /** Flag for whether or not to show the gpa in the UI */
  showGpa: Scalars['Boolean'];
  /** Status description such as Satisfied or Not Satisfied */
  statusDescription?: Maybe<Scalars['String']>;
  /** Title of the requirement */
  title: Scalars['String'];
};

/** Generic object returned from mutations that would otherwise return void */
export type ResponseStatus = {
  __typename?: 'ResponseStatus';
  /** The id of the object that was mutated */
  id: Scalars['String'];
  /** The ids of the objects that were mutated */
  ids: Array<Scalars['String']>;
  /** Error message if there is one */
  message: Scalars['String'];
  /** Whether the request was successful or not */
  success: Scalars['Boolean'];
};

/** Term that is active for scheduling */
export type SchedulerActiveTerm = {
  __typename?: 'SchedulerActiveTerm';
  /** Term description, aka title in Scheduler */
  description: Scalars['String'];
  /** Term code */
  termCode: Scalars['String'];
};

/** Catalog Course returned by the search query */
export type SearchCourse = {
  __typename?: 'SearchCourse';
  /** The academic group description of this course */
  academicGroupDescription?: Maybe<Scalars['String']>;
  /** The course's campus */
  campus?: Maybe<Scalars['String']>;
  /** The courseId that comes from the SIS */
  courseId?: Maybe<Scalars['String']>;
  /** Course number, i.e. 101 or 204A */
  courseNumber: Scalars['String'];
  /** Maximum number of credits awarded by the course */
  creditsMax: Scalars['Float'];
  /** Minimum number of credits awarded by the course */
  creditsMin: Scalars['Float'];
  /** Description of the course */
  description: Scalars['String'];
  /** The course's ID in the SIS */
  externalCourseId: Scalars['String'];
  /** Unique identifier for the course */
  id: Scalars['ID'];
  /** The prereq/coreq description for this course */
  requisiteDescription?: Maybe<Scalars['String']>;
  /** The long prereq/coreq description for this course */
  requisiteDescriptionLong?: Maybe<Scalars['String']>;
  /** Description of the subject associated with the course */
  subjectDescription?: Maybe<Scalars['String']>;
  /** ID of the subject associated with the course */
  subjectId: Scalars['String'];
  /** Title of the course */
  title: Scalars['String'];
};

/** Section Field Text Customization Center Settings used for field labels in tables and details. Paired with grid settings. */
export type SectionFieldText = {
  __typename?: 'SectionFieldText';
  /** The campus section specific label */
  campus: Scalars['String'];
  /** The campus plural section specific label */
  campusPlural: Scalars['String'];
  /** The component section specific label */
  component: Scalars['String'];
  /** The course number section specific label */
  course: Scalars['String'];
  /** The credit section specific label */
  credit: Scalars['String'];
  /** The credits section specific label */
  credits: Scalars['String'];
  /** The dates section specific label */
  dates: Scalars['String'];
  /** The days section specific label */
  days: Scalars['String'];
  /** The instruction mode section specific label */
  instructionMode: Scalars['String'];
  /** The instructor section specific label */
  instructor: Scalars['String'];
  /** The instructor plural section specific label */
  instructorPlural: Scalars['String'];
  /** The location section specific label */
  location: Scalars['String'];
  /** The meetings section specific label */
  meetings: Scalars['String'];
  /** The open seats section specific label */
  openSeats: Scalars['String'];
  /** The registration number section specific label */
  registrationNumber: Scalars['String'];
  /** The rooms section specific label */
  rooms: Scalars['String'];
  /** The time section specific label */
  time: Scalars['String'];
};

/** The input object for sending an email */
export type SendEmailInput = {
  /** The email address that should be carbon copied on this email */
  ccEmail?: InputMaybe<Scalars['String']>;
  /** The body of the email */
  message?: InputMaybe<Scalars['String']>;
  /** The subject of the email */
  subject?: InputMaybe<Scalars['String']>;
  /** The email address that this email should be sent to */
  toEmail: Scalars['String'];
};

/** Settings that don't fit under any other place. Overall important toggles that can change the way the tools work and act. */
export type SisSettings = {
  __typename?: 'SisSettings';
  /** Is registration enabled. This enabled a different header and registration buttons. */
  liveRegistration: Scalars['Boolean'];
  /** Which sisType the current environment is configured to be */
  sisType: SisType;
};

/** The current institution sis type */
export enum SisType {
  Banner = 'BANNER',
  Colleague = 'COLLEAGUE',
  Flat = 'FLAT',
  Peoplesoft = 'PEOPLESOFT',
  Unknown = 'UNKNOWN',
  Workday = 'WORKDAY'
}

export type SiteSettings = {
  __typename?: 'SiteSettings';
  /** Settings for the Academic Planner, aka student-app */
  academicPlanningSettings: AcademicPlanningSettings;
  /** Settings to control admin features */
  adminSetting: AdminSettings;
  /** Settings to control the authentication process */
  authSettings: AuthSettings;
  /** Settings typically related to the shopping cart */
  cartSettings: CartSettings;
  /** Settings to control course search */
  courseSearchSettings: CourseSearchSettings;
  /** Settings typically related to course display */
  courseSettings: CourseSettings;
  /** Settings to control help display including urls and text */
  helpSettings: HelpSettings;
  /** Settings that control the home page in Scheduler */
  homeSettings: HomeSettings;
  /** Settings for interaction with the sis. These are optionally controlled by the client. */
  integrationSettings: IntegrationSettings;
  /** Controls labels for section display */
  sectionFieldText: SectionFieldText;
  /** Settings that don't fit under any other place. Overall important toggles that can change the way the tools work and act. */
  sisSettings: SisSettings;
  /** Settings for controlling theming */
  styleSettings: StyleSettings;
  /** Labels for use in the app. */
  text: Text;
};

/** Sort order for use with paged results, ASC & DESC */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Student academic programs, major, minor, etc. */
export type StudentAcademicProgram = {
  __typename?: 'StudentAcademicProgram';
  /** Description of the academic program */
  description: Scalars['String'];
  /** Unique ID of the academic program */
  programId: Scalars['String'];
  /** The type of this academic program (ie: Major, Minor) */
  type: Scalars['String'];
};

/** Login button options to dynamically control which auth0 connections to use */
export type StudentAppAuth0LoginOption = {
  __typename?: 'StudentAppAuth0LoginOption';
  /** Which auth0 connection should this login button use during login */
  auth0Connection: Scalars['String'];
  /** Label for the login button option */
  label: Scalars['String'];
};

/** The type of authentication provider */
export enum StudentAppAuthProviderType {
  Auth0 = 'AUTH0',
  Oidc = 'OIDC'
}

/** Student Attribute */
export type StudentAttribute = {
  __typename?: 'StudentAttribute';
  /** Attribute code */
  code?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** Attribute value */
  value?: Maybe<Scalars['String']>;
};

/** Student Course */
export type StudentCourse = {
  __typename?: 'StudentCourse';
  /** External Id of the course from CivEtl */
  civCourseId?: Maybe<Scalars['String']>;
  /** External Id of the course from the sis */
  courseExternalId: Scalars['String'];
  /** The amount of credits the course was taken for */
  credits?: Maybe<Scalars['Float']>;
  /** The grade received */
  displayGrade?: Maybe<Scalars['String']>;
  /** The externalId of the instructor */
  instructorExternalId?: Maybe<Scalars['String']>;
  /** The first name of the instructor */
  instructorFirstName?: Maybe<Scalars['String']>;
  /** The last name of the instructor */
  instructorLastName?: Maybe<Scalars['String']>;
  /** The instructors associated to this course */
  instructors?: Maybe<Array<Maybe<CourseInstructor>>>;
  /** Is the course active */
  isActive: Scalars['Boolean'];
  /** Is the course completed */
  isCompleted: Scalars['Boolean'];
  /** Is the course registered for and not yet in progress */
  isRegistered: Scalars['Boolean'];
  /** Is the course retaken */
  isRetake: Scalars['Boolean'];
  /** Is the course a transfer course */
  isTransfer: Scalars['Boolean'];
  /** Is the course waitlisted */
  isWaitlisted: Scalars['Boolean'];
  /** Is the student withdrawn from the course */
  isWithdrawn: Scalars['Boolean'];
  /** The timestamp of when this data was inserted */
  lastSyncTimestamp: Scalars['DateTime'];
  /** LMS recorded average daily class visits for course */
  lmsAverageDailyClassVisits?: Maybe<Scalars['Float']>;
  /** LMS recorded average grade for course */
  lmsAverageGrade?: Maybe<Scalars['Float']>;
  /** LMS recorded daily class visits for student */
  lmsDailyClassVisits?: Maybe<Scalars['Float']>;
  /** LMS recorded grade for student */
  lmsGrade?: Maybe<Scalars['Float']>;
  /** The term season when the course was taken, for example: Fall, Spring, Summer */
  season?: Maybe<Scalars['String']>;
  /** ExternalId of the section */
  sectionExternalId?: Maybe<Scalars['String']>;
  /** Describes how the student took the class, for example: Online, Offline or Blended */
  sectionModality?: Maybe<Scalars['String']>;
  /** Display Name of session, for example: Off-Schedule, Full Term, Intersession, 7-Week Block 1 */
  sessionDisplayName?: Maybe<Scalars['String']>;
  /** Date the course ended */
  sessionEndDate?: Maybe<Scalars['Date']>;
  /** Date the course started */
  sessionStartDate?: Maybe<Scalars['Date']>;
  /** Title of the course */
  title?: Maybe<Scalars['String']>;
  /** The year when the course was taken */
  year?: Maybe<Scalars['Int']>;
};

/** Degree plan */
export type StudentDataDegreePlan = {
  __typename?: 'StudentDataDegreePlan';
  /** Courses for the degree plan */
  courses?: Maybe<Array<DegreePlanCourse>>;
  /** The degree plan description */
  description?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** The degree plan name */
  name?: Maybe<Scalars['String']>;
  /** Placeholders for the degree plan */
  placeHolders?: Maybe<Array<DegreePlanPlaceHolder>>;
  /** The degree plan id */
  planId?: Maybe<Scalars['String']>;
  /** Sources */
  sources?: Maybe<Scalars['String']>;
};

/** The input object used for requesting student data */
export type StudentDataRequestInput = {
  /** The environment of the application (for example: demo) */
  environment: Scalars['String'];
  /** The user sub.  Needed for response processing */
  sub?: InputMaybe<Scalars['String']>;
  /** The student id for whom to get the student data for */
  username: Scalars['String'];
};

/** The payload returned from the student data subscription */
export type StudentDataSubscriptionPayload = {
  __typename?: 'StudentDataSubscriptionPayload';
  /** The students id */
  studentId: Scalars['String'];
};

/** Filter type for student login status. */
export enum StudentLoginFilter {
  StudentsWithoutLogin = 'STUDENTS_WITHOUT_LOGIN',
  StudentsWithLogin = 'STUDENTS_WITH_LOGIN'
}

/** Student Major */
export type StudentMajor = {
  __typename?: 'StudentMajor';
  /** The unique id */
  id: Scalars['ID'];
  /** The major code */
  majorCode?: Maybe<Scalars['String']>;
  /** The major name */
  majorName?: Maybe<Scalars['String']>;
};

/** Data object containing student information and if it has plans or not */
export type StudentPlanCreation = {
  __typename?: 'StudentPlanCreation';
  /** The initial term of the student */
  admitTerm?: Maybe<Scalars['String']>;
  /** The campus of the student */
  campus?: Maybe<Scalars['String']>;
  /** The first name of the student */
  firstName: Scalars['String'];
  /** The date of the last login */
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** The last name of the student */
  lastName: Scalars['String'];
  /** Flag indication whether the student has plans or not */
  planCreation: Scalars['Boolean'];
  /** The identifier for the student */
  studentId: Scalars['String'];
};

/** Possible options for the Student Plan Creation Report */
export enum StudentPlanCreationReportOption {
  All = 'ALL',
  WithoutPlan = 'WITHOUT_PLAN',
  WithPlan = 'WITH_PLAN'
}

/** Detailed information on a list of students and when they last logged in to the student app. */
export type StudentPlanDetail = {
  __typename?: 'StudentPlanDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** When the student last logged into student-app. */
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Students last name */
  lastName: Scalars['String'];
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
};

export type StudentPlanDetailEdge = {
  __typename?: 'StudentPlanDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: StudentPlanDetail;
};

/** Filter type for student plan status. */
export enum StudentPlanFilter {
  StudentsWithoutPlans = 'STUDENTS_WITHOUT_PLANS',
  StudentsWithPlans = 'STUDENTS_WITH_PLANS'
}

/** Student Profile */
export type StudentProfile = {
  __typename?: 'StudentProfile';
  /** The home campus associated with this student */
  campus?: Maybe<Scalars['String']>;
  /** The career associated with this student */
  career: Scalars['String'];
  /** The career code associated with this student */
  careerCode?: Maybe<Scalars['String']>;
  /** The cumulative credits this student has earned */
  cumulativeCreditsEarned?: Maybe<Scalars['Float']>;
  /** The cumulative GPA this student has earned */
  cumulativeGpa?: Maybe<Scalars['Float']>;
  /** The cumulated transfer credits this student has earned */
  cumulativeTransferCreditsEarned?: Maybe<Scalars['Float']>;
  /** The student's email address */
  email: Scalars['String'];
  /** Environment that the student belongs to */
  environment: Scalars['String'];
  /** The expected graduation term for this student */
  expectedGradTerm?: Maybe<Scalars['String']>;
  /** The expected graduation year for this student */
  expectedGradYear?: Maybe<Scalars['Int']>;
  /** ID of the student in the SIS */
  externalId: Scalars['String'];
  /** Student's first name */
  firstName: Scalars['String'];
  /** ID of the student in se_sis_data database */
  id: Scalars['ID'];
  /** Student's last name */
  lastName: Scalars['String'];
  /** Preferred name for the student */
  preferredName?: Maybe<Scalars['String']>;
  /** The start term for this student */
  startTerm?: Maybe<Scalars['String']>;
  /** The start term code for this student */
  startTermCode?: Maybe<Scalars['String']>;
  /** The start term description for this student */
  startTermDescription?: Maybe<Scalars['String']>;
  /** The start year for this student */
  startYear?: Maybe<Scalars['Int']>;
};

/** Student Term Gpa */
export type StudentTermGpa = {
  __typename?: 'StudentTermGpa';
  /** Credits attempted by the student for the particular term */
  creditsAttempted?: Maybe<Scalars['Float']>;
  /** Credits earned by the student for the particular term */
  creditsEarned?: Maybe<Scalars['Float']>;
  /** GPA for the student for the particular term */
  gpa: Scalars['Float'];
  /** Term season, such as Fall, Winter, Spring, Summer */
  season?: Maybe<Scalars['String']>;
  /** The term's code as defined in the SIS */
  termCode?: Maybe<Scalars['String']>;
  /** Year for the term */
  year?: Maybe<Scalars['Int']>;
};

/** Student usage statistics */
export type StudentUsage = {
  __typename?: 'StudentUsage';
  /** Student usage statistics per month */
  monthly: Array<StudentUsageMonthlyAggregate>;
};

/** Monthly usage statistic */
export type StudentUsageMonthlyAggregate = {
  __typename?: 'StudentUsageMonthlyAggregate';
  /** Month */
  month: Scalars['Int'];
  /** Total Login count for given month */
  numberOfLogins: Scalars['Int'];
  /** New student count for given month */
  numberOfNewStudents: Scalars['Int'];
  /** Year */
  year: Scalars['String'];
};

/** Student user data information from the sis */
export type StudentUser = User & {
  __typename?: 'StudentUser';
  /** The academic programs for the student */
  academicPrograms?: Maybe<Array<AcademicProgram>>;
  /** Additional SIS-specific data for the student.  This field is json, but on the backend its a Map<string, string> */
  additionalData?: Maybe<Scalars['JSON']>;
  /** Additional identifiers */
  additionalIdentifiers?: Maybe<Array<AdditionalIdentifier>>;
  /** App User Id for user */
  appUserId: Scalars['Int'];
  /** When was user created */
  createdTimestamp: Scalars['DateTime'];
  /** The degree plans for the student */
  degreePlans?: Maybe<Array<StudentDataDegreePlan>>;
  /** Display Name */
  displayName?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['EmailAddress']>;
  /** SAAS Environment */
  environment: Scalars['String'];
  /** Filters */
  filters?: Maybe<Array<Filter>>;
  /** First Name */
  firstName?: Maybe<Scalars['String']>;
  /** Holds that the student has */
  holds?: Maybe<Array<Hold>>;
  /** Generated User ID Unique Per Role */
  id: Scalars['Long'];
  /** Last Name */
  lastName?: Maybe<Scalars['String']>;
  /** Timestamp of when the user profile was last updated from identity provider */
  lastSyncTimestamp?: Maybe<Scalars['DateTime']>;
  /** Messages */
  messages?: Maybe<Array<Message>>;
  /** The name of the student */
  name?: Maybe<Scalars['String']>;
  /** User Picture */
  picture?: Maybe<Scalars['String']>;
  /** Registration Worksheet Student Ids */
  registrationWorksheetStudentIds?: Maybe<Array<Scalars['String']>>;
  /** The selected career */
  selectedCareer?: Maybe<Scalars['String']>;
  /** The selected term */
  selectedTerm?: Maybe<Scalars['String']>;
  /** When the user last logged into planning/student-app */
  studentAppLastLoginTimestamp?: Maybe<Scalars['DateTime']>;
  /** The students id */
  studentId?: Maybe<Scalars['String']>;
  /** JWT Subject Identifier */
  sub?: Maybe<Scalars['String']>;
  /** Term information for the student */
  terms?: Maybe<Array<Term>>;
};

/** Response object containing studentUser data, and possibly the correlationId, if a request was made to get the latest student data */
export type StudentUserResponse = {
  __typename?: 'StudentUserResponse';
  /** The correlationId from the sis-bridge-service.  Populated only if a request was made to get the latest data */
  correlationId?: Maybe<Scalars['String']>;
  /** The student user object */
  studentUser: StudentUser;
};

/** Style Customization Center Settings */
export type StyleSettings = {
  __typename?: 'StyleSettings';
  /** The url for the logo to display using the logo file name */
  logoUrl: Scalars['String'];
  /** Color of the navigation bar */
  navbarColor: Scalars['String'];
  /** Primary color */
  primaryColor: Scalars['String'];
  /** Additional color that will be used in the header and as an accent color */
  secondaryColor: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** A subscription that notifies when the apply template process is complete.  Matches based on correlationId */
  applyTemplateComplete: ApplyTemplateResponse;
  /** Stream events from the Civitas Learning AI assistant, one event per token or tool status */
  assistantMessageStream: AssistantStreamEvent;
  /** A subscription that notifies when the audit generation is complete.  Matches based on correlationId */
  auditGenerationComplete: AuditResponse;
  changeLogAdded: ChangeLog;
  commentAdded: Comment;
  /** Subscription that returns the data of who last made changes to the plan */
  planChangedBy: PlanChangedBy;
  studentDataUpdated: StudentDataSubscriptionPayload;
};


export type SubscriptionApplyTemplateCompleteArgs = {
  correlationIds: Array<Scalars['String']>;
};


export type SubscriptionAssistantMessageStreamArgs = {
  history: Array<MessageInput>;
  message: Scalars['String'];
  pageContext: Scalars['String'];
  skill?: InputMaybe<Scalars['String']>;
};


export type SubscriptionAuditGenerationCompleteArgs = {
  correlationId: Scalars['String'];
  enableCrossListingUsedCourses?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionChangeLogAddedArgs = {
  planId: Scalars['String'];
};


export type SubscriptionCommentAddedArgs = {
  planId?: InputMaybe<Scalars['String']>;
  subscribeToAll?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionPlanChangedByArgs = {
  planId: Scalars['String'];
};


export type SubscriptionStudentDataUpdatedArgs = {
  correlationId: Scalars['String'];
};

/** Course suggestion result */
export type SuggestCourse = {
  __typename?: 'SuggestCourse';
  /** Course Number */
  courseNumber: Scalars['String'];
  /** Course Description */
  description: Scalars['String'];
  /** External unique ID */
  externalCourseId: Scalars['String'];
  /** Internal unique ID */
  id: Scalars['ID'];
  /** Subject ID */
  subjectId: Scalars['String'];
  /** Title */
  title: Scalars['String'];
  /** When the course is typically offered */
  typicallyOffered: Scalars['String'];
};

/** Overrides for label and table names for template detail fields. */
export type TemplateDetailOption = {
  __typename?: 'TemplateDetailOption';
  /** The key for the detail option, e.g. "College" */
  key: Scalars['String'];
  /** The label override to use for the detail option */
  label: Scalars['String'];
  /** Override for the table to pull the data from for the dropdown */
  table: Scalars['String'];
  /** Title of the field for display purposes */
  title: Scalars['String'];
  /** PlanType or SubplanType depending on the table (ACAD_PLAN or ACAD_SUBPLAN); can also be ALL. Used for filtering the records in the et-service */
  type?: Maybe<Scalars['String']>;
};

/** Extracted data from plan templates for reporting */
export type TemplateExtractData = {
  __typename?: 'TemplateExtractData';
  /** The campus code associated with the template */
  campus?: Maybe<Scalars['String']>;
  /** The campus description associated with the template */
  campusDescription?: Maybe<Scalars['String']>;
  /** The catalog year code associated with the template */
  catalogYear?: Maybe<Scalars['String']>;
  /** The catalog year description associated with the template */
  catalogYearDescription?: Maybe<Scalars['String']>;
  /** The college code associated with the template */
  college?: Maybe<Scalars['String']>;
  /** The college description associated with the template */
  collegeDescription?: Maybe<Scalars['String']>;
  /** The concentration code associated with the template */
  concentration?: Maybe<Scalars['String']>;
  /** The course code or title */
  course?: Maybe<Scalars['String']>;
  /** The sequence order of the course within the term */
  courseSequence?: Maybe<Scalars['Int']>;
  /** The number of credits for the course */
  credits?: Maybe<Scalars['Float']>;
  /** The degree code associated with the template */
  degree?: Maybe<Scalars['String']>;
  /** The major code(s) associated with the template */
  major?: Maybe<Scalars['String']>;
  /** The minor code(s) associated with the template */
  minor?: Maybe<Scalars['String']>;
  /** The status of the template (PUBLISHED, DRAFT, ARCHIVED) */
  status?: Maybe<Scalars['String']>;
  /** The term title or code */
  term?: Maybe<Scalars['String']>;
  /** The sequence order of the term in the template */
  termSequence?: Maybe<Scalars['Int']>;
  /** The title of the template */
  title: Scalars['String'];
};

/** Possible status for a template */
export enum TemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Term information for the student */
export type Term = {
  __typename?: 'Term';
  /** List of career term enroll dates */
  careerTermEnrollDates?: Maybe<Array<CareerTermEnrollDate>>;
  /** List of holds */
  holds?: Maybe<Array<Hold>>;
  /** The home campus code */
  homeCampusCode?: Maybe<Scalars['String']>;
  /** The home campus description */
  homeCampusDescription?: Maybe<Scalars['String']>;
  /** The unique id */
  id: Scalars['ID'];
  /** List of registration time tickets */
  registrationTimeTickets?: Maybe<Array<RegistrationTimeTicket>>;
  /** List of student attributes */
  studentAttributes?: Maybe<Array<StudentAttribute>>;
  /** List of student majors */
  studentMajors?: Maybe<Array<StudentMajor>>;
  /** The term code */
  termCode?: Maybe<Scalars['String']>;
  /** The name of the term */
  termName?: Maybe<Scalars['String']>;
};

/** Pairs of types and values to use for template terms */
export type TermOption = {
  __typename?: 'TermOption';
  /** The term type */
  type: Scalars['String'];
  /** The value or name to display for the term */
  value: Scalars['String'];
};

/** Mapping of term types to identifiers. Identifier can be a description, or the last digit of a termCode, depending on termTypeIdentifierMode. */
export type TermTypeIdentifier = {
  __typename?: 'TermTypeIdentifier';
  /** The value that is used to identify term type during translation. i.e. "1" or "Spr" */
  identifier: Scalars['String'];
  /** The term type to assign during translation. */
  termType: Scalars['String'];
};

/** Term field used for mapping term types */
export enum TermTypeIdentifierMode {
  Description = 'DESCRIPTION',
  TermCode = 'TERM_CODE'
}

/** Text Setting to customize labels / fields for use across the applications */
export type Text = {
  __typename?: 'Text';
  /** Advisor label */
  advisor: Scalars['String'];
  /** Advisor plural label */
  advisorPlural: Scalars['String'];
  /** Campus label */
  campus: Scalars['String'];
  /** Campus plural label */
  campusPlural: Scalars['String'];
  /** Course label */
  course: Scalars['String'];
  /** Course plural label */
  coursePlural: Scalars['String'];
  /** Course status label */
  courseStatus: Scalars['String'];
  /** Instruction mode label */
  instructionMode: Scalars['String'];
  /** Instruction mode plural label */
  instructionModePlural: Scalars['String'];
  /** Instructor label */
  instructor: Scalars['String'];
  /** Instructor plural label */
  instructorPlural: Scalars['String'];
  /** Location label */
  location: Scalars['String'];
  /** Location plural label */
  locationPlural: Scalars['String'];
  /** Schedule planner title */
  plannerTitle: Scalars['String'];
  /** Register label */
  register: Scalars['String'];
  /** Registered label */
  registered: Scalars['String'];
  /** Schedule label */
  schedule: Scalars['String'];
  /** Schedule plural label */
  schedulePlural: Scalars['String'];
  /** Section label */
  sectionPlural: Scalars['String'];
  /** Term label */
  term: Scalars['String'];
  /** Term label (plural) */
  termPlural: Scalars['String'];
  /** University label for display in admin area */
  universityTitle: Scalars['String'];
};

/** Detailed information on a list of students who have planned courses that are not available for a specified term. */
export type UnavailableCourseDetail = {
  __typename?: 'UnavailableCourseDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** Students last name */
  lastName: Scalars['String'];
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
  /** Number of unavailable courses the student has planned */
  unofferedCoursesCount: Scalars['Int'];
};

export type UnavailableCourseDetailEdge = {
  __typename?: 'UnavailableCourseDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: UnavailableCourseDetail;
};

/** Detailed information on which students have unread comments, and how many unread comments there are on their primary plan */
export type UnreadCommentCountDetail = {
  __typename?: 'UnreadCommentCountDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** Students last name */
  lastName: Scalars['String'];
  /** Most recent comment date */
  mostRecent?: Maybe<Scalars['DateTime']>;
  /** Title of the students primary plan */
  planTitle: Scalars['String'];
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
  /** The number of unread comments on their primary plan */
  unreadCommentCount: Scalars['Int'];
};

export type UnreadCommentCountDetailEdge = {
  __typename?: 'UnreadCommentCountDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: UnreadCommentCountDetail;
};

/** Detailed information on a list of students who have courses in their shopping carts. */
export type UnregisteredCountDetail = {
  __typename?: 'UnregisteredCountDetail';
  /** Students first name */
  firstName: Scalars['String'];
  /** Students last name */
  lastName: Scalars['String'];
  /** Students appUserId */
  studentAppUserId: Scalars['Int'];
  /** Students external id from the sis */
  studentId: Scalars['String'];
};

export type UnregisteredCountDetailEdge = {
  __typename?: 'UnregisteredCountDetailEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: UnregisteredCountDetail;
};

export type UpdateIntegrationSettingsInput = {
  /** An optional comment about what was changed and why */
  comment?: InputMaybe<Scalars['String']>;
  /** Integration settings for use in communication with external systems. */
  integrationSettings: IntegrationSettingsInput;
};

/** The input object used for updating the items locked value */
export type UpdateLockForAllItemsInput = {
  /** The value to be updated in all plan items */
  locked: Scalars['Boolean'];
  /** The plan id of the items to be updated */
  planId: Scalars['String'];
};

/** The input object used for updating the group's externalTermId and title. */
export type UpdatePlanGroupTermInput = {
  /** The id to link the codified term with the group */
  externalTermId: Scalars['String'];
  /** The unique identifier of the group */
  id: Scalars['ID'];
  /** The description of the codified term to use for the title */
  title: Scalars['String'];
};

/** The input object used for updating the group title */
export type UpdatePlanGroupTitleInput = {
  /** The unique identifier of the group */
  id: Scalars['ID'];
  /** The title of the group */
  title: Scalars['String'];
};

/** The input object used for updating plans */
export type UpdatePlanInput = {
  /** The campus identifier associated with this template */
  campusCode?: InputMaybe<Scalars['String']>;
  /** The catalog year associated with this template */
  catalogYear?: InputMaybe<Scalars['String']>;
  /** The catalog year description, such as 2020-2021 */
  catalogYearDescription?: InputMaybe<Scalars['String']>;
  /** The college identifier associated with this template */
  collegeCode?: InputMaybe<Scalars['String']>;
  /** The concentration identifier associated with this template */
  concentrationCode?: InputMaybe<Scalars['String']>;
  /** The degree identifier associated with this template */
  degreeCode?: InputMaybe<Scalars['String']>;
  /** A description of the template */
  description?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the plan */
  id: Scalars['ID'];
  /** A flag to denote whether this plan is public */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** The title of the plan */
  title?: InputMaybe<Scalars['String']>;
};

/** The input object used for updating items */
export type UpdatePlanItemInput = {
  /** The campus identifier associated with this placeholder template */
  campusCode?: InputMaybe<Scalars['String']>;
  /** The catalog year associated with this placeholder template */
  catalogYear?: InputMaybe<Scalars['String']>;
  /** The catalog year description, such as 2020-2021 */
  catalogYearDescription?: InputMaybe<Scalars['String']>;
  /** The college identifier associated with this placeholder template */
  collegeCode?: InputMaybe<Scalars['String']>;
  /** The concentration identifier associated with this placeholder template */
  concentrationCode?: InputMaybe<Scalars['String']>;
  /** The internal id of the course */
  courseId?: InputMaybe<Scalars['String']>;
  /** The courseNumber associated with this item */
  courseNumber?: InputMaybe<Scalars['String']>;
  /** Maximum amount of credits for this course */
  creditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum amount of credits for this course */
  creditsMin?: InputMaybe<Scalars['Float']>;
  /** The degree identifier associated with this placeholder template */
  degreeCode?: InputMaybe<Scalars['String']>;
  /** The freeform description of an item */
  description?: InputMaybe<Scalars['String']>;
  /** The sequence / position within the group. If omitted, the end of the list will be assumed */
  displaySequence?: InputMaybe<Scalars['Int']>;
  /** The externalCourseId of the course; should be the same as the externalCourseId in catalogCourse from the sis-data-service */
  externalCourseId?: InputMaybe<Scalars['String']>;
  /** The groupId that this item is assigned to; null if the item is not assigned to a group */
  groupId?: InputMaybe<Scalars['String']>;
  /** The unique id of the item */
  id: Scalars['ID'];
  /** Whether the plan item is a course placeholder that the student must choose a course for. */
  isCoursePlaceholder?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan item was locked by an admin. */
  locked?: InputMaybe<Scalars['Boolean']>;
  /** Maximum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMax?: InputMaybe<Scalars['Float']>;
  /** Minimum amount of credits for this item, if this item is either a placeholder or non-codified course */
  nonCourseCreditsMin?: InputMaybe<Scalars['Float']>;
  /** The freeform description of an item, if this item is either a placeholder or non-codified course */
  nonCourseDescription?: InputMaybe<Scalars['String']>;
  /** The title of an item, if this item is either a placeholder or non-codified course */
  nonCourseTitle?: InputMaybe<Scalars['String']>;
  /** The placeholder courses for this item, if this item is a placeholder */
  placeholderCourses?: InputMaybe<Array<PlaceholderCourseInput>>;
  /** The planId that this item is assigned to */
  planId?: InputMaybe<Scalars['String']>;
  /** Whether the plan item was required by an admin. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** The subjectId associated with this item */
  subjectId?: InputMaybe<Scalars['String']>;
  /** The title of the item */
  title?: InputMaybe<Scalars['String']>;
};

/** The input object used for updating the item title */
export type UpdatePlanItemTitleInput = {
  /** The unique id of the item */
  id: Scalars['ID'];
  /** The title of the item */
  nonCourseTitle: Scalars['String'];
};

/** The input object used for updating the plan title */
export type UpdatePlanTitleInput = {
  /** The unique identifier of the plan */
  id: Scalars['ID'];
  /** The title of the plan */
  title: Scalars['String'];
};

/** The input object used for updating the template group title */
export type UpdateTemplateGroupTitleInput = {
  /** The unique identifier of the group */
  id: Scalars['ID'];
  /** The termType as defined by TermOption.type */
  termType: Scalars['String'];
  /** The title as defined by TermOption.value */
  title: Scalars['String'];
};

/** The input object used for creating or updating admin users on login */
export type UpsertAdminUserInput = {
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  externalRoles?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  picture?: InputMaybe<Scalars['String']>;
};

/** Response object for upserting an admin user. */
export type UpsertAdminUserResponse = {
  __typename?: 'UpsertAdminUserResponse';
  adminUser: AdminUser;
  effectivePermissions: Array<AdminUserPermission>;
};

/** The input object used for creating or updating student users on login */
export type UpsertStudentUserProfileInput = {
  /** Display Name */
  displayName?: InputMaybe<Scalars['String']>;
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First Name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the student from external system */
  studentId: Scalars['String'];
};

export type User = {
  /** App User Id for user */
  appUserId: Scalars['Int'];
  /** Display Name */
  displayName?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['EmailAddress']>;
  /** SAAS Environment */
  environment: Scalars['String'];
  /** First Name */
  firstName?: Maybe<Scalars['String']>;
  /** Generated User ID Unique Per Role */
  id: Scalars['Long'];
  /** Last Name */
  lastName?: Maybe<Scalars['String']>;
  /** Timestamp of when the user profile was last updated from identity provider */
  lastSyncTimestamp?: Maybe<Scalars['DateTime']>;
  /** User Picture */
  picture?: Maybe<Scalars['String']>;
  /** JWT Subject Identifier */
  sub?: Maybe<Scalars['String']>;
};

/** The currently authenticated user. */
export type Viewer = {
  __typename?: 'Viewer';
  permissions: Array<Scalars['String']>;
  roles: Array<Scalars['String']>;
};

/** Student details from watchlist query. */
export type WatchlistStudent = {
  __typename?: 'WatchlistStudent';
  /** The student's first name */
  firstName?: Maybe<Scalars['String']>;
  /** When the student last logged into student-app. */
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** The student's last name */
  lastName?: Maybe<Scalars['String']>;
  /** The student's preferred name */
  preferredName?: Maybe<Scalars['String']>;
  /** The title of the student's primary plan, if applicable */
  primaryPlanTitle?: Maybe<Scalars['String']>;
  /** The appUserId for the student */
  studentAppUserId: Scalars['Int'];
  /** The external civETL id for the student */
  studentExternalId?: Maybe<Scalars['String']>;
  /** The external civETL id for the student. This field will replace studentExternalId */
  studentId?: Maybe<Scalars['String']>;
};

/** The input object used for requesting a what-if audit run */
export type WhatIfAuditRequestInput = {
  /** The code of the career; peoplesoft specific */
  career?: InputMaybe<Scalars['String']>;
  /** This is called catalogYear, but appears to be a term code in psoft and dw */
  catalogYear?: InputMaybe<Scalars['String']>;
  /** The code of the degree; degree works specific */
  degree?: InputMaybe<Scalars['String']>;
  /** The environment of the application (for example: demo) */
  environment: Scalars['String'];
  /** The student app user id for whom this audit should be run for */
  studentAppUserId: Scalars['Int'];
  /** The program stack(s) to run the what-if audit on */
  whatIfProgramStacks?: InputMaybe<Array<InputMaybe<WhatIfProgramStackInput>>>;
};

/** The major, minor, concentration selection used when the what-if audit was run */
export type WhatIfProgramStack = {
  __typename?: 'WhatIfProgramStack';
  /** The code of the concentration */
  concentration: Scalars['String'];
  /** The code of the major */
  major: Scalars['String'];
  /** The code of the minor */
  minor: Scalars['String'];
  /** The code of the program; peoplesoft specific */
  program: Scalars['String'];
};

/** The major, minor, concentration selections for running the what-if audit */
export type WhatIfProgramStackInput = {
  /** The code of the concentration */
  concentration?: InputMaybe<Scalars['String']>;
  /** The code of the major */
  major?: InputMaybe<Scalars['String']>;
  /** The code of the minor */
  minor?: InputMaybe<Scalars['String']>;
  /** The code of the program; peoplesoft specific */
  program?: InputMaybe<Scalars['String']>;
};

export type AcademicPlanningSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AcademicPlanningSettingsQuery = { __typename?: 'Query', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', alwaysShowRequirementCourseAndCreditCounts: boolean, auditRefreshNudgeInterval: number, courseTakenRequirementMessage: string, duplicateCourseMessage: string, enableAcademicPlanning: boolean, enableLmsCoursesView: boolean, enableSubstitutionUsedCourses: boolean, externalDegreeAuditUrl: string, failedGrades: Array<string>, hideRequirementPercentComplete: boolean, hideTermsOffered: boolean, hideRequisitesOnPlanItemDetails: boolean, lockPlanBoardToHomeCampus: boolean, notUsedRequirementGroups: Array<string>, readOnlyPlansForStudents: boolean, allowPlaceholderEditInReadOnly: boolean, notUsedRequirements: Array<string>, pastTermYears: number, showExceptionsOnPlanAlerts: boolean, templateDetailOptions: Array<{ __typename?: 'TemplateDetailOption', key: string, label: string, table: string, title: string }>, termOptions: Array<{ __typename?: 'TermOption', type: string, value: string }> } };

export type DegreeAuditSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type DegreeAuditSettingsQuery = { __typename?: 'Query', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', externalDegreeAuditUrl: string, degreeRequirementsPanelConfiguration: DegreeRequirementsPanelConfiguration, hideRequirementPercentComplete: boolean, showExceptionsOnAudit: boolean, showExceptionsOnPlanAlerts: boolean } };

export type DegreeAuditSettingsFragment = { __typename?: 'AcademicPlanningSettings', externalDegreeAuditUrl: string, degreeRequirementsPanelConfiguration: DegreeRequirementsPanelConfiguration, hideRequirementPercentComplete: boolean, showExceptionsOnAudit: boolean, showExceptionsOnPlanAlerts: boolean };

export type AssistantMessageStreamSubscriptionVariables = Exact<{
  message: Scalars['String'];
  history: Array<MessageInput> | MessageInput;
  pageContext: Scalars['String'];
  skill?: InputMaybe<Scalars['String']>;
}>;


export type AssistantMessageStreamSubscription = { __typename?: 'Subscription', assistantMessageStream: { __typename?: 'AssistantStreamEvent', type: AssistantStreamEventType, content?: string | null } };

export type AssistantSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssistantSkillsQuery = { __typename?: 'Query', assistantSkills: Array<{ __typename?: 'AssistantSkill', name: string, description: string }> };

export type AuditReportQueryVariables = Exact<{
  studentAppUserId?: InputMaybe<Scalars['Int']>;
  correlationId?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
}>;


export type AuditReportQuery = { __typename?: 'Query', auditReport: { __typename: 'AuditReport', id?: string | null, correlationId?: string | null, runDate: any, careers: Array<{ __typename?: 'Career', id?: string | null, description: string, title: string, programs?: Array<{ __typename?: 'DegreeProgram', id?: string | null, code: string, description: string, met: boolean, plans?: Array<{ __typename?: 'DegreePlan', id?: string | null, code: string, description: string, met: boolean, subPlans?: Array<{ __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean } | null> | null } | null> | null } | null> | null, requirementGroups?: Array<{ __typename?: 'RequirementGroup', id?: string | null, description: string, title: string, statusDescription?: string | null, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, requirements: Array<{ __typename?: 'Requirement', id?: string | null, description: string, statusDescription?: string | null, title: string, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null, requirementLines?: Array<{ __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null }> }> | null, fallThroughCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, overTheLimitCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, insufficientCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null }> } };

export type AvailableAuditReportTypesQueryVariables = Exact<{
  studentAppUserId: Scalars['Int'];
}>;


export type AvailableAuditReportTypesQuery = { __typename?: 'Query', availableAuditReportTypes: Array<{ __typename?: 'AdditionalAuditReportType', auditReportType: string, career: string, careerCode: string }> };

export type GenerateAuditReportMutationVariables = Exact<{
  input: AuditRequestInput;
}>;


export type GenerateAuditReportMutation = { __typename?: 'Mutation', generateAuditReport: { __typename?: 'CorrelatableResponse', correlationId: string } };

export type AuditGenerationCompleteSubscriptionVariables = Exact<{
  correlationId: Scalars['String'];
  enableCrossListingUsedCourses?: InputMaybe<Scalars['Boolean']>;
}>;


export type AuditGenerationCompleteSubscription = { __typename?: 'Subscription', auditGenerationComplete: { __typename?: 'AuditResponse', correlationId: string, auditReport?: { __typename: 'AuditReport', id?: string | null, correlationId?: string | null, runDate: any, careers: Array<{ __typename?: 'Career', id?: string | null, description: string, title: string, programs?: Array<{ __typename?: 'DegreeProgram', id?: string | null, code: string, description: string, met: boolean, plans?: Array<{ __typename?: 'DegreePlan', id?: string | null, code: string, description: string, met: boolean, subPlans?: Array<{ __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean } | null> | null } | null> | null } | null> | null, requirementGroups?: Array<{ __typename?: 'RequirementGroup', id?: string | null, description: string, title: string, statusDescription?: string | null, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, requirements: Array<{ __typename?: 'Requirement', id?: string | null, description: string, statusDescription?: string | null, title: string, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null, requirementLines?: Array<{ __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null }> }> | null, fallThroughCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, overTheLimitCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, insufficientCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null }> } | null, errors?: Array<{ __typename?: 'AuditError', type: AuditErrorType, message: string }> | null } };

export type AuditReportDataFragment = { __typename: 'AuditReport', id?: string | null, correlationId?: string | null, runDate: any, careers: Array<{ __typename?: 'Career', id?: string | null, description: string, title: string, programs?: Array<{ __typename?: 'DegreeProgram', id?: string | null, code: string, description: string, met: boolean, plans?: Array<{ __typename?: 'DegreePlan', id?: string | null, code: string, description: string, met: boolean, subPlans?: Array<{ __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean } | null> | null } | null> | null } | null> | null, requirementGroups?: Array<{ __typename?: 'RequirementGroup', id?: string | null, description: string, title: string, statusDescription?: string | null, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, requirements: Array<{ __typename?: 'Requirement', id?: string | null, description: string, statusDescription?: string | null, title: string, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null, requirementLines?: Array<{ __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null }> }> | null, fallThroughCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, overTheLimitCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null, insufficientCourses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null } | null> | null }> };

export type AuditProgramDataFragment = { __typename?: 'DegreeProgram', id?: string | null, code: string, description: string, met: boolean, plans?: Array<{ __typename?: 'DegreePlan', id?: string | null, code: string, description: string, met: boolean, subPlans?: Array<{ __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean } | null> | null } | null> | null };

export type AuditPlanDataFragment = { __typename?: 'DegreePlan', id?: string | null, code: string, description: string, met: boolean, subPlans?: Array<{ __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean } | null> | null };

export type AuditSubPlanDataFragment = { __typename?: 'DegreeSubPlan', id?: string | null, code: string, description: string, met: boolean };

export type AuditRequirementGroupDataFragment = { __typename?: 'RequirementGroup', id?: string | null, description: string, title: string, statusDescription?: string | null, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, requirements: Array<{ __typename?: 'Requirement', id?: string | null, description: string, statusDescription?: string | null, title: string, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null, requirementLines?: Array<{ __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null }> };

export type AuditRequirementLineDataFragment = { __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null };

export type AuditRequirementDataFragment = { __typename?: 'Requirement', id?: string | null, description: string, statusDescription?: string | null, title: string, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, externalId?: string | null, gpaActual: string, gpaRequired: string, met: boolean, inProgress: boolean, showGpa: boolean, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null, requirementLines?: Array<{ __typename?: 'RequirementLine', id?: string | null, title: string, description: string, statusDescription?: string | null, met: boolean, inProgress: boolean, coursesNeeded: string, coursesRequired: string, coursesUsed: string, creditsNeeded: string, creditsRequired: string, creditsUsed: string, gpaActual: string, gpaRequired: string, showGpa: boolean, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null, courses?: Array<{ __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null }> | null };

export type AuditCourseDataFragment = { __typename?: 'AuditCourse', id?: string | null, courseNumber: string, credits: string, enrolled?: boolean | null, equivalentCourseGroupId?: string | null, externalCourseId: string, fallThrough?: boolean | null, fallThroughCode?: string | null, gradeReceived: string, overTheLimit?: boolean | null, planned?: boolean | null, requirementGroupExternalId: string, requirementGroupTitle: string, requirementExternalId: string, requirementTitle: string, requirementLineTitle?: string | null, subjectId: string, termCode?: string | null, termDescription?: string | null, title: string, topicDescription?: string | null, topicId?: string | null, usedToMeetRequirement: boolean, inProgress: boolean, withdrawn?: boolean | null, courseTakenInReq?: boolean | null, substitutionSubjectId?: string | null, substitutionCourseNumber?: string | null, substitutionExternalCourseId?: string | null, exceptions?: Array<{ __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string }> | null };

export type AuditExceptionDataFragment = { __typename?: 'Exception', id?: string | null, additionalInformation: string, applyStatus: string, courseNumberBegin: string, createdDate: any, createdEmail: string, createdName: string, degree: string, details: string, detailsHidden: boolean, enforced: string, exceptionType: string, labelTag: string, reason: string, remark: string, school: string, status: string, subjectId: string, title: string, userLast: string };

export type CreateUsersMutationVariables = Exact<{
  input: CreateUsersInput;
}>;


export type CreateUsersMutation = { __typename?: 'Mutation', createUsers: { __typename?: 'CreateUsersResponse', appUserId?: number | null, effectivePermissions?: Array<AdminUserPermission> | null, firstName?: string | null, lastName?: string | null } };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self: { __typename?: 'AppUser', id: number, permissions?: Array<AdminUserPermission | null> | null, adminUser?: { __typename?: 'AdminUser', id: any, appUserId: number, sub?: string | null, email?: any | null, firstName?: string | null, lastName?: string | null } | null, studentUser?: { __typename?: 'StudentUser', id: any, appUserId: number, sub?: string | null, email?: any | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, studentId?: string | null } | null } };

export type SchedulerLoginMutationVariables = Exact<{
  input: CreateSchedulerLoginInput;
}>;


export type SchedulerLoginMutation = { __typename?: 'Mutation', schedulerLogin?: { __typename?: 'CreateSchedulerLoginResponse', key: string } | null };

export type CatalogCourseFragment = { __typename?: 'CatalogCourse', id: string, environment: string, courseNumber: string, description: string, externalCourseId: string, creditsMax: number, creditsMin: number, inProgress?: boolean | null, subjectId: string, title: string, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, usedToMeetRequirement?: boolean | null, requirementTitles?: Array<string | null> | null };

export type CatalogSearchResultFragment = { __typename?: 'SearchCourse', id: string, externalCourseId: string, subjectId: string, subjectDescription?: string | null, courseId?: string | null, courseNumber: string, title: string, description: string, creditsMax: number, creditsMin: number, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, campus?: string | null, academicGroupDescription?: string | null };

export type CatalogCourseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CatalogCourseQuery = { __typename?: 'Query', catalogCourse: { __typename?: 'CatalogCourse', id: string, environment: string, courseNumber: string, description: string, externalCourseId: string, creditsMax: number, creditsMin: number, inProgress?: boolean | null, subjectId: string, title: string, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, usedToMeetRequirement?: boolean | null, requirementTitles?: Array<string | null> | null } };

export type SearchCoursesQueryVariables = Exact<{
  text: Scalars['String'];
  environment: Scalars['String'];
  campus?: InputMaybe<Scalars['String']>;
  termCode?: InputMaybe<Scalars['String']>;
}>;


export type SearchCoursesQuery = { __typename?: 'Query', searchCourses: Array<{ __typename?: 'SearchCourse', id: string, externalCourseId: string, subjectId: string, subjectDescription?: string | null, courseId?: string | null, courseNumber: string, title: string, description: string, creditsMax: number, creditsMin: number, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, campus?: string | null, academicGroupDescription?: string | null }> };

export type CourseHistoryFragment = { __typename?: 'StudentCourse', civCourseId?: string | null, courseExternalId: string, credits?: number | null, displayGrade?: string | null, instructorExternalId?: string | null, instructorFirstName?: string | null, instructorLastName?: string | null, isActive: boolean, isCompleted: boolean, isRegistered: boolean, isRetake: boolean, isTransfer: boolean, isWaitlisted: boolean, isWithdrawn: boolean, lastSyncTimestamp: any, lmsAverageDailyClassVisits?: number | null, lmsAverageGrade?: number | null, lmsDailyClassVisits?: number | null, lmsGrade?: number | null, season?: string | null, sectionExternalId?: string | null, sectionModality?: string | null, sessionStartDate?: any | null, title?: string | null, year?: number | null, instructors?: Array<{ __typename?: 'CourseInstructor', courseExternalId: string, facultyExternalId?: string | null, instructorFirstName?: string | null, instructorLastName?: string | null, lastSyncTimestamp: any, season?: string | null, sectionExternalId?: string | null, year?: number | null } | null> | null };

export type StudentTermGpaFragment = { __typename?: 'StudentTermGpa', creditsAttempted?: number | null, creditsEarned?: number | null, gpa: number, season?: string | null, termCode?: string | null, year?: number | null };

export type StudentCoursesQueryVariables = Exact<{
  studentAppUserId: Scalars['Int'];
}>;


export type StudentCoursesQuery = { __typename?: 'Query', studentCourses: Array<{ __typename?: 'StudentCourse', civCourseId?: string | null, courseExternalId: string, credits?: number | null, displayGrade?: string | null, instructorExternalId?: string | null, instructorFirstName?: string | null, instructorLastName?: string | null, isActive: boolean, isCompleted: boolean, isRegistered: boolean, isRetake: boolean, isTransfer: boolean, isWaitlisted: boolean, isWithdrawn: boolean, lastSyncTimestamp: any, lmsAverageDailyClassVisits?: number | null, lmsAverageGrade?: number | null, lmsDailyClassVisits?: number | null, lmsGrade?: number | null, season?: string | null, sectionExternalId?: string | null, sectionModality?: string | null, sessionStartDate?: any | null, title?: string | null, year?: number | null, instructors?: Array<{ __typename?: 'CourseInstructor', courseExternalId: string, facultyExternalId?: string | null, instructorFirstName?: string | null, instructorLastName?: string | null, lastSyncTimestamp: any, season?: string | null, sectionExternalId?: string | null, year?: number | null } | null> | null }> };

export type StudentTermGpaQueryVariables = Exact<{
  studentAppUserId: Scalars['Int'];
}>;


export type StudentTermGpaQuery = { __typename?: 'Query', studentTermGpa: Array<{ __typename?: 'StudentTermGpa', creditsAttempted?: number | null, creditsEarned?: number | null, gpa: number, season?: string | null, termCode?: string | null, year?: number | null }> };

export type CourseDataLastUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type CourseDataLastUpdateQuery = { __typename?: 'Query', courseDataLastUpdate?: any | null };

export type HasCaseloadQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
}>;


export type HasCaseloadQuery = { __typename?: 'Query', hasCaseload: boolean };

export type UnreadCommentCountQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
}>;


export type UnreadCommentCountQuery = { __typename?: 'Query', unreadCommentCount: number };

export type DownloadUnreadCommentCountDetailQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type DownloadUnreadCommentCountDetailQuery = { __typename?: 'Query', downloadUnreadCommentCountDetail: Array<{ __typename?: 'UnreadCommentCountDetail', firstName: string, lastName: string, planTitle: string, studentId: string, unreadCommentCount: number, mostRecent?: any | null }> };

export type UnreadCommentCountDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type UnreadCommentCountDetailsQuery = { __typename?: 'Query', unreadCommentCountDetails: { __typename?: 'QueryUnreadCommentCountDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'UnreadCommentCountDetailEdge', node: { __typename?: 'UnreadCommentCountDetail', firstName: string, lastName: string, planTitle: string, studentId: string, studentAppUserId: number, unreadCommentCount: number, mostRecent?: any | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PlanCreationCountsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
}>;


export type PlanCreationCountsQuery = { __typename?: 'Query', planCreationCounts: { __typename?: 'PlanCreationDetail', studentsWithPlansCount: number, studentsWithoutPlansCount: number } };

export type DownloadPlanCreationDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  filter?: InputMaybe<StudentPlanFilter>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  loginFilter?: InputMaybe<StudentLoginFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type DownloadPlanCreationDetailsQuery = { __typename?: 'Query', downloadPlanCreationDetails: Array<{ __typename?: 'StudentPlanDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, lastLogin?: any | null }> };

export type PlanCreationDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  filter?: InputMaybe<StudentPlanFilter>;
  loginFilter?: InputMaybe<StudentLoginFilter>;
}>;


export type PlanCreationDetailsQuery = { __typename?: 'Query', planCreationDetails: { __typename?: 'QueryPlanCreationDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'StudentPlanDetailEdge', node: { __typename?: 'StudentPlanDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, lastLogin?: any | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type IncomingNoPlanCountQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
}>;


export type IncomingNoPlanCountQuery = { __typename?: 'Query', incomingNoPlanCount: number };

export type DownloadIncomingNoPlanDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  majorFilter?: InputMaybe<AcademicProgramFilter>;
  minorFilter?: InputMaybe<AcademicProgramFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type DownloadIncomingNoPlanDetailsQuery = { __typename?: 'Query', downloadIncomingNoPlanDetails: Array<{ __typename?: 'IncomingNoPlanDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, academicPrograms?: Array<{ __typename?: 'StudentAcademicProgram', description: string, programId: string, type: string } | null> | null }> };

export type IncomingNoPlanDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  majorFilter?: InputMaybe<AcademicProgramFilter>;
  minorFilter?: InputMaybe<AcademicProgramFilter>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type IncomingNoPlanDetailsQuery = { __typename?: 'Query', incomingNoPlanDetails: { __typename?: 'QueryIncomingNoPlanDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'IncomingNoPlanDetailEdge', node: { __typename?: 'IncomingNoPlanDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, academicPrograms?: Array<{ __typename?: 'StudentAcademicProgram', description: string, programId: string, type: string } | null> | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, majors: Array<{ __typename?: 'StudentAcademicProgram', description: string, programId: string }>, minors: Array<{ __typename?: 'StudentAcademicProgram', description: string, programId: string }> } };

export type CreditCountsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
}>;


export type CreditCountsQuery = { __typename?: 'Query', creditCounts: { __typename?: 'CreditCounts', noCredits: number, zeroToThreeCredits: number, fourToSixCredits: number, sevenToNineCredits: number, tenToTwelveCredits: number, thirteenToFifteenCredits: number, sixteenPlusCredits: number } };

export type DownloadCreditCountDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  maxCredits?: InputMaybe<Scalars['Int']>;
  minCredits?: InputMaybe<Scalars['Int']>;
  noCredits?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type DownloadCreditCountDetailsQuery = { __typename?: 'Query', downloadCreditCountDetails: Array<{ __typename?: 'CreditCountDetail', firstName: string, lastName: string, maxCredits?: number | null, minCredits?: number | null, studentId: string, studentAppUserId: number }> };

export type CreditCountDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  noCredits?: InputMaybe<Scalars['Boolean']>;
  minCredits?: InputMaybe<Scalars['Int']>;
  maxCredits?: InputMaybe<Scalars['Int']>;
  termCode: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type CreditCountDetailsQuery = { __typename?: 'Query', creditCountDetails: { __typename?: 'QueryCreditCountDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'CreditCountDetailEdge', node: { __typename?: 'CreditCountDetail', firstName: string, lastName: string, maxCredits?: number | null, minCredits?: number | null, studentId: string, studentAppUserId: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UnregisteredCountQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
}>;


export type UnregisteredCountQuery = { __typename?: 'Query', unregisteredCount: number };

export type NotRegisteredCountQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
}>;


export type NotRegisteredCountQuery = { __typename?: 'Query', notRegisteredCount: number };

export type DownloadNotRegisteredCountDetailQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type DownloadNotRegisteredCountDetailQuery = { __typename?: 'Query', downloadNotRegisteredCountDetail: Array<{ __typename?: 'NotRegisteredCountDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number }> };

export type NotRegisteredCountDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type NotRegisteredCountDetailsQuery = { __typename?: 'Query', notRegisteredCountDetails: { __typename?: 'QueryNotRegisteredCountDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'NotRegisteredCountDetailEdge', node: { __typename?: 'NotRegisteredCountDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type DownloadUnregisteredCountDetailQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type DownloadUnregisteredCountDetailQuery = { __typename?: 'Query', downloadUnregisteredCountDetail: Array<{ __typename?: 'UnregisteredCountDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number }> };

export type UnregisteredCountDetailsQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type UnregisteredCountDetailsQuery = { __typename?: 'Query', unregisteredCountDetails: { __typename?: 'QueryUnregisteredCountDetails_Connection', totalCount: number, edges: Array<{ __typename?: 'UnregisteredCountDetailEdge', node: { __typename?: 'UnregisteredCountDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type WatchlistStudentFragment = { __typename?: 'WatchlistStudent', studentAppUserId: number, studentId?: string | null, firstName?: string | null, lastName?: string | null, primaryPlanTitle?: string | null, lastLogin?: any | null };

export type AddStudentToWatchlistMutationVariables = Exact<{
  studentAppUserId: Scalars['Int'];
}>;


export type AddStudentToWatchlistMutation = { __typename?: 'Mutation', addStudentToWatchlist: { __typename?: 'WatchlistStudent', studentAppUserId: number, studentId?: string | null, firstName?: string | null, lastName?: string | null, primaryPlanTitle?: string | null, lastLogin?: any | null } };

export type IsStudentInWatchlistQueryVariables = Exact<{
  studentAppUserId: Scalars['Int'];
}>;


export type IsStudentInWatchlistQuery = { __typename?: 'Query', isStudentInWatchlist: boolean };

export type RemoveStudentFromWatchlistMutationVariables = Exact<{
  studentAppUserId?: InputMaybe<Scalars['Int']>;
}>;


export type RemoveStudentFromWatchlistMutation = { __typename?: 'Mutation', removeStudentFromWatchlist: { __typename?: 'ResponseStatus', id: string, message: string, success: boolean } };

export type WatchlistQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
}>;


export type WatchlistQuery = { __typename?: 'Query', watchlist: Array<{ __typename?: 'WatchlistStudent', studentAppUserId: number, studentId?: string | null, firstName?: string | null, lastName?: string | null, primaryPlanTitle?: string | null, lastLogin?: any | null }> };

export type UnavailableCourseCountQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
}>;


export type UnavailableCourseCountQuery = { __typename?: 'Query', unavailableCourseCount: number };

export type DownloadUnavailableCourseDetailQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  termCode: Scalars['String'];
}>;


export type DownloadUnavailableCourseDetailQuery = { __typename?: 'Query', downloadUnavailableCourseDetail: Array<{ __typename?: 'UnavailableCourseDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, unofferedCoursesCount: number }> };

export type UnavailableCourseDetailQueryVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  termCode: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type UnavailableCourseDetailQuery = { __typename?: 'Query', unavailableCourseDetail: { __typename?: 'QueryUnavailableCourseDetail_Connection', totalCount: number, edges: Array<{ __typename?: 'UnavailableCourseDetailEdge', node: { __typename?: 'UnavailableCourseDetail', firstName: string, lastName: string, studentId: string, studentAppUserId: number, unofferedCoursesCount: number } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type MarkAllStudentCommentsAsReadMutationVariables = Exact<{
  advisorExternalId?: InputMaybe<Scalars['String']>;
  excludeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeAllStudents?: InputMaybe<Scalars['Boolean']>;
  includeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type MarkAllStudentCommentsAsReadMutation = { __typename?: 'Mutation', markAllStudentCommentsAsRead: { __typename?: 'ResponseStatus', success: boolean, message: string, ids: Array<string> } };

export type DiagnosticLogDataFragment = { __typename?: 'DiagnosticLog', id: number, message: string, startDate: any, endDate: any };

export type DiagnosticLogsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  endDate?: InputMaybe<Scalars['Timestamp']>;
  types?: InputMaybe<Array<DiagnosticLogType> | DiagnosticLogType>;
}>;


export type DiagnosticLogsQuery = { __typename?: 'Query', diagnosticLogsPaged: { __typename?: 'DiagnosticLogPagedResult', resultCount: number, page: number, pageSize: number, sortKey: string, results: Array<{ __typename?: 'DiagnosticLog', id: number, message: string, startDate: any, endDate: any }> } };

export type SendEmailMutationVariables = Exact<{
  input: SendEmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', sendEmail: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type IntegrationSettingsDataFragment = { __typename?: 'IntegrationSettings', gatewayUrl: string, automaticUpdates: boolean, registrationUrl: string, customSendToCartUrl: string, courseListingSoapAction: string, sendToCartSoapAction: string, planningCatalogRequestPath: string, planningTermRequestPath: string, auditRequestPath: string, academicStructureRequestPath: string, restGatewayUrl: string, nodeName: string, basicAuthUsername: string, basicAuthPasswordSet: boolean, dataServiceUserName: string, dataServicePasswordSet: boolean, dataServiceDbName: string, openSeatsReportPath: string, auditSystem: AuditSystem, auditReportType: string, whatIfAuditReportType: string, whatIfAuditRequestPath: string, institution: string, integrationFields: Array<{ __typename?: 'IntegrationField', key: string, description: string }> };

export type DiagnosticSettingsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DiagnosticSettingsDataQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', integrationSettings: { __typename?: 'IntegrationSettings', gatewayUrl: string, automaticUpdates: boolean, registrationUrl: string, customSendToCartUrl: string, courseListingSoapAction: string, sendToCartSoapAction: string, planningCatalogRequestPath: string, planningTermRequestPath: string, auditRequestPath: string, academicStructureRequestPath: string, restGatewayUrl: string, nodeName: string, basicAuthUsername: string, basicAuthPasswordSet: boolean, dataServiceUserName: string, dataServicePasswordSet: boolean, dataServiceDbName: string, openSeatsReportPath: string, auditSystem: AuditSystem, auditReportType: string, whatIfAuditReportType: string, whatIfAuditRequestPath: string, institution: string, integrationFields: Array<{ __typename?: 'IntegrationField', key: string, description: string }> } } };

export type UpdateIntegrationSettingsMutationVariables = Exact<{
  input: UpdateIntegrationSettingsInput;
}>;


export type UpdateIntegrationSettingsMutation = { __typename?: 'Mutation', updateIntegrationSettings: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type BoardAlertFragment = { __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel };

export type BoardItemFragment = { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null };

export type BoardCommentFragment = { __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null };

export type BoardMajorFragment = { __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null };

export type BoardMinorFragment = { __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null };

export type BoardGroupFragment = { __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> };

export type BoardPlanFragment = { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> };

export type ItemMajorFragment = { __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null };

export type ItemMinorFragment = { __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null };

export type PlaceholderCourseFragment = { __typename?: 'PlaceholderCourse', campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string };

export type PlanItemDetailsFragment = { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null };

export type OwnerPlanFragment = { __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any };

export type ChangeLogFragment = { __typename?: 'ChangeLog', id: string, changedByAppUserId: number, changedTimestamp: any, description: string, planId: string, groupId?: string | null, itemId?: string | null };

export type ChangeLogEdgeNodeFragment = { __typename?: 'ChangeLogEdge', node: { __typename?: 'ChangeLog', id: string, changedByAppUserId: number, changedTimestamp: any, description: string, planId: string, groupId?: string | null, itemId?: string | null } };

export type ChangeLogPageInfoFragment = { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean };

export type ChangeLogConnectionFragment = { __typename?: 'ChangeLogConnection', edges: Array<{ __typename?: 'ChangeLogEdge', node: { __typename?: 'ChangeLog', id: string, changedByAppUserId: number, changedTimestamp: any, description: string, planId: string, groupId?: string | null, itemId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } };

export type PlansByOwnerQueryVariables = Exact<{
  ownerAppUserId: Scalars['Int'];
}>;


export type PlansByOwnerQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any }> };

export type PlanQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlanQuery = { __typename?: 'Query', plan: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }, planAlerts: Array<{ __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel }> };

export type PrimaryPlanQueryVariables = Exact<{
  ownerAppUserId: Scalars['Int'];
}>;


export type PrimaryPlanQuery = { __typename?: 'Query', primaryPlan?: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } | null };

export type PlaceholderCourseDetailQueryVariables = Exact<{
  courseNumber?: InputMaybe<Scalars['String']>;
  externalCourseId?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  subjectId?: InputMaybe<Scalars['String']>;
}>;


export type PlaceholderCourseDetailQuery = { __typename?: 'Query', placeholderCourseDetail: { __typename?: 'PlaceholderCourseDetail', course: { __typename?: 'CatalogCourse', campus?: string | null, campusDescription?: string | null, career?: string | null, courseNumber: string, creditsMax: number, creditsMin: number, description: string, environment: string, externalCourseId: string, inProgress?: boolean | null, requirementTitles?: Array<string | null> | null, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, subjectDescription: string, subjectId: string, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null }, alerts: Array<{ __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel }> } };

export type PlanItemQueryVariables = Exact<{
  id: Scalars['String'];
  planId: Scalars['String'];
}>;


export type PlanItemQuery = { __typename?: 'Query', plan: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }, planItem: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null }, planAlerts: Array<{ __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel }> };

export type AddPlanMutationVariables = Exact<{
  input: CreatePlanInput;
}>;


export type AddPlanMutation = { __typename?: 'Mutation', addPlan: { __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isTemplate: boolean, publishedAt?: any | null, status?: TemplateStatus | null, templateMessage?: string | null, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } };

export type GroupByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GroupByIdQuery = { __typename?: 'Query', planGroup: { __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> } };

export type PlanGroupsQueryVariables = Exact<{
  planId: Scalars['String'];
}>;


export type PlanGroupsQuery = { __typename?: 'Query', planGroups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }> };

export type PlanUnreadQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlanUnreadQuery = { __typename?: 'Query', planUnread: boolean };

export type AddPlanGroupMutationVariables = Exact<{
  input: CreatePlanGroupInput;
}>;


export type AddPlanGroupMutation = { __typename?: 'Mutation', addPlanGroup: { __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> } };

export type UpdatePlanGroupTitleMutationVariables = Exact<{
  input: UpdatePlanGroupTitleInput;
}>;


export type UpdatePlanGroupTitleMutation = { __typename?: 'Mutation', updatePlanGroupTitle: { __typename?: 'PlanGroup', id: string, title: string } };

export type AddTemplateGroupMutationVariables = Exact<{
  input: CreatePlanGroupInput;
}>;


export type AddTemplateGroupMutation = { __typename?: 'Mutation', addTemplateGroup: { __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> } };

export type UpdateTemplateGroupTitleMutationVariables = Exact<{
  input: UpdateTemplateGroupTitleInput;
}>;


export type UpdateTemplateGroupTitleMutation = { __typename?: 'Mutation', updateTemplateGroupTitle: { __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> } };

export type MoveTemplateGroupMutationVariables = Exact<{
  input: MovePlanGroupInput;
}>;


export type MoveTemplateGroupMutation = { __typename?: 'Mutation', moveTemplateGroup: { __typename?: 'PlanGroup', id: string, planId: string, displaySequence: number } };

export type DeleteTemplateGroupMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteTemplateGroupMutation = { __typename?: 'Mutation', deleteTemplateGroup: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type AddPlanItemMutationVariables = Exact<{
  input: CreatePlanItemInput;
}>;


export type AddPlanItemMutation = { __typename?: 'Mutation', addPlanItem: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null } };

export type UpdatePlanItemMutationVariables = Exact<{
  input: UpdatePlanItemInput;
}>;


export type UpdatePlanItemMutation = { __typename?: 'Mutation', updatePlanItem: { __typename: 'PlanItem', id: string, availability?: CourseAvailability | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type MovePlanItemMutationVariables = Exact<{
  input: MovePlanItemInput;
}>;


export type MovePlanItemMutation = { __typename?: 'Mutation', movePlanItem: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type DeletePlanItemMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeletePlanItemMutation = { __typename?: 'Mutation', deletePlanItem: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type CopyPlanMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type CopyPlanMutation = { __typename?: 'Mutation', copyPlan: { __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any } };

export type CopyEmbeddedPlanMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type CopyEmbeddedPlanMutation = { __typename?: 'Mutation', copyEmbeddedPlan: { __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any } };

export type MakePlanPrimaryMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type MakePlanPrimaryMutation = { __typename?: 'Mutation', makePlanPrimary: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type UpdatePlanTitleMutationVariables = Exact<{
  input: UpdatePlanTitleInput;
}>;


export type UpdatePlanTitleMutation = { __typename?: 'Mutation', updatePlanTitle: { __typename?: 'Plan', id: string, title: string } };

export type UpdateLockForAllItemsMutationVariables = Exact<{
  input: UpdateLockForAllItemsInput;
}>;


export type UpdateLockForAllItemsMutation = { __typename?: 'Mutation', updateLockForAllItems: { __typename?: 'ResponseStatus', success: boolean, message: string } };

export type DeletePlanMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeletePlanMutation = { __typename?: 'Mutation', deletePlan: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type ClearPlanMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type ClearPlanMutation = { __typename?: 'Mutation', clearPlan: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } };

export type DeletePlanGroupMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeletePlanGroupMutation = { __typename?: 'Mutation', deletePlanGroup: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type MovePlanGroupMutationVariables = Exact<{
  input: MovePlanGroupInput;
}>;


export type MovePlanGroupMutation = { __typename?: 'Mutation', movePlanGroup: { __typename?: 'PlanGroup', id: string, planId: string, displaySequence: number } };

export type ChangesQueryVariables = Exact<{
  planId: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ChangesQuery = { __typename?: 'Query', changes: { __typename?: 'ChangeLogConnection', edges: Array<{ __typename?: 'ChangeLogEdge', node: { __typename?: 'ChangeLog', id: string, changedByAppUserId: number, changedTimestamp: any, description: string, planId: string, groupId?: string | null, itemId?: string | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type OnChangeLogAddedSubscriptionVariables = Exact<{
  planId: Scalars['String'];
}>;


export type OnChangeLogAddedSubscription = { __typename?: 'Subscription', changeLogAdded: { __typename?: 'ChangeLog', id: string, planId: string, itemId?: string | null, groupId?: string | null, description: string, changedByAppUserId: number, changedTimestamp: any } };

export type OnPlanChangedBySubscriptionVariables = Exact<{
  planId: Scalars['String'];
}>;


export type OnPlanChangedBySubscription = { __typename?: 'Subscription', planChangedBy: { __typename?: 'PlanChangedBy', changedByAppUserId: number } };

export type AddCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null } };

export type DeleteCommentMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type MarkAllCommentsAsReadMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type MarkAllCommentsAsReadMutation = { __typename?: 'Mutation', markAllCommentsAsRead: Array<{ __typename?: 'Comment', id: string }> };

export type CommentAddedSubscriptionVariables = Exact<{
  planId?: InputMaybe<Scalars['String']>;
  subscribeToAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type CommentAddedSubscription = { __typename?: 'Subscription', commentAdded: { __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null } };

export type CommentsByGroupIdQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type CommentsByGroupIdQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }> };

export type UpdatePlanGroupTermMutationVariables = Exact<{
  input: UpdatePlanGroupTermInput;
}>;


export type UpdatePlanGroupTermMutation = { __typename?: 'Mutation', updatePlanGroupTerm: { __typename?: 'PlanGroup', id: string, externalTermId?: string | null, title: string } };

export type TemplateFragment = { __typename?: 'Plan', id: string, title: string, createdByAppUserId: number, creatorName?: string | null, campusCode: string, campusDescription?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, degreeCode: string, degreeDescription?: string | null, publishedAt?: any | null, status?: TemplateStatus | null, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> };

export type TemplatesQueryVariables = Exact<{
  environment?: InputMaybe<Scalars['String']>;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Plan', id: string, title: string, createdByAppUserId: number, creatorName?: string | null, campusCode: string, campusDescription?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, degreeCode: string, degreeDescription?: string | null, publishedAt?: any | null, status?: TemplateStatus | null, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }> };

export type TemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type TemplateQuery = { __typename?: 'Query', template: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }, planAlerts: Array<{ __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel }> };

export type UpdateTemplateCampusMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateCampusMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, campusCode: string, campusDescription?: string | null } };

export type UpdateTemplateCatalogMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateCatalogMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null } };

export type UpdateTemplateCollegeMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateCollegeMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, collegeCode: string, collegeDescription?: string | null } };

export type UpdateTemplateConcentrationMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateConcentrationMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, concentrationCode: string, concentrationDescription?: string | null } };

export type UpdateTemplateDescriptionMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateDescriptionMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, description: string } };

export type UpdateTemplateDegreeMutationVariables = Exact<{
  input: UpdatePlanInput;
}>;


export type UpdateTemplateDegreeMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'Plan', id: string, degreeCode: string, degreeDescription?: string | null } };

export type AcademicStructureDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AcademicStructureDataQuery = { __typename?: 'Query', campuses: Array<{ __typename?: 'Campus', id: string, code: string, description: string }>, getColleges: Array<{ __typename?: 'College', id: string, code: string, description: string }>, getDegrees: Array<{ __typename?: 'Degree', id: string, code: string, description: string }>, getMajors: Array<{ __typename?: 'Major', id: string, code: string, description: string }>, getMinors: Array<{ __typename?: 'Minor', id: string, code: string, description: string, major: string }>, getConcentrations: Array<{ __typename?: 'Concentration', id: string, code: string, description: string, major: string, minor: string }> };

export type AddMajorMutationVariables = Exact<{
  input: CreatePlanMajorInput;
}>;


export type AddMajorMutation = { __typename?: 'Mutation', addMajor: { __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null } };

export type DeleteMajorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMajorMutation = { __typename?: 'Mutation', deleteMajor: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type AddMinorMutationVariables = Exact<{
  input: CreatePlanMinorInput;
}>;


export type AddMinorMutation = { __typename?: 'Mutation', addMinor: { __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null } };

export type DeleteMinorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMinorMutation = { __typename?: 'Mutation', deleteMinor: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type AddTemplateMutationVariables = Exact<{
  input: CreatePlanInput;
}>;


export type AddTemplateMutation = { __typename?: 'Mutation', addTemplate: { __typename?: 'Plan', id: string, createdAt: any, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, ownerAppUserId: number, planViewedAt?: any | null, sourcePlanId?: string | null, title: string, updatedAt: any, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isTemplate: boolean, publishedAt?: any | null, status?: TemplateStatus | null, templateMessage?: string | null, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } };

export type PublishTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type PublishTemplateMutation = { __typename?: 'Mutation', publishTemplate: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } };

export type ArchiveTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type ArchiveTemplateMutation = { __typename?: 'Mutation', archiveTemplate: { __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteTemplate: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type CopyAllPublishedTemplatesMutationVariables = Exact<{ [key: string]: never; }>;


export type CopyAllPublishedTemplatesMutation = { __typename?: 'Mutation', copyAllPublishedTemplates: { __typename?: 'CopyAllPublishedTemplatesResponse', copiedCount: number, success: boolean, message: string, plans?: Array<{ __typename?: 'Plan', id: string, title: string, status?: TemplateStatus | null } | null> | null } };

export type BulkLockAllStudentPlansMutationVariables = Exact<{
  locked: Scalars['Boolean'];
}>;


export type BulkLockAllStudentPlansMutation = { __typename?: 'Mutation', bulkLockAllStudentPlans: { __typename?: 'BulkLockJobResponse', jobId: string, message: string } };

export type BulkLockJobStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type BulkLockJobStatusQuery = { __typename?: 'Query', bulkLockJobStatus: { __typename?: 'BulkLockJobStatus', jobId: string, status: BulkLockJobStatusEnum, totalStudents: number, processedStudents: number, lockedPlans: number, errors: Array<string>, startedAt?: any | null, completedAt?: any | null } };

export type ApplyTemplateMutationVariables = Exact<{
  input: ApplyTemplateInput;
}>;


export type ApplyTemplateMutation = { __typename?: 'Mutation', applyTemplate: { __typename?: 'ApplyTemplateResponse', correlationId: string, studentCount: number, templateTitle: string } };

export type ApplyTemplateResponseQueryVariables = Exact<{
  correlationId: Scalars['String'];
}>;


export type ApplyTemplateResponseQuery = { __typename?: 'Query', applyTemplateResponse: { __typename?: 'ApplyTemplateResponse', correlationId: string, status: ApplyTemplateStatus, studentCount: number, templateTitle: string, failureReason?: string | null, plansCreated?: Array<{ __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }> | null } };

export type ApplyTemplateCompleteSubscriptionVariables = Exact<{
  correlationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ApplyTemplateCompleteSubscription = { __typename?: 'Subscription', applyTemplateComplete: { __typename?: 'ApplyTemplateResponse', correlationId: string, status: ApplyTemplateStatus, studentCount: number, templateTitle: string, failureReason?: string | null, plansCreated?: Array<{ __typename?: 'Plan', id: string, catalogYear: string, catalogYearDescription?: string | null, changelogViewedAt?: any | null, campusCode: string, campusDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, createdAt: any, creatorName?: string | null, degreeCode: string, degreeDescription?: string | null, description: string, isFromTemplate?: boolean | null, isPrimary: boolean, isShared: boolean, isTemplate: boolean, ownerAppUserId: number, planViewedAt?: any | null, publishedAt?: any | null, sourcePlanId?: string | null, status?: TemplateStatus | null, templateMessage?: string | null, title: string, updatedAt: any, readOnlyForStudents: boolean, groups: Array<{ __typename?: 'PlanGroup', id: string, title: string, externalTermId?: string | null, planId: string, displaySequence: number, termSequence?: number | null, termType?: string | null, comments: Array<{ __typename?: 'Comment', id: string, comment: string, createdByAppUserId: number, createdAt: any, creatorName?: string | null, groupId: string, planId: string, read: boolean, readTimestamp?: any | null }>, items: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> }>, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }> | null } };

export type TouchChangelogViewedMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type TouchChangelogViewedMutation = { __typename?: 'Mutation', touchChangelogViewed: { __typename?: 'Plan', id: string, changelogViewedAt?: any | null } };

export type ChangeLogViewedAtQueryVariables = Exact<{
  planId: Scalars['String'];
}>;


export type ChangeLogViewedAtQuery = { __typename?: 'Query', plan: { __typename?: 'Plan', id: string, changelogViewedAt?: any | null } };

export type DismissPlanAlertMutationVariables = Exact<{
  input: DismissAlertInput;
}>;


export type DismissPlanAlertMutation = { __typename?: 'Mutation', dismissPlanAlert: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type PlanAlertsQueryVariables = Exact<{
  planId: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
}>;


export type PlanAlertsQuery = { __typename?: 'Query', planAlerts: Array<{ __typename?: 'PlanAlert', alertKey: string, alertType: AlertType, groupId?: string | null, itemId?: string | null, level: AlertLevel }> };

export type PlaceholderTemplatesQueryVariables = Exact<{
  environment?: InputMaybe<Scalars['String']>;
}>;


export type PlaceholderTemplatesQuery = { __typename?: 'Query', placeholderTemplates: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null }> };

export type PlaceholderTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlaceholderTemplateQuery = { __typename?: 'Query', placeholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type PlaceholderTemplateInUseLocationsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlaceholderTemplateInUseLocationsQuery = { __typename?: 'Query', placeholderTemplateInUseLocations: Array<{ __typename?: 'Plan', id: string, title: string, createdByAppUserId: number, creatorName?: string | null, campusCode: string, campusDescription?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, degreeCode: string, degreeDescription?: string | null, publishedAt?: any | null, status?: TemplateStatus | null, majors: Array<{ __typename?: 'PlanMajor', id: string, planId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'PlanMinor', id: string, planId: string, minorCode: string, minorDescription?: string | null }> }> };

export type AddPlaceholderTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type AddPlaceholderTemplateMutation = { __typename?: 'Mutation', addPlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type DeletePlaceholderTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeletePlaceholderTemplateMutation = { __typename?: 'Mutation', deletePlaceholderTemplate: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type ArchivePlaceholderTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type ArchivePlaceholderTemplateMutation = { __typename?: 'Mutation', archivePlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type PublishPlaceholderTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type PublishPlaceholderTemplateMutation = { __typename?: 'Mutation', publishPlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type CopyPlaceholderTemplateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type CopyPlaceholderTemplateMutation = { __typename?: 'Mutation', copyPlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type UpdatePlaceholderTemplateMutationVariables = Exact<{
  input: UpdatePlanItemInput;
}>;


export type UpdatePlaceholderTemplateMutation = { __typename?: 'Mutation', updatePlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusCode?: string | null, campusDescription?: string | null, career?: string | null, catalogYear: string, catalogYearDescription?: string | null, collegeCode: string, collegeDescription?: string | null, concentrationCode: string, concentrationDescription?: string | null, courseId?: string | null, courseNumber?: string | null, creatorName?: string | null, creditsMax?: number | null, creditsMin?: number | null, degreeCode: string, degreeDescription?: string | null, description?: string | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseDescription?: string | null, nonCourseTitle?: string | null, planId: string, publishedAt?: any | null, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, status?: TemplateStatus | null, subjectDescription?: string | null, subjectId?: string | null, title: string, typicallyOffered?: string | null, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null, majors: Array<{ __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null }>, minors: Array<{ __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null }>, placeholderCourses?: Array<{ __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } | null> | null } };

export type AddPlaceholderCourseMutationVariables = Exact<{
  input: PlaceholderCourseInput;
}>;


export type AddPlaceholderCourseMutation = { __typename?: 'Mutation', addPlaceholderCourse: { __typename?: 'PlaceholderCourse', id: string, campus?: string | null, campusDescription?: string | null, courseNumber: string, creditsMax?: number | null, creditsMin?: number | null, description?: string | null, externalCourseId?: string | null, subjectId: string, subjectDescription?: string | null, title: string } };

export type DeletePlaceholderCourseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePlaceholderCourseMutation = { __typename?: 'Mutation', deletePlaceholderCourse: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type SearchPlaceholderTemplatesQueryVariables = Exact<{
  searchText: Scalars['String'];
  environment: Scalars['String'];
  campusCode?: InputMaybe<Scalars['String']>;
}>;


export type SearchPlaceholderTemplatesQuery = { __typename?: 'Query', searchPlaceholderTemplates: Array<{ __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null }> };

export type ItemFromPlaceholderTemplateMutationVariables = Exact<{
  input: ItemFromPlaceholderTemplateInput;
}>;


export type ItemFromPlaceholderTemplateMutation = { __typename?: 'Mutation', itemFromPlaceholderTemplate: { __typename?: 'PlanItem', id: string, availability?: CourseAvailability | null, campusDescription?: string | null, career?: string | null, courseNumber?: string | null, creditsMax?: number | null, creditsMin?: number | null, displaySequence: number, equivalentCourseGroupId?: string | null, externalCourseId?: string | null, gradeReceived?: string | null, groupId?: string | null, inProgress?: boolean | null, isActive: boolean, isCoursePlaceholder: boolean, locked: boolean, nonCourseCreditsMax?: number | null, nonCourseCreditsMin?: number | null, nonCourseTitle?: string | null, planId: string, required: boolean, requirementTitles: Array<string>, requisiteDescription?: string | null, requisiteDescriptionLong?: string | null, showRequisiteAlert?: boolean | null, subjectId?: string | null, termGradeReceived?: string | null, title: string, usedToMeetRequirement?: boolean | null, courseTakenInReq?: boolean | null, enrollmentStatus?: { __typename?: 'EnrollmentStatus', enrolled?: boolean | null, termCode?: string | null, termDescription?: string | null } | null } };

export type AddItemMajorMutationVariables = Exact<{
  input: CreateItemMajorInput;
}>;


export type AddItemMajorMutation = { __typename?: 'Mutation', addItemMajor: { __typename?: 'ItemMajor', id: string, itemId: string, majorCode: string, majorDescription?: string | null } };

export type DeleteItemMajorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteItemMajorMutation = { __typename?: 'Mutation', deleteItemMajor: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type AddItemMinorMutationVariables = Exact<{
  input: CreateItemMinorInput;
}>;


export type AddItemMinorMutation = { __typename?: 'Mutation', addItemMinor: { __typename?: 'ItemMinor', id: string, itemId: string, minorCode: string, minorDescription?: string | null } };

export type DeleteItemMinorMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteItemMinorMutation = { __typename?: 'Mutation', deleteItemMinor: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type UpdatePlanReadOnlyForStudentsMutationVariables = Exact<{
  planId: Scalars['String'];
  readOnlyForStudents: Scalars['Boolean'];
}>;


export type UpdatePlanReadOnlyForStudentsMutation = { __typename?: 'Mutation', updatePlanReadOnlyForStudents: { __typename?: 'PlanReadOnlyForStudentsResult', id: string, readOnlyForStudents: boolean } };

export type ResetAllPlansReadOnlyMutationVariables = Exact<{
  readOnlyForStudents: Scalars['Boolean'];
}>;


export type ResetAllPlansReadOnlyMutation = { __typename?: 'Mutation', resetAllPlansReadOnly: { __typename?: 'BulkReadOnlyJobResponse', jobId: string, message: string } };

export type ReadOnlyBulkActionStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type ReadOnlyBulkActionStatusQuery = { __typename?: 'Query', readOnlyBulkActionStatus: { __typename?: 'BulkReadOnlyJobStatus', jobId: string, status: BulkReadOnlyJobStatusEnum, totalPlans: number, processedPlans: number, failedPlans: number, errors: Array<string>, startedAt?: any | null, completedAt?: any | null } };

export type ReportTermDataFragment = { __typename?: 'ReportTerm', id: string, name: string, active: boolean, externalId: string };

export type PlanningReportTermDataFragment = { __typename?: 'PlanningTerm', id: string, description: string, termCode: string, termType?: string | null };

export type ReportTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportTermsQuery = { __typename?: 'Query', reportTerms: Array<{ __typename?: 'ReportTerm', id: string, name: string, active: boolean, externalId: string }> };

export type MonthlyUsageDataFragment = { __typename?: 'StudentUsageMonthlyAggregate', numberOfNewStudents: number, numberOfLogins: number, month: number, year: string };

export type StudentUsageDataFragment = { __typename?: 'StudentUsage', monthly: Array<{ __typename?: 'StudentUsageMonthlyAggregate', numberOfNewStudents: number, numberOfLogins: number, month: number, year: string }> };

export type StudentUsageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentUsageDataQuery = { __typename?: 'Query', studentUsage: { __typename?: 'StudentUsage', monthly: Array<{ __typename?: 'StudentUsageMonthlyAggregate', numberOfNewStudents: number, numberOfLogins: number, month: number, year: string }> } };

export type PlanningCourseDemandQueryVariables = Exact<{
  termIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type PlanningCourseDemandQuery = { __typename?: 'Query', planningCourseDemand: Array<{ __typename?: 'PlanningCourseDemand', courseNumber: string, studentsCount: number, subjectId: string, termId: string }> };

export type PlanningCourseDemandRawQueryVariables = Exact<{
  termIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type PlanningCourseDemandRawQuery = { __typename?: 'Query', planningCourseDemandRaw: Array<{ __typename?: 'PlanningCourseDemandRaw', courseNumber: string, studentId: string, subjectId: string, termId: string }> };

export type PlanningReportTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanningReportTermsQuery = { __typename?: 'Query', planningReportTerms: Array<{ __typename?: 'PlanningTerm', id: string, description: string, termCode: string, termType?: string | null }> };

export type StudentPlanCreationDataQueryVariables = Exact<{
  reportOption?: InputMaybe<StudentPlanCreationReportOption>;
}>;


export type StudentPlanCreationDataQuery = { __typename?: 'Query', studentPlanCreationData: Array<{ __typename?: 'StudentPlanCreation', firstName: string, lastName: string, studentId: string, lastLogin?: any | null, admitTerm?: string | null, planCreation: boolean, campus?: string | null }> };

export type TemplateExtractDataQueryVariables = Exact<{
  templateIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type TemplateExtractDataQuery = { __typename?: 'Query', templateExtractData: Array<{ __typename?: 'TemplateExtractData', title: string, status?: string | null, campus?: string | null, campusDescription?: string | null, college?: string | null, collegeDescription?: string | null, degree?: string | null, major?: string | null, minor?: string | null, catalogYear?: string | null, catalogYearDescription?: string | null, concentration?: string | null, term?: string | null, termSequence?: number | null, course?: string | null, courseSequence?: number | null, credits?: number | null }> };

export type ActiveTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveTermsQuery = { __typename?: 'Query', activeTerms: Array<{ __typename?: 'SchedulerActiveTerm', description: string, termCode: string }> };

export type SchedulerActiveTermDataFragment = { __typename?: 'SchedulerActiveTerm', description: string, termCode: string };

export type SisSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SisSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', sisSettings: { __typename?: 'SisSettings', liveRegistration: boolean } } };

export type PublicAuthSettingsQueryVariables = Exact<{
  environment: Scalars['String'];
}>;


export type PublicAuthSettingsQuery = { __typename?: 'Query', publicSettings: { __typename?: 'PublicSiteSettings', authSettings: { __typename?: 'PublicAuthSettings', enableStudentAppFederatedLogout: boolean, studentAppProvider: StudentAppAuthProviderType, studentAppOidcAuthority?: string | null, studentAppOidcClientId?: string | null, studentAppOidcAudience?: string | null, studentAppOidcDefaultIdpAlias?: string | null, studentAppAuth0LoginOptions: Array<{ __typename?: 'StudentAppAuth0LoginOption', auth0Connection: string, label: string }> } } };

export type AppSettingsFragment = { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', adminAnalyticsLabel: string, adminAnalyticsUrl: string, advisingLabel: string, advisingUrl: string, alwaysShowRequirementCourseAndCreditCounts: boolean, auditRefreshNudgeInterval: number, disallowPrimaryPlanRemoval: boolean, disallowSwitchingPlans: boolean, enableAdminAnalyticsLink: boolean, enableAdvisingLink: boolean, enableLockAllPlanItems: boolean, defaultPlanLockedState: boolean, enableMarkAllCommentsAsRead: boolean, enableCrossListingUsedCourses: boolean, enableSubstitutionUsedCourses: boolean, courseDisplayFormat: string, courseHistoryProgressSummaryOptions: Array<CourseHistoryProgressSummaryOption>, courseTakenRequirementMessage: string, degreeRequirementsPanelConfiguration: DegreeRequirementsPanelConfiguration, disableElevio: boolean, disableElevioForStudents: boolean, duplicateCourseMessage: string, pastTermYears: number, planDisclaimer: string, requireTemplatePlanItems: boolean, showExceptionsOnPlanAlerts: boolean, showGradesOnPlanItems: boolean, showWithdrawnStatusOnPlanItems: boolean, hideTermsOffered: boolean, hideRequisitesOnPlanItemDetails: boolean, readOnlyPlansForStudents: boolean, allowPlaceholderEditInReadOnly: boolean, advisorViewOwnPlan: boolean }, adminSetting: { __typename?: 'AdminSettings', features: Array<string> }, authSettings: { __typename?: 'AuthSettings', enableStudentAppFederatedLogout: boolean, studentAppProvider: StudentAppAuthProviderType }, cartSettings: { __typename?: 'CartSettings', cartLabel: string }, homeSettings: { __typename?: 'HomeSettings', signoutText: string }, sectionFieldText: { __typename?: 'SectionFieldText', credit: string, credits: string }, text: { __typename?: 'Text', advisor: string, advisorPlural: string, campus: string, campusPlural: string, course: string, coursePlural: string, locationPlural: string, plannerTitle: string, register: string, registered: string, schedule: string, schedulePlural: string, term: string, termPlural: string }, integrationSettings: { __typename?: 'IntegrationSettings', auditReportType: string, additionalAuditReportTypes: Array<{ __typename?: 'AdditionalAuditReportType', careerCode: string, career: string, auditReportType: string }> } };

export type AppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', adminAnalyticsLabel: string, adminAnalyticsUrl: string, advisingLabel: string, advisingUrl: string, alwaysShowRequirementCourseAndCreditCounts: boolean, auditRefreshNudgeInterval: number, disallowPrimaryPlanRemoval: boolean, disallowSwitchingPlans: boolean, enableAdminAnalyticsLink: boolean, enableAdvisingLink: boolean, enableLockAllPlanItems: boolean, defaultPlanLockedState: boolean, enableMarkAllCommentsAsRead: boolean, enableCrossListingUsedCourses: boolean, enableSubstitutionUsedCourses: boolean, courseDisplayFormat: string, courseHistoryProgressSummaryOptions: Array<CourseHistoryProgressSummaryOption>, courseTakenRequirementMessage: string, degreeRequirementsPanelConfiguration: DegreeRequirementsPanelConfiguration, disableElevio: boolean, disableElevioForStudents: boolean, duplicateCourseMessage: string, pastTermYears: number, planDisclaimer: string, requireTemplatePlanItems: boolean, showExceptionsOnPlanAlerts: boolean, showGradesOnPlanItems: boolean, showWithdrawnStatusOnPlanItems: boolean, hideTermsOffered: boolean, hideRequisitesOnPlanItemDetails: boolean, readOnlyPlansForStudents: boolean, allowPlaceholderEditInReadOnly: boolean, advisorViewOwnPlan: boolean }, adminSetting: { __typename?: 'AdminSettings', features: Array<string> }, authSettings: { __typename?: 'AuthSettings', enableStudentAppFederatedLogout: boolean, studentAppProvider: StudentAppAuthProviderType }, cartSettings: { __typename?: 'CartSettings', cartLabel: string }, homeSettings: { __typename?: 'HomeSettings', signoutText: string }, sectionFieldText: { __typename?: 'SectionFieldText', credit: string, credits: string }, text: { __typename?: 'Text', advisor: string, advisorPlural: string, campus: string, campusPlural: string, course: string, coursePlural: string, locationPlural: string, plannerTitle: string, register: string, registered: string, schedule: string, schedulePlural: string, term: string, termPlural: string }, integrationSettings: { __typename?: 'IntegrationSettings', auditReportType: string, additionalAuditReportTypes: Array<{ __typename?: 'AdditionalAuditReportType', careerCode: string, career: string, auditReportType: string }> } } };

export type HomeSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', homeSettings: { __typename?: 'HomeSettings', signoutText: string } } };

export type HomeSettingsFragment = { __typename?: 'SiteSettings', homeSettings: { __typename?: 'HomeSettings', signoutText: string } };

export type NewPlanSettingsFragment = { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', newPlanTermFilters: Array<{ __typename?: 'NewPlanTermFilter', label: string, termType: string }> } };

export type NewPlanSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewPlanSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', newPlanTermFilters: Array<{ __typename?: 'NewPlanTermFilter', label: string, termType: string }> } } };

export type HelpSettingsFragment = { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', planningHelpLinkText: string, planningHelpLinkUrl: string, planningHelpVideosText: string, planningHelpVideosUrl: string, studentHelpLinkText: string, studentHelpLinkUrl: string }, helpSettings: { __typename?: 'HelpSettings', links: Array<{ __typename?: 'HelpLink', description: string, key: string, title: string, url: string }>, videos: Array<{ __typename?: 'HelpVideo', description: string, key: string, skillLevel: string, subText: string, url: string }> }, homeSettings: { __typename?: 'HomeSettings', customLinkText: string, customLinkUrl: string, helpText: string, helpUrl: string } };

export type HelpSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HelpSettingsQuery = { __typename?: 'Query', siteSettings: { __typename?: 'SiteSettings', academicPlanningSettings: { __typename?: 'AcademicPlanningSettings', planningHelpLinkText: string, planningHelpLinkUrl: string, planningHelpVideosText: string, planningHelpVideosUrl: string, studentHelpLinkText: string, studentHelpLinkUrl: string }, helpSettings: { __typename?: 'HelpSettings', links: Array<{ __typename?: 'HelpLink', description: string, key: string, title: string, url: string }>, videos: Array<{ __typename?: 'HelpVideo', description: string, key: string, skillLevel: string, subText: string, url: string }> }, homeSettings: { __typename?: 'HomeSettings', customLinkText: string, customLinkUrl: string, helpText: string, helpUrl: string } } };

export type StudentUserProfileMutationVariables = Exact<{
  input: UpsertStudentUserProfileInput;
}>;


export type StudentUserProfileMutation = { __typename?: 'Mutation', studentUserProfile: { __typename?: 'StudentUser', appUserId: number, picture?: string | null } };

export type StudentProfileFragment = { __typename?: 'StudentProfile', id: string, career: string, cumulativeCreditsEarned?: number | null, cumulativeGpa?: number | null, cumulativeTransferCreditsEarned?: number | null, email: string, environment: string, externalId: string, firstName: string, lastName: string, preferredName?: string | null, careerCode?: string | null, campus?: string | null };

export type SearchStudentsQueryVariables = Exact<{
  text: Scalars['String'];
}>;


export type SearchStudentsQuery = { __typename?: 'Query', searchStudents: Array<{ __typename?: 'StudentProfile', id: string, career: string, cumulativeCreditsEarned?: number | null, cumulativeGpa?: number | null, cumulativeTransferCreditsEarned?: number | null, email: string, environment: string, externalId: string, firstName: string, lastName: string, preferredName?: string | null, careerCode?: string | null, campus?: string | null }> };

export type StudentProfileQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type StudentProfileQuery = { __typename?: 'Query', studentProfile: { __typename?: 'StudentProfile', id: string, career: string, cumulativeCreditsEarned?: number | null, cumulativeGpa?: number | null, cumulativeTransferCreditsEarned?: number | null, email: string, environment: string, externalId: string, firstName: string, lastName: string, preferredName?: string | null, careerCode?: string | null, campus?: string | null } };

export type AppUserStudentProfileQueryVariables = Exact<{
  appUserId: Scalars['Int'];
}>;


export type AppUserStudentProfileQuery = { __typename?: 'Query', appUserStudentProfile?: { __typename?: 'StudentProfile', id: string, career: string, cumulativeCreditsEarned?: number | null, cumulativeGpa?: number | null, cumulativeTransferCreditsEarned?: number | null, email: string, environment: string, externalId: string, firstName: string, lastName: string, preferredName?: string | null, careerCode?: string | null, campus?: string | null } | null };

export type TermFragment = { __typename?: 'PlanningTerm', id: string, academicYear: number, startDate: any, description: string, endDate: any, isDisabled: boolean, termCode: string, termType?: string | null };

export type GetTermsQueryVariables = Exact<{
  startYear?: InputMaybe<Scalars['Int']>;
}>;


export type GetTermsQuery = { __typename?: 'Query', getTerms: Array<{ __typename?: 'PlanningTerm', id: string, academicYear: number, startDate: any, description: string, endDate: any, isDisabled: boolean, termCode: string, termType?: string | null }> };

export type GetCurrentAndFutureTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentAndFutureTermsQuery = { __typename?: 'Query', getTerms: Array<{ __typename?: 'PlanningTerm', id: string, academicYear: number, startDate: any, description: string, endDate: any, isDisabled: boolean, termCode: string, termType?: string | null }> };

export type GetAcademicYearsQueryVariables = Exact<{
  startYear?: InputMaybe<Scalars['Int']>;
}>;


export type GetAcademicYearsQuery = { __typename?: 'Query', getAcademicYears: Array<{ __typename?: 'AcademicYear', academicYear: string, academicYearDescription: string, endDate: any, startDate: any }> };

export type UpdateLastLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastLoginMutation = { __typename?: 'Mutation', updateStudentAppLastLogin: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export type BatchCreateAdminUsersMutationVariables = Exact<{
  input: BatchCreateAdminUsersInput;
}>;


export type BatchCreateAdminUsersMutation = { __typename?: 'Mutation', batchCreateAdminUsers: { __typename?: 'BatchCreateAdminUsersResponse', createdUsers: Array<{ __typename?: 'AdminUser', id: any, email?: any | null, firstName?: string | null, lastName?: string | null }>, failedUsers: Array<{ __typename?: 'BatchFailedAdminUser', email?: string | null, firstName?: string | null, lastName?: string | null }>, updatedUsers: Array<{ __typename?: 'AdminUser', id: any, email?: any | null, firstName?: string | null, lastName?: string | null }> } };

export type UpsertCompletedCoursePreferenceMutationVariables = Exact<{
  input: CompletedCoursePreferenceInput;
}>;


export type UpsertCompletedCoursePreferenceMutation = { __typename?: 'Mutation', upsertCompletedCoursePreference: { __typename?: 'ResponseStatus', id: string, success: boolean, message: string } };

export const DegreeAuditSettingsFragmentDoc = gql`
    fragment degreeAuditSettings on AcademicPlanningSettings {
  externalDegreeAuditUrl
  degreeRequirementsPanelConfiguration
  hideRequirementPercentComplete
  showExceptionsOnAudit
  showExceptionsOnPlanAlerts
}
    `;
export const AuditSubPlanDataFragmentDoc = gql`
    fragment auditSubPlanData on DegreeSubPlan {
  id
  code
  description
  met
}
    `;
export const AuditPlanDataFragmentDoc = gql`
    fragment auditPlanData on DegreePlan {
  id
  code
  description
  met
  subPlans {
    ...auditSubPlanData
  }
}
    ${AuditSubPlanDataFragmentDoc}`;
export const AuditProgramDataFragmentDoc = gql`
    fragment auditProgramData on DegreeProgram {
  id
  code
  description
  met
  plans {
    ...auditPlanData
  }
}
    ${AuditPlanDataFragmentDoc}`;
export const AuditExceptionDataFragmentDoc = gql`
    fragment auditExceptionData on Exception {
  id
  additionalInformation
  applyStatus
  courseNumberBegin
  createdDate
  createdEmail
  createdName
  degree
  details
  detailsHidden
  enforced
  exceptionType
  labelTag
  reason
  remark
  school
  status
  subjectId
  title
  userLast
}
    `;
export const AuditCourseDataFragmentDoc = gql`
    fragment auditCourseData on AuditCourse {
  id
  courseNumber
  credits
  enrolled
  equivalentCourseGroupId
  exceptions {
    ...auditExceptionData
  }
  externalCourseId
  fallThrough
  fallThroughCode
  gradeReceived
  overTheLimit
  planned
  requirementGroupExternalId
  requirementGroupTitle
  requirementExternalId
  requirementTitle
  requirementLineTitle
  subjectId
  termCode
  termDescription
  title
  topicDescription
  topicId
  usedToMeetRequirement
  inProgress
  withdrawn
  courseTakenInReq
  substitutionSubjectId
  substitutionCourseNumber
  substitutionExternalCourseId
}
    ${AuditExceptionDataFragmentDoc}`;
export const AuditRequirementLineDataFragmentDoc = gql`
    fragment auditRequirementLineData on RequirementLine {
  id
  title
  description
  statusDescription
  met
  inProgress
  courses {
    ...auditCourseData
  }
  coursesNeeded
  coursesRequired
  coursesUsed
  creditsNeeded
  creditsRequired
  creditsUsed
  exceptions {
    ...auditExceptionData
  }
  gpaActual
  gpaRequired
  showGpa
}
    ${AuditCourseDataFragmentDoc}
${AuditExceptionDataFragmentDoc}`;
export const AuditRequirementDataFragmentDoc = gql`
    fragment auditRequirementData on Requirement {
  id
  description
  statusDescription
  title
  coursesNeeded
  coursesRequired
  coursesUsed
  creditsNeeded
  creditsRequired
  creditsUsed
  exceptions {
    ...auditExceptionData
  }
  externalId
  gpaActual
  gpaRequired
  met
  inProgress
  requirementLines {
    ...auditRequirementLineData
  }
  showGpa
  courses {
    ...auditCourseData
  }
}
    ${AuditExceptionDataFragmentDoc}
${AuditRequirementLineDataFragmentDoc}
${AuditCourseDataFragmentDoc}`;
export const AuditRequirementGroupDataFragmentDoc = gql`
    fragment auditRequirementGroupData on RequirementGroup {
  id
  description
  title
  statusDescription
  coursesNeeded
  coursesRequired
  coursesUsed
  creditsNeeded
  creditsRequired
  creditsUsed
  externalId
  gpaActual
  gpaRequired
  met
  inProgress
  requirements {
    ...auditRequirementData
  }
  showGpa
}
    ${AuditRequirementDataFragmentDoc}`;
export const AuditReportDataFragmentDoc = gql`
    fragment auditReportData on AuditReport {
  id
  __typename
  correlationId
  runDate
  careers {
    id
    description
    title
    programs {
      ...auditProgramData
    }
    requirementGroups {
      ...auditRequirementGroupData
    }
    fallThroughCourses {
      ...auditCourseData
    }
    overTheLimitCourses {
      ...auditCourseData
    }
    insufficientCourses {
      ...auditCourseData
    }
  }
}
    ${AuditProgramDataFragmentDoc}
${AuditRequirementGroupDataFragmentDoc}
${AuditCourseDataFragmentDoc}`;
export const CatalogCourseFragmentDoc = gql`
    fragment catalogCourse on CatalogCourse {
  id
  environment
  courseNumber
  description
  externalCourseId
  creditsMax
  creditsMin
  inProgress
  subjectId
  title
  requisiteDescription
  requisiteDescriptionLong
  usedToMeetRequirement
  requirementTitles
}
    `;
export const CatalogSearchResultFragmentDoc = gql`
    fragment catalogSearchResult on SearchCourse {
  id
  externalCourseId
  subjectId
  subjectDescription
  courseId
  courseNumber
  title
  description
  creditsMax
  creditsMin
  requisiteDescription
  requisiteDescriptionLong
  campus
  academicGroupDescription
}
    `;
export const CourseHistoryFragmentDoc = gql`
    fragment courseHistory on StudentCourse {
  civCourseId
  courseExternalId
  credits
  displayGrade
  instructorExternalId
  instructorFirstName
  instructorLastName
  instructors {
    courseExternalId
    facultyExternalId
    instructorFirstName
    instructorLastName
    lastSyncTimestamp
    season
    sectionExternalId
    year
  }
  isActive
  isCompleted
  isRegistered
  isRetake
  isTransfer
  isWaitlisted
  isWithdrawn
  lastSyncTimestamp
  lmsAverageDailyClassVisits
  lmsAverageGrade
  lmsDailyClassVisits
  lmsGrade
  season
  sectionExternalId
  sectionModality
  sessionStartDate
  title
  year
}
    `;
export const StudentTermGpaFragmentDoc = gql`
    fragment studentTermGpa on StudentTermGpa {
  creditsAttempted
  creditsEarned
  gpa
  season
  termCode
  year
}
    `;
export const WatchlistStudentFragmentDoc = gql`
    fragment watchlistStudent on WatchlistStudent {
  studentAppUserId
  studentId
  firstName
  lastName
  primaryPlanTitle
  lastLogin
}
    `;
export const DiagnosticLogDataFragmentDoc = gql`
    fragment diagnosticLogData on DiagnosticLog {
  id
  message
  startDate
  endDate
}
    `;
export const IntegrationSettingsDataFragmentDoc = gql`
    fragment integrationSettingsData on IntegrationSettings {
  gatewayUrl
  automaticUpdates
  registrationUrl
  customSendToCartUrl
  courseListingSoapAction
  sendToCartSoapAction
  planningCatalogRequestPath
  planningTermRequestPath
  auditRequestPath
  academicStructureRequestPath
  restGatewayUrl
  nodeName
  basicAuthUsername
  basicAuthPasswordSet
  dataServiceUserName
  dataServicePasswordSet
  dataServiceDbName
  openSeatsReportPath
  auditSystem
  auditReportType
  whatIfAuditReportType
  whatIfAuditRequestPath
  institution
  integrationFields {
    key
    description
  }
}
    `;
export const BoardAlertFragmentDoc = gql`
    fragment boardAlert on PlanAlert {
  alertKey
  alertType
  groupId
  itemId
  level
}
    `;
export const BoardCommentFragmentDoc = gql`
    fragment boardComment on Comment {
  id
  comment
  createdByAppUserId
  createdAt
  creatorName
  groupId
  planId
  read
  readTimestamp
}
    `;
export const BoardItemFragmentDoc = gql`
    fragment boardItem on PlanItem {
  id
  availability
  campusDescription
  career
  courseNumber
  creditsMax
  creditsMin
  displaySequence
  enrollmentStatus {
    enrolled
    termCode
    termDescription
  }
  equivalentCourseGroupId
  externalCourseId
  gradeReceived
  groupId
  inProgress
  isActive
  isCoursePlaceholder
  locked
  nonCourseCreditsMax
  nonCourseCreditsMin
  nonCourseTitle
  planId
  required
  requirementTitles
  requisiteDescription
  requisiteDescriptionLong
  showRequisiteAlert
  subjectId
  termGradeReceived
  title
  usedToMeetRequirement
  courseTakenInReq
}
    `;
export const BoardGroupFragmentDoc = gql`
    fragment boardGroup on PlanGroup {
  id
  comments {
    ...boardComment
  }
  title
  externalTermId
  planId
  displaySequence
  termSequence
  termType
  items {
    ...boardItem
  }
}
    ${BoardCommentFragmentDoc}
${BoardItemFragmentDoc}`;
export const BoardMajorFragmentDoc = gql`
    fragment boardMajor on PlanMajor {
  id
  planId
  majorCode
  majorDescription
}
    `;
export const BoardMinorFragmentDoc = gql`
    fragment boardMinor on PlanMinor {
  id
  planId
  minorCode
  minorDescription
}
    `;
export const BoardPlanFragmentDoc = gql`
    fragment boardPlan on Plan {
  id
  catalogYear
  catalogYearDescription
  changelogViewedAt
  campusCode
  campusDescription
  collegeCode
  collegeDescription
  concentrationCode
  concentrationDescription
  createdAt
  creatorName
  degreeCode
  degreeDescription
  description
  groups {
    ...boardGroup
  }
  isFromTemplate
  isPrimary
  isShared
  isTemplate
  majors {
    ...boardMajor
  }
  minors {
    ...boardMinor
  }
  ownerAppUserId
  planViewedAt
  publishedAt
  sourcePlanId
  status
  templateMessage
  title
  updatedAt
  readOnlyForStudents
}
    ${BoardGroupFragmentDoc}
${BoardMajorFragmentDoc}
${BoardMinorFragmentDoc}`;
export const ItemMajorFragmentDoc = gql`
    fragment itemMajor on ItemMajor {
  id
  itemId
  majorCode
  majorDescription
}
    `;
export const ItemMinorFragmentDoc = gql`
    fragment itemMinor on ItemMinor {
  id
  itemId
  minorCode
  minorDescription
}
    `;
export const PlaceholderCourseFragmentDoc = gql`
    fragment placeholderCourse on PlaceholderCourse {
  campus
  campusDescription
  courseNumber
  creditsMax
  creditsMin
  description
  externalCourseId
  subjectId
  subjectDescription
  title
}
    `;
export const PlanItemDetailsFragmentDoc = gql`
    fragment planItemDetails on PlanItem {
  id
  availability
  campusCode
  campusDescription
  career
  catalogYear
  catalogYearDescription
  collegeCode
  collegeDescription
  concentrationCode
  concentrationDescription
  courseId
  courseNumber
  creatorName
  creditsMax
  creditsMin
  degreeCode
  degreeDescription
  description
  displaySequence
  enrollmentStatus {
    enrolled
    termCode
    termDescription
  }
  equivalentCourseGroupId
  externalCourseId
  groupId
  inProgress
  isActive
  isCoursePlaceholder
  locked
  majors {
    ...itemMajor
  }
  minors {
    ...itemMinor
  }
  nonCourseCreditsMax
  nonCourseCreditsMin
  nonCourseDescription
  nonCourseTitle
  placeholderCourses {
    id
    ...placeholderCourse
  }
  planId
  publishedAt
  required
  requirementTitles
  requisiteDescription
  requisiteDescriptionLong
  showRequisiteAlert
  status
  subjectDescription
  subjectId
  title
  typicallyOffered
  usedToMeetRequirement
  courseTakenInReq
}
    ${ItemMajorFragmentDoc}
${ItemMinorFragmentDoc}
${PlaceholderCourseFragmentDoc}`;
export const OwnerPlanFragmentDoc = gql`
    fragment OwnerPlan on Plan {
  id
  createdAt
  isFromTemplate
  isPrimary
  isShared
  ownerAppUserId
  planViewedAt
  sourcePlanId
  title
  updatedAt
}
    `;
export const ChangeLogFragmentDoc = gql`
    fragment ChangeLog on ChangeLog {
  id
  changedByAppUserId
  changedTimestamp
  description
  planId
  groupId
  itemId
}
    `;
export const ChangeLogEdgeNodeFragmentDoc = gql`
    fragment changeLogEdgeNode on ChangeLogEdge {
  node {
    ...ChangeLog
  }
}
    ${ChangeLogFragmentDoc}`;
export const ChangeLogPageInfoFragmentDoc = gql`
    fragment changeLogPageInfo on PageInfo {
  endCursor
  hasNextPage
}
    `;
export const ChangeLogConnectionFragmentDoc = gql`
    fragment changeLogConnection on ChangeLogConnection {
  edges {
    ...changeLogEdgeNode
  }
  pageInfo {
    ...changeLogPageInfo
  }
}
    ${ChangeLogEdgeNodeFragmentDoc}
${ChangeLogPageInfoFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment Template on Plan {
  id
  title
  createdByAppUserId
  creatorName
  campusCode
  campusDescription
  catalogYear
  catalogYearDescription
  collegeCode
  collegeDescription
  concentrationCode
  concentrationDescription
  degreeCode
  degreeDescription
  majors {
    ...boardMajor
  }
  minors {
    ...boardMinor
  }
  publishedAt
  status
}
    ${BoardMajorFragmentDoc}
${BoardMinorFragmentDoc}`;
export const ReportTermDataFragmentDoc = gql`
    fragment reportTermData on ReportTerm {
  id
  name
  active
  externalId
}
    `;
export const PlanningReportTermDataFragmentDoc = gql`
    fragment planningReportTermData on PlanningTerm {
  id
  description
  termCode
  termType
}
    `;
export const MonthlyUsageDataFragmentDoc = gql`
    fragment monthlyUsageData on StudentUsageMonthlyAggregate {
  numberOfNewStudents
  numberOfLogins
  month
  year
}
    `;
export const StudentUsageDataFragmentDoc = gql`
    fragment studentUsageData on StudentUsage {
  monthly {
    ...monthlyUsageData
  }
}
    ${MonthlyUsageDataFragmentDoc}`;
export const SchedulerActiveTermDataFragmentDoc = gql`
    fragment SchedulerActiveTermData on SchedulerActiveTerm {
  description
  termCode
}
    `;
export const AppSettingsFragmentDoc = gql`
    fragment appSettings on SiteSettings {
  academicPlanningSettings {
    adminAnalyticsLabel
    adminAnalyticsUrl
    advisingLabel
    advisingUrl
    alwaysShowRequirementCourseAndCreditCounts
    auditRefreshNudgeInterval
    disallowPrimaryPlanRemoval
    disallowSwitchingPlans
    enableAdminAnalyticsLink
    enableAdvisingLink
    enableLockAllPlanItems
    defaultPlanLockedState
    enableMarkAllCommentsAsRead
    enableCrossListingUsedCourses
    enableSubstitutionUsedCourses
    courseDisplayFormat
    courseHistoryProgressSummaryOptions
    courseTakenRequirementMessage
    degreeRequirementsPanelConfiguration
    disableElevio
    disableElevioForStudents
    duplicateCourseMessage
    pastTermYears
    planDisclaimer
    requireTemplatePlanItems
    showExceptionsOnPlanAlerts
    showGradesOnPlanItems
    showWithdrawnStatusOnPlanItems
    hideTermsOffered
    hideRequisitesOnPlanItemDetails
    readOnlyPlansForStudents
    allowPlaceholderEditInReadOnly
    advisorViewOwnPlan
  }
  adminSetting {
    features
  }
  authSettings {
    enableStudentAppFederatedLogout
    studentAppProvider
  }
  cartSettings {
    cartLabel
  }
  homeSettings {
    signoutText
  }
  sectionFieldText {
    credit
    credits
  }
  text {
    advisor
    advisorPlural
    campus
    campusPlural
    course
    coursePlural
    locationPlural
    plannerTitle
    register
    registered
    schedule
    schedulePlural
    term
    termPlural
  }
  integrationSettings {
    auditReportType
    additionalAuditReportTypes {
      careerCode
      career
      auditReportType
    }
  }
}
    `;
export const HomeSettingsFragmentDoc = gql`
    fragment homeSettings on SiteSettings {
  homeSettings {
    signoutText
  }
}
    `;
export const NewPlanSettingsFragmentDoc = gql`
    fragment newPlanSettings on SiteSettings {
  academicPlanningSettings {
    newPlanTermFilters {
      label
      termType
    }
  }
}
    `;
export const HelpSettingsFragmentDoc = gql`
    fragment helpSettings on SiteSettings {
  academicPlanningSettings {
    planningHelpLinkText
    planningHelpLinkUrl
    planningHelpVideosText
    planningHelpVideosUrl
    studentHelpLinkText
    studentHelpLinkUrl
  }
  helpSettings {
    links {
      description
      key
      title
      url
    }
    videos {
      description
      key
      skillLevel
      subText
      url
    }
  }
  homeSettings {
    customLinkText
    customLinkUrl
    helpText
    helpUrl
  }
}
    `;
export const StudentProfileFragmentDoc = gql`
    fragment studentProfile on StudentProfile {
  id
  career
  cumulativeCreditsEarned
  cumulativeGpa
  cumulativeTransferCreditsEarned
  email
  environment
  externalId
  firstName
  lastName
  preferredName
  email
  career
  careerCode
  campus
}
    `;
export const TermFragmentDoc = gql`
    fragment term on PlanningTerm {
  id
  academicYear
  startDate
  description
  endDate
  isDisabled
  termCode
  termType
}
    `;
export const AcademicPlanningSettingsDocument = gql`
    query academicPlanningSettings {
  academicPlanningSettings {
    alwaysShowRequirementCourseAndCreditCounts
    auditRefreshNudgeInterval
    courseTakenRequirementMessage
    duplicateCourseMessage
    enableAcademicPlanning
    enableLmsCoursesView
    enableSubstitutionUsedCourses
    externalDegreeAuditUrl
    failedGrades
    hideRequirementPercentComplete
    hideTermsOffered
    hideRequisitesOnPlanItemDetails
    lockPlanBoardToHomeCampus
    notUsedRequirementGroups
    readOnlyPlansForStudents
    allowPlaceholderEditInReadOnly
    notUsedRequirements
    pastTermYears
    showExceptionsOnPlanAlerts
    templateDetailOptions {
      key
      label
      table
      title
    }
    termOptions {
      type
      value
    }
  }
}
    `;

/**
 * __useAcademicPlanningSettingsQuery__
 *
 * To run a query within a React component, call `useAcademicPlanningSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicPlanningSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicPlanningSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcademicPlanningSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AcademicPlanningSettingsQuery, AcademicPlanningSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcademicPlanningSettingsQuery, AcademicPlanningSettingsQueryVariables>(AcademicPlanningSettingsDocument, options);
      }
export function useAcademicPlanningSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcademicPlanningSettingsQuery, AcademicPlanningSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcademicPlanningSettingsQuery, AcademicPlanningSettingsQueryVariables>(AcademicPlanningSettingsDocument, options);
        }
export type AcademicPlanningSettingsQueryHookResult = ReturnType<typeof useAcademicPlanningSettingsQuery>;
export type AcademicPlanningSettingsLazyQueryHookResult = ReturnType<typeof useAcademicPlanningSettingsLazyQuery>;
export type AcademicPlanningSettingsQueryResult = Apollo.QueryResult<AcademicPlanningSettingsQuery, AcademicPlanningSettingsQueryVariables>;
export const DegreeAuditSettingsDocument = gql`
    query degreeAuditSettings {
  academicPlanningSettings {
    ...degreeAuditSettings
  }
}
    ${DegreeAuditSettingsFragmentDoc}`;

/**
 * __useDegreeAuditSettingsQuery__
 *
 * To run a query within a React component, call `useDegreeAuditSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDegreeAuditSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDegreeAuditSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDegreeAuditSettingsQuery(baseOptions?: Apollo.QueryHookOptions<DegreeAuditSettingsQuery, DegreeAuditSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DegreeAuditSettingsQuery, DegreeAuditSettingsQueryVariables>(DegreeAuditSettingsDocument, options);
      }
export function useDegreeAuditSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DegreeAuditSettingsQuery, DegreeAuditSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DegreeAuditSettingsQuery, DegreeAuditSettingsQueryVariables>(DegreeAuditSettingsDocument, options);
        }
export type DegreeAuditSettingsQueryHookResult = ReturnType<typeof useDegreeAuditSettingsQuery>;
export type DegreeAuditSettingsLazyQueryHookResult = ReturnType<typeof useDegreeAuditSettingsLazyQuery>;
export type DegreeAuditSettingsQueryResult = Apollo.QueryResult<DegreeAuditSettingsQuery, DegreeAuditSettingsQueryVariables>;
export const AssistantMessageStreamDocument = gql`
    subscription AssistantMessageStream($message: String!, $history: [MessageInput!]!, $pageContext: String!, $skill: String) {
  assistantMessageStream(
    message: $message
    history: $history
    pageContext: $pageContext
    skill: $skill
  ) {
    type
    content
  }
}
    `;

/**
 * __useAssistantMessageStreamSubscription__
 *
 * To run a query within a React component, call `useAssistantMessageStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssistantMessageStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantMessageStreamSubscription({
 *   variables: {
 *      message: // value for 'message'
 *      history: // value for 'history'
 *      pageContext: // value for 'pageContext'
 *      skill: // value for 'skill'
 *   },
 * });
 */
export function useAssistantMessageStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<AssistantMessageStreamSubscription, AssistantMessageStreamSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AssistantMessageStreamSubscription, AssistantMessageStreamSubscriptionVariables>(AssistantMessageStreamDocument, options);
      }
export type AssistantMessageStreamSubscriptionHookResult = ReturnType<typeof useAssistantMessageStreamSubscription>;
export type AssistantMessageStreamSubscriptionResult = Apollo.SubscriptionResult<AssistantMessageStreamSubscription>;
export const AssistantSkillsDocument = gql`
    query AssistantSkills {
  assistantSkills {
    name
    description
  }
}
    `;

/**
 * __useAssistantSkillsQuery__
 *
 * To run a query within a React component, call `useAssistantSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssistantSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssistantSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssistantSkillsQuery(baseOptions?: Apollo.QueryHookOptions<AssistantSkillsQuery, AssistantSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssistantSkillsQuery, AssistantSkillsQueryVariables>(AssistantSkillsDocument, options);
      }
export function useAssistantSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssistantSkillsQuery, AssistantSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssistantSkillsQuery, AssistantSkillsQueryVariables>(AssistantSkillsDocument, options);
        }
export type AssistantSkillsQueryHookResult = ReturnType<typeof useAssistantSkillsQuery>;
export type AssistantSkillsLazyQueryHookResult = ReturnType<typeof useAssistantSkillsLazyQuery>;
export type AssistantSkillsQueryResult = Apollo.QueryResult<AssistantSkillsQuery, AssistantSkillsQueryVariables>;
export const AuditReportDocument = gql`
    query auditReport($studentAppUserId: Int, $correlationId: String, $reportType: String) {
  auditReport(
    studentAppUserId: $studentAppUserId
    correlationId: $correlationId
    reportType: $reportType
  ) {
    ...auditReportData
  }
}
    ${AuditReportDataFragmentDoc}`;

/**
 * __useAuditReportQuery__
 *
 * To run a query within a React component, call `useAuditReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditReportQuery({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *      correlationId: // value for 'correlationId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useAuditReportQuery(baseOptions?: Apollo.QueryHookOptions<AuditReportQuery, AuditReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditReportQuery, AuditReportQueryVariables>(AuditReportDocument, options);
      }
export function useAuditReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditReportQuery, AuditReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditReportQuery, AuditReportQueryVariables>(AuditReportDocument, options);
        }
export type AuditReportQueryHookResult = ReturnType<typeof useAuditReportQuery>;
export type AuditReportLazyQueryHookResult = ReturnType<typeof useAuditReportLazyQuery>;
export type AuditReportQueryResult = Apollo.QueryResult<AuditReportQuery, AuditReportQueryVariables>;
export const AvailableAuditReportTypesDocument = gql`
    query availableAuditReportTypes($studentAppUserId: Int!) {
  availableAuditReportTypes(studentAppUserId: $studentAppUserId) {
    auditReportType
    career
    careerCode
  }
}
    `;

/**
 * __useAvailableAuditReportTypesQuery__
 *
 * To run a query within a React component, call `useAvailableAuditReportTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAuditReportTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAuditReportTypesQuery({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useAvailableAuditReportTypesQuery(baseOptions: Apollo.QueryHookOptions<AvailableAuditReportTypesQuery, AvailableAuditReportTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAuditReportTypesQuery, AvailableAuditReportTypesQueryVariables>(AvailableAuditReportTypesDocument, options);
      }
export function useAvailableAuditReportTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAuditReportTypesQuery, AvailableAuditReportTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAuditReportTypesQuery, AvailableAuditReportTypesQueryVariables>(AvailableAuditReportTypesDocument, options);
        }
export type AvailableAuditReportTypesQueryHookResult = ReturnType<typeof useAvailableAuditReportTypesQuery>;
export type AvailableAuditReportTypesLazyQueryHookResult = ReturnType<typeof useAvailableAuditReportTypesLazyQuery>;
export type AvailableAuditReportTypesQueryResult = Apollo.QueryResult<AvailableAuditReportTypesQuery, AvailableAuditReportTypesQueryVariables>;
export const GenerateAuditReportDocument = gql`
    mutation generateAuditReport($input: AuditRequestInput!) {
  generateAuditReport(input: $input) {
    correlationId
  }
}
    `;
export type GenerateAuditReportMutationFn = Apollo.MutationFunction<GenerateAuditReportMutation, GenerateAuditReportMutationVariables>;

/**
 * __useGenerateAuditReportMutation__
 *
 * To run a mutation, you first call `useGenerateAuditReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuditReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuditReportMutation, { data, loading, error }] = useGenerateAuditReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAuditReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAuditReportMutation, GenerateAuditReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAuditReportMutation, GenerateAuditReportMutationVariables>(GenerateAuditReportDocument, options);
      }
export type GenerateAuditReportMutationHookResult = ReturnType<typeof useGenerateAuditReportMutation>;
export type GenerateAuditReportMutationResult = Apollo.MutationResult<GenerateAuditReportMutation>;
export type GenerateAuditReportMutationOptions = Apollo.BaseMutationOptions<GenerateAuditReportMutation, GenerateAuditReportMutationVariables>;
export const AuditGenerationCompleteDocument = gql`
    subscription auditGenerationComplete($correlationId: String!, $enableCrossListingUsedCourses: Boolean) {
  auditGenerationComplete(
    correlationId: $correlationId
    enableCrossListingUsedCourses: $enableCrossListingUsedCourses
  ) {
    auditReport {
      ...auditReportData
    }
    correlationId
    errors {
      type
      message
    }
  }
}
    ${AuditReportDataFragmentDoc}`;

/**
 * __useAuditGenerationCompleteSubscription__
 *
 * To run a query within a React component, call `useAuditGenerationCompleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAuditGenerationCompleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditGenerationCompleteSubscription({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *      enableCrossListingUsedCourses: // value for 'enableCrossListingUsedCourses'
 *   },
 * });
 */
export function useAuditGenerationCompleteSubscription(baseOptions: Apollo.SubscriptionHookOptions<AuditGenerationCompleteSubscription, AuditGenerationCompleteSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AuditGenerationCompleteSubscription, AuditGenerationCompleteSubscriptionVariables>(AuditGenerationCompleteDocument, options);
      }
export type AuditGenerationCompleteSubscriptionHookResult = ReturnType<typeof useAuditGenerationCompleteSubscription>;
export type AuditGenerationCompleteSubscriptionResult = Apollo.SubscriptionResult<AuditGenerationCompleteSubscription>;
export const CreateUsersDocument = gql`
    mutation createUsers($input: CreateUsersInput!) {
  createUsers(input: $input) {
    appUserId
    effectivePermissions
    firstName
    lastName
  }
}
    `;
export type CreateUsersMutationFn = Apollo.MutationFunction<CreateUsersMutation, CreateUsersMutationVariables>;

/**
 * __useCreateUsersMutation__
 *
 * To run a mutation, you first call `useCreateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUsersMutation, { data, loading, error }] = useCreateUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateUsersMutation, CreateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUsersMutation, CreateUsersMutationVariables>(CreateUsersDocument, options);
      }
export type CreateUsersMutationHookResult = ReturnType<typeof useCreateUsersMutation>;
export type CreateUsersMutationResult = Apollo.MutationResult<CreateUsersMutation>;
export type CreateUsersMutationOptions = Apollo.BaseMutationOptions<CreateUsersMutation, CreateUsersMutationVariables>;
export const SelfDocument = gql`
    query self {
  self {
    id
    permissions
    adminUser {
      id
      appUserId
      sub
      email
      firstName
      lastName
    }
    studentUser {
      id
      appUserId
      sub
      email
      displayName
      firstName
      lastName
      name
      studentId
    }
  }
}
    `;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: Apollo.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
      }
export function useSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfQueryResult = Apollo.QueryResult<SelfQuery, SelfQueryVariables>;
export const SchedulerLoginDocument = gql`
    mutation schedulerLogin($input: CreateSchedulerLoginInput!) {
  schedulerLogin(input: $input) {
    key
  }
}
    `;
export type SchedulerLoginMutationFn = Apollo.MutationFunction<SchedulerLoginMutation, SchedulerLoginMutationVariables>;

/**
 * __useSchedulerLoginMutation__
 *
 * To run a mutation, you first call `useSchedulerLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulerLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulerLoginMutation, { data, loading, error }] = useSchedulerLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchedulerLoginMutation(baseOptions?: Apollo.MutationHookOptions<SchedulerLoginMutation, SchedulerLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulerLoginMutation, SchedulerLoginMutationVariables>(SchedulerLoginDocument, options);
      }
export type SchedulerLoginMutationHookResult = ReturnType<typeof useSchedulerLoginMutation>;
export type SchedulerLoginMutationResult = Apollo.MutationResult<SchedulerLoginMutation>;
export type SchedulerLoginMutationOptions = Apollo.BaseMutationOptions<SchedulerLoginMutation, SchedulerLoginMutationVariables>;
export const CatalogCourseDocument = gql`
    query catalogCourse($id: ID!) {
  catalogCourse(id: $id) {
    ...catalogCourse
  }
}
    ${CatalogCourseFragmentDoc}`;

/**
 * __useCatalogCourseQuery__
 *
 * To run a query within a React component, call `useCatalogCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCatalogCourseQuery(baseOptions: Apollo.QueryHookOptions<CatalogCourseQuery, CatalogCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogCourseQuery, CatalogCourseQueryVariables>(CatalogCourseDocument, options);
      }
export function useCatalogCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogCourseQuery, CatalogCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogCourseQuery, CatalogCourseQueryVariables>(CatalogCourseDocument, options);
        }
export type CatalogCourseQueryHookResult = ReturnType<typeof useCatalogCourseQuery>;
export type CatalogCourseLazyQueryHookResult = ReturnType<typeof useCatalogCourseLazyQuery>;
export type CatalogCourseQueryResult = Apollo.QueryResult<CatalogCourseQuery, CatalogCourseQueryVariables>;
export const SearchCoursesDocument = gql`
    query searchCourses($text: String!, $environment: String!, $campus: String, $termCode: String) {
  searchCourses(
    text: $text
    environment: $environment
    campus: $campus
    termCode: $termCode
  ) {
    ...catalogSearchResult
  }
}
    ${CatalogSearchResultFragmentDoc}`;

/**
 * __useSearchCoursesQuery__
 *
 * To run a query within a React component, call `useSearchCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCoursesQuery({
 *   variables: {
 *      text: // value for 'text'
 *      environment: // value for 'environment'
 *      campus: // value for 'campus'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useSearchCoursesQuery(baseOptions: Apollo.QueryHookOptions<SearchCoursesQuery, SearchCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCoursesQuery, SearchCoursesQueryVariables>(SearchCoursesDocument, options);
      }
export function useSearchCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCoursesQuery, SearchCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCoursesQuery, SearchCoursesQueryVariables>(SearchCoursesDocument, options);
        }
export type SearchCoursesQueryHookResult = ReturnType<typeof useSearchCoursesQuery>;
export type SearchCoursesLazyQueryHookResult = ReturnType<typeof useSearchCoursesLazyQuery>;
export type SearchCoursesQueryResult = Apollo.QueryResult<SearchCoursesQuery, SearchCoursesQueryVariables>;
export const StudentCoursesDocument = gql`
    query studentCourses($studentAppUserId: Int!) {
  studentCourses(studentAppUserId: $studentAppUserId) {
    ...courseHistory
  }
}
    ${CourseHistoryFragmentDoc}`;

/**
 * __useStudentCoursesQuery__
 *
 * To run a query within a React component, call `useStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentCoursesQuery({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<StudentCoursesQuery, StudentCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentCoursesQuery, StudentCoursesQueryVariables>(StudentCoursesDocument, options);
      }
export function useStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentCoursesQuery, StudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentCoursesQuery, StudentCoursesQueryVariables>(StudentCoursesDocument, options);
        }
export type StudentCoursesQueryHookResult = ReturnType<typeof useStudentCoursesQuery>;
export type StudentCoursesLazyQueryHookResult = ReturnType<typeof useStudentCoursesLazyQuery>;
export type StudentCoursesQueryResult = Apollo.QueryResult<StudentCoursesQuery, StudentCoursesQueryVariables>;
export const StudentTermGpaDocument = gql`
    query studentTermGpa($studentAppUserId: Int!) {
  studentTermGpa(studentAppUserId: $studentAppUserId) {
    ...studentTermGpa
  }
}
    ${StudentTermGpaFragmentDoc}`;

/**
 * __useStudentTermGpaQuery__
 *
 * To run a query within a React component, call `useStudentTermGpaQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentTermGpaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentTermGpaQuery({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useStudentTermGpaQuery(baseOptions: Apollo.QueryHookOptions<StudentTermGpaQuery, StudentTermGpaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentTermGpaQuery, StudentTermGpaQueryVariables>(StudentTermGpaDocument, options);
      }
export function useStudentTermGpaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentTermGpaQuery, StudentTermGpaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentTermGpaQuery, StudentTermGpaQueryVariables>(StudentTermGpaDocument, options);
        }
export type StudentTermGpaQueryHookResult = ReturnType<typeof useStudentTermGpaQuery>;
export type StudentTermGpaLazyQueryHookResult = ReturnType<typeof useStudentTermGpaLazyQuery>;
export type StudentTermGpaQueryResult = Apollo.QueryResult<StudentTermGpaQuery, StudentTermGpaQueryVariables>;
export const CourseDataLastUpdateDocument = gql`
    query courseDataLastUpdate {
  courseDataLastUpdate
}
    `;

/**
 * __useCourseDataLastUpdateQuery__
 *
 * To run a query within a React component, call `useCourseDataLastUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseDataLastUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseDataLastUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCourseDataLastUpdateQuery(baseOptions?: Apollo.QueryHookOptions<CourseDataLastUpdateQuery, CourseDataLastUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseDataLastUpdateQuery, CourseDataLastUpdateQueryVariables>(CourseDataLastUpdateDocument, options);
      }
export function useCourseDataLastUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseDataLastUpdateQuery, CourseDataLastUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseDataLastUpdateQuery, CourseDataLastUpdateQueryVariables>(CourseDataLastUpdateDocument, options);
        }
export type CourseDataLastUpdateQueryHookResult = ReturnType<typeof useCourseDataLastUpdateQuery>;
export type CourseDataLastUpdateLazyQueryHookResult = ReturnType<typeof useCourseDataLastUpdateLazyQuery>;
export type CourseDataLastUpdateQueryResult = Apollo.QueryResult<CourseDataLastUpdateQuery, CourseDataLastUpdateQueryVariables>;
export const HasCaseloadDocument = gql`
    query hasCaseload($advisorExternalId: String) {
  hasCaseload(advisorExternalId: $advisorExternalId)
}
    `;

/**
 * __useHasCaseloadQuery__
 *
 * To run a query within a React component, call `useHasCaseloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasCaseloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasCaseloadQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *   },
 * });
 */
export function useHasCaseloadQuery(baseOptions?: Apollo.QueryHookOptions<HasCaseloadQuery, HasCaseloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasCaseloadQuery, HasCaseloadQueryVariables>(HasCaseloadDocument, options);
      }
export function useHasCaseloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasCaseloadQuery, HasCaseloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasCaseloadQuery, HasCaseloadQueryVariables>(HasCaseloadDocument, options);
        }
export type HasCaseloadQueryHookResult = ReturnType<typeof useHasCaseloadQuery>;
export type HasCaseloadLazyQueryHookResult = ReturnType<typeof useHasCaseloadLazyQuery>;
export type HasCaseloadQueryResult = Apollo.QueryResult<HasCaseloadQuery, HasCaseloadQueryVariables>;
export const UnreadCommentCountDocument = gql`
    query unreadCommentCount($advisorExternalId: String, $includeAllStudents: Boolean) {
  unreadCommentCount(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
  )
}
    `;

/**
 * __useUnreadCommentCountQuery__
 *
 * To run a query within a React component, call `useUnreadCommentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadCommentCountQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *   },
 * });
 */
export function useUnreadCommentCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadCommentCountQuery, UnreadCommentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadCommentCountQuery, UnreadCommentCountQueryVariables>(UnreadCommentCountDocument, options);
      }
export function useUnreadCommentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadCommentCountQuery, UnreadCommentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadCommentCountQuery, UnreadCommentCountQueryVariables>(UnreadCommentCountDocument, options);
        }
export type UnreadCommentCountQueryHookResult = ReturnType<typeof useUnreadCommentCountQuery>;
export type UnreadCommentCountLazyQueryHookResult = ReturnType<typeof useUnreadCommentCountLazyQuery>;
export type UnreadCommentCountQueryResult = Apollo.QueryResult<UnreadCommentCountQuery, UnreadCommentCountQueryVariables>;
export const DownloadUnreadCommentCountDetailDocument = gql`
    query downloadUnreadCommentCountDetail($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $sortKey: String, $sortOrder: SortOrder) {
  downloadUnreadCommentCountDetail(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    sortKey: $sortKey
    sortOrder: $sortOrder
  ) {
    firstName
    lastName
    planTitle
    studentId
    unreadCommentCount
    mostRecent
  }
}
    `;

/**
 * __useDownloadUnreadCommentCountDetailQuery__
 *
 * To run a query within a React component, call `useDownloadUnreadCommentCountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUnreadCommentCountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUnreadCommentCountDetailQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useDownloadUnreadCommentCountDetailQuery(baseOptions?: Apollo.QueryHookOptions<DownloadUnreadCommentCountDetailQuery, DownloadUnreadCommentCountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUnreadCommentCountDetailQuery, DownloadUnreadCommentCountDetailQueryVariables>(DownloadUnreadCommentCountDetailDocument, options);
      }
export function useDownloadUnreadCommentCountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUnreadCommentCountDetailQuery, DownloadUnreadCommentCountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUnreadCommentCountDetailQuery, DownloadUnreadCommentCountDetailQueryVariables>(DownloadUnreadCommentCountDetailDocument, options);
        }
export type DownloadUnreadCommentCountDetailQueryHookResult = ReturnType<typeof useDownloadUnreadCommentCountDetailQuery>;
export type DownloadUnreadCommentCountDetailLazyQueryHookResult = ReturnType<typeof useDownloadUnreadCommentCountDetailLazyQuery>;
export type DownloadUnreadCommentCountDetailQueryResult = Apollo.QueryResult<DownloadUnreadCommentCountDetailQuery, DownloadUnreadCommentCountDetailQueryVariables>;
export const UnreadCommentCountDetailsDocument = gql`
    query unreadCommentCountDetails($advisorExternalId: String, $includeAllStudents: Boolean, $first: Int, $after: String, $sortKey: String, $sortOrder: SortOrder, $last: Int, $before: String) {
  unreadCommentCountDetails(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    first: $first
    after: $after
    sortKey: $sortKey
    sortOrder: $sortOrder
    last: $last
    before: $before
  ) {
    edges {
      node {
        firstName
        lastName
        planTitle
        studentId
        studentAppUserId
        unreadCommentCount
        mostRecent
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useUnreadCommentCountDetailsQuery__
 *
 * To run a query within a React component, call `useUnreadCommentCountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommentCountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadCommentCountDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUnreadCommentCountDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UnreadCommentCountDetailsQuery, UnreadCommentCountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadCommentCountDetailsQuery, UnreadCommentCountDetailsQueryVariables>(UnreadCommentCountDetailsDocument, options);
      }
export function useUnreadCommentCountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadCommentCountDetailsQuery, UnreadCommentCountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadCommentCountDetailsQuery, UnreadCommentCountDetailsQueryVariables>(UnreadCommentCountDetailsDocument, options);
        }
export type UnreadCommentCountDetailsQueryHookResult = ReturnType<typeof useUnreadCommentCountDetailsQuery>;
export type UnreadCommentCountDetailsLazyQueryHookResult = ReturnType<typeof useUnreadCommentCountDetailsLazyQuery>;
export type UnreadCommentCountDetailsQueryResult = Apollo.QueryResult<UnreadCommentCountDetailsQuery, UnreadCommentCountDetailsQueryVariables>;
export const PlanCreationCountsDocument = gql`
    query planCreationCounts($advisorExternalId: String, $includeAllStudents: Boolean) {
  planCreationCounts(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
  ) {
    studentsWithPlansCount
    studentsWithoutPlansCount
  }
}
    `;

/**
 * __usePlanCreationCountsQuery__
 *
 * To run a query within a React component, call `usePlanCreationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanCreationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanCreationCountsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *   },
 * });
 */
export function usePlanCreationCountsQuery(baseOptions?: Apollo.QueryHookOptions<PlanCreationCountsQuery, PlanCreationCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanCreationCountsQuery, PlanCreationCountsQueryVariables>(PlanCreationCountsDocument, options);
      }
export function usePlanCreationCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanCreationCountsQuery, PlanCreationCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanCreationCountsQuery, PlanCreationCountsQueryVariables>(PlanCreationCountsDocument, options);
        }
export type PlanCreationCountsQueryHookResult = ReturnType<typeof usePlanCreationCountsQuery>;
export type PlanCreationCountsLazyQueryHookResult = ReturnType<typeof usePlanCreationCountsLazyQuery>;
export type PlanCreationCountsQueryResult = Apollo.QueryResult<PlanCreationCountsQuery, PlanCreationCountsQueryVariables>;
export const DownloadPlanCreationDetailsDocument = gql`
    query downloadPlanCreationDetails($advisorExternalId: String, $excludeIds: [String!], $filter: StudentPlanFilter, $includeAllStudents: Boolean, $includeIds: [String!], $loginFilter: StudentLoginFilter, $sortKey: String, $sortOrder: SortOrder) {
  downloadPlanCreationDetails(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    filter: $filter
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    loginFilter: $loginFilter
    sortKey: $sortKey
    sortOrder: $sortOrder
  ) {
    firstName
    lastName
    studentId
    studentAppUserId
    lastLogin
  }
}
    `;

/**
 * __useDownloadPlanCreationDetailsQuery__
 *
 * To run a query within a React component, call `useDownloadPlanCreationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPlanCreationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPlanCreationDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      filter: // value for 'filter'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      loginFilter: // value for 'loginFilter'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useDownloadPlanCreationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DownloadPlanCreationDetailsQuery, DownloadPlanCreationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadPlanCreationDetailsQuery, DownloadPlanCreationDetailsQueryVariables>(DownloadPlanCreationDetailsDocument, options);
      }
export function useDownloadPlanCreationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadPlanCreationDetailsQuery, DownloadPlanCreationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadPlanCreationDetailsQuery, DownloadPlanCreationDetailsQueryVariables>(DownloadPlanCreationDetailsDocument, options);
        }
export type DownloadPlanCreationDetailsQueryHookResult = ReturnType<typeof useDownloadPlanCreationDetailsQuery>;
export type DownloadPlanCreationDetailsLazyQueryHookResult = ReturnType<typeof useDownloadPlanCreationDetailsLazyQuery>;
export type DownloadPlanCreationDetailsQueryResult = Apollo.QueryResult<DownloadPlanCreationDetailsQuery, DownloadPlanCreationDetailsQueryVariables>;
export const PlanCreationDetailsDocument = gql`
    query planCreationDetails($advisorExternalId: String, $after: String, $before: String, $first: Int, $includeAllStudents: Boolean, $last: Int, $sortKey: String, $sortOrder: SortOrder, $filter: StudentPlanFilter, $loginFilter: StudentLoginFilter) {
  planCreationDetails(
    advisorExternalId: $advisorExternalId
    after: $after
    before: $before
    first: $first
    includeAllStudents: $includeAllStudents
    last: $last
    sortKey: $sortKey
    sortOrder: $sortOrder
    filter: $filter
    loginFilter: $loginFilter
  ) {
    edges {
      node {
        firstName
        lastName
        studentId
        studentAppUserId
        lastLogin
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __usePlanCreationDetailsQuery__
 *
 * To run a query within a React component, call `usePlanCreationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanCreationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanCreationDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      last: // value for 'last'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *      loginFilter: // value for 'loginFilter'
 *   },
 * });
 */
export function usePlanCreationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PlanCreationDetailsQuery, PlanCreationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanCreationDetailsQuery, PlanCreationDetailsQueryVariables>(PlanCreationDetailsDocument, options);
      }
export function usePlanCreationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanCreationDetailsQuery, PlanCreationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanCreationDetailsQuery, PlanCreationDetailsQueryVariables>(PlanCreationDetailsDocument, options);
        }
export type PlanCreationDetailsQueryHookResult = ReturnType<typeof usePlanCreationDetailsQuery>;
export type PlanCreationDetailsLazyQueryHookResult = ReturnType<typeof usePlanCreationDetailsLazyQuery>;
export type PlanCreationDetailsQueryResult = Apollo.QueryResult<PlanCreationDetailsQuery, PlanCreationDetailsQueryVariables>;
export const IncomingNoPlanCountDocument = gql`
    query incomingNoPlanCount($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!) {
  incomingNoPlanCount(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
  )
}
    `;

/**
 * __useIncomingNoPlanCountQuery__
 *
 * To run a query within a React component, call `useIncomingNoPlanCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingNoPlanCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingNoPlanCountQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useIncomingNoPlanCountQuery(baseOptions: Apollo.QueryHookOptions<IncomingNoPlanCountQuery, IncomingNoPlanCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingNoPlanCountQuery, IncomingNoPlanCountQueryVariables>(IncomingNoPlanCountDocument, options);
      }
export function useIncomingNoPlanCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingNoPlanCountQuery, IncomingNoPlanCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingNoPlanCountQuery, IncomingNoPlanCountQueryVariables>(IncomingNoPlanCountDocument, options);
        }
export type IncomingNoPlanCountQueryHookResult = ReturnType<typeof useIncomingNoPlanCountQuery>;
export type IncomingNoPlanCountLazyQueryHookResult = ReturnType<typeof useIncomingNoPlanCountLazyQuery>;
export type IncomingNoPlanCountQueryResult = Apollo.QueryResult<IncomingNoPlanCountQuery, IncomingNoPlanCountQueryVariables>;
export const DownloadIncomingNoPlanDetailsDocument = gql`
    query downloadIncomingNoPlanDetails($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $majorFilter: AcademicProgramFilter, $minorFilter: AcademicProgramFilter, $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  downloadIncomingNoPlanDetails(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    majorFilter: $majorFilter
    minorFilter: $minorFilter
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
    excludeIds: $excludeIds
    includeIds: $includeIds
  ) {
    firstName
    lastName
    studentId
    studentAppUserId
    academicPrograms {
      description
      programId
      type
    }
  }
}
    `;

/**
 * __useDownloadIncomingNoPlanDetailsQuery__
 *
 * To run a query within a React component, call `useDownloadIncomingNoPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadIncomingNoPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadIncomingNoPlanDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      majorFilter: // value for 'majorFilter'
 *      minorFilter: // value for 'minorFilter'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useDownloadIncomingNoPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<DownloadIncomingNoPlanDetailsQuery, DownloadIncomingNoPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadIncomingNoPlanDetailsQuery, DownloadIncomingNoPlanDetailsQueryVariables>(DownloadIncomingNoPlanDetailsDocument, options);
      }
export function useDownloadIncomingNoPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadIncomingNoPlanDetailsQuery, DownloadIncomingNoPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadIncomingNoPlanDetailsQuery, DownloadIncomingNoPlanDetailsQueryVariables>(DownloadIncomingNoPlanDetailsDocument, options);
        }
export type DownloadIncomingNoPlanDetailsQueryHookResult = ReturnType<typeof useDownloadIncomingNoPlanDetailsQuery>;
export type DownloadIncomingNoPlanDetailsLazyQueryHookResult = ReturnType<typeof useDownloadIncomingNoPlanDetailsLazyQuery>;
export type DownloadIncomingNoPlanDetailsQueryResult = Apollo.QueryResult<DownloadIncomingNoPlanDetailsQuery, DownloadIncomingNoPlanDetailsQueryVariables>;
export const IncomingNoPlanDetailsDocument = gql`
    query incomingNoPlanDetails($advisorExternalId: String, $after: String, $before: String, $first: Int, $includeAllStudents: Boolean, $last: Int, $majorFilter: AcademicProgramFilter, $minorFilter: AcademicProgramFilter, $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  incomingNoPlanDetails(
    advisorExternalId: $advisorExternalId
    after: $after
    before: $before
    first: $first
    includeAllStudents: $includeAllStudents
    last: $last
    majorFilter: $majorFilter
    minorFilter: $minorFilter
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
  ) {
    edges {
      node {
        firstName
        lastName
        studentId
        studentAppUserId
        academicPrograms {
          description
          programId
          type
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    majors {
      description
      programId
    }
    minors {
      description
      programId
    }
  }
}
    `;

/**
 * __useIncomingNoPlanDetailsQuery__
 *
 * To run a query within a React component, call `useIncomingNoPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingNoPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingNoPlanDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      last: // value for 'last'
 *      majorFilter: // value for 'majorFilter'
 *      minorFilter: // value for 'minorFilter'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useIncomingNoPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<IncomingNoPlanDetailsQuery, IncomingNoPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingNoPlanDetailsQuery, IncomingNoPlanDetailsQueryVariables>(IncomingNoPlanDetailsDocument, options);
      }
export function useIncomingNoPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingNoPlanDetailsQuery, IncomingNoPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingNoPlanDetailsQuery, IncomingNoPlanDetailsQueryVariables>(IncomingNoPlanDetailsDocument, options);
        }
export type IncomingNoPlanDetailsQueryHookResult = ReturnType<typeof useIncomingNoPlanDetailsQuery>;
export type IncomingNoPlanDetailsLazyQueryHookResult = ReturnType<typeof useIncomingNoPlanDetailsLazyQuery>;
export type IncomingNoPlanDetailsQueryResult = Apollo.QueryResult<IncomingNoPlanDetailsQuery, IncomingNoPlanDetailsQueryVariables>;
export const CreditCountsDocument = gql`
    query creditCounts($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!) {
  creditCounts(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
  ) {
    noCredits
    zeroToThreeCredits
    fourToSixCredits
    sevenToNineCredits
    tenToTwelveCredits
    thirteenToFifteenCredits
    sixteenPlusCredits
  }
}
    `;

/**
 * __useCreditCountsQuery__
 *
 * To run a query within a React component, call `useCreditCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCountsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useCreditCountsQuery(baseOptions: Apollo.QueryHookOptions<CreditCountsQuery, CreditCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCountsQuery, CreditCountsQueryVariables>(CreditCountsDocument, options);
      }
export function useCreditCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCountsQuery, CreditCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCountsQuery, CreditCountsQueryVariables>(CreditCountsDocument, options);
        }
export type CreditCountsQueryHookResult = ReturnType<typeof useCreditCountsQuery>;
export type CreditCountsLazyQueryHookResult = ReturnType<typeof useCreditCountsLazyQuery>;
export type CreditCountsQueryResult = Apollo.QueryResult<CreditCountsQuery, CreditCountsQueryVariables>;
export const DownloadCreditCountDetailsDocument = gql`
    query downloadCreditCountDetails($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $maxCredits: Int, $minCredits: Int, $noCredits: Boolean, $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  downloadCreditCountDetails(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    maxCredits: $maxCredits
    minCredits: $minCredits
    noCredits: $noCredits
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
  ) {
    firstName
    lastName
    maxCredits
    minCredits
    studentId
    studentAppUserId
  }
}
    `;

/**
 * __useDownloadCreditCountDetailsQuery__
 *
 * To run a query within a React component, call `useDownloadCreditCountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCreditCountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCreditCountDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      maxCredits: // value for 'maxCredits'
 *      minCredits: // value for 'minCredits'
 *      noCredits: // value for 'noCredits'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useDownloadCreditCountDetailsQuery(baseOptions: Apollo.QueryHookOptions<DownloadCreditCountDetailsQuery, DownloadCreditCountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCreditCountDetailsQuery, DownloadCreditCountDetailsQueryVariables>(DownloadCreditCountDetailsDocument, options);
      }
export function useDownloadCreditCountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCreditCountDetailsQuery, DownloadCreditCountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCreditCountDetailsQuery, DownloadCreditCountDetailsQueryVariables>(DownloadCreditCountDetailsDocument, options);
        }
export type DownloadCreditCountDetailsQueryHookResult = ReturnType<typeof useDownloadCreditCountDetailsQuery>;
export type DownloadCreditCountDetailsLazyQueryHookResult = ReturnType<typeof useDownloadCreditCountDetailsLazyQuery>;
export type DownloadCreditCountDetailsQueryResult = Apollo.QueryResult<DownloadCreditCountDetailsQuery, DownloadCreditCountDetailsQueryVariables>;
export const CreditCountDetailsDocument = gql`
    query creditCountDetails($advisorExternalId: String, $includeAllStudents: Boolean, $noCredits: Boolean, $minCredits: Int, $maxCredits: Int, $termCode: String!, $first: Int, $after: String, $sortKey: String, $sortOrder: SortOrder, $last: Int, $before: String) {
  creditCountDetails(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    noCredits: $noCredits
    minCredits: $minCredits
    maxCredits: $maxCredits
    termCode: $termCode
    first: $first
    after: $after
    sortKey: $sortKey
    sortOrder: $sortOrder
    last: $last
    before: $before
  ) {
    edges {
      node {
        firstName
        lastName
        maxCredits
        minCredits
        studentId
        studentAppUserId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useCreditCountDetailsQuery__
 *
 * To run a query within a React component, call `useCreditCountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditCountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditCountDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      noCredits: // value for 'noCredits'
 *      minCredits: // value for 'minCredits'
 *      maxCredits: // value for 'maxCredits'
 *      termCode: // value for 'termCode'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useCreditCountDetailsQuery(baseOptions: Apollo.QueryHookOptions<CreditCountDetailsQuery, CreditCountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditCountDetailsQuery, CreditCountDetailsQueryVariables>(CreditCountDetailsDocument, options);
      }
export function useCreditCountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditCountDetailsQuery, CreditCountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditCountDetailsQuery, CreditCountDetailsQueryVariables>(CreditCountDetailsDocument, options);
        }
export type CreditCountDetailsQueryHookResult = ReturnType<typeof useCreditCountDetailsQuery>;
export type CreditCountDetailsLazyQueryHookResult = ReturnType<typeof useCreditCountDetailsLazyQuery>;
export type CreditCountDetailsQueryResult = Apollo.QueryResult<CreditCountDetailsQuery, CreditCountDetailsQueryVariables>;
export const UnregisteredCountDocument = gql`
    query unregisteredCount($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!) {
  unregisteredCount(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
  )
}
    `;

/**
 * __useUnregisteredCountQuery__
 *
 * To run a query within a React component, call `useUnregisteredCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnregisteredCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnregisteredCountQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useUnregisteredCountQuery(baseOptions: Apollo.QueryHookOptions<UnregisteredCountQuery, UnregisteredCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnregisteredCountQuery, UnregisteredCountQueryVariables>(UnregisteredCountDocument, options);
      }
export function useUnregisteredCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnregisteredCountQuery, UnregisteredCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnregisteredCountQuery, UnregisteredCountQueryVariables>(UnregisteredCountDocument, options);
        }
export type UnregisteredCountQueryHookResult = ReturnType<typeof useUnregisteredCountQuery>;
export type UnregisteredCountLazyQueryHookResult = ReturnType<typeof useUnregisteredCountLazyQuery>;
export type UnregisteredCountQueryResult = Apollo.QueryResult<UnregisteredCountQuery, UnregisteredCountQueryVariables>;
export const NotRegisteredCountDocument = gql`
    query notRegisteredCount($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!) {
  notRegisteredCount(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
  )
}
    `;

/**
 * __useNotRegisteredCountQuery__
 *
 * To run a query within a React component, call `useNotRegisteredCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotRegisteredCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotRegisteredCountQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useNotRegisteredCountQuery(baseOptions: Apollo.QueryHookOptions<NotRegisteredCountQuery, NotRegisteredCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotRegisteredCountQuery, NotRegisteredCountQueryVariables>(NotRegisteredCountDocument, options);
      }
export function useNotRegisteredCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotRegisteredCountQuery, NotRegisteredCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotRegisteredCountQuery, NotRegisteredCountQueryVariables>(NotRegisteredCountDocument, options);
        }
export type NotRegisteredCountQueryHookResult = ReturnType<typeof useNotRegisteredCountQuery>;
export type NotRegisteredCountLazyQueryHookResult = ReturnType<typeof useNotRegisteredCountLazyQuery>;
export type NotRegisteredCountQueryResult = Apollo.QueryResult<NotRegisteredCountQuery, NotRegisteredCountQueryVariables>;
export const DownloadNotRegisteredCountDetailDocument = gql`
    query downloadNotRegisteredCountDetail($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  downloadNotRegisteredCountDetail(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
  ) {
    firstName
    lastName
    studentId
    studentAppUserId
  }
}
    `;

/**
 * __useDownloadNotRegisteredCountDetailQuery__
 *
 * To run a query within a React component, call `useDownloadNotRegisteredCountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadNotRegisteredCountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadNotRegisteredCountDetailQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useDownloadNotRegisteredCountDetailQuery(baseOptions: Apollo.QueryHookOptions<DownloadNotRegisteredCountDetailQuery, DownloadNotRegisteredCountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadNotRegisteredCountDetailQuery, DownloadNotRegisteredCountDetailQueryVariables>(DownloadNotRegisteredCountDetailDocument, options);
      }
export function useDownloadNotRegisteredCountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadNotRegisteredCountDetailQuery, DownloadNotRegisteredCountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadNotRegisteredCountDetailQuery, DownloadNotRegisteredCountDetailQueryVariables>(DownloadNotRegisteredCountDetailDocument, options);
        }
export type DownloadNotRegisteredCountDetailQueryHookResult = ReturnType<typeof useDownloadNotRegisteredCountDetailQuery>;
export type DownloadNotRegisteredCountDetailLazyQueryHookResult = ReturnType<typeof useDownloadNotRegisteredCountDetailLazyQuery>;
export type DownloadNotRegisteredCountDetailQueryResult = Apollo.QueryResult<DownloadNotRegisteredCountDetailQuery, DownloadNotRegisteredCountDetailQueryVariables>;
export const NotRegisteredCountDetailsDocument = gql`
    query notRegisteredCountDetails($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!, $first: Int, $after: String, $sortKey: String, $sortOrder: SortOrder, $last: Int, $before: String) {
  notRegisteredCountDetails(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
    first: $first
    after: $after
    sortKey: $sortKey
    sortOrder: $sortOrder
    last: $last
    before: $before
  ) {
    edges {
      node {
        firstName
        lastName
        studentId
        studentAppUserId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useNotRegisteredCountDetailsQuery__
 *
 * To run a query within a React component, call `useNotRegisteredCountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotRegisteredCountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotRegisteredCountDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useNotRegisteredCountDetailsQuery(baseOptions: Apollo.QueryHookOptions<NotRegisteredCountDetailsQuery, NotRegisteredCountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotRegisteredCountDetailsQuery, NotRegisteredCountDetailsQueryVariables>(NotRegisteredCountDetailsDocument, options);
      }
export function useNotRegisteredCountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotRegisteredCountDetailsQuery, NotRegisteredCountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotRegisteredCountDetailsQuery, NotRegisteredCountDetailsQueryVariables>(NotRegisteredCountDetailsDocument, options);
        }
export type NotRegisteredCountDetailsQueryHookResult = ReturnType<typeof useNotRegisteredCountDetailsQuery>;
export type NotRegisteredCountDetailsLazyQueryHookResult = ReturnType<typeof useNotRegisteredCountDetailsLazyQuery>;
export type NotRegisteredCountDetailsQueryResult = Apollo.QueryResult<NotRegisteredCountDetailsQuery, NotRegisteredCountDetailsQueryVariables>;
export const DownloadUnregisteredCountDetailDocument = gql`
    query downloadUnregisteredCountDetail($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  downloadUnregisteredCountDetail(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
  ) {
    firstName
    lastName
    studentId
    studentAppUserId
  }
}
    `;

/**
 * __useDownloadUnregisteredCountDetailQuery__
 *
 * To run a query within a React component, call `useDownloadUnregisteredCountDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUnregisteredCountDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUnregisteredCountDetailQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useDownloadUnregisteredCountDetailQuery(baseOptions: Apollo.QueryHookOptions<DownloadUnregisteredCountDetailQuery, DownloadUnregisteredCountDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUnregisteredCountDetailQuery, DownloadUnregisteredCountDetailQueryVariables>(DownloadUnregisteredCountDetailDocument, options);
      }
export function useDownloadUnregisteredCountDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUnregisteredCountDetailQuery, DownloadUnregisteredCountDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUnregisteredCountDetailQuery, DownloadUnregisteredCountDetailQueryVariables>(DownloadUnregisteredCountDetailDocument, options);
        }
export type DownloadUnregisteredCountDetailQueryHookResult = ReturnType<typeof useDownloadUnregisteredCountDetailQuery>;
export type DownloadUnregisteredCountDetailLazyQueryHookResult = ReturnType<typeof useDownloadUnregisteredCountDetailLazyQuery>;
export type DownloadUnregisteredCountDetailQueryResult = Apollo.QueryResult<DownloadUnregisteredCountDetailQuery, DownloadUnregisteredCountDetailQueryVariables>;
export const UnregisteredCountDetailsDocument = gql`
    query unregisteredCountDetails($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!, $first: Int, $after: String, $sortKey: String, $sortOrder: SortOrder, $last: Int, $before: String) {
  unregisteredCountDetails(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
    first: $first
    after: $after
    sortKey: $sortKey
    sortOrder: $sortOrder
    last: $last
    before: $before
  ) {
    edges {
      node {
        firstName
        lastName
        studentId
        studentAppUserId
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useUnregisteredCountDetailsQuery__
 *
 * To run a query within a React component, call `useUnregisteredCountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnregisteredCountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnregisteredCountDetailsQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUnregisteredCountDetailsQuery(baseOptions: Apollo.QueryHookOptions<UnregisteredCountDetailsQuery, UnregisteredCountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnregisteredCountDetailsQuery, UnregisteredCountDetailsQueryVariables>(UnregisteredCountDetailsDocument, options);
      }
export function useUnregisteredCountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnregisteredCountDetailsQuery, UnregisteredCountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnregisteredCountDetailsQuery, UnregisteredCountDetailsQueryVariables>(UnregisteredCountDetailsDocument, options);
        }
export type UnregisteredCountDetailsQueryHookResult = ReturnType<typeof useUnregisteredCountDetailsQuery>;
export type UnregisteredCountDetailsLazyQueryHookResult = ReturnType<typeof useUnregisteredCountDetailsLazyQuery>;
export type UnregisteredCountDetailsQueryResult = Apollo.QueryResult<UnregisteredCountDetailsQuery, UnregisteredCountDetailsQueryVariables>;
export const AddStudentToWatchlistDocument = gql`
    mutation addStudentToWatchlist($studentAppUserId: Int!) {
  addStudentToWatchlist(studentAppUserId: $studentAppUserId) {
    ...watchlistStudent
  }
}
    ${WatchlistStudentFragmentDoc}`;
export type AddStudentToWatchlistMutationFn = Apollo.MutationFunction<AddStudentToWatchlistMutation, AddStudentToWatchlistMutationVariables>;

/**
 * __useAddStudentToWatchlistMutation__
 *
 * To run a mutation, you first call `useAddStudentToWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentToWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentToWatchlistMutation, { data, loading, error }] = useAddStudentToWatchlistMutation({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useAddStudentToWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentToWatchlistMutation, AddStudentToWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStudentToWatchlistMutation, AddStudentToWatchlistMutationVariables>(AddStudentToWatchlistDocument, options);
      }
export type AddStudentToWatchlistMutationHookResult = ReturnType<typeof useAddStudentToWatchlistMutation>;
export type AddStudentToWatchlistMutationResult = Apollo.MutationResult<AddStudentToWatchlistMutation>;
export type AddStudentToWatchlistMutationOptions = Apollo.BaseMutationOptions<AddStudentToWatchlistMutation, AddStudentToWatchlistMutationVariables>;
export const IsStudentInWatchlistDocument = gql`
    query isStudentInWatchlist($studentAppUserId: Int!) {
  isStudentInWatchlist(studentAppUserId: $studentAppUserId)
}
    `;

/**
 * __useIsStudentInWatchlistQuery__
 *
 * To run a query within a React component, call `useIsStudentInWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsStudentInWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsStudentInWatchlistQuery({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useIsStudentInWatchlistQuery(baseOptions: Apollo.QueryHookOptions<IsStudentInWatchlistQuery, IsStudentInWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsStudentInWatchlistQuery, IsStudentInWatchlistQueryVariables>(IsStudentInWatchlistDocument, options);
      }
export function useIsStudentInWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsStudentInWatchlistQuery, IsStudentInWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsStudentInWatchlistQuery, IsStudentInWatchlistQueryVariables>(IsStudentInWatchlistDocument, options);
        }
export type IsStudentInWatchlistQueryHookResult = ReturnType<typeof useIsStudentInWatchlistQuery>;
export type IsStudentInWatchlistLazyQueryHookResult = ReturnType<typeof useIsStudentInWatchlistLazyQuery>;
export type IsStudentInWatchlistQueryResult = Apollo.QueryResult<IsStudentInWatchlistQuery, IsStudentInWatchlistQueryVariables>;
export const RemoveStudentFromWatchlistDocument = gql`
    mutation removeStudentFromWatchlist($studentAppUserId: Int) {
  removeStudentFromWatchlist(studentAppUserId: $studentAppUserId) {
    id
    message
    success
  }
}
    `;
export type RemoveStudentFromWatchlistMutationFn = Apollo.MutationFunction<RemoveStudentFromWatchlistMutation, RemoveStudentFromWatchlistMutationVariables>;

/**
 * __useRemoveStudentFromWatchlistMutation__
 *
 * To run a mutation, you first call `useRemoveStudentFromWatchlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentFromWatchlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentFromWatchlistMutation, { data, loading, error }] = useRemoveStudentFromWatchlistMutation({
 *   variables: {
 *      studentAppUserId: // value for 'studentAppUserId'
 *   },
 * });
 */
export function useRemoveStudentFromWatchlistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStudentFromWatchlistMutation, RemoveStudentFromWatchlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStudentFromWatchlistMutation, RemoveStudentFromWatchlistMutationVariables>(RemoveStudentFromWatchlistDocument, options);
      }
export type RemoveStudentFromWatchlistMutationHookResult = ReturnType<typeof useRemoveStudentFromWatchlistMutation>;
export type RemoveStudentFromWatchlistMutationResult = Apollo.MutationResult<RemoveStudentFromWatchlistMutation>;
export type RemoveStudentFromWatchlistMutationOptions = Apollo.BaseMutationOptions<RemoveStudentFromWatchlistMutation, RemoveStudentFromWatchlistMutationVariables>;
export const WatchlistDocument = gql`
    query watchlist($advisorExternalId: String) {
  watchlist(advisorExternalId: $advisorExternalId) {
    ...watchlistStudent
  }
}
    ${WatchlistStudentFragmentDoc}`;

/**
 * __useWatchlistQuery__
 *
 * To run a query within a React component, call `useWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *   },
 * });
 */
export function useWatchlistQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistQuery, WatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistQuery, WatchlistQueryVariables>(WatchlistDocument, options);
      }
export function useWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistQuery, WatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistQuery, WatchlistQueryVariables>(WatchlistDocument, options);
        }
export type WatchlistQueryHookResult = ReturnType<typeof useWatchlistQuery>;
export type WatchlistLazyQueryHookResult = ReturnType<typeof useWatchlistLazyQuery>;
export type WatchlistQueryResult = Apollo.QueryResult<WatchlistQuery, WatchlistQueryVariables>;
export const UnavailableCourseCountDocument = gql`
    query unavailableCourseCount($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!) {
  unavailableCourseCount(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
  )
}
    `;

/**
 * __useUnavailableCourseCountQuery__
 *
 * To run a query within a React component, call `useUnavailableCourseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnavailableCourseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnavailableCourseCountQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useUnavailableCourseCountQuery(baseOptions: Apollo.QueryHookOptions<UnavailableCourseCountQuery, UnavailableCourseCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnavailableCourseCountQuery, UnavailableCourseCountQueryVariables>(UnavailableCourseCountDocument, options);
      }
export function useUnavailableCourseCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnavailableCourseCountQuery, UnavailableCourseCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnavailableCourseCountQuery, UnavailableCourseCountQueryVariables>(UnavailableCourseCountDocument, options);
        }
export type UnavailableCourseCountQueryHookResult = ReturnType<typeof useUnavailableCourseCountQuery>;
export type UnavailableCourseCountLazyQueryHookResult = ReturnType<typeof useUnavailableCourseCountLazyQuery>;
export type UnavailableCourseCountQueryResult = Apollo.QueryResult<UnavailableCourseCountQuery, UnavailableCourseCountQueryVariables>;
export const DownloadUnavailableCourseDetailDocument = gql`
    query downloadUnavailableCourseDetail($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!], $sortKey: String, $sortOrder: SortOrder, $termCode: String!) {
  downloadUnavailableCourseDetail(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
    sortKey: $sortKey
    sortOrder: $sortOrder
    termCode: $termCode
  ) {
    firstName
    lastName
    studentId
    studentAppUserId
    unofferedCoursesCount
  }
}
    `;

/**
 * __useDownloadUnavailableCourseDetailQuery__
 *
 * To run a query within a React component, call `useDownloadUnavailableCourseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUnavailableCourseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUnavailableCourseDetailQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      termCode: // value for 'termCode'
 *   },
 * });
 */
export function useDownloadUnavailableCourseDetailQuery(baseOptions: Apollo.QueryHookOptions<DownloadUnavailableCourseDetailQuery, DownloadUnavailableCourseDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUnavailableCourseDetailQuery, DownloadUnavailableCourseDetailQueryVariables>(DownloadUnavailableCourseDetailDocument, options);
      }
export function useDownloadUnavailableCourseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUnavailableCourseDetailQuery, DownloadUnavailableCourseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUnavailableCourseDetailQuery, DownloadUnavailableCourseDetailQueryVariables>(DownloadUnavailableCourseDetailDocument, options);
        }
export type DownloadUnavailableCourseDetailQueryHookResult = ReturnType<typeof useDownloadUnavailableCourseDetailQuery>;
export type DownloadUnavailableCourseDetailLazyQueryHookResult = ReturnType<typeof useDownloadUnavailableCourseDetailLazyQuery>;
export type DownloadUnavailableCourseDetailQueryResult = Apollo.QueryResult<DownloadUnavailableCourseDetailQuery, DownloadUnavailableCourseDetailQueryVariables>;
export const UnavailableCourseDetailDocument = gql`
    query unavailableCourseDetail($advisorExternalId: String, $includeAllStudents: Boolean, $termCode: String!, $first: Int, $after: String, $sortKey: String, $sortOrder: SortOrder, $last: Int, $before: String) {
  unavailableCourseDetail(
    advisorExternalId: $advisorExternalId
    includeAllStudents: $includeAllStudents
    termCode: $termCode
    first: $first
    after: $after
    sortKey: $sortKey
    sortOrder: $sortOrder
    last: $last
    before: $before
  ) {
    edges {
      node {
        firstName
        lastName
        studentId
        studentAppUserId
        unofferedCoursesCount
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useUnavailableCourseDetailQuery__
 *
 * To run a query within a React component, call `useUnavailableCourseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnavailableCourseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnavailableCourseDetailQuery({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      termCode: // value for 'termCode'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUnavailableCourseDetailQuery(baseOptions: Apollo.QueryHookOptions<UnavailableCourseDetailQuery, UnavailableCourseDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnavailableCourseDetailQuery, UnavailableCourseDetailQueryVariables>(UnavailableCourseDetailDocument, options);
      }
export function useUnavailableCourseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnavailableCourseDetailQuery, UnavailableCourseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnavailableCourseDetailQuery, UnavailableCourseDetailQueryVariables>(UnavailableCourseDetailDocument, options);
        }
export type UnavailableCourseDetailQueryHookResult = ReturnType<typeof useUnavailableCourseDetailQuery>;
export type UnavailableCourseDetailLazyQueryHookResult = ReturnType<typeof useUnavailableCourseDetailLazyQuery>;
export type UnavailableCourseDetailQueryResult = Apollo.QueryResult<UnavailableCourseDetailQuery, UnavailableCourseDetailQueryVariables>;
export const MarkAllStudentCommentsAsReadDocument = gql`
    mutation MarkAllStudentCommentsAsRead($advisorExternalId: String, $excludeIds: [String!], $includeAllStudents: Boolean, $includeIds: [String!]) {
  markAllStudentCommentsAsRead(
    advisorExternalId: $advisorExternalId
    excludeIds: $excludeIds
    includeAllStudents: $includeAllStudents
    includeIds: $includeIds
  ) {
    success
    message
    ids
  }
}
    `;
export type MarkAllStudentCommentsAsReadMutationFn = Apollo.MutationFunction<MarkAllStudentCommentsAsReadMutation, MarkAllStudentCommentsAsReadMutationVariables>;

/**
 * __useMarkAllStudentCommentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllStudentCommentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllStudentCommentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllStudentCommentsAsReadMutation, { data, loading, error }] = useMarkAllStudentCommentsAsReadMutation({
 *   variables: {
 *      advisorExternalId: // value for 'advisorExternalId'
 *      excludeIds: // value for 'excludeIds'
 *      includeAllStudents: // value for 'includeAllStudents'
 *      includeIds: // value for 'includeIds'
 *   },
 * });
 */
export function useMarkAllStudentCommentsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllStudentCommentsAsReadMutation, MarkAllStudentCommentsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllStudentCommentsAsReadMutation, MarkAllStudentCommentsAsReadMutationVariables>(MarkAllStudentCommentsAsReadDocument, options);
      }
export type MarkAllStudentCommentsAsReadMutationHookResult = ReturnType<typeof useMarkAllStudentCommentsAsReadMutation>;
export type MarkAllStudentCommentsAsReadMutationResult = Apollo.MutationResult<MarkAllStudentCommentsAsReadMutation>;
export type MarkAllStudentCommentsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllStudentCommentsAsReadMutation, MarkAllStudentCommentsAsReadMutationVariables>;
export const DiagnosticLogsDocument = gql`
    query diagnosticLogs($page: Int, $pageSize: Int, $sortKey: String, $sortOrder: SortOrder, $startDate: Timestamp, $endDate: Timestamp, $types: [DiagnosticLogType!]) {
  diagnosticLogsPaged(
    input: {page: $page, pageSize: $pageSize, sortKey: $sortKey, sortOrder: $sortOrder, startDate: $startDate, endDate: $endDate, types: $types}
  ) {
    resultCount
    page
    pageSize
    sortKey
    results {
      ...diagnosticLogData
    }
  }
}
    ${DiagnosticLogDataFragmentDoc}`;

/**
 * __useDiagnosticLogsQuery__
 *
 * To run a query within a React component, call `useDiagnosticLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticLogsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortKey: // value for 'sortKey'
 *      sortOrder: // value for 'sortOrder'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useDiagnosticLogsQuery(baseOptions?: Apollo.QueryHookOptions<DiagnosticLogsQuery, DiagnosticLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticLogsQuery, DiagnosticLogsQueryVariables>(DiagnosticLogsDocument, options);
      }
export function useDiagnosticLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticLogsQuery, DiagnosticLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticLogsQuery, DiagnosticLogsQueryVariables>(DiagnosticLogsDocument, options);
        }
export type DiagnosticLogsQueryHookResult = ReturnType<typeof useDiagnosticLogsQuery>;
export type DiagnosticLogsLazyQueryHookResult = ReturnType<typeof useDiagnosticLogsLazyQuery>;
export type DiagnosticLogsQueryResult = Apollo.QueryResult<DiagnosticLogsQuery, DiagnosticLogsQueryVariables>;
export const SendEmailDocument = gql`
    mutation SendEmail($input: SendEmailInput!) {
  sendEmail(input: $input) {
    id
    success
    message
  }
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, options);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const DiagnosticSettingsDataDocument = gql`
    query DiagnosticSettingsData {
  siteSettings {
    integrationSettings {
      ...integrationSettingsData
    }
  }
}
    ${IntegrationSettingsDataFragmentDoc}`;

/**
 * __useDiagnosticSettingsDataQuery__
 *
 * To run a query within a React component, call `useDiagnosticSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosticSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagnosticSettingsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiagnosticSettingsDataQuery(baseOptions?: Apollo.QueryHookOptions<DiagnosticSettingsDataQuery, DiagnosticSettingsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagnosticSettingsDataQuery, DiagnosticSettingsDataQueryVariables>(DiagnosticSettingsDataDocument, options);
      }
export function useDiagnosticSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagnosticSettingsDataQuery, DiagnosticSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagnosticSettingsDataQuery, DiagnosticSettingsDataQueryVariables>(DiagnosticSettingsDataDocument, options);
        }
export type DiagnosticSettingsDataQueryHookResult = ReturnType<typeof useDiagnosticSettingsDataQuery>;
export type DiagnosticSettingsDataLazyQueryHookResult = ReturnType<typeof useDiagnosticSettingsDataLazyQuery>;
export type DiagnosticSettingsDataQueryResult = Apollo.QueryResult<DiagnosticSettingsDataQuery, DiagnosticSettingsDataQueryVariables>;
export const UpdateIntegrationSettingsDocument = gql`
    mutation UpdateIntegrationSettings($input: UpdateIntegrationSettingsInput!) {
  updateIntegrationSettings(input: $input) {
    id
    success
    message
  }
}
    `;
export type UpdateIntegrationSettingsMutationFn = Apollo.MutationFunction<UpdateIntegrationSettingsMutation, UpdateIntegrationSettingsMutationVariables>;

/**
 * __useUpdateIntegrationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationSettingsMutation, { data, loading, error }] = useUpdateIntegrationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationSettingsMutation, UpdateIntegrationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationSettingsMutation, UpdateIntegrationSettingsMutationVariables>(UpdateIntegrationSettingsDocument, options);
      }
export type UpdateIntegrationSettingsMutationHookResult = ReturnType<typeof useUpdateIntegrationSettingsMutation>;
export type UpdateIntegrationSettingsMutationResult = Apollo.MutationResult<UpdateIntegrationSettingsMutation>;
export type UpdateIntegrationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationSettingsMutation, UpdateIntegrationSettingsMutationVariables>;
export const PlansByOwnerDocument = gql`
    query plansByOwner($ownerAppUserId: Int!) {
  plans(ownerAppUserId: $ownerAppUserId) {
    ...OwnerPlan
  }
}
    ${OwnerPlanFragmentDoc}`;

/**
 * __usePlansByOwnerQuery__
 *
 * To run a query within a React component, call `usePlansByOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansByOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansByOwnerQuery({
 *   variables: {
 *      ownerAppUserId: // value for 'ownerAppUserId'
 *   },
 * });
 */
export function usePlansByOwnerQuery(baseOptions: Apollo.QueryHookOptions<PlansByOwnerQuery, PlansByOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansByOwnerQuery, PlansByOwnerQueryVariables>(PlansByOwnerDocument, options);
      }
export function usePlansByOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansByOwnerQuery, PlansByOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansByOwnerQuery, PlansByOwnerQueryVariables>(PlansByOwnerDocument, options);
        }
export type PlansByOwnerQueryHookResult = ReturnType<typeof usePlansByOwnerQuery>;
export type PlansByOwnerLazyQueryHookResult = ReturnType<typeof usePlansByOwnerLazyQuery>;
export type PlansByOwnerQueryResult = Apollo.QueryResult<PlansByOwnerQuery, PlansByOwnerQueryVariables>;
export const PlanDocument = gql`
    query plan($id: String!) {
  plan(id: $id) {
    ...boardPlan
  }
  planAlerts(planId: $id) {
    ...boardAlert
  }
}
    ${BoardPlanFragmentDoc}
${BoardAlertFragmentDoc}`;

/**
 * __usePlanQuery__
 *
 * To run a query within a React component, call `usePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanQuery(baseOptions: Apollo.QueryHookOptions<PlanQuery, PlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
      }
export function usePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanQuery, PlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
        }
export type PlanQueryHookResult = ReturnType<typeof usePlanQuery>;
export type PlanLazyQueryHookResult = ReturnType<typeof usePlanLazyQuery>;
export type PlanQueryResult = Apollo.QueryResult<PlanQuery, PlanQueryVariables>;
export const PrimaryPlanDocument = gql`
    query primaryPlan($ownerAppUserId: Int!) {
  primaryPlan(ownerAppUserId: $ownerAppUserId) {
    ...boardPlan
  }
}
    ${BoardPlanFragmentDoc}`;

/**
 * __usePrimaryPlanQuery__
 *
 * To run a query within a React component, call `usePrimaryPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryPlanQuery({
 *   variables: {
 *      ownerAppUserId: // value for 'ownerAppUserId'
 *   },
 * });
 */
export function usePrimaryPlanQuery(baseOptions: Apollo.QueryHookOptions<PrimaryPlanQuery, PrimaryPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimaryPlanQuery, PrimaryPlanQueryVariables>(PrimaryPlanDocument, options);
      }
export function usePrimaryPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimaryPlanQuery, PrimaryPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimaryPlanQuery, PrimaryPlanQueryVariables>(PrimaryPlanDocument, options);
        }
export type PrimaryPlanQueryHookResult = ReturnType<typeof usePrimaryPlanQuery>;
export type PrimaryPlanLazyQueryHookResult = ReturnType<typeof usePrimaryPlanLazyQuery>;
export type PrimaryPlanQueryResult = Apollo.QueryResult<PrimaryPlanQuery, PrimaryPlanQueryVariables>;
export const PlaceholderCourseDetailDocument = gql`
    query placeholderCourseDetail($courseNumber: String, $externalCourseId: String, $itemId: String!, $subjectId: String) {
  placeholderCourseDetail(
    courseNumber: $courseNumber
    externalCourseId: $externalCourseId
    itemId: $itemId
    subjectId: $subjectId
  ) {
    course {
      campus
      campusDescription
      career
      courseNumber
      creditsMax
      creditsMin
      description
      environment
      externalCourseId
      inProgress
      requirementTitles
      requisiteDescription
      requisiteDescriptionLong
      subjectDescription
      subjectId
      title
      typicallyOffered
      usedToMeetRequirement
    }
    alerts {
      ...boardAlert
    }
  }
}
    ${BoardAlertFragmentDoc}`;

/**
 * __usePlaceholderCourseDetailQuery__
 *
 * To run a query within a React component, call `usePlaceholderCourseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderCourseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderCourseDetailQuery({
 *   variables: {
 *      courseNumber: // value for 'courseNumber'
 *      externalCourseId: // value for 'externalCourseId'
 *      itemId: // value for 'itemId'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function usePlaceholderCourseDetailQuery(baseOptions: Apollo.QueryHookOptions<PlaceholderCourseDetailQuery, PlaceholderCourseDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceholderCourseDetailQuery, PlaceholderCourseDetailQueryVariables>(PlaceholderCourseDetailDocument, options);
      }
export function usePlaceholderCourseDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceholderCourseDetailQuery, PlaceholderCourseDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceholderCourseDetailQuery, PlaceholderCourseDetailQueryVariables>(PlaceholderCourseDetailDocument, options);
        }
export type PlaceholderCourseDetailQueryHookResult = ReturnType<typeof usePlaceholderCourseDetailQuery>;
export type PlaceholderCourseDetailLazyQueryHookResult = ReturnType<typeof usePlaceholderCourseDetailLazyQuery>;
export type PlaceholderCourseDetailQueryResult = Apollo.QueryResult<PlaceholderCourseDetailQuery, PlaceholderCourseDetailQueryVariables>;
export const PlanItemDocument = gql`
    query planItem($id: String!, $planId: String!) {
  plan(id: $planId) {
    ...boardPlan
  }
  planItem(id: $id) {
    ...planItemDetails
  }
  planAlerts(planId: $planId, itemId: $id) {
    ...boardAlert
  }
}
    ${BoardPlanFragmentDoc}
${PlanItemDetailsFragmentDoc}
${BoardAlertFragmentDoc}`;

/**
 * __usePlanItemQuery__
 *
 * To run a query within a React component, call `usePlanItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function usePlanItemQuery(baseOptions: Apollo.QueryHookOptions<PlanItemQuery, PlanItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanItemQuery, PlanItemQueryVariables>(PlanItemDocument, options);
      }
export function usePlanItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanItemQuery, PlanItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanItemQuery, PlanItemQueryVariables>(PlanItemDocument, options);
        }
export type PlanItemQueryHookResult = ReturnType<typeof usePlanItemQuery>;
export type PlanItemLazyQueryHookResult = ReturnType<typeof usePlanItemLazyQuery>;
export type PlanItemQueryResult = Apollo.QueryResult<PlanItemQuery, PlanItemQueryVariables>;
export const AddPlanDocument = gql`
    mutation AddPlan($input: CreatePlanInput!) {
  addPlan(input: $input) {
    ...OwnerPlan
    ...boardPlan
  }
}
    ${OwnerPlanFragmentDoc}
${BoardPlanFragmentDoc}`;
export type AddPlanMutationFn = Apollo.MutationFunction<AddPlanMutation, AddPlanMutationVariables>;

/**
 * __useAddPlanMutation__
 *
 * To run a mutation, you first call `useAddPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlanMutation, { data, loading, error }] = useAddPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlanMutation(baseOptions?: Apollo.MutationHookOptions<AddPlanMutation, AddPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlanMutation, AddPlanMutationVariables>(AddPlanDocument, options);
      }
export type AddPlanMutationHookResult = ReturnType<typeof useAddPlanMutation>;
export type AddPlanMutationResult = Apollo.MutationResult<AddPlanMutation>;
export type AddPlanMutationOptions = Apollo.BaseMutationOptions<AddPlanMutation, AddPlanMutationVariables>;
export const GroupByIdDocument = gql`
    query groupById($id: String!) {
  planGroup(id: $id) {
    ...boardGroup
  }
}
    ${BoardGroupFragmentDoc}`;

/**
 * __useGroupByIdQuery__
 *
 * To run a query within a React component, call `useGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
      }
export function useGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupByIdQuery, GroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupByIdQuery, GroupByIdQueryVariables>(GroupByIdDocument, options);
        }
export type GroupByIdQueryHookResult = ReturnType<typeof useGroupByIdQuery>;
export type GroupByIdLazyQueryHookResult = ReturnType<typeof useGroupByIdLazyQuery>;
export type GroupByIdQueryResult = Apollo.QueryResult<GroupByIdQuery, GroupByIdQueryVariables>;
export const PlanGroupsDocument = gql`
    query planGroups($planId: String!) {
  planGroups(planId: $planId) {
    ...boardGroup
  }
}
    ${BoardGroupFragmentDoc}`;

/**
 * __usePlanGroupsQuery__
 *
 * To run a query within a React component, call `usePlanGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanGroupsQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function usePlanGroupsQuery(baseOptions: Apollo.QueryHookOptions<PlanGroupsQuery, PlanGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanGroupsQuery, PlanGroupsQueryVariables>(PlanGroupsDocument, options);
      }
export function usePlanGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanGroupsQuery, PlanGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanGroupsQuery, PlanGroupsQueryVariables>(PlanGroupsDocument, options);
        }
export type PlanGroupsQueryHookResult = ReturnType<typeof usePlanGroupsQuery>;
export type PlanGroupsLazyQueryHookResult = ReturnType<typeof usePlanGroupsLazyQuery>;
export type PlanGroupsQueryResult = Apollo.QueryResult<PlanGroupsQuery, PlanGroupsQueryVariables>;
export const PlanUnreadDocument = gql`
    query planUnread($id: String!) {
  planUnread(id: $id)
}
    `;

/**
 * __usePlanUnreadQuery__
 *
 * To run a query within a React component, call `usePlanUnreadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanUnreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanUnreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanUnreadQuery(baseOptions: Apollo.QueryHookOptions<PlanUnreadQuery, PlanUnreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanUnreadQuery, PlanUnreadQueryVariables>(PlanUnreadDocument, options);
      }
export function usePlanUnreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanUnreadQuery, PlanUnreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanUnreadQuery, PlanUnreadQueryVariables>(PlanUnreadDocument, options);
        }
export type PlanUnreadQueryHookResult = ReturnType<typeof usePlanUnreadQuery>;
export type PlanUnreadLazyQueryHookResult = ReturnType<typeof usePlanUnreadLazyQuery>;
export type PlanUnreadQueryResult = Apollo.QueryResult<PlanUnreadQuery, PlanUnreadQueryVariables>;
export const AddPlanGroupDocument = gql`
    mutation AddPlanGroup($input: CreatePlanGroupInput!) {
  addPlanGroup(input: $input) {
    ...boardGroup
  }
}
    ${BoardGroupFragmentDoc}`;
export type AddPlanGroupMutationFn = Apollo.MutationFunction<AddPlanGroupMutation, AddPlanGroupMutationVariables>;

/**
 * __useAddPlanGroupMutation__
 *
 * To run a mutation, you first call `useAddPlanGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlanGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlanGroupMutation, { data, loading, error }] = useAddPlanGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlanGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddPlanGroupMutation, AddPlanGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlanGroupMutation, AddPlanGroupMutationVariables>(AddPlanGroupDocument, options);
      }
export type AddPlanGroupMutationHookResult = ReturnType<typeof useAddPlanGroupMutation>;
export type AddPlanGroupMutationResult = Apollo.MutationResult<AddPlanGroupMutation>;
export type AddPlanGroupMutationOptions = Apollo.BaseMutationOptions<AddPlanGroupMutation, AddPlanGroupMutationVariables>;
export const UpdatePlanGroupTitleDocument = gql`
    mutation UpdatePlanGroupTitle($input: UpdatePlanGroupTitleInput!) {
  updatePlanGroupTitle(input: $input) {
    id
    title
  }
}
    `;
export type UpdatePlanGroupTitleMutationFn = Apollo.MutationFunction<UpdatePlanGroupTitleMutation, UpdatePlanGroupTitleMutationVariables>;

/**
 * __useUpdatePlanGroupTitleMutation__
 *
 * To run a mutation, you first call `useUpdatePlanGroupTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanGroupTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanGroupTitleMutation, { data, loading, error }] = useUpdatePlanGroupTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanGroupTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanGroupTitleMutation, UpdatePlanGroupTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanGroupTitleMutation, UpdatePlanGroupTitleMutationVariables>(UpdatePlanGroupTitleDocument, options);
      }
export type UpdatePlanGroupTitleMutationHookResult = ReturnType<typeof useUpdatePlanGroupTitleMutation>;
export type UpdatePlanGroupTitleMutationResult = Apollo.MutationResult<UpdatePlanGroupTitleMutation>;
export type UpdatePlanGroupTitleMutationOptions = Apollo.BaseMutationOptions<UpdatePlanGroupTitleMutation, UpdatePlanGroupTitleMutationVariables>;
export const AddTemplateGroupDocument = gql`
    mutation AddTemplateGroup($input: CreatePlanGroupInput!) {
  addTemplateGroup(input: $input) {
    ...boardGroup
  }
}
    ${BoardGroupFragmentDoc}`;
export type AddTemplateGroupMutationFn = Apollo.MutationFunction<AddTemplateGroupMutation, AddTemplateGroupMutationVariables>;

/**
 * __useAddTemplateGroupMutation__
 *
 * To run a mutation, you first call `useAddTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemplateGroupMutation, { data, loading, error }] = useAddTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddTemplateGroupMutation, AddTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTemplateGroupMutation, AddTemplateGroupMutationVariables>(AddTemplateGroupDocument, options);
      }
export type AddTemplateGroupMutationHookResult = ReturnType<typeof useAddTemplateGroupMutation>;
export type AddTemplateGroupMutationResult = Apollo.MutationResult<AddTemplateGroupMutation>;
export type AddTemplateGroupMutationOptions = Apollo.BaseMutationOptions<AddTemplateGroupMutation, AddTemplateGroupMutationVariables>;
export const UpdateTemplateGroupTitleDocument = gql`
    mutation UpdateTemplateGroupTitle($input: UpdateTemplateGroupTitleInput!) {
  updateTemplateGroupTitle(input: $input) {
    id
    ...boardGroup
  }
}
    ${BoardGroupFragmentDoc}`;
export type UpdateTemplateGroupTitleMutationFn = Apollo.MutationFunction<UpdateTemplateGroupTitleMutation, UpdateTemplateGroupTitleMutationVariables>;

/**
 * __useUpdateTemplateGroupTitleMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateGroupTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateGroupTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateGroupTitleMutation, { data, loading, error }] = useUpdateTemplateGroupTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateGroupTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateGroupTitleMutation, UpdateTemplateGroupTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateGroupTitleMutation, UpdateTemplateGroupTitleMutationVariables>(UpdateTemplateGroupTitleDocument, options);
      }
export type UpdateTemplateGroupTitleMutationHookResult = ReturnType<typeof useUpdateTemplateGroupTitleMutation>;
export type UpdateTemplateGroupTitleMutationResult = Apollo.MutationResult<UpdateTemplateGroupTitleMutation>;
export type UpdateTemplateGroupTitleMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateGroupTitleMutation, UpdateTemplateGroupTitleMutationVariables>;
export const MoveTemplateGroupDocument = gql`
    mutation MoveTemplateGroup($input: MovePlanGroupInput!) {
  moveTemplateGroup(input: $input) {
    id
    planId
    displaySequence
  }
}
    `;
export type MoveTemplateGroupMutationFn = Apollo.MutationFunction<MoveTemplateGroupMutation, MoveTemplateGroupMutationVariables>;

/**
 * __useMoveTemplateGroupMutation__
 *
 * To run a mutation, you first call `useMoveTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTemplateGroupMutation, { data, loading, error }] = useMoveTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveTemplateGroupMutation, MoveTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveTemplateGroupMutation, MoveTemplateGroupMutationVariables>(MoveTemplateGroupDocument, options);
      }
export type MoveTemplateGroupMutationHookResult = ReturnType<typeof useMoveTemplateGroupMutation>;
export type MoveTemplateGroupMutationResult = Apollo.MutationResult<MoveTemplateGroupMutation>;
export type MoveTemplateGroupMutationOptions = Apollo.BaseMutationOptions<MoveTemplateGroupMutation, MoveTemplateGroupMutationVariables>;
export const DeleteTemplateGroupDocument = gql`
    mutation DeleteTemplateGroup($input: String!) {
  deleteTemplateGroup(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeleteTemplateGroupMutationFn = Apollo.MutationFunction<DeleteTemplateGroupMutation, DeleteTemplateGroupMutationVariables>;

/**
 * __useDeleteTemplateGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateGroupMutation, { data, loading, error }] = useDeleteTemplateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateGroupMutation, DeleteTemplateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateGroupMutation, DeleteTemplateGroupMutationVariables>(DeleteTemplateGroupDocument, options);
      }
export type DeleteTemplateGroupMutationHookResult = ReturnType<typeof useDeleteTemplateGroupMutation>;
export type DeleteTemplateGroupMutationResult = Apollo.MutationResult<DeleteTemplateGroupMutation>;
export type DeleteTemplateGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateGroupMutation, DeleteTemplateGroupMutationVariables>;
export const AddPlanItemDocument = gql`
    mutation AddPlanItem($input: CreatePlanItemInput!) {
  addPlanItem(input: $input) {
    ...boardItem
  }
}
    ${BoardItemFragmentDoc}`;
export type AddPlanItemMutationFn = Apollo.MutationFunction<AddPlanItemMutation, AddPlanItemMutationVariables>;

/**
 * __useAddPlanItemMutation__
 *
 * To run a mutation, you first call `useAddPlanItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlanItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlanItemMutation, { data, loading, error }] = useAddPlanItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlanItemMutation(baseOptions?: Apollo.MutationHookOptions<AddPlanItemMutation, AddPlanItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlanItemMutation, AddPlanItemMutationVariables>(AddPlanItemDocument, options);
      }
export type AddPlanItemMutationHookResult = ReturnType<typeof useAddPlanItemMutation>;
export type AddPlanItemMutationResult = Apollo.MutationResult<AddPlanItemMutation>;
export type AddPlanItemMutationOptions = Apollo.BaseMutationOptions<AddPlanItemMutation, AddPlanItemMutationVariables>;
export const UpdatePlanItemDocument = gql`
    mutation UpdatePlanItem($input: UpdatePlanItemInput!) {
  updatePlanItem(input: $input) {
    __typename
    id
    availability
    courseNumber
    creditsMax
    creditsMin
    description
    displaySequence
    equivalentCourseGroupId
    externalCourseId
    groupId
    inProgress
    isActive
    isCoursePlaceholder
    locked
    nonCourseCreditsMax
    nonCourseCreditsMin
    nonCourseDescription
    nonCourseTitle
    placeholderCourses {
      ...placeholderCourse
    }
    planId
    required
    requirementTitles
    requisiteDescription
    requisiteDescriptionLong
    showRequisiteAlert
    subjectId
    title
    typicallyOffered
    usedToMeetRequirement
  }
}
    ${PlaceholderCourseFragmentDoc}`;
export type UpdatePlanItemMutationFn = Apollo.MutationFunction<UpdatePlanItemMutation, UpdatePlanItemMutationVariables>;

/**
 * __useUpdatePlanItemMutation__
 *
 * To run a mutation, you first call `useUpdatePlanItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanItemMutation, { data, loading, error }] = useUpdatePlanItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanItemMutation, UpdatePlanItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanItemMutation, UpdatePlanItemMutationVariables>(UpdatePlanItemDocument, options);
      }
export type UpdatePlanItemMutationHookResult = ReturnType<typeof useUpdatePlanItemMutation>;
export type UpdatePlanItemMutationResult = Apollo.MutationResult<UpdatePlanItemMutation>;
export type UpdatePlanItemMutationOptions = Apollo.BaseMutationOptions<UpdatePlanItemMutation, UpdatePlanItemMutationVariables>;
export const MovePlanItemDocument = gql`
    mutation MovePlanItem($input: MovePlanItemInput!) {
  movePlanItem(input: $input) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type MovePlanItemMutationFn = Apollo.MutationFunction<MovePlanItemMutation, MovePlanItemMutationVariables>;

/**
 * __useMovePlanItemMutation__
 *
 * To run a mutation, you first call `useMovePlanItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePlanItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePlanItemMutation, { data, loading, error }] = useMovePlanItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovePlanItemMutation(baseOptions?: Apollo.MutationHookOptions<MovePlanItemMutation, MovePlanItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePlanItemMutation, MovePlanItemMutationVariables>(MovePlanItemDocument, options);
      }
export type MovePlanItemMutationHookResult = ReturnType<typeof useMovePlanItemMutation>;
export type MovePlanItemMutationResult = Apollo.MutationResult<MovePlanItemMutation>;
export type MovePlanItemMutationOptions = Apollo.BaseMutationOptions<MovePlanItemMutation, MovePlanItemMutationVariables>;
export const DeletePlanItemDocument = gql`
    mutation DeletePlanItem($input: String!) {
  deletePlanItem(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeletePlanItemMutationFn = Apollo.MutationFunction<DeletePlanItemMutation, DeletePlanItemMutationVariables>;

/**
 * __useDeletePlanItemMutation__
 *
 * To run a mutation, you first call `useDeletePlanItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanItemMutation, { data, loading, error }] = useDeletePlanItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlanItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanItemMutation, DeletePlanItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanItemMutation, DeletePlanItemMutationVariables>(DeletePlanItemDocument, options);
      }
export type DeletePlanItemMutationHookResult = ReturnType<typeof useDeletePlanItemMutation>;
export type DeletePlanItemMutationResult = Apollo.MutationResult<DeletePlanItemMutation>;
export type DeletePlanItemMutationOptions = Apollo.BaseMutationOptions<DeletePlanItemMutation, DeletePlanItemMutationVariables>;
export const CopyPlanDocument = gql`
    mutation CopyPlan($input: String!) {
  copyPlan(input: $input) {
    ...OwnerPlan
  }
}
    ${OwnerPlanFragmentDoc}`;
export type CopyPlanMutationFn = Apollo.MutationFunction<CopyPlanMutation, CopyPlanMutationVariables>;

/**
 * __useCopyPlanMutation__
 *
 * To run a mutation, you first call `useCopyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPlanMutation, { data, loading, error }] = useCopyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyPlanMutation(baseOptions?: Apollo.MutationHookOptions<CopyPlanMutation, CopyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyPlanMutation, CopyPlanMutationVariables>(CopyPlanDocument, options);
      }
export type CopyPlanMutationHookResult = ReturnType<typeof useCopyPlanMutation>;
export type CopyPlanMutationResult = Apollo.MutationResult<CopyPlanMutation>;
export type CopyPlanMutationOptions = Apollo.BaseMutationOptions<CopyPlanMutation, CopyPlanMutationVariables>;
export const CopyEmbeddedPlanDocument = gql`
    mutation CopyEmbeddedPlan($input: String!) {
  copyEmbeddedPlan(input: $input) {
    ...OwnerPlan
  }
}
    ${OwnerPlanFragmentDoc}`;
export type CopyEmbeddedPlanMutationFn = Apollo.MutationFunction<CopyEmbeddedPlanMutation, CopyEmbeddedPlanMutationVariables>;

/**
 * __useCopyEmbeddedPlanMutation__
 *
 * To run a mutation, you first call `useCopyEmbeddedPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyEmbeddedPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyEmbeddedPlanMutation, { data, loading, error }] = useCopyEmbeddedPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyEmbeddedPlanMutation(baseOptions?: Apollo.MutationHookOptions<CopyEmbeddedPlanMutation, CopyEmbeddedPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyEmbeddedPlanMutation, CopyEmbeddedPlanMutationVariables>(CopyEmbeddedPlanDocument, options);
      }
export type CopyEmbeddedPlanMutationHookResult = ReturnType<typeof useCopyEmbeddedPlanMutation>;
export type CopyEmbeddedPlanMutationResult = Apollo.MutationResult<CopyEmbeddedPlanMutation>;
export type CopyEmbeddedPlanMutationOptions = Apollo.BaseMutationOptions<CopyEmbeddedPlanMutation, CopyEmbeddedPlanMutationVariables>;
export const MakePlanPrimaryDocument = gql`
    mutation MakePlanPrimary($input: String!) {
  makePlanPrimary(input: $input) {
    id
    success
    message
  }
}
    `;
export type MakePlanPrimaryMutationFn = Apollo.MutationFunction<MakePlanPrimaryMutation, MakePlanPrimaryMutationVariables>;

/**
 * __useMakePlanPrimaryMutation__
 *
 * To run a mutation, you first call `useMakePlanPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePlanPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePlanPrimaryMutation, { data, loading, error }] = useMakePlanPrimaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakePlanPrimaryMutation(baseOptions?: Apollo.MutationHookOptions<MakePlanPrimaryMutation, MakePlanPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePlanPrimaryMutation, MakePlanPrimaryMutationVariables>(MakePlanPrimaryDocument, options);
      }
export type MakePlanPrimaryMutationHookResult = ReturnType<typeof useMakePlanPrimaryMutation>;
export type MakePlanPrimaryMutationResult = Apollo.MutationResult<MakePlanPrimaryMutation>;
export type MakePlanPrimaryMutationOptions = Apollo.BaseMutationOptions<MakePlanPrimaryMutation, MakePlanPrimaryMutationVariables>;
export const UpdatePlanTitleDocument = gql`
    mutation UpdatePlanTitle($input: UpdatePlanTitleInput!) {
  updatePlanTitle(input: $input) {
    id
    title
  }
}
    `;
export type UpdatePlanTitleMutationFn = Apollo.MutationFunction<UpdatePlanTitleMutation, UpdatePlanTitleMutationVariables>;

/**
 * __useUpdatePlanTitleMutation__
 *
 * To run a mutation, you first call `useUpdatePlanTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanTitleMutation, { data, loading, error }] = useUpdatePlanTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanTitleMutation, UpdatePlanTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanTitleMutation, UpdatePlanTitleMutationVariables>(UpdatePlanTitleDocument, options);
      }
export type UpdatePlanTitleMutationHookResult = ReturnType<typeof useUpdatePlanTitleMutation>;
export type UpdatePlanTitleMutationResult = Apollo.MutationResult<UpdatePlanTitleMutation>;
export type UpdatePlanTitleMutationOptions = Apollo.BaseMutationOptions<UpdatePlanTitleMutation, UpdatePlanTitleMutationVariables>;
export const UpdateLockForAllItemsDocument = gql`
    mutation UpdateLockForAllItems($input: UpdateLockForAllItemsInput!) {
  updateLockForAllItems(input: $input) {
    success
    message
  }
}
    `;
export type UpdateLockForAllItemsMutationFn = Apollo.MutationFunction<UpdateLockForAllItemsMutation, UpdateLockForAllItemsMutationVariables>;

/**
 * __useUpdateLockForAllItemsMutation__
 *
 * To run a mutation, you first call `useUpdateLockForAllItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLockForAllItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLockForAllItemsMutation, { data, loading, error }] = useUpdateLockForAllItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLockForAllItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLockForAllItemsMutation, UpdateLockForAllItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLockForAllItemsMutation, UpdateLockForAllItemsMutationVariables>(UpdateLockForAllItemsDocument, options);
      }
export type UpdateLockForAllItemsMutationHookResult = ReturnType<typeof useUpdateLockForAllItemsMutation>;
export type UpdateLockForAllItemsMutationResult = Apollo.MutationResult<UpdateLockForAllItemsMutation>;
export type UpdateLockForAllItemsMutationOptions = Apollo.BaseMutationOptions<UpdateLockForAllItemsMutation, UpdateLockForAllItemsMutationVariables>;
export const DeletePlanDocument = gql`
    mutation DeletePlan($input: String!) {
  deletePlan(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeletePlanMutationFn = Apollo.MutationFunction<DeletePlanMutation, DeletePlanMutationVariables>;

/**
 * __useDeletePlanMutation__
 *
 * To run a mutation, you first call `useDeletePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanMutation, { data, loading, error }] = useDeletePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlanMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanMutation, DeletePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanMutation, DeletePlanMutationVariables>(DeletePlanDocument, options);
      }
export type DeletePlanMutationHookResult = ReturnType<typeof useDeletePlanMutation>;
export type DeletePlanMutationResult = Apollo.MutationResult<DeletePlanMutation>;
export type DeletePlanMutationOptions = Apollo.BaseMutationOptions<DeletePlanMutation, DeletePlanMutationVariables>;
export const ClearPlanDocument = gql`
    mutation ClearPlan($input: String!) {
  clearPlan(input: $input) {
    ...boardPlan
  }
}
    ${BoardPlanFragmentDoc}`;
export type ClearPlanMutationFn = Apollo.MutationFunction<ClearPlanMutation, ClearPlanMutationVariables>;

/**
 * __useClearPlanMutation__
 *
 * To run a mutation, you first call `useClearPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearPlanMutation, { data, loading, error }] = useClearPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearPlanMutation(baseOptions?: Apollo.MutationHookOptions<ClearPlanMutation, ClearPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearPlanMutation, ClearPlanMutationVariables>(ClearPlanDocument, options);
      }
export type ClearPlanMutationHookResult = ReturnType<typeof useClearPlanMutation>;
export type ClearPlanMutationResult = Apollo.MutationResult<ClearPlanMutation>;
export type ClearPlanMutationOptions = Apollo.BaseMutationOptions<ClearPlanMutation, ClearPlanMutationVariables>;
export const DeletePlanGroupDocument = gql`
    mutation DeletePlanGroup($input: String!) {
  deletePlanGroup(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeletePlanGroupMutationFn = Apollo.MutationFunction<DeletePlanGroupMutation, DeletePlanGroupMutationVariables>;

/**
 * __useDeletePlanGroupMutation__
 *
 * To run a mutation, you first call `useDeletePlanGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanGroupMutation, { data, loading, error }] = useDeletePlanGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlanGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanGroupMutation, DeletePlanGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanGroupMutation, DeletePlanGroupMutationVariables>(DeletePlanGroupDocument, options);
      }
export type DeletePlanGroupMutationHookResult = ReturnType<typeof useDeletePlanGroupMutation>;
export type DeletePlanGroupMutationResult = Apollo.MutationResult<DeletePlanGroupMutation>;
export type DeletePlanGroupMutationOptions = Apollo.BaseMutationOptions<DeletePlanGroupMutation, DeletePlanGroupMutationVariables>;
export const MovePlanGroupDocument = gql`
    mutation MovePlanGroup($input: MovePlanGroupInput!) {
  movePlanGroup(input: $input) {
    id
    planId
    displaySequence
  }
}
    `;
export type MovePlanGroupMutationFn = Apollo.MutationFunction<MovePlanGroupMutation, MovePlanGroupMutationVariables>;

/**
 * __useMovePlanGroupMutation__
 *
 * To run a mutation, you first call `useMovePlanGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovePlanGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movePlanGroupMutation, { data, loading, error }] = useMovePlanGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovePlanGroupMutation(baseOptions?: Apollo.MutationHookOptions<MovePlanGroupMutation, MovePlanGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovePlanGroupMutation, MovePlanGroupMutationVariables>(MovePlanGroupDocument, options);
      }
export type MovePlanGroupMutationHookResult = ReturnType<typeof useMovePlanGroupMutation>;
export type MovePlanGroupMutationResult = Apollo.MutationResult<MovePlanGroupMutation>;
export type MovePlanGroupMutationOptions = Apollo.BaseMutationOptions<MovePlanGroupMutation, MovePlanGroupMutationVariables>;
export const ChangesDocument = gql`
    query changes($planId: String!, $first: Int!, $after: String) {
  changes(planId: $planId, first: $first, after: $after) {
    ...changeLogConnection
  }
}
    ${ChangeLogConnectionFragmentDoc}`;

/**
 * __useChangesQuery__
 *
 * To run a query within a React component, call `useChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangesQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useChangesQuery(baseOptions: Apollo.QueryHookOptions<ChangesQuery, ChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangesQuery, ChangesQueryVariables>(ChangesDocument, options);
      }
export function useChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangesQuery, ChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangesQuery, ChangesQueryVariables>(ChangesDocument, options);
        }
export type ChangesQueryHookResult = ReturnType<typeof useChangesQuery>;
export type ChangesLazyQueryHookResult = ReturnType<typeof useChangesLazyQuery>;
export type ChangesQueryResult = Apollo.QueryResult<ChangesQuery, ChangesQueryVariables>;
export const OnChangeLogAddedDocument = gql`
    subscription onChangeLogAdded($planId: String!) {
  changeLogAdded(planId: $planId) {
    id
    planId
    itemId
    groupId
    description
    changedByAppUserId
    changedTimestamp
  }
}
    `;

/**
 * __useOnChangeLogAddedSubscription__
 *
 * To run a query within a React component, call `useOnChangeLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnChangeLogAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnChangeLogAddedSubscription({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useOnChangeLogAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnChangeLogAddedSubscription, OnChangeLogAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnChangeLogAddedSubscription, OnChangeLogAddedSubscriptionVariables>(OnChangeLogAddedDocument, options);
      }
export type OnChangeLogAddedSubscriptionHookResult = ReturnType<typeof useOnChangeLogAddedSubscription>;
export type OnChangeLogAddedSubscriptionResult = Apollo.SubscriptionResult<OnChangeLogAddedSubscription>;
export const OnPlanChangedByDocument = gql`
    subscription onPlanChangedBy($planId: String!) {
  planChangedBy(planId: $planId) {
    changedByAppUserId
  }
}
    `;

/**
 * __useOnPlanChangedBySubscription__
 *
 * To run a query within a React component, call `useOnPlanChangedBySubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPlanChangedBySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPlanChangedBySubscription({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useOnPlanChangedBySubscription(baseOptions: Apollo.SubscriptionHookOptions<OnPlanChangedBySubscription, OnPlanChangedBySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPlanChangedBySubscription, OnPlanChangedBySubscriptionVariables>(OnPlanChangedByDocument, options);
      }
export type OnPlanChangedBySubscriptionHookResult = ReturnType<typeof useOnPlanChangedBySubscription>;
export type OnPlanChangedBySubscriptionResult = Apollo.SubscriptionResult<OnPlanChangedBySubscription>;
export const AddCommentDocument = gql`
    mutation AddComment($input: CreateCommentInput!) {
  addComment(input: $input) {
    ...boardComment
  }
}
    ${BoardCommentFragmentDoc}`;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($input: String!) {
  deleteComment(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const MarkAllCommentsAsReadDocument = gql`
    mutation MarkAllCommentsAsRead($input: String!) {
  markAllCommentsAsRead(input: $input) {
    id
  }
}
    `;
export type MarkAllCommentsAsReadMutationFn = Apollo.MutationFunction<MarkAllCommentsAsReadMutation, MarkAllCommentsAsReadMutationVariables>;

/**
 * __useMarkAllCommentsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllCommentsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllCommentsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllCommentsAsReadMutation, { data, loading, error }] = useMarkAllCommentsAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAllCommentsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllCommentsAsReadMutation, MarkAllCommentsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllCommentsAsReadMutation, MarkAllCommentsAsReadMutationVariables>(MarkAllCommentsAsReadDocument, options);
      }
export type MarkAllCommentsAsReadMutationHookResult = ReturnType<typeof useMarkAllCommentsAsReadMutation>;
export type MarkAllCommentsAsReadMutationResult = Apollo.MutationResult<MarkAllCommentsAsReadMutation>;
export type MarkAllCommentsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllCommentsAsReadMutation, MarkAllCommentsAsReadMutationVariables>;
export const CommentAddedDocument = gql`
    subscription CommentAdded($planId: String, $subscribeToAll: Boolean) {
  commentAdded(planId: $planId, subscribeToAll: $subscribeToAll) {
    ...boardComment
  }
}
    ${BoardCommentFragmentDoc}`;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *      planId: // value for 'planId'
 *      subscribeToAll: // value for 'subscribeToAll'
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentAddedSubscription, CommentAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentAddedSubscription, CommentAddedSubscriptionVariables>(CommentAddedDocument, options);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<CommentAddedSubscription>;
export const CommentsByGroupIdDocument = gql`
    query commentsByGroupId($groupId: String!) {
  comments(groupId: $groupId) {
    ...boardComment
  }
}
    ${BoardCommentFragmentDoc}`;

/**
 * __useCommentsByGroupIdQuery__
 *
 * To run a query within a React component, call `useCommentsByGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsByGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsByGroupIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useCommentsByGroupIdQuery(baseOptions: Apollo.QueryHookOptions<CommentsByGroupIdQuery, CommentsByGroupIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsByGroupIdQuery, CommentsByGroupIdQueryVariables>(CommentsByGroupIdDocument, options);
      }
export function useCommentsByGroupIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsByGroupIdQuery, CommentsByGroupIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsByGroupIdQuery, CommentsByGroupIdQueryVariables>(CommentsByGroupIdDocument, options);
        }
export type CommentsByGroupIdQueryHookResult = ReturnType<typeof useCommentsByGroupIdQuery>;
export type CommentsByGroupIdLazyQueryHookResult = ReturnType<typeof useCommentsByGroupIdLazyQuery>;
export type CommentsByGroupIdQueryResult = Apollo.QueryResult<CommentsByGroupIdQuery, CommentsByGroupIdQueryVariables>;
export const UpdatePlanGroupTermDocument = gql`
    mutation updatePlanGroupTerm($input: UpdatePlanGroupTermInput!) {
  updatePlanGroupTerm(input: $input) {
    id
    externalTermId
    title
  }
}
    `;
export type UpdatePlanGroupTermMutationFn = Apollo.MutationFunction<UpdatePlanGroupTermMutation, UpdatePlanGroupTermMutationVariables>;

/**
 * __useUpdatePlanGroupTermMutation__
 *
 * To run a mutation, you first call `useUpdatePlanGroupTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanGroupTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanGroupTermMutation, { data, loading, error }] = useUpdatePlanGroupTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlanGroupTermMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanGroupTermMutation, UpdatePlanGroupTermMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanGroupTermMutation, UpdatePlanGroupTermMutationVariables>(UpdatePlanGroupTermDocument, options);
      }
export type UpdatePlanGroupTermMutationHookResult = ReturnType<typeof useUpdatePlanGroupTermMutation>;
export type UpdatePlanGroupTermMutationResult = Apollo.MutationResult<UpdatePlanGroupTermMutation>;
export type UpdatePlanGroupTermMutationOptions = Apollo.BaseMutationOptions<UpdatePlanGroupTermMutation, UpdatePlanGroupTermMutationVariables>;
export const TemplatesDocument = gql`
    query templates($environment: String) {
  templates(environment: $environment) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const TemplateDocument = gql`
    query template($id: String!) {
  template(id: $id) {
    ...boardPlan
  }
  planAlerts(planId: $id) {
    ...boardAlert
  }
}
    ${BoardPlanFragmentDoc}
${BoardAlertFragmentDoc}`;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions: Apollo.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<TemplateQuery, TemplateQueryVariables>;
export const UpdateTemplateCampusDocument = gql`
    mutation UpdateTemplateCampus($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    campusCode
    campusDescription
  }
}
    `;
export type UpdateTemplateCampusMutationFn = Apollo.MutationFunction<UpdateTemplateCampusMutation, UpdateTemplateCampusMutationVariables>;

/**
 * __useUpdateTemplateCampusMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateCampusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateCampusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateCampusMutation, { data, loading, error }] = useUpdateTemplateCampusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateCampusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateCampusMutation, UpdateTemplateCampusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateCampusMutation, UpdateTemplateCampusMutationVariables>(UpdateTemplateCampusDocument, options);
      }
export type UpdateTemplateCampusMutationHookResult = ReturnType<typeof useUpdateTemplateCampusMutation>;
export type UpdateTemplateCampusMutationResult = Apollo.MutationResult<UpdateTemplateCampusMutation>;
export type UpdateTemplateCampusMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateCampusMutation, UpdateTemplateCampusMutationVariables>;
export const UpdateTemplateCatalogDocument = gql`
    mutation UpdateTemplateCatalog($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    catalogYear
    catalogYearDescription
  }
}
    `;
export type UpdateTemplateCatalogMutationFn = Apollo.MutationFunction<UpdateTemplateCatalogMutation, UpdateTemplateCatalogMutationVariables>;

/**
 * __useUpdateTemplateCatalogMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateCatalogMutation, { data, loading, error }] = useUpdateTemplateCatalogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateCatalogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateCatalogMutation, UpdateTemplateCatalogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateCatalogMutation, UpdateTemplateCatalogMutationVariables>(UpdateTemplateCatalogDocument, options);
      }
export type UpdateTemplateCatalogMutationHookResult = ReturnType<typeof useUpdateTemplateCatalogMutation>;
export type UpdateTemplateCatalogMutationResult = Apollo.MutationResult<UpdateTemplateCatalogMutation>;
export type UpdateTemplateCatalogMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateCatalogMutation, UpdateTemplateCatalogMutationVariables>;
export const UpdateTemplateCollegeDocument = gql`
    mutation UpdateTemplateCollege($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    collegeCode
    collegeDescription
  }
}
    `;
export type UpdateTemplateCollegeMutationFn = Apollo.MutationFunction<UpdateTemplateCollegeMutation, UpdateTemplateCollegeMutationVariables>;

/**
 * __useUpdateTemplateCollegeMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateCollegeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateCollegeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateCollegeMutation, { data, loading, error }] = useUpdateTemplateCollegeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateCollegeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateCollegeMutation, UpdateTemplateCollegeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateCollegeMutation, UpdateTemplateCollegeMutationVariables>(UpdateTemplateCollegeDocument, options);
      }
export type UpdateTemplateCollegeMutationHookResult = ReturnType<typeof useUpdateTemplateCollegeMutation>;
export type UpdateTemplateCollegeMutationResult = Apollo.MutationResult<UpdateTemplateCollegeMutation>;
export type UpdateTemplateCollegeMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateCollegeMutation, UpdateTemplateCollegeMutationVariables>;
export const UpdateTemplateConcentrationDocument = gql`
    mutation UpdateTemplateConcentration($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    concentrationCode
    concentrationDescription
  }
}
    `;
export type UpdateTemplateConcentrationMutationFn = Apollo.MutationFunction<UpdateTemplateConcentrationMutation, UpdateTemplateConcentrationMutationVariables>;

/**
 * __useUpdateTemplateConcentrationMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateConcentrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateConcentrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateConcentrationMutation, { data, loading, error }] = useUpdateTemplateConcentrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateConcentrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateConcentrationMutation, UpdateTemplateConcentrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateConcentrationMutation, UpdateTemplateConcentrationMutationVariables>(UpdateTemplateConcentrationDocument, options);
      }
export type UpdateTemplateConcentrationMutationHookResult = ReturnType<typeof useUpdateTemplateConcentrationMutation>;
export type UpdateTemplateConcentrationMutationResult = Apollo.MutationResult<UpdateTemplateConcentrationMutation>;
export type UpdateTemplateConcentrationMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateConcentrationMutation, UpdateTemplateConcentrationMutationVariables>;
export const UpdateTemplateDescriptionDocument = gql`
    mutation UpdateTemplateDescription($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    description
  }
}
    `;
export type UpdateTemplateDescriptionMutationFn = Apollo.MutationFunction<UpdateTemplateDescriptionMutation, UpdateTemplateDescriptionMutationVariables>;

/**
 * __useUpdateTemplateDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateDescriptionMutation, { data, loading, error }] = useUpdateTemplateDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateDescriptionMutation, UpdateTemplateDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateDescriptionMutation, UpdateTemplateDescriptionMutationVariables>(UpdateTemplateDescriptionDocument, options);
      }
export type UpdateTemplateDescriptionMutationHookResult = ReturnType<typeof useUpdateTemplateDescriptionMutation>;
export type UpdateTemplateDescriptionMutationResult = Apollo.MutationResult<UpdateTemplateDescriptionMutation>;
export type UpdateTemplateDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateDescriptionMutation, UpdateTemplateDescriptionMutationVariables>;
export const UpdateTemplateDegreeDocument = gql`
    mutation UpdateTemplateDegree($input: UpdatePlanInput!) {
  updateTemplate(input: $input) {
    id
    degreeCode
    degreeDescription
  }
}
    `;
export type UpdateTemplateDegreeMutationFn = Apollo.MutationFunction<UpdateTemplateDegreeMutation, UpdateTemplateDegreeMutationVariables>;

/**
 * __useUpdateTemplateDegreeMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateDegreeMutation, { data, loading, error }] = useUpdateTemplateDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateDegreeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateDegreeMutation, UpdateTemplateDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateDegreeMutation, UpdateTemplateDegreeMutationVariables>(UpdateTemplateDegreeDocument, options);
      }
export type UpdateTemplateDegreeMutationHookResult = ReturnType<typeof useUpdateTemplateDegreeMutation>;
export type UpdateTemplateDegreeMutationResult = Apollo.MutationResult<UpdateTemplateDegreeMutation>;
export type UpdateTemplateDegreeMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateDegreeMutation, UpdateTemplateDegreeMutationVariables>;
export const AcademicStructureDataDocument = gql`
    query academicStructureData {
  campuses {
    id
    code
    description
  }
  getColleges {
    id
    code
    description
  }
  getDegrees {
    id
    code
    description
  }
  getMajors {
    id
    code
    description
  }
  getMinors {
    id
    code
    description
    major
  }
  getConcentrations {
    id
    code
    description
    major
    minor
  }
}
    `;

/**
 * __useAcademicStructureDataQuery__
 *
 * To run a query within a React component, call `useAcademicStructureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicStructureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicStructureDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcademicStructureDataQuery(baseOptions?: Apollo.QueryHookOptions<AcademicStructureDataQuery, AcademicStructureDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcademicStructureDataQuery, AcademicStructureDataQueryVariables>(AcademicStructureDataDocument, options);
      }
export function useAcademicStructureDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcademicStructureDataQuery, AcademicStructureDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcademicStructureDataQuery, AcademicStructureDataQueryVariables>(AcademicStructureDataDocument, options);
        }
export type AcademicStructureDataQueryHookResult = ReturnType<typeof useAcademicStructureDataQuery>;
export type AcademicStructureDataLazyQueryHookResult = ReturnType<typeof useAcademicStructureDataLazyQuery>;
export type AcademicStructureDataQueryResult = Apollo.QueryResult<AcademicStructureDataQuery, AcademicStructureDataQueryVariables>;
export const AddMajorDocument = gql`
    mutation AddMajor($input: CreatePlanMajorInput!) {
  addMajor(input: $input) {
    ...boardMajor
  }
}
    ${BoardMajorFragmentDoc}`;
export type AddMajorMutationFn = Apollo.MutationFunction<AddMajorMutation, AddMajorMutationVariables>;

/**
 * __useAddMajorMutation__
 *
 * To run a mutation, you first call `useAddMajorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMajorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMajorMutation, { data, loading, error }] = useAddMajorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMajorMutation(baseOptions?: Apollo.MutationHookOptions<AddMajorMutation, AddMajorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMajorMutation, AddMajorMutationVariables>(AddMajorDocument, options);
      }
export type AddMajorMutationHookResult = ReturnType<typeof useAddMajorMutation>;
export type AddMajorMutationResult = Apollo.MutationResult<AddMajorMutation>;
export type AddMajorMutationOptions = Apollo.BaseMutationOptions<AddMajorMutation, AddMajorMutationVariables>;
export const DeleteMajorDocument = gql`
    mutation DeleteMajor($id: String!) {
  deleteMajor(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeleteMajorMutationFn = Apollo.MutationFunction<DeleteMajorMutation, DeleteMajorMutationVariables>;

/**
 * __useDeleteMajorMutation__
 *
 * To run a mutation, you first call `useDeleteMajorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMajorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMajorMutation, { data, loading, error }] = useDeleteMajorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMajorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMajorMutation, DeleteMajorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMajorMutation, DeleteMajorMutationVariables>(DeleteMajorDocument, options);
      }
export type DeleteMajorMutationHookResult = ReturnType<typeof useDeleteMajorMutation>;
export type DeleteMajorMutationResult = Apollo.MutationResult<DeleteMajorMutation>;
export type DeleteMajorMutationOptions = Apollo.BaseMutationOptions<DeleteMajorMutation, DeleteMajorMutationVariables>;
export const AddMinorDocument = gql`
    mutation AddMinor($input: CreatePlanMinorInput!) {
  addMinor(input: $input) {
    ...boardMinor
  }
}
    ${BoardMinorFragmentDoc}`;
export type AddMinorMutationFn = Apollo.MutationFunction<AddMinorMutation, AddMinorMutationVariables>;

/**
 * __useAddMinorMutation__
 *
 * To run a mutation, you first call `useAddMinorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMinorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMinorMutation, { data, loading, error }] = useAddMinorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMinorMutation(baseOptions?: Apollo.MutationHookOptions<AddMinorMutation, AddMinorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMinorMutation, AddMinorMutationVariables>(AddMinorDocument, options);
      }
export type AddMinorMutationHookResult = ReturnType<typeof useAddMinorMutation>;
export type AddMinorMutationResult = Apollo.MutationResult<AddMinorMutation>;
export type AddMinorMutationOptions = Apollo.BaseMutationOptions<AddMinorMutation, AddMinorMutationVariables>;
export const DeleteMinorDocument = gql`
    mutation DeleteMinor($id: String!) {
  deleteMinor(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeleteMinorMutationFn = Apollo.MutationFunction<DeleteMinorMutation, DeleteMinorMutationVariables>;

/**
 * __useDeleteMinorMutation__
 *
 * To run a mutation, you first call `useDeleteMinorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMinorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMinorMutation, { data, loading, error }] = useDeleteMinorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMinorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMinorMutation, DeleteMinorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMinorMutation, DeleteMinorMutationVariables>(DeleteMinorDocument, options);
      }
export type DeleteMinorMutationHookResult = ReturnType<typeof useDeleteMinorMutation>;
export type DeleteMinorMutationResult = Apollo.MutationResult<DeleteMinorMutation>;
export type DeleteMinorMutationOptions = Apollo.BaseMutationOptions<DeleteMinorMutation, DeleteMinorMutationVariables>;
export const AddTemplateDocument = gql`
    mutation AddTemplate($input: CreatePlanInput!) {
  addTemplate(input: $input) {
    ...OwnerPlan
    ...boardPlan
  }
}
    ${OwnerPlanFragmentDoc}
${BoardPlanFragmentDoc}`;
export type AddTemplateMutationFn = Apollo.MutationFunction<AddTemplateMutation, AddTemplateMutationVariables>;

/**
 * __useAddTemplateMutation__
 *
 * To run a mutation, you first call `useAddTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTemplateMutation, { data, loading, error }] = useAddTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddTemplateMutation, AddTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTemplateMutation, AddTemplateMutationVariables>(AddTemplateDocument, options);
      }
export type AddTemplateMutationHookResult = ReturnType<typeof useAddTemplateMutation>;
export type AddTemplateMutationResult = Apollo.MutationResult<AddTemplateMutation>;
export type AddTemplateMutationOptions = Apollo.BaseMutationOptions<AddTemplateMutation, AddTemplateMutationVariables>;
export const PublishTemplateDocument = gql`
    mutation PublishTemplate($input: String!) {
  publishTemplate(input: $input) {
    ...boardPlan
  }
}
    ${BoardPlanFragmentDoc}`;
export type PublishTemplateMutationFn = Apollo.MutationFunction<PublishTemplateMutation, PublishTemplateMutationVariables>;

/**
 * __usePublishTemplateMutation__
 *
 * To run a mutation, you first call `usePublishTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTemplateMutation, { data, loading, error }] = usePublishTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PublishTemplateMutation, PublishTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTemplateMutation, PublishTemplateMutationVariables>(PublishTemplateDocument, options);
      }
export type PublishTemplateMutationHookResult = ReturnType<typeof usePublishTemplateMutation>;
export type PublishTemplateMutationResult = Apollo.MutationResult<PublishTemplateMutation>;
export type PublishTemplateMutationOptions = Apollo.BaseMutationOptions<PublishTemplateMutation, PublishTemplateMutationVariables>;
export const ArchiveTemplateDocument = gql`
    mutation ArchiveTemplate($input: String!) {
  archiveTemplate(input: $input) {
    ...boardPlan
  }
}
    ${BoardPlanFragmentDoc}`;
export type ArchiveTemplateMutationFn = Apollo.MutationFunction<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>;

/**
 * __useArchiveTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTemplateMutation, { data, loading, error }] = useArchiveTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>(ArchiveTemplateDocument, options);
      }
export type ArchiveTemplateMutationHookResult = ReturnType<typeof useArchiveTemplateMutation>;
export type ArchiveTemplateMutationResult = Apollo.MutationResult<ArchiveTemplateMutation>;
export type ArchiveTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveTemplateMutation, ArchiveTemplateMutationVariables>;
export const DeleteTemplateDocument = gql`
    mutation DeleteTemplate($id: String!) {
  deleteTemplate(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const CopyAllPublishedTemplatesDocument = gql`
    mutation CopyAllPublishedTemplates {
  copyAllPublishedTemplates {
    copiedCount
    success
    message
    plans {
      id
      title
      status
    }
  }
}
    `;
export type CopyAllPublishedTemplatesMutationFn = Apollo.MutationFunction<CopyAllPublishedTemplatesMutation, CopyAllPublishedTemplatesMutationVariables>;

/**
 * __useCopyAllPublishedTemplatesMutation__
 *
 * To run a mutation, you first call `useCopyAllPublishedTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAllPublishedTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAllPublishedTemplatesMutation, { data, loading, error }] = useCopyAllPublishedTemplatesMutation({
 *   variables: {
 *   },
 * });
 */
export function useCopyAllPublishedTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<CopyAllPublishedTemplatesMutation, CopyAllPublishedTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAllPublishedTemplatesMutation, CopyAllPublishedTemplatesMutationVariables>(CopyAllPublishedTemplatesDocument, options);
      }
export type CopyAllPublishedTemplatesMutationHookResult = ReturnType<typeof useCopyAllPublishedTemplatesMutation>;
export type CopyAllPublishedTemplatesMutationResult = Apollo.MutationResult<CopyAllPublishedTemplatesMutation>;
export type CopyAllPublishedTemplatesMutationOptions = Apollo.BaseMutationOptions<CopyAllPublishedTemplatesMutation, CopyAllPublishedTemplatesMutationVariables>;
export const BulkLockAllStudentPlansDocument = gql`
    mutation BulkLockAllStudentPlans($locked: Boolean!) {
  bulkLockAllStudentPlans(locked: $locked) {
    jobId
    message
  }
}
    `;
export type BulkLockAllStudentPlansMutationFn = Apollo.MutationFunction<BulkLockAllStudentPlansMutation, BulkLockAllStudentPlansMutationVariables>;

/**
 * __useBulkLockAllStudentPlansMutation__
 *
 * To run a mutation, you first call `useBulkLockAllStudentPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkLockAllStudentPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkLockAllStudentPlansMutation, { data, loading, error }] = useBulkLockAllStudentPlansMutation({
 *   variables: {
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useBulkLockAllStudentPlansMutation(baseOptions?: Apollo.MutationHookOptions<BulkLockAllStudentPlansMutation, BulkLockAllStudentPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkLockAllStudentPlansMutation, BulkLockAllStudentPlansMutationVariables>(BulkLockAllStudentPlansDocument, options);
      }
export type BulkLockAllStudentPlansMutationHookResult = ReturnType<typeof useBulkLockAllStudentPlansMutation>;
export type BulkLockAllStudentPlansMutationResult = Apollo.MutationResult<BulkLockAllStudentPlansMutation>;
export type BulkLockAllStudentPlansMutationOptions = Apollo.BaseMutationOptions<BulkLockAllStudentPlansMutation, BulkLockAllStudentPlansMutationVariables>;
export const BulkLockJobStatusDocument = gql`
    query BulkLockJobStatus($jobId: String!) {
  bulkLockJobStatus(jobId: $jobId) {
    jobId
    status
    totalStudents
    processedStudents
    lockedPlans
    errors
    startedAt
    completedAt
  }
}
    `;

/**
 * __useBulkLockJobStatusQuery__
 *
 * To run a query within a React component, call `useBulkLockJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkLockJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkLockJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBulkLockJobStatusQuery(baseOptions: Apollo.QueryHookOptions<BulkLockJobStatusQuery, BulkLockJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkLockJobStatusQuery, BulkLockJobStatusQueryVariables>(BulkLockJobStatusDocument, options);
      }
export function useBulkLockJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkLockJobStatusQuery, BulkLockJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkLockJobStatusQuery, BulkLockJobStatusQueryVariables>(BulkLockJobStatusDocument, options);
        }
export type BulkLockJobStatusQueryHookResult = ReturnType<typeof useBulkLockJobStatusQuery>;
export type BulkLockJobStatusLazyQueryHookResult = ReturnType<typeof useBulkLockJobStatusLazyQuery>;
export type BulkLockJobStatusQueryResult = Apollo.QueryResult<BulkLockJobStatusQuery, BulkLockJobStatusQueryVariables>;
export const ApplyTemplateDocument = gql`
    mutation ApplyTemplate($input: ApplyTemplateInput!) {
  applyTemplate(input: $input) {
    correlationId
    studentCount
    templateTitle
  }
}
    `;
export type ApplyTemplateMutationFn = Apollo.MutationFunction<ApplyTemplateMutation, ApplyTemplateMutationVariables>;

/**
 * __useApplyTemplateMutation__
 *
 * To run a mutation, you first call `useApplyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyTemplateMutation, { data, loading, error }] = useApplyTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ApplyTemplateMutation, ApplyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyTemplateMutation, ApplyTemplateMutationVariables>(ApplyTemplateDocument, options);
      }
export type ApplyTemplateMutationHookResult = ReturnType<typeof useApplyTemplateMutation>;
export type ApplyTemplateMutationResult = Apollo.MutationResult<ApplyTemplateMutation>;
export type ApplyTemplateMutationOptions = Apollo.BaseMutationOptions<ApplyTemplateMutation, ApplyTemplateMutationVariables>;
export const ApplyTemplateResponseDocument = gql`
    query applyTemplateResponse($correlationId: String!) {
  applyTemplateResponse(correlationId: $correlationId) {
    plansCreated {
      ...boardPlan
    }
    correlationId
    status
    studentCount
    templateTitle
    failureReason
  }
}
    ${BoardPlanFragmentDoc}`;

/**
 * __useApplyTemplateResponseQuery__
 *
 * To run a query within a React component, call `useApplyTemplateResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplateResponseQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useApplyTemplateResponseQuery(baseOptions: Apollo.QueryHookOptions<ApplyTemplateResponseQuery, ApplyTemplateResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyTemplateResponseQuery, ApplyTemplateResponseQueryVariables>(ApplyTemplateResponseDocument, options);
      }
export function useApplyTemplateResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyTemplateResponseQuery, ApplyTemplateResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyTemplateResponseQuery, ApplyTemplateResponseQueryVariables>(ApplyTemplateResponseDocument, options);
        }
export type ApplyTemplateResponseQueryHookResult = ReturnType<typeof useApplyTemplateResponseQuery>;
export type ApplyTemplateResponseLazyQueryHookResult = ReturnType<typeof useApplyTemplateResponseLazyQuery>;
export type ApplyTemplateResponseQueryResult = Apollo.QueryResult<ApplyTemplateResponseQuery, ApplyTemplateResponseQueryVariables>;
export const ApplyTemplateCompleteDocument = gql`
    subscription applyTemplateComplete($correlationIds: [String!]!) {
  applyTemplateComplete(correlationIds: $correlationIds) {
    plansCreated {
      ...boardPlan
    }
    correlationId
    status
    studentCount
    templateTitle
    failureReason
  }
}
    ${BoardPlanFragmentDoc}`;

/**
 * __useApplyTemplateCompleteSubscription__
 *
 * To run a query within a React component, call `useApplyTemplateCompleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateCompleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplateCompleteSubscription({
 *   variables: {
 *      correlationIds: // value for 'correlationIds'
 *   },
 * });
 */
export function useApplyTemplateCompleteSubscription(baseOptions: Apollo.SubscriptionHookOptions<ApplyTemplateCompleteSubscription, ApplyTemplateCompleteSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ApplyTemplateCompleteSubscription, ApplyTemplateCompleteSubscriptionVariables>(ApplyTemplateCompleteDocument, options);
      }
export type ApplyTemplateCompleteSubscriptionHookResult = ReturnType<typeof useApplyTemplateCompleteSubscription>;
export type ApplyTemplateCompleteSubscriptionResult = Apollo.SubscriptionResult<ApplyTemplateCompleteSubscription>;
export const TouchChangelogViewedDocument = gql`
    mutation touchChangelogViewed($input: String!) {
  touchChangelogViewed(input: $input) {
    id
    changelogViewedAt
  }
}
    `;
export type TouchChangelogViewedMutationFn = Apollo.MutationFunction<TouchChangelogViewedMutation, TouchChangelogViewedMutationVariables>;

/**
 * __useTouchChangelogViewedMutation__
 *
 * To run a mutation, you first call `useTouchChangelogViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchChangelogViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchChangelogViewedMutation, { data, loading, error }] = useTouchChangelogViewedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTouchChangelogViewedMutation(baseOptions?: Apollo.MutationHookOptions<TouchChangelogViewedMutation, TouchChangelogViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TouchChangelogViewedMutation, TouchChangelogViewedMutationVariables>(TouchChangelogViewedDocument, options);
      }
export type TouchChangelogViewedMutationHookResult = ReturnType<typeof useTouchChangelogViewedMutation>;
export type TouchChangelogViewedMutationResult = Apollo.MutationResult<TouchChangelogViewedMutation>;
export type TouchChangelogViewedMutationOptions = Apollo.BaseMutationOptions<TouchChangelogViewedMutation, TouchChangelogViewedMutationVariables>;
export const ChangeLogViewedAtDocument = gql`
    query changeLogViewedAt($planId: String!) {
  plan(id: $planId) {
    id
    changelogViewedAt
  }
}
    `;

/**
 * __useChangeLogViewedAtQuery__
 *
 * To run a query within a React component, call `useChangeLogViewedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogViewedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogViewedAtQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useChangeLogViewedAtQuery(baseOptions: Apollo.QueryHookOptions<ChangeLogViewedAtQuery, ChangeLogViewedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeLogViewedAtQuery, ChangeLogViewedAtQueryVariables>(ChangeLogViewedAtDocument, options);
      }
export function useChangeLogViewedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeLogViewedAtQuery, ChangeLogViewedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeLogViewedAtQuery, ChangeLogViewedAtQueryVariables>(ChangeLogViewedAtDocument, options);
        }
export type ChangeLogViewedAtQueryHookResult = ReturnType<typeof useChangeLogViewedAtQuery>;
export type ChangeLogViewedAtLazyQueryHookResult = ReturnType<typeof useChangeLogViewedAtLazyQuery>;
export type ChangeLogViewedAtQueryResult = Apollo.QueryResult<ChangeLogViewedAtQuery, ChangeLogViewedAtQueryVariables>;
export const DismissPlanAlertDocument = gql`
    mutation dismissPlanAlert($input: DismissAlertInput!) {
  dismissPlanAlert(input: $input) {
    id
    success
    message
  }
}
    `;
export type DismissPlanAlertMutationFn = Apollo.MutationFunction<DismissPlanAlertMutation, DismissPlanAlertMutationVariables>;

/**
 * __useDismissPlanAlertMutation__
 *
 * To run a mutation, you first call `useDismissPlanAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissPlanAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissPlanAlertMutation, { data, loading, error }] = useDismissPlanAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissPlanAlertMutation(baseOptions?: Apollo.MutationHookOptions<DismissPlanAlertMutation, DismissPlanAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissPlanAlertMutation, DismissPlanAlertMutationVariables>(DismissPlanAlertDocument, options);
      }
export type DismissPlanAlertMutationHookResult = ReturnType<typeof useDismissPlanAlertMutation>;
export type DismissPlanAlertMutationResult = Apollo.MutationResult<DismissPlanAlertMutation>;
export type DismissPlanAlertMutationOptions = Apollo.BaseMutationOptions<DismissPlanAlertMutation, DismissPlanAlertMutationVariables>;
export const PlanAlertsDocument = gql`
    query planAlerts($planId: String!, $groupId: String, $itemId: String) {
  planAlerts(planId: $planId, groupId: $groupId, itemId: $itemId) {
    ...boardAlert
  }
}
    ${BoardAlertFragmentDoc}`;

/**
 * __usePlanAlertsQuery__
 *
 * To run a query within a React component, call `usePlanAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanAlertsQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      groupId: // value for 'groupId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function usePlanAlertsQuery(baseOptions: Apollo.QueryHookOptions<PlanAlertsQuery, PlanAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanAlertsQuery, PlanAlertsQueryVariables>(PlanAlertsDocument, options);
      }
export function usePlanAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanAlertsQuery, PlanAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanAlertsQuery, PlanAlertsQueryVariables>(PlanAlertsDocument, options);
        }
export type PlanAlertsQueryHookResult = ReturnType<typeof usePlanAlertsQuery>;
export type PlanAlertsLazyQueryHookResult = ReturnType<typeof usePlanAlertsLazyQuery>;
export type PlanAlertsQueryResult = Apollo.QueryResult<PlanAlertsQuery, PlanAlertsQueryVariables>;
export const PlaceholderTemplatesDocument = gql`
    query placeholderTemplates($environment: String) {
  placeholderTemplates(environment: $environment) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;

/**
 * __usePlaceholderTemplatesQuery__
 *
 * To run a query within a React component, call `usePlaceholderTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderTemplatesQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function usePlaceholderTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<PlaceholderTemplatesQuery, PlaceholderTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceholderTemplatesQuery, PlaceholderTemplatesQueryVariables>(PlaceholderTemplatesDocument, options);
      }
export function usePlaceholderTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceholderTemplatesQuery, PlaceholderTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceholderTemplatesQuery, PlaceholderTemplatesQueryVariables>(PlaceholderTemplatesDocument, options);
        }
export type PlaceholderTemplatesQueryHookResult = ReturnType<typeof usePlaceholderTemplatesQuery>;
export type PlaceholderTemplatesLazyQueryHookResult = ReturnType<typeof usePlaceholderTemplatesLazyQuery>;
export type PlaceholderTemplatesQueryResult = Apollo.QueryResult<PlaceholderTemplatesQuery, PlaceholderTemplatesQueryVariables>;
export const PlaceholderTemplateDocument = gql`
    query placeholderTemplate($id: String!) {
  placeholderTemplate(id: $id) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;

/**
 * __usePlaceholderTemplateQuery__
 *
 * To run a query within a React component, call `usePlaceholderTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaceholderTemplateQuery(baseOptions: Apollo.QueryHookOptions<PlaceholderTemplateQuery, PlaceholderTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceholderTemplateQuery, PlaceholderTemplateQueryVariables>(PlaceholderTemplateDocument, options);
      }
export function usePlaceholderTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceholderTemplateQuery, PlaceholderTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceholderTemplateQuery, PlaceholderTemplateQueryVariables>(PlaceholderTemplateDocument, options);
        }
export type PlaceholderTemplateQueryHookResult = ReturnType<typeof usePlaceholderTemplateQuery>;
export type PlaceholderTemplateLazyQueryHookResult = ReturnType<typeof usePlaceholderTemplateLazyQuery>;
export type PlaceholderTemplateQueryResult = Apollo.QueryResult<PlaceholderTemplateQuery, PlaceholderTemplateQueryVariables>;
export const PlaceholderTemplateInUseLocationsDocument = gql`
    query placeholderTemplateInUseLocations($id: String!) {
  placeholderTemplateInUseLocations(id: $id) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __usePlaceholderTemplateInUseLocationsQuery__
 *
 * To run a query within a React component, call `usePlaceholderTemplateInUseLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderTemplateInUseLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderTemplateInUseLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaceholderTemplateInUseLocationsQuery(baseOptions: Apollo.QueryHookOptions<PlaceholderTemplateInUseLocationsQuery, PlaceholderTemplateInUseLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceholderTemplateInUseLocationsQuery, PlaceholderTemplateInUseLocationsQueryVariables>(PlaceholderTemplateInUseLocationsDocument, options);
      }
export function usePlaceholderTemplateInUseLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceholderTemplateInUseLocationsQuery, PlaceholderTemplateInUseLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceholderTemplateInUseLocationsQuery, PlaceholderTemplateInUseLocationsQueryVariables>(PlaceholderTemplateInUseLocationsDocument, options);
        }
export type PlaceholderTemplateInUseLocationsQueryHookResult = ReturnType<typeof usePlaceholderTemplateInUseLocationsQuery>;
export type PlaceholderTemplateInUseLocationsLazyQueryHookResult = ReturnType<typeof usePlaceholderTemplateInUseLocationsLazyQuery>;
export type PlaceholderTemplateInUseLocationsQueryResult = Apollo.QueryResult<PlaceholderTemplateInUseLocationsQuery, PlaceholderTemplateInUseLocationsQueryVariables>;
export const AddPlaceholderTemplateDocument = gql`
    mutation AddPlaceholderTemplate {
  addPlaceholderTemplate {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type AddPlaceholderTemplateMutationFn = Apollo.MutationFunction<AddPlaceholderTemplateMutation, AddPlaceholderTemplateMutationVariables>;

/**
 * __useAddPlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useAddPlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaceholderTemplateMutation, { data, loading, error }] = useAddPlaceholderTemplateMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddPlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddPlaceholderTemplateMutation, AddPlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlaceholderTemplateMutation, AddPlaceholderTemplateMutationVariables>(AddPlaceholderTemplateDocument, options);
      }
export type AddPlaceholderTemplateMutationHookResult = ReturnType<typeof useAddPlaceholderTemplateMutation>;
export type AddPlaceholderTemplateMutationResult = Apollo.MutationResult<AddPlaceholderTemplateMutation>;
export type AddPlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<AddPlaceholderTemplateMutation, AddPlaceholderTemplateMutationVariables>;
export const DeletePlaceholderTemplateDocument = gql`
    mutation DeletePlaceholderTemplate($input: String!) {
  deletePlaceholderTemplate(input: $input) {
    id
    success
    message
  }
}
    `;
export type DeletePlaceholderTemplateMutationFn = Apollo.MutationFunction<DeletePlaceholderTemplateMutation, DeletePlaceholderTemplateMutationVariables>;

/**
 * __useDeletePlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaceholderTemplateMutation, { data, loading, error }] = useDeletePlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaceholderTemplateMutation, DeletePlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaceholderTemplateMutation, DeletePlaceholderTemplateMutationVariables>(DeletePlaceholderTemplateDocument, options);
      }
export type DeletePlaceholderTemplateMutationHookResult = ReturnType<typeof useDeletePlaceholderTemplateMutation>;
export type DeletePlaceholderTemplateMutationResult = Apollo.MutationResult<DeletePlaceholderTemplateMutation>;
export type DeletePlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePlaceholderTemplateMutation, DeletePlaceholderTemplateMutationVariables>;
export const ArchivePlaceholderTemplateDocument = gql`
    mutation ArchivePlaceholderTemplate($input: String!) {
  archivePlaceholderTemplate(input: $input) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type ArchivePlaceholderTemplateMutationFn = Apollo.MutationFunction<ArchivePlaceholderTemplateMutation, ArchivePlaceholderTemplateMutationVariables>;

/**
 * __useArchivePlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useArchivePlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePlaceholderTemplateMutation, { data, loading, error }] = useArchivePlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchivePlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePlaceholderTemplateMutation, ArchivePlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePlaceholderTemplateMutation, ArchivePlaceholderTemplateMutationVariables>(ArchivePlaceholderTemplateDocument, options);
      }
export type ArchivePlaceholderTemplateMutationHookResult = ReturnType<typeof useArchivePlaceholderTemplateMutation>;
export type ArchivePlaceholderTemplateMutationResult = Apollo.MutationResult<ArchivePlaceholderTemplateMutation>;
export type ArchivePlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<ArchivePlaceholderTemplateMutation, ArchivePlaceholderTemplateMutationVariables>;
export const PublishPlaceholderTemplateDocument = gql`
    mutation publishPlaceholderTemplate($input: String!) {
  publishPlaceholderTemplate(input: $input) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type PublishPlaceholderTemplateMutationFn = Apollo.MutationFunction<PublishPlaceholderTemplateMutation, PublishPlaceholderTemplateMutationVariables>;

/**
 * __usePublishPlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `usePublishPlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPlaceholderTemplateMutation, { data, loading, error }] = usePublishPlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishPlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PublishPlaceholderTemplateMutation, PublishPlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPlaceholderTemplateMutation, PublishPlaceholderTemplateMutationVariables>(PublishPlaceholderTemplateDocument, options);
      }
export type PublishPlaceholderTemplateMutationHookResult = ReturnType<typeof usePublishPlaceholderTemplateMutation>;
export type PublishPlaceholderTemplateMutationResult = Apollo.MutationResult<PublishPlaceholderTemplateMutation>;
export type PublishPlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<PublishPlaceholderTemplateMutation, PublishPlaceholderTemplateMutationVariables>;
export const CopyPlaceholderTemplateDocument = gql`
    mutation CopyPlaceholderTemplate($input: String!) {
  copyPlaceholderTemplate(input: $input) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type CopyPlaceholderTemplateMutationFn = Apollo.MutationFunction<CopyPlaceholderTemplateMutation, CopyPlaceholderTemplateMutationVariables>;

/**
 * __useCopyPlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useCopyPlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPlaceholderTemplateMutation, { data, loading, error }] = useCopyPlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyPlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CopyPlaceholderTemplateMutation, CopyPlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyPlaceholderTemplateMutation, CopyPlaceholderTemplateMutationVariables>(CopyPlaceholderTemplateDocument, options);
      }
export type CopyPlaceholderTemplateMutationHookResult = ReturnType<typeof useCopyPlaceholderTemplateMutation>;
export type CopyPlaceholderTemplateMutationResult = Apollo.MutationResult<CopyPlaceholderTemplateMutation>;
export type CopyPlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<CopyPlaceholderTemplateMutation, CopyPlaceholderTemplateMutationVariables>;
export const UpdatePlaceholderTemplateDocument = gql`
    mutation UpdatePlaceholderTemplate($input: UpdatePlanItemInput!) {
  updatePlaceholderTemplate(input: $input) {
    ...planItemDetails
  }
}
    ${PlanItemDetailsFragmentDoc}`;
export type UpdatePlaceholderTemplateMutationFn = Apollo.MutationFunction<UpdatePlaceholderTemplateMutation, UpdatePlaceholderTemplateMutationVariables>;

/**
 * __useUpdatePlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceholderTemplateMutation, { data, loading, error }] = useUpdatePlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceholderTemplateMutation, UpdatePlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceholderTemplateMutation, UpdatePlaceholderTemplateMutationVariables>(UpdatePlaceholderTemplateDocument, options);
      }
export type UpdatePlaceholderTemplateMutationHookResult = ReturnType<typeof useUpdatePlaceholderTemplateMutation>;
export type UpdatePlaceholderTemplateMutationResult = Apollo.MutationResult<UpdatePlaceholderTemplateMutation>;
export type UpdatePlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceholderTemplateMutation, UpdatePlaceholderTemplateMutationVariables>;
export const AddPlaceholderCourseDocument = gql`
    mutation AddPlaceholderCourse($input: PlaceholderCourseInput!) {
  addPlaceholderCourse(input: $input) {
    id
    ...placeholderCourse
  }
}
    ${PlaceholderCourseFragmentDoc}`;
export type AddPlaceholderCourseMutationFn = Apollo.MutationFunction<AddPlaceholderCourseMutation, AddPlaceholderCourseMutationVariables>;

/**
 * __useAddPlaceholderCourseMutation__
 *
 * To run a mutation, you first call `useAddPlaceholderCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaceholderCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaceholderCourseMutation, { data, loading, error }] = useAddPlaceholderCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlaceholderCourseMutation(baseOptions?: Apollo.MutationHookOptions<AddPlaceholderCourseMutation, AddPlaceholderCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlaceholderCourseMutation, AddPlaceholderCourseMutationVariables>(AddPlaceholderCourseDocument, options);
      }
export type AddPlaceholderCourseMutationHookResult = ReturnType<typeof useAddPlaceholderCourseMutation>;
export type AddPlaceholderCourseMutationResult = Apollo.MutationResult<AddPlaceholderCourseMutation>;
export type AddPlaceholderCourseMutationOptions = Apollo.BaseMutationOptions<AddPlaceholderCourseMutation, AddPlaceholderCourseMutationVariables>;
export const DeletePlaceholderCourseDocument = gql`
    mutation DeletePlaceholderCourse($id: String!) {
  deletePlaceholderCourse(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeletePlaceholderCourseMutationFn = Apollo.MutationFunction<DeletePlaceholderCourseMutation, DeletePlaceholderCourseMutationVariables>;

/**
 * __useDeletePlaceholderCourseMutation__
 *
 * To run a mutation, you first call `useDeletePlaceholderCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaceholderCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaceholderCourseMutation, { data, loading, error }] = useDeletePlaceholderCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlaceholderCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaceholderCourseMutation, DeletePlaceholderCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaceholderCourseMutation, DeletePlaceholderCourseMutationVariables>(DeletePlaceholderCourseDocument, options);
      }
export type DeletePlaceholderCourseMutationHookResult = ReturnType<typeof useDeletePlaceholderCourseMutation>;
export type DeletePlaceholderCourseMutationResult = Apollo.MutationResult<DeletePlaceholderCourseMutation>;
export type DeletePlaceholderCourseMutationOptions = Apollo.BaseMutationOptions<DeletePlaceholderCourseMutation, DeletePlaceholderCourseMutationVariables>;
export const SearchPlaceholderTemplatesDocument = gql`
    query searchPlaceholderTemplates($searchText: String!, $environment: String!, $campusCode: String) {
  searchPlaceholderTemplates(
    searchText: $searchText
    environment: $environment
    campusCode: $campusCode
  ) {
    ...boardItem
  }
}
    ${BoardItemFragmentDoc}`;

/**
 * __useSearchPlaceholderTemplatesQuery__
 *
 * To run a query within a React component, call `useSearchPlaceholderTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlaceholderTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlaceholderTemplatesQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      environment: // value for 'environment'
 *      campusCode: // value for 'campusCode'
 *   },
 * });
 */
export function useSearchPlaceholderTemplatesQuery(baseOptions: Apollo.QueryHookOptions<SearchPlaceholderTemplatesQuery, SearchPlaceholderTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPlaceholderTemplatesQuery, SearchPlaceholderTemplatesQueryVariables>(SearchPlaceholderTemplatesDocument, options);
      }
export function useSearchPlaceholderTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPlaceholderTemplatesQuery, SearchPlaceholderTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPlaceholderTemplatesQuery, SearchPlaceholderTemplatesQueryVariables>(SearchPlaceholderTemplatesDocument, options);
        }
export type SearchPlaceholderTemplatesQueryHookResult = ReturnType<typeof useSearchPlaceholderTemplatesQuery>;
export type SearchPlaceholderTemplatesLazyQueryHookResult = ReturnType<typeof useSearchPlaceholderTemplatesLazyQuery>;
export type SearchPlaceholderTemplatesQueryResult = Apollo.QueryResult<SearchPlaceholderTemplatesQuery, SearchPlaceholderTemplatesQueryVariables>;
export const ItemFromPlaceholderTemplateDocument = gql`
    mutation itemFromPlaceholderTemplate($input: ItemFromPlaceholderTemplateInput!) {
  itemFromPlaceholderTemplate(input: $input) {
    ...boardItem
  }
}
    ${BoardItemFragmentDoc}`;
export type ItemFromPlaceholderTemplateMutationFn = Apollo.MutationFunction<ItemFromPlaceholderTemplateMutation, ItemFromPlaceholderTemplateMutationVariables>;

/**
 * __useItemFromPlaceholderTemplateMutation__
 *
 * To run a mutation, you first call `useItemFromPlaceholderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItemFromPlaceholderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itemFromPlaceholderTemplateMutation, { data, loading, error }] = useItemFromPlaceholderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useItemFromPlaceholderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ItemFromPlaceholderTemplateMutation, ItemFromPlaceholderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItemFromPlaceholderTemplateMutation, ItemFromPlaceholderTemplateMutationVariables>(ItemFromPlaceholderTemplateDocument, options);
      }
export type ItemFromPlaceholderTemplateMutationHookResult = ReturnType<typeof useItemFromPlaceholderTemplateMutation>;
export type ItemFromPlaceholderTemplateMutationResult = Apollo.MutationResult<ItemFromPlaceholderTemplateMutation>;
export type ItemFromPlaceholderTemplateMutationOptions = Apollo.BaseMutationOptions<ItemFromPlaceholderTemplateMutation, ItemFromPlaceholderTemplateMutationVariables>;
export const AddItemMajorDocument = gql`
    mutation AddItemMajor($input: CreateItemMajorInput!) {
  addItemMajor(input: $input) {
    ...itemMajor
  }
}
    ${ItemMajorFragmentDoc}`;
export type AddItemMajorMutationFn = Apollo.MutationFunction<AddItemMajorMutation, AddItemMajorMutationVariables>;

/**
 * __useAddItemMajorMutation__
 *
 * To run a mutation, you first call `useAddItemMajorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMajorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMajorMutation, { data, loading, error }] = useAddItemMajorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemMajorMutation(baseOptions?: Apollo.MutationHookOptions<AddItemMajorMutation, AddItemMajorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemMajorMutation, AddItemMajorMutationVariables>(AddItemMajorDocument, options);
      }
export type AddItemMajorMutationHookResult = ReturnType<typeof useAddItemMajorMutation>;
export type AddItemMajorMutationResult = Apollo.MutationResult<AddItemMajorMutation>;
export type AddItemMajorMutationOptions = Apollo.BaseMutationOptions<AddItemMajorMutation, AddItemMajorMutationVariables>;
export const DeleteItemMajorDocument = gql`
    mutation DeleteItemMajor($id: String!) {
  deleteItemMajor(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeleteItemMajorMutationFn = Apollo.MutationFunction<DeleteItemMajorMutation, DeleteItemMajorMutationVariables>;

/**
 * __useDeleteItemMajorMutation__
 *
 * To run a mutation, you first call `useDeleteItemMajorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMajorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMajorMutation, { data, loading, error }] = useDeleteItemMajorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteItemMajorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemMajorMutation, DeleteItemMajorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemMajorMutation, DeleteItemMajorMutationVariables>(DeleteItemMajorDocument, options);
      }
export type DeleteItemMajorMutationHookResult = ReturnType<typeof useDeleteItemMajorMutation>;
export type DeleteItemMajorMutationResult = Apollo.MutationResult<DeleteItemMajorMutation>;
export type DeleteItemMajorMutationOptions = Apollo.BaseMutationOptions<DeleteItemMajorMutation, DeleteItemMajorMutationVariables>;
export const AddItemMinorDocument = gql`
    mutation AddItemMinor($input: CreateItemMinorInput!) {
  addItemMinor(input: $input) {
    ...itemMinor
  }
}
    ${ItemMinorFragmentDoc}`;
export type AddItemMinorMutationFn = Apollo.MutationFunction<AddItemMinorMutation, AddItemMinorMutationVariables>;

/**
 * __useAddItemMinorMutation__
 *
 * To run a mutation, you first call `useAddItemMinorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMinorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMinorMutation, { data, loading, error }] = useAddItemMinorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemMinorMutation(baseOptions?: Apollo.MutationHookOptions<AddItemMinorMutation, AddItemMinorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemMinorMutation, AddItemMinorMutationVariables>(AddItemMinorDocument, options);
      }
export type AddItemMinorMutationHookResult = ReturnType<typeof useAddItemMinorMutation>;
export type AddItemMinorMutationResult = Apollo.MutationResult<AddItemMinorMutation>;
export type AddItemMinorMutationOptions = Apollo.BaseMutationOptions<AddItemMinorMutation, AddItemMinorMutationVariables>;
export const DeleteItemMinorDocument = gql`
    mutation DeleteItemMinor($id: String!) {
  deleteItemMinor(id: $id) {
    id
    success
    message
  }
}
    `;
export type DeleteItemMinorMutationFn = Apollo.MutationFunction<DeleteItemMinorMutation, DeleteItemMinorMutationVariables>;

/**
 * __useDeleteItemMinorMutation__
 *
 * To run a mutation, you first call `useDeleteItemMinorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMinorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMinorMutation, { data, loading, error }] = useDeleteItemMinorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteItemMinorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemMinorMutation, DeleteItemMinorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemMinorMutation, DeleteItemMinorMutationVariables>(DeleteItemMinorDocument, options);
      }
export type DeleteItemMinorMutationHookResult = ReturnType<typeof useDeleteItemMinorMutation>;
export type DeleteItemMinorMutationResult = Apollo.MutationResult<DeleteItemMinorMutation>;
export type DeleteItemMinorMutationOptions = Apollo.BaseMutationOptions<DeleteItemMinorMutation, DeleteItemMinorMutationVariables>;
export const UpdatePlanReadOnlyForStudentsDocument = gql`
    mutation UpdatePlanReadOnlyForStudents($planId: String!, $readOnlyForStudents: Boolean!) {
  updatePlanReadOnlyForStudents(
    planId: $planId
    readOnlyForStudents: $readOnlyForStudents
  ) {
    id
    readOnlyForStudents
  }
}
    `;
export type UpdatePlanReadOnlyForStudentsMutationFn = Apollo.MutationFunction<UpdatePlanReadOnlyForStudentsMutation, UpdatePlanReadOnlyForStudentsMutationVariables>;

/**
 * __useUpdatePlanReadOnlyForStudentsMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReadOnlyForStudentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReadOnlyForStudentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReadOnlyForStudentsMutation, { data, loading, error }] = useUpdatePlanReadOnlyForStudentsMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      readOnlyForStudents: // value for 'readOnlyForStudents'
 *   },
 * });
 */
export function useUpdatePlanReadOnlyForStudentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReadOnlyForStudentsMutation, UpdatePlanReadOnlyForStudentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReadOnlyForStudentsMutation, UpdatePlanReadOnlyForStudentsMutationVariables>(UpdatePlanReadOnlyForStudentsDocument, options);
      }
export type UpdatePlanReadOnlyForStudentsMutationHookResult = ReturnType<typeof useUpdatePlanReadOnlyForStudentsMutation>;
export type UpdatePlanReadOnlyForStudentsMutationResult = Apollo.MutationResult<UpdatePlanReadOnlyForStudentsMutation>;
export type UpdatePlanReadOnlyForStudentsMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReadOnlyForStudentsMutation, UpdatePlanReadOnlyForStudentsMutationVariables>;
export const ResetAllPlansReadOnlyDocument = gql`
    mutation ResetAllPlansReadOnly($readOnlyForStudents: Boolean!) {
  resetAllPlansReadOnly(readOnlyForStudents: $readOnlyForStudents) {
    jobId
    message
  }
}
    `;
export type ResetAllPlansReadOnlyMutationFn = Apollo.MutationFunction<ResetAllPlansReadOnlyMutation, ResetAllPlansReadOnlyMutationVariables>;

/**
 * __useResetAllPlansReadOnlyMutation__
 *
 * To run a mutation, you first call `useResetAllPlansReadOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllPlansReadOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllPlansReadOnlyMutation, { data, loading, error }] = useResetAllPlansReadOnlyMutation({
 *   variables: {
 *      readOnlyForStudents: // value for 'readOnlyForStudents'
 *   },
 * });
 */
export function useResetAllPlansReadOnlyMutation(baseOptions?: Apollo.MutationHookOptions<ResetAllPlansReadOnlyMutation, ResetAllPlansReadOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAllPlansReadOnlyMutation, ResetAllPlansReadOnlyMutationVariables>(ResetAllPlansReadOnlyDocument, options);
      }
export type ResetAllPlansReadOnlyMutationHookResult = ReturnType<typeof useResetAllPlansReadOnlyMutation>;
export type ResetAllPlansReadOnlyMutationResult = Apollo.MutationResult<ResetAllPlansReadOnlyMutation>;
export type ResetAllPlansReadOnlyMutationOptions = Apollo.BaseMutationOptions<ResetAllPlansReadOnlyMutation, ResetAllPlansReadOnlyMutationVariables>;
export const ReadOnlyBulkActionStatusDocument = gql`
    query ReadOnlyBulkActionStatus($jobId: String!) {
  readOnlyBulkActionStatus(jobId: $jobId) {
    jobId
    status
    totalPlans
    processedPlans
    failedPlans
    errors
    startedAt
    completedAt
  }
}
    `;

/**
 * __useReadOnlyBulkActionStatusQuery__
 *
 * To run a query within a React component, call `useReadOnlyBulkActionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOnlyBulkActionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOnlyBulkActionStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useReadOnlyBulkActionStatusQuery(baseOptions: Apollo.QueryHookOptions<ReadOnlyBulkActionStatusQuery, ReadOnlyBulkActionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOnlyBulkActionStatusQuery, ReadOnlyBulkActionStatusQueryVariables>(ReadOnlyBulkActionStatusDocument, options);
      }
export function useReadOnlyBulkActionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOnlyBulkActionStatusQuery, ReadOnlyBulkActionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOnlyBulkActionStatusQuery, ReadOnlyBulkActionStatusQueryVariables>(ReadOnlyBulkActionStatusDocument, options);
        }
export type ReadOnlyBulkActionStatusQueryHookResult = ReturnType<typeof useReadOnlyBulkActionStatusQuery>;
export type ReadOnlyBulkActionStatusLazyQueryHookResult = ReturnType<typeof useReadOnlyBulkActionStatusLazyQuery>;
export type ReadOnlyBulkActionStatusQueryResult = Apollo.QueryResult<ReadOnlyBulkActionStatusQuery, ReadOnlyBulkActionStatusQueryVariables>;
export const ReportTermsDocument = gql`
    query reportTerms {
  reportTerms {
    ...reportTermData
  }
}
    ${ReportTermDataFragmentDoc}`;

/**
 * __useReportTermsQuery__
 *
 * To run a query within a React component, call `useReportTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportTermsQuery(baseOptions?: Apollo.QueryHookOptions<ReportTermsQuery, ReportTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportTermsQuery, ReportTermsQueryVariables>(ReportTermsDocument, options);
      }
export function useReportTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportTermsQuery, ReportTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportTermsQuery, ReportTermsQueryVariables>(ReportTermsDocument, options);
        }
export type ReportTermsQueryHookResult = ReturnType<typeof useReportTermsQuery>;
export type ReportTermsLazyQueryHookResult = ReturnType<typeof useReportTermsLazyQuery>;
export type ReportTermsQueryResult = Apollo.QueryResult<ReportTermsQuery, ReportTermsQueryVariables>;
export const StudentUsageDataDocument = gql`
    query studentUsageData {
  studentUsage {
    ...studentUsageData
  }
}
    ${StudentUsageDataFragmentDoc}`;

/**
 * __useStudentUsageDataQuery__
 *
 * To run a query within a React component, call `useStudentUsageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentUsageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentUsageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentUsageDataQuery(baseOptions?: Apollo.QueryHookOptions<StudentUsageDataQuery, StudentUsageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentUsageDataQuery, StudentUsageDataQueryVariables>(StudentUsageDataDocument, options);
      }
export function useStudentUsageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentUsageDataQuery, StudentUsageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentUsageDataQuery, StudentUsageDataQueryVariables>(StudentUsageDataDocument, options);
        }
export type StudentUsageDataQueryHookResult = ReturnType<typeof useStudentUsageDataQuery>;
export type StudentUsageDataLazyQueryHookResult = ReturnType<typeof useStudentUsageDataLazyQuery>;
export type StudentUsageDataQueryResult = Apollo.QueryResult<StudentUsageDataQuery, StudentUsageDataQueryVariables>;
export const PlanningCourseDemandDocument = gql`
    query planningCourseDemand($termIds: [String!]!) {
  planningCourseDemand(termIds: $termIds) {
    courseNumber
    studentsCount
    subjectId
    termId
  }
}
    `;

/**
 * __usePlanningCourseDemandQuery__
 *
 * To run a query within a React component, call `usePlanningCourseDemandQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningCourseDemandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningCourseDemandQuery({
 *   variables: {
 *      termIds: // value for 'termIds'
 *   },
 * });
 */
export function usePlanningCourseDemandQuery(baseOptions: Apollo.QueryHookOptions<PlanningCourseDemandQuery, PlanningCourseDemandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningCourseDemandQuery, PlanningCourseDemandQueryVariables>(PlanningCourseDemandDocument, options);
      }
export function usePlanningCourseDemandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningCourseDemandQuery, PlanningCourseDemandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningCourseDemandQuery, PlanningCourseDemandQueryVariables>(PlanningCourseDemandDocument, options);
        }
export type PlanningCourseDemandQueryHookResult = ReturnType<typeof usePlanningCourseDemandQuery>;
export type PlanningCourseDemandLazyQueryHookResult = ReturnType<typeof usePlanningCourseDemandLazyQuery>;
export type PlanningCourseDemandQueryResult = Apollo.QueryResult<PlanningCourseDemandQuery, PlanningCourseDemandQueryVariables>;
export const PlanningCourseDemandRawDocument = gql`
    query planningCourseDemandRaw($termIds: [String!]!) {
  planningCourseDemandRaw(termIds: $termIds) {
    courseNumber
    studentId
    subjectId
    termId
  }
}
    `;

/**
 * __usePlanningCourseDemandRawQuery__
 *
 * To run a query within a React component, call `usePlanningCourseDemandRawQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningCourseDemandRawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningCourseDemandRawQuery({
 *   variables: {
 *      termIds: // value for 'termIds'
 *   },
 * });
 */
export function usePlanningCourseDemandRawQuery(baseOptions: Apollo.QueryHookOptions<PlanningCourseDemandRawQuery, PlanningCourseDemandRawQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningCourseDemandRawQuery, PlanningCourseDemandRawQueryVariables>(PlanningCourseDemandRawDocument, options);
      }
export function usePlanningCourseDemandRawLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningCourseDemandRawQuery, PlanningCourseDemandRawQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningCourseDemandRawQuery, PlanningCourseDemandRawQueryVariables>(PlanningCourseDemandRawDocument, options);
        }
export type PlanningCourseDemandRawQueryHookResult = ReturnType<typeof usePlanningCourseDemandRawQuery>;
export type PlanningCourseDemandRawLazyQueryHookResult = ReturnType<typeof usePlanningCourseDemandRawLazyQuery>;
export type PlanningCourseDemandRawQueryResult = Apollo.QueryResult<PlanningCourseDemandRawQuery, PlanningCourseDemandRawQueryVariables>;
export const PlanningReportTermsDocument = gql`
    query planningReportTerms {
  planningReportTerms {
    ...planningReportTermData
  }
}
    ${PlanningReportTermDataFragmentDoc}`;

/**
 * __usePlanningReportTermsQuery__
 *
 * To run a query within a React component, call `usePlanningReportTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningReportTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningReportTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanningReportTermsQuery(baseOptions?: Apollo.QueryHookOptions<PlanningReportTermsQuery, PlanningReportTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningReportTermsQuery, PlanningReportTermsQueryVariables>(PlanningReportTermsDocument, options);
      }
export function usePlanningReportTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningReportTermsQuery, PlanningReportTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningReportTermsQuery, PlanningReportTermsQueryVariables>(PlanningReportTermsDocument, options);
        }
export type PlanningReportTermsQueryHookResult = ReturnType<typeof usePlanningReportTermsQuery>;
export type PlanningReportTermsLazyQueryHookResult = ReturnType<typeof usePlanningReportTermsLazyQuery>;
export type PlanningReportTermsQueryResult = Apollo.QueryResult<PlanningReportTermsQuery, PlanningReportTermsQueryVariables>;
export const StudentPlanCreationDataDocument = gql`
    query studentPlanCreationData($reportOption: StudentPlanCreationReportOption) {
  studentPlanCreationData(reportOption: $reportOption) {
    firstName
    lastName
    studentId
    lastLogin
    admitTerm
    planCreation
    campus
  }
}
    `;

/**
 * __useStudentPlanCreationDataQuery__
 *
 * To run a query within a React component, call `useStudentPlanCreationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPlanCreationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPlanCreationDataQuery({
 *   variables: {
 *      reportOption: // value for 'reportOption'
 *   },
 * });
 */
export function useStudentPlanCreationDataQuery(baseOptions?: Apollo.QueryHookOptions<StudentPlanCreationDataQuery, StudentPlanCreationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentPlanCreationDataQuery, StudentPlanCreationDataQueryVariables>(StudentPlanCreationDataDocument, options);
      }
export function useStudentPlanCreationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentPlanCreationDataQuery, StudentPlanCreationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentPlanCreationDataQuery, StudentPlanCreationDataQueryVariables>(StudentPlanCreationDataDocument, options);
        }
export type StudentPlanCreationDataQueryHookResult = ReturnType<typeof useStudentPlanCreationDataQuery>;
export type StudentPlanCreationDataLazyQueryHookResult = ReturnType<typeof useStudentPlanCreationDataLazyQuery>;
export type StudentPlanCreationDataQueryResult = Apollo.QueryResult<StudentPlanCreationDataQuery, StudentPlanCreationDataQueryVariables>;
export const TemplateExtractDataDocument = gql`
    query templateExtractData($templateIds: [String!]!) {
  templateExtractData(templateIds: $templateIds) {
    title
    status
    campus
    campusDescription
    college
    collegeDescription
    degree
    major
    minor
    catalogYear
    catalogYearDescription
    concentration
    term
    termSequence
    course
    courseSequence
    credits
  }
}
    `;

/**
 * __useTemplateExtractDataQuery__
 *
 * To run a query within a React component, call `useTemplateExtractDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateExtractDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateExtractDataQuery({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useTemplateExtractDataQuery(baseOptions: Apollo.QueryHookOptions<TemplateExtractDataQuery, TemplateExtractDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateExtractDataQuery, TemplateExtractDataQueryVariables>(TemplateExtractDataDocument, options);
      }
export function useTemplateExtractDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateExtractDataQuery, TemplateExtractDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateExtractDataQuery, TemplateExtractDataQueryVariables>(TemplateExtractDataDocument, options);
        }
export type TemplateExtractDataQueryHookResult = ReturnType<typeof useTemplateExtractDataQuery>;
export type TemplateExtractDataLazyQueryHookResult = ReturnType<typeof useTemplateExtractDataLazyQuery>;
export type TemplateExtractDataQueryResult = Apollo.QueryResult<TemplateExtractDataQuery, TemplateExtractDataQueryVariables>;
export const ActiveTermsDocument = gql`
    query activeTerms {
  activeTerms {
    ...SchedulerActiveTermData
  }
}
    ${SchedulerActiveTermDataFragmentDoc}`;

/**
 * __useActiveTermsQuery__
 *
 * To run a query within a React component, call `useActiveTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveTermsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveTermsQuery, ActiveTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveTermsQuery, ActiveTermsQueryVariables>(ActiveTermsDocument, options);
      }
export function useActiveTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveTermsQuery, ActiveTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveTermsQuery, ActiveTermsQueryVariables>(ActiveTermsDocument, options);
        }
export type ActiveTermsQueryHookResult = ReturnType<typeof useActiveTermsQuery>;
export type ActiveTermsLazyQueryHookResult = ReturnType<typeof useActiveTermsLazyQuery>;
export type ActiveTermsQueryResult = Apollo.QueryResult<ActiveTermsQuery, ActiveTermsQueryVariables>;
export const SisSettingsDocument = gql`
    query sisSettings {
  siteSettings {
    sisSettings {
      liveRegistration
    }
  }
}
    `;

/**
 * __useSisSettingsQuery__
 *
 * To run a query within a React component, call `useSisSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSisSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSisSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSisSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SisSettingsQuery, SisSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SisSettingsQuery, SisSettingsQueryVariables>(SisSettingsDocument, options);
      }
export function useSisSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SisSettingsQuery, SisSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SisSettingsQuery, SisSettingsQueryVariables>(SisSettingsDocument, options);
        }
export type SisSettingsQueryHookResult = ReturnType<typeof useSisSettingsQuery>;
export type SisSettingsLazyQueryHookResult = ReturnType<typeof useSisSettingsLazyQuery>;
export type SisSettingsQueryResult = Apollo.QueryResult<SisSettingsQuery, SisSettingsQueryVariables>;
export const PublicAuthSettingsDocument = gql`
    query publicAuthSettings($environment: String!) {
  publicSettings(environment: $environment) {
    authSettings {
      studentAppAuth0LoginOptions {
        auth0Connection
        label
      }
      enableStudentAppFederatedLogout
      studentAppProvider
      studentAppOidcAuthority
      studentAppOidcClientId
      studentAppOidcAudience
      studentAppOidcDefaultIdpAlias
    }
  }
}
    `;

/**
 * __usePublicAuthSettingsQuery__
 *
 * To run a query within a React component, call `usePublicAuthSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAuthSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAuthSettingsQuery({
 *   variables: {
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function usePublicAuthSettingsQuery(baseOptions: Apollo.QueryHookOptions<PublicAuthSettingsQuery, PublicAuthSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAuthSettingsQuery, PublicAuthSettingsQueryVariables>(PublicAuthSettingsDocument, options);
      }
export function usePublicAuthSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAuthSettingsQuery, PublicAuthSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAuthSettingsQuery, PublicAuthSettingsQueryVariables>(PublicAuthSettingsDocument, options);
        }
export type PublicAuthSettingsQueryHookResult = ReturnType<typeof usePublicAuthSettingsQuery>;
export type PublicAuthSettingsLazyQueryHookResult = ReturnType<typeof usePublicAuthSettingsLazyQuery>;
export type PublicAuthSettingsQueryResult = Apollo.QueryResult<PublicAuthSettingsQuery, PublicAuthSettingsQueryVariables>;
export const AppSettingsDocument = gql`
    query appSettings {
  siteSettings {
    ...appSettings
  }
}
    ${AppSettingsFragmentDoc}`;

/**
 * __useAppSettingsQuery__
 *
 * To run a query within a React component, call `useAppSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AppSettingsQuery, AppSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettingsQuery, AppSettingsQueryVariables>(AppSettingsDocument, options);
      }
export function useAppSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettingsQuery, AppSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettingsQuery, AppSettingsQueryVariables>(AppSettingsDocument, options);
        }
export type AppSettingsQueryHookResult = ReturnType<typeof useAppSettingsQuery>;
export type AppSettingsLazyQueryHookResult = ReturnType<typeof useAppSettingsLazyQuery>;
export type AppSettingsQueryResult = Apollo.QueryResult<AppSettingsQuery, AppSettingsQueryVariables>;
export const HomeSettingsDocument = gql`
    query homeSettings {
  siteSettings {
    homeSettings {
      signoutText
    }
  }
}
    `;

/**
 * __useHomeSettingsQuery__
 *
 * To run a query within a React component, call `useHomeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeSettingsQuery(baseOptions?: Apollo.QueryHookOptions<HomeSettingsQuery, HomeSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeSettingsQuery, HomeSettingsQueryVariables>(HomeSettingsDocument, options);
      }
export function useHomeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeSettingsQuery, HomeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeSettingsQuery, HomeSettingsQueryVariables>(HomeSettingsDocument, options);
        }
export type HomeSettingsQueryHookResult = ReturnType<typeof useHomeSettingsQuery>;
export type HomeSettingsLazyQueryHookResult = ReturnType<typeof useHomeSettingsLazyQuery>;
export type HomeSettingsQueryResult = Apollo.QueryResult<HomeSettingsQuery, HomeSettingsQueryVariables>;
export const NewPlanSettingsDocument = gql`
    query newPlanSettings {
  siteSettings {
    ...newPlanSettings
  }
}
    ${NewPlanSettingsFragmentDoc}`;

/**
 * __useNewPlanSettingsQuery__
 *
 * To run a query within a React component, call `useNewPlanSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewPlanSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewPlanSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewPlanSettingsQuery(baseOptions?: Apollo.QueryHookOptions<NewPlanSettingsQuery, NewPlanSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewPlanSettingsQuery, NewPlanSettingsQueryVariables>(NewPlanSettingsDocument, options);
      }
export function useNewPlanSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewPlanSettingsQuery, NewPlanSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewPlanSettingsQuery, NewPlanSettingsQueryVariables>(NewPlanSettingsDocument, options);
        }
export type NewPlanSettingsQueryHookResult = ReturnType<typeof useNewPlanSettingsQuery>;
export type NewPlanSettingsLazyQueryHookResult = ReturnType<typeof useNewPlanSettingsLazyQuery>;
export type NewPlanSettingsQueryResult = Apollo.QueryResult<NewPlanSettingsQuery, NewPlanSettingsQueryVariables>;
export const HelpSettingsDocument = gql`
    query helpSettings {
  siteSettings {
    ...helpSettings
  }
}
    ${HelpSettingsFragmentDoc}`;

/**
 * __useHelpSettingsQuery__
 *
 * To run a query within a React component, call `useHelpSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpSettingsQuery(baseOptions?: Apollo.QueryHookOptions<HelpSettingsQuery, HelpSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelpSettingsQuery, HelpSettingsQueryVariables>(HelpSettingsDocument, options);
      }
export function useHelpSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelpSettingsQuery, HelpSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelpSettingsQuery, HelpSettingsQueryVariables>(HelpSettingsDocument, options);
        }
export type HelpSettingsQueryHookResult = ReturnType<typeof useHelpSettingsQuery>;
export type HelpSettingsLazyQueryHookResult = ReturnType<typeof useHelpSettingsLazyQuery>;
export type HelpSettingsQueryResult = Apollo.QueryResult<HelpSettingsQuery, HelpSettingsQueryVariables>;
export const StudentUserProfileDocument = gql`
    mutation studentUserProfile($input: UpsertStudentUserProfileInput!) {
  studentUserProfile(input: $input) {
    appUserId
    picture
  }
}
    `;
export type StudentUserProfileMutationFn = Apollo.MutationFunction<StudentUserProfileMutation, StudentUserProfileMutationVariables>;

/**
 * __useStudentUserProfileMutation__
 *
 * To run a mutation, you first call `useStudentUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentUserProfileMutation, { data, loading, error }] = useStudentUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<StudentUserProfileMutation, StudentUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentUserProfileMutation, StudentUserProfileMutationVariables>(StudentUserProfileDocument, options);
      }
export type StudentUserProfileMutationHookResult = ReturnType<typeof useStudentUserProfileMutation>;
export type StudentUserProfileMutationResult = Apollo.MutationResult<StudentUserProfileMutation>;
export type StudentUserProfileMutationOptions = Apollo.BaseMutationOptions<StudentUserProfileMutation, StudentUserProfileMutationVariables>;
export const SearchStudentsDocument = gql`
    query searchStudents($text: String!) {
  searchStudents(text: $text) {
    ...studentProfile
  }
}
    ${StudentProfileFragmentDoc}`;

/**
 * __useSearchStudentsQuery__
 *
 * To run a query within a React component, call `useSearchStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStudentsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchStudentsQuery(baseOptions: Apollo.QueryHookOptions<SearchStudentsQuery, SearchStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchStudentsQuery, SearchStudentsQueryVariables>(SearchStudentsDocument, options);
      }
export function useSearchStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchStudentsQuery, SearchStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchStudentsQuery, SearchStudentsQueryVariables>(SearchStudentsDocument, options);
        }
export type SearchStudentsQueryHookResult = ReturnType<typeof useSearchStudentsQuery>;
export type SearchStudentsLazyQueryHookResult = ReturnType<typeof useSearchStudentsLazyQuery>;
export type SearchStudentsQueryResult = Apollo.QueryResult<SearchStudentsQuery, SearchStudentsQueryVariables>;
export const StudentProfileDocument = gql`
    query studentProfile($externalId: String!) {
  studentProfile(externalId: $externalId) {
    ...studentProfile
  }
}
    ${StudentProfileFragmentDoc}`;

/**
 * __useStudentProfileQuery__
 *
 * To run a query within a React component, call `useStudentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentProfileQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useStudentProfileQuery(baseOptions: Apollo.QueryHookOptions<StudentProfileQuery, StudentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, options);
      }
export function useStudentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentProfileQuery, StudentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentProfileQuery, StudentProfileQueryVariables>(StudentProfileDocument, options);
        }
export type StudentProfileQueryHookResult = ReturnType<typeof useStudentProfileQuery>;
export type StudentProfileLazyQueryHookResult = ReturnType<typeof useStudentProfileLazyQuery>;
export type StudentProfileQueryResult = Apollo.QueryResult<StudentProfileQuery, StudentProfileQueryVariables>;
export const AppUserStudentProfileDocument = gql`
    query appUserStudentProfile($appUserId: Int!) {
  appUserStudentProfile(appUserId: $appUserId) {
    ...studentProfile
  }
}
    ${StudentProfileFragmentDoc}`;

/**
 * __useAppUserStudentProfileQuery__
 *
 * To run a query within a React component, call `useAppUserStudentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppUserStudentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppUserStudentProfileQuery({
 *   variables: {
 *      appUserId: // value for 'appUserId'
 *   },
 * });
 */
export function useAppUserStudentProfileQuery(baseOptions: Apollo.QueryHookOptions<AppUserStudentProfileQuery, AppUserStudentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppUserStudentProfileQuery, AppUserStudentProfileQueryVariables>(AppUserStudentProfileDocument, options);
      }
export function useAppUserStudentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppUserStudentProfileQuery, AppUserStudentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppUserStudentProfileQuery, AppUserStudentProfileQueryVariables>(AppUserStudentProfileDocument, options);
        }
export type AppUserStudentProfileQueryHookResult = ReturnType<typeof useAppUserStudentProfileQuery>;
export type AppUserStudentProfileLazyQueryHookResult = ReturnType<typeof useAppUserStudentProfileLazyQuery>;
export type AppUserStudentProfileQueryResult = Apollo.QueryResult<AppUserStudentProfileQuery, AppUserStudentProfileQueryVariables>;
export const GetTermsDocument = gql`
    query getTerms($startYear: Int) {
  getTerms(startYear: $startYear) {
    ...term
  }
}
    ${TermFragmentDoc}`;

/**
 * __useGetTermsQuery__
 *
 * To run a query within a React component, call `useGetTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsQuery({
 *   variables: {
 *      startYear: // value for 'startYear'
 *   },
 * });
 */
export function useGetTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
      }
export function useGetTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
        }
export type GetTermsQueryHookResult = ReturnType<typeof useGetTermsQuery>;
export type GetTermsLazyQueryHookResult = ReturnType<typeof useGetTermsLazyQuery>;
export type GetTermsQueryResult = Apollo.QueryResult<GetTermsQuery, GetTermsQueryVariables>;
export const GetCurrentAndFutureTermsDocument = gql`
    query getCurrentAndFutureTerms {
  getTerms(currentAndFutureTerms: true) {
    ...term
  }
}
    ${TermFragmentDoc}`;

/**
 * __useGetCurrentAndFutureTermsQuery__
 *
 * To run a query within a React component, call `useGetCurrentAndFutureTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAndFutureTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAndFutureTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAndFutureTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentAndFutureTermsQuery, GetCurrentAndFutureTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentAndFutureTermsQuery, GetCurrentAndFutureTermsQueryVariables>(GetCurrentAndFutureTermsDocument, options);
      }
export function useGetCurrentAndFutureTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentAndFutureTermsQuery, GetCurrentAndFutureTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentAndFutureTermsQuery, GetCurrentAndFutureTermsQueryVariables>(GetCurrentAndFutureTermsDocument, options);
        }
export type GetCurrentAndFutureTermsQueryHookResult = ReturnType<typeof useGetCurrentAndFutureTermsQuery>;
export type GetCurrentAndFutureTermsLazyQueryHookResult = ReturnType<typeof useGetCurrentAndFutureTermsLazyQuery>;
export type GetCurrentAndFutureTermsQueryResult = Apollo.QueryResult<GetCurrentAndFutureTermsQuery, GetCurrentAndFutureTermsQueryVariables>;
export const GetAcademicYearsDocument = gql`
    query getAcademicYears($startYear: Int) {
  getAcademicYears(startYear: $startYear) {
    academicYear
    academicYearDescription
    endDate
    startDate
  }
}
    `;

/**
 * __useGetAcademicYearsQuery__
 *
 * To run a query within a React component, call `useGetAcademicYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicYearsQuery({
 *   variables: {
 *      startYear: // value for 'startYear'
 *   },
 * });
 */
export function useGetAcademicYearsQuery(baseOptions?: Apollo.QueryHookOptions<GetAcademicYearsQuery, GetAcademicYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcademicYearsQuery, GetAcademicYearsQueryVariables>(GetAcademicYearsDocument, options);
      }
export function useGetAcademicYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcademicYearsQuery, GetAcademicYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcademicYearsQuery, GetAcademicYearsQueryVariables>(GetAcademicYearsDocument, options);
        }
export type GetAcademicYearsQueryHookResult = ReturnType<typeof useGetAcademicYearsQuery>;
export type GetAcademicYearsLazyQueryHookResult = ReturnType<typeof useGetAcademicYearsLazyQuery>;
export type GetAcademicYearsQueryResult = Apollo.QueryResult<GetAcademicYearsQuery, GetAcademicYearsQueryVariables>;
export const UpdateLastLoginDocument = gql`
    mutation updateLastLogin {
  updateStudentAppLastLogin {
    id
    success
    message
  }
}
    `;
export type UpdateLastLoginMutationFn = Apollo.MutationFunction<UpdateLastLoginMutation, UpdateLastLoginMutationVariables>;

/**
 * __useUpdateLastLoginMutation__
 *
 * To run a mutation, you first call `useUpdateLastLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastLoginMutation, { data, loading, error }] = useUpdateLastLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastLoginMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastLoginMutation, UpdateLastLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastLoginMutation, UpdateLastLoginMutationVariables>(UpdateLastLoginDocument, options);
      }
export type UpdateLastLoginMutationHookResult = ReturnType<typeof useUpdateLastLoginMutation>;
export type UpdateLastLoginMutationResult = Apollo.MutationResult<UpdateLastLoginMutation>;
export type UpdateLastLoginMutationOptions = Apollo.BaseMutationOptions<UpdateLastLoginMutation, UpdateLastLoginMutationVariables>;
export const BatchCreateAdminUsersDocument = gql`
    mutation batchCreateAdminUsers($input: BatchCreateAdminUsersInput!) {
  batchCreateAdminUsers(input: $input) {
    createdUsers {
      id
      email
      firstName
      lastName
    }
    failedUsers {
      email
      firstName
      lastName
    }
    updatedUsers {
      id
      email
      firstName
      lastName
    }
  }
}
    `;
export type BatchCreateAdminUsersMutationFn = Apollo.MutationFunction<BatchCreateAdminUsersMutation, BatchCreateAdminUsersMutationVariables>;

/**
 * __useBatchCreateAdminUsersMutation__
 *
 * To run a mutation, you first call `useBatchCreateAdminUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateAdminUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateAdminUsersMutation, { data, loading, error }] = useBatchCreateAdminUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateAdminUsersMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateAdminUsersMutation, BatchCreateAdminUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateAdminUsersMutation, BatchCreateAdminUsersMutationVariables>(BatchCreateAdminUsersDocument, options);
      }
export type BatchCreateAdminUsersMutationHookResult = ReturnType<typeof useBatchCreateAdminUsersMutation>;
export type BatchCreateAdminUsersMutationResult = Apollo.MutationResult<BatchCreateAdminUsersMutation>;
export type BatchCreateAdminUsersMutationOptions = Apollo.BaseMutationOptions<BatchCreateAdminUsersMutation, BatchCreateAdminUsersMutationVariables>;
export const UpsertCompletedCoursePreferenceDocument = gql`
    mutation upsertCompletedCoursePreference($input: CompletedCoursePreferenceInput!) {
  upsertCompletedCoursePreference(input: $input) {
    id
    success
    message
  }
}
    `;
export type UpsertCompletedCoursePreferenceMutationFn = Apollo.MutationFunction<UpsertCompletedCoursePreferenceMutation, UpsertCompletedCoursePreferenceMutationVariables>;

/**
 * __useUpsertCompletedCoursePreferenceMutation__
 *
 * To run a mutation, you first call `useUpsertCompletedCoursePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompletedCoursePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompletedCoursePreferenceMutation, { data, loading, error }] = useUpsertCompletedCoursePreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCompletedCoursePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompletedCoursePreferenceMutation, UpsertCompletedCoursePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompletedCoursePreferenceMutation, UpsertCompletedCoursePreferenceMutationVariables>(UpsertCompletedCoursePreferenceDocument, options);
      }
export type UpsertCompletedCoursePreferenceMutationHookResult = ReturnType<typeof useUpsertCompletedCoursePreferenceMutation>;
export type UpsertCompletedCoursePreferenceMutationResult = Apollo.MutationResult<UpsertCompletedCoursePreferenceMutation>;
export type UpsertCompletedCoursePreferenceMutationOptions = Apollo.BaseMutationOptions<UpsertCompletedCoursePreferenceMutation, UpsertCompletedCoursePreferenceMutationVariables>;